/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		22: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 234);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = jQuery;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return noopActions; });
/* harmony export (immutable) */ __webpack_exports__["a"] = registerJQueryPlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined__);
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * This simple helper aids in the creation of creating/registering a jquery
 * plugin.
 * @module lib/createJqueryPlugin
 */




var NOOP = function NOOP() {};

/**
 * Provides noop actions for sensible defaults.
 * @type {Object}
 */
var noopActions = {
  deregister: NOOP
};

/**
 * Contains a number of methods representing actions.
 * @param {HTMLElement} el - The element applied to the plugin
 * @param {string} name - The name of the plugin
 */
var actions = function actions(el, name) {
  return {
    /**
     * Performs a deregisteration on the plugin
     */
    deregister: function deregister() {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.removeData(el, name);
    }
  };
};
var DEFAULT_OPTIONS = {
  cache: true
};

/**
 * Simple helper function that creates/register a jQuery plugin.
 * @param {string} name - The name of the plugin to reguster
 * @param {jQueryPluginCallback} cb - A callback function
 */
function registerJQueryPlugin(name, cb) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _Object$assign = Object.assign({}, DEFAULT_OPTIONS, options),
    cache = _Object$assign.cache;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn[name] = function pluginRegister() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var $obj = this;
    var opt = args[0];
    var _$obj$toArray$map$fil = $obj.toArray().map(function (el) {
        if (__WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(opt)) {
          var instance = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.data(el, name);
          if (!instance) {
            // eslint-disable-next-line no-console
            return console.warn("Attempted to call method ".concat(opt, " when no instance existed for ").concat(name));
          }
          if (!instance[opt]) {
            // eslint-disable-next-line no-console
            return console.warn("No method found for ".concat(opt, " on ").concat(name));
          }
          var argList = args.slice(1);
          return instance[opt].apply(instance, _toConsumableArray(argList));
        }
        if (__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default()(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.data(el, name)) || !cache) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.data(el, name, cb(el, opt, actions(el, name)) || {});
        }

        // this is here so we can identify that chaining should occur and also
        // shut up eslint from complaining about a needed return value
        return undefined;
      }).filter(function (val) {
        return !__WEBPACK_IMPORTED_MODULE_2_lodash_isUndefined___default()(val);
      }),
      _$obj$toArray$map$fil2 = _slicedToArray(_$obj$toArray$map$fil, 1),
      result = _$obj$toArray$map$fil2[0];
    return result || $obj;
  };
}

/**
 * This callback is used for registering a jQuery plugin.
 * @callback jQueryPluginCallback
 * @param {HTMLElement} el - The element applied to the plugin
 * @param {Object} options - Options forwarded along to the plugin.
 * @param {Object} actions - Actions that can be taken on the plugin
 */

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - The container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */

var mergeOptions = function mergeOptions() {
  var DEFAULTS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = arguments.length > 2 ? arguments[2] : undefined;
  var opts = Object.assign({}, DEFAULTS, options, $el ? $el.data() : {});
  return opts;
};
/* harmony default export */ __webpack_exports__["a"] = (mergeOptions);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/**
 * Keyboard JS
 * Parses keyboard events
 * Trap the focus in the given element
 */


var keyCodes = {
  8: 'BACKSPACE',
  9: 'TAB',
  13: 'ENTER',
  27: 'ESCAPE',
  32: 'SPACE',
  37: 'ARROWLEFT',
  38: 'ARROWUP',
  39: 'ARROWRIGHT',
  40: 'ARROWDOWN'
};
var keyDirections = ['UP', 'RIGHT', 'DOWN', 'LEFT'];
/*
 * Constants for easier comparing.
 * Can be used like Keyboard.parseKey(event) === Keyboard.keys.SPACE
 */
var getKeyCodes = function getKeyCodes(kcs) {
  var k = {};
  Object.keys(kcs).forEach(function (key) {
    k[kcs[key]] = kcs[key];
  });
  return k;
};
var Keyboard = {
  keys: getKeyCodes(keyCodes),
  /**
   * Parses the (keyboard) event and returns a String that represents its key
   * Can be used like Keyboard.parseKey(event) === Keyboard.keys.SPACE
   * @param {Event} event - the event generated by the event handler
   * @return String key - String that represents the key pressed
   */
  parseKey: function parseKey(event) {
    var key;
    if (event.key !== undefined) {
      key = event.key.toUpperCase();
      if (key === " " || event.which === 32) {
        key = 'SPACE';
      }
      if (key === 'ESC') {
        key = 'ESCAPE';
      }
      if (keyDirections.indexOf(key) > -1) {
        key = "ARROW".concat(key);
      }
    } else {
      key = keyCodes[event.which || event.keyCode] || String.fromCharCode(event.which).toUpperCase();
    }

    // Remove un-printable characters, e.g. for `fromCharCode` calls for CTRL only events
    key = key.replace(/\W+/, '');
    if (event.shiftKey) key = "SHIFT_".concat(key);
    if (event.ctrlKey) key = "CTRL_".concat(key);
    if (event.altKey) key = "ALT_".concat(key);

    // Remove trailing underscore, in case only modifiers were used (e.g. only `CTRL_ALT`)
    key = key.replace(/_$/, '');
    return key;
  },
  /**
   * Finds all focusable elements within the given `$element`
   * @param {jQuery} $el - jQuery object to search within
   * @return {jQuery} $focusable - all focusable elements within `$el`
   */
  findFocusable: function findFocusable($el) {
    // only have visible elements and those that have a tabindex greater or equal 0
    return $el.find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(':visible').filter(function (index, el) {
      return el.getAttribute('tabindex') >= 0;
    });
  },
  /**
   * Traps the focus in the given element.
   * @param  {jQuery} $el - jQuery object to trap the foucs into.
   */
  trapFocus: function trapFocus($el) {
    $el.on('keydown.trapfocus', function (event) {
      var parsedKey = Keyboard.parseKey(event);
      if (parsedKey === 'TAB' || parsedKey === 'SHIFT_TAB') {
        // New element might be loaded. If the target is the same as the last,
        // attempt to rerun trapFocus Logic.
        var $focusable = Keyboard.findFocusable($el);
        var $firstFocusable = $focusable.eq(0);
        var $lastFocusable = $focusable.eq(-1);
        if (parsedKey === 'TAB' && event.target === $lastFocusable[0]) {
          event.preventDefault();
          $firstFocusable.focus();
        } else if (parsedKey === 'SHIFT_TAB') {
          if (event.target === $firstFocusable[0]) {
            event.preventDefault();
            $lastFocusable.focus();
          }
          if (__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.inArray(event.target, $focusable) === -1) {
            $lastFocusable.focus();
          }
        }
      }
    });
  },
  /**
   * Releases the trapped focus from the given element.
   * @param  {jQuery} $el  jQuery object to release the focus for.
   * @param  {jQuery} $lastFocus return to last focus
   */
  releaseFocus: function releaseFocus($el, $lastFocus) {
    $el.off('keydown.trapfocus');
    if ($lastFocus) {
      $lastFocus.focus();
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (Keyboard);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(170);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(19),
    isObject = __webpack_require__(9);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(79);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  check(typeof this == 'object' && this) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 10 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
module.exports = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(124);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(12);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(23),
    getRawTag = __webpack_require__(455),
    objectToString = __webpack_require__(488);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EVENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TYPES; });
/* unused harmony export default */
/* unused harmony export defaultUpdateOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createJQueryPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_property__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_symbol__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible initiating form field behaviors and sending events down to any
 * behaviors or extended functionality.
 * @module formFieldBehavior
 */




/**
 * Defines default options for form field behaviors
 * @type {Object}
 */
var FORM_FIELD_BEHAVIOR_OPTIONS = {
  labelElement: 'label',
  fieldElements: ['input', 'select', 'textarea'],
  behaviors: []
};

/**
 * Defines the different types of supported events.
 * @type {Object}
 */
var EVENTS = {
  FOCUS: 'focus',
  BLUR: 'blur',
  INVALID: 'invalid',
  INPUT: 'input',
  CHANGE: 'change',
  LOAD: 'load',
  // This is a nonstandard event, but it does provide clarity when an element
  // was no longer but in its current state it is valid
  VALID: 'valid'
};

/**
 * Defines the types associated to the elements within form field behaviors. It
 * uses Symbol as the value so that unique values can be used without caring
 * about conflicts values. Think of this similar to an Enum or an IOTA.
 * @enum
 * @type {Object}
 */
var TYPES = {
  CONTAINER: __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default()('container'),
  LABEL: __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default()('label'),
  FIELD: __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default()('field')
};

/**
 * Creates a FIELD based on the block and optionally supplied element.
 * @private
 * @param {Symbol} type - Uniquely identify a type of FIELD
 * @param {HTMLElement} container - Contains the child elements
 * @param {string} block - The block name
 * @param {string|null} [element=null] - The element name
 * @returns {Object} The name and node representing the FIELD.
 */
var createField = function createField(type, container, block) {
  var element = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  if (element) {
    var name = "".concat(block, "__").concat(element);
    return {
      type: type,
      name: name,
      node: container.querySelector(".".concat(name))
    };
  }
  return {
    type: type,
    name: block,
    node: container
  };
};

/**
 * Negotiates and resolves the form FIELD within the CONTAINER. There are a
 * number of possible element names that can be used, so this will ensure that
 * the supported element names correlate to what is in the DOM.
 * @private
 * @param {HTMLElement} container - Contains the form FIELD element
 * @param {string} block - The block name
 * @param {Array} fieldElements = Possible elements names
 * @returns {Object} The name and node representing the form FIELD.
 */
var getFormField = function getFormField(container, block, fieldElements) {
  var _fieldElements$map$fi = fieldElements.map(function (element) {
      return createField(TYPES.FIELD, container, block, element);
    }).filter(function (_ref) {
      var node = _ref.node;
      return node;
    }),
    _fieldElements$map$fi2 = _toArray(_fieldElements$map$fi),
    field = _fieldElements$map$fi2[0],
    otherFields = _arrayLikeToArray(_fieldElements$map$fi2).slice(1);
  if (otherFields.length) {
    throw new Error('Form field behaviors only supports one field in a container');
  }
  if (!field) {
    throw new Error('No form field node found in form field behaviors');
  }
  return field;
};

/**
 * Provides additional data that can be used from the consumer side of the
 * form field behavior. Think of this as extra data that isn't part of the
 * event.
 * @private
 * @param {HTMLElement} fieldElement - The form field element
 * @returns {Object} Data to be passed along to the event.
 */
var buildAdditionalData = function buildAdditionalData(fieldElement) {
  var _ref2 = __WEBPACK_IMPORTED_MODULE_0_lodash_property___default()('form.dataset')(fieldElement) || {},
    validateOnlyOnSubmit = _ref2.validateOnlyOnSubmit;
  return {
    validateOnlyOnSubmit: !!validateOnlyOnSubmit
  };
};

/**
 * Creates an event listener and passes back all the necessary properties
 * needed for clean up.
 * @private
 * @param {string} eventName - The name of the event
 * @param {HTMLElement} node - Element receiving the event
 * @param {Array} behaviors - The listeners or behaviors provided from the outside
 * @param {Function} [fn=e => e] - Allow for internal hooking in of the callback
 * @returns {Object} Properties containing event information
 */
var addListener = function addListener(eventName, node, behaviors) {
  var fn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (e) {
    return e;
  };
  var handler;
  var data = buildAdditionalData(node);
  node.addEventListener(eventName, handler = function handler(e) {
    fn(e);
    behaviors.forEach(function (listener) {
      return listener && listener(eventName, e, data);
    });
  });
  return {
    node: node,
    eventName: eventName,
    handler: handler
  };
};

/**
 * Removes all events applied to an instance of form field behaviors.
 * @private
 * @param {Object} listeners - Info about each element
 */
var _removeListeners = function removeListeners(listeners) {
  listeners.forEach(function (listener) {
    if (!listener) {
      return;
    }
    var node = listener.node,
      eventName = listener.eventName,
      handler = listener.handler;
    node.removeEventListener(eventName, handler);
  });
};

/**
 * Fires off a load event denoting that the element has loaded.
 * @private
 * @param {HTMLElement} fieldNode - The element receiving the event
 */
var fireLoadEvent = function fireLoadEvent(fieldNode) {
  var evt = new CustomEvent(EVENTS.LOAD);
  fieldNode.dispatchEvent(evt);
};

/**
 * Responsible for handling any select specific events.
 * @param {HTMLElement} fieldNode - Element receiving the event
 * @param {Array} listeners - Called on when event has been fired off
 * @returns {Function|null} Event handler or null depending on if the event
 * will be fired off
 */
var addChangeListener = function addChangeListener(fieldNode, listeners) {
  if (fieldNode.tagName.toLowerCase() === 'select') {
    return addListener(EVENTS.CHANGE, fieldNode, listeners);
  }
  return null;
};

/**
 * Responsible for setting up any behavior that needs to hook into form field
 * behaviors. The goal of this work is to:
 *
 * - Offload responsibility of the interaction so any form field behavior
 *   functionality can scale horizontally.
 * - Decrease the amount of event bound to the DOM by calling on the listener
 *   provided by the behavior.
 * - Consolidate all events for ease of clean up.
 *
 * As part of the setup, a number of requirements are needed for a form field
 * behavior include:
 *
 * - A CONTAINER element (the one passed in)
 * - A LABEL element
 * - Some kinda of form FIELD element
 *
 * Once all the requirements have been met, form field behaviors will interact
 * with "behaviors", which serve the following purposes:
 *
 * - Accept the output of elements
 * - Respond to any events dictated by form field behaviors by forwarding along
 *   the event name followed by the event on the form field
 *
 * To do so, a behavior is a function where the returned function acts as the
 * responder. In it's simplest form, a behavior is a function that returns a
 * function, where the first function passes along all the "nodes" or elements
 * defined in TYPES and the second function (or inner function) it used for
 * listening to/responding to events.
 *
 * @example
 * const myBehavior = (blockElement, labelElement, fieldFormElement) => (type, evt) => {
 *   switch(type) {
 *     case 'FOCUS':
 *       blockElement.classList.add('i-do-focus-things');
 *     case 'BLUR':
 *       blockElement.classList.remove('i-do-focus-things');
 *       blockElement.classList.add('i-do-blur-things');
 *   };
 * };
 *
 * formFieldBehaviors($el, 'some-block', {
 *   behaviors: [myBehavior]
 * });
 *
 * @see TYPES
 * @see FORM_FIELD_BEHAVIOR_OPTIONS
 * @param {HTMLElement} container - The element containing the LABEL and FIELD
 * @param {string} block - Name of top level block
 * @param {string} labelElement - Name of label element associated with the block
 * @param {Object} options - Options used for overriding
 * @returns {Object} Properties used for interacting after the initial call
 */
function formFieldBehaviors(container, block) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _Object$assign = Object.assign({}, FORM_FIELD_BEHAVIOR_OPTIONS, options),
    labelElement = _Object$assign.labelElement,
    fieldElements = _Object$assign.fieldElements,
    behaviors = _Object$assign.behaviors,
    _Object$assign$deregi = _Object$assign.deregister,
    deregister = _Object$assign$deregi === void 0 ? function () {} : _Object$assign$deregi;
  var formField = getFormField(container, block, fieldElements);
  var label = createField(TYPES.LABEL, container, block, labelElement);
  if (!label.node) {
    throw new Error("No field found in a form field behavior for ".concat(label.name));
  }
  var elements = [createField(TYPES.CONTAINER, container, block), label, formField];
  var FOCUS = EVENTS.FOCUS,
    BLUR = EVENTS.BLUR,
    INVALID = EVENTS.INVALID,
    INPUT = EVENTS.INPUT,
    LOAD = EVENTS.LOAD,
    VALID = EVENTS.VALID;
  var listeners = behaviors.map(function (behavior) {
    return behavior.apply(void 0, elements);
  });
  var fieldNode = formField.node;
  var focusListener = addListener(FOCUS, fieldNode, listeners, function (_ref3) {
    var target = _ref3.target;
    return target.setCustomValidity('');
  });
  var blurListener = addListener(BLUR, fieldNode, listeners);
  var invalidListener = addListener(INVALID, fieldNode, listeners);
  var inputListener = addListener(INPUT, fieldNode, listeners);
  var loadListener = addListener(LOAD, fieldNode, listeners);
  var changeListener = addChangeListener(fieldNode, listeners);
  var validListener = addListener(VALID, fieldNode, listeners);
  var eventListeners = [focusListener, blurListener, invalidListener, inputListener, loadListener, changeListener, validListener];

  // At this point all the necessary elements are in the DOM so we communicate
  // to any subscribers that the form field behavior functionality has loaded.
  fireLoadEvent(fieldNode);
  return {
    removeListeners: function removeListeners() {
      deregister();
      _removeListeners(eventListeners);
    }
  };
}

/**
 * Responsible for providing default implementaiton of update options.
 * @param {HTMLElement} el - Element receiving form field behaviors
 * @param {Object} options - Configurable options
 */
var defaultUpdateOptions = function defaultUpdateOptions(el, options) {
  return options;
};

/**
 * Responsible for bootstrapping together jQuery plugin at runtime.
 * @param {string} block - Name of block being referenced
 * @param {Array} behaviors - Any implemented behaviors.
 * @param {*} updateOptions - Called on prior to make modifications to options
 * or element
 * @returns {Function} Called on when plugin is called on
 */
var bootstrapJQueryPlugin = function bootstrapJQueryPlugin(block, behaviors, updateOptions) {
  return function (el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["b" /* noopActions */],
      deregister = _ref4.deregister;
    var _options$behaviors = options.behaviors,
      pluginBehaviors = _options$behaviors === void 0 ? [] : _options$behaviors;
    var combinedBehaviors = behaviors.concat(pluginBehaviors);
    var opts = Object.assign({
      formFieldBehaviors: formFieldBehaviors,
      behaviors: combinedBehaviors,
      deregister: deregister
    }, options);
    var formFieldBehaviorsFn = opts.formFieldBehaviors;
    var nextOptions = updateOptions(el, opts);
    return formFieldBehaviorsFn(el, block, nextOptions);
  };
};

/**
 * Responsible for creating a jQuery plugin from a form field behaviors
 * instance. Think of this has a jQuery plugin adapter for form field behaviors.
 * @param {string} pluginName - Name of plugin to create
 * @param {string} block - Name of block being referenced
 * @param {Array} behaviors - Any implemented behaviors.
 * @param {Function} [updateOptions=defaultUpdateOptions] - Called on so that any
 * dynamic options can be set at runtime.
 */
var createJQueryPlugin = function createJQueryPlugin(pluginName, block, behaviors) {
  var updateOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultUpdateOptions;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(pluginName, bootstrapJQueryPlugin(block, behaviors, updateOptions));
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(13);
var toObject = __webpack_require__(365);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(412),
    getValue = __webpack_require__(456);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9),
    now = __webpack_require__(522),
    toNumber = __webpack_require__(191);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(149),
    baseKeys = __webpack_require__(415),
    isArrayLike = __webpack_require__(35);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(342);
var $includes = __webpack_require__(120).includes;
var fails = __webpack_require__(12);
var addToUnscopables = __webpack_require__(336);

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// Safari 26.4- bug
var BROKEN_ON_SPARSE_WITH_FROM_INDEX = fails(function () {
  // eslint-disable-next-line no-sparse-arrays, es/no-array-prototype-includes -- detection
  return [, 1].includes(undefined, 1);
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE || BROKEN_ON_SPARSE_WITH_FROM_INDEX }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;
(function (factory) {
  'use strict';

  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined') {
    module.exports = factory(require('jquery'));
  } else {
    factory(jQuery);
  }
})(function ($) {
  'use strict';

  var Slick = window.Slick || {};
  Slick = function () {
    var instanceUid = 0;
    function Slick(element, settings) {
      var _ = this,
        dataSettings;
      _.defaults = {
        accessibility: true,
        adaptiveHeight: false,
        appendArrows: $(element),
        appendDots: $(element),
        arrows: true,
        asNavFor: null,
        prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: false,
        autoplaySpeed: 3000,
        centerMode: false,
        centerPadding: '50px',
        cssEase: 'ease',
        customPaging: function customPaging(slider, i) {
          return $('<button type="button" />').text(i + 1);
        },
        dots: false,
        dotsClass: 'slick-dots',
        draggable: true,
        easing: 'linear',
        edgeFriction: 0.35,
        fade: false,
        focusOnSelect: false,
        focusOnChange: false,
        infinite: true,
        initialSlide: 0,
        lazyLoad: 'ondemand',
        mobileFirst: false,
        pauseOnHover: true,
        pauseOnFocus: true,
        pauseOnDotsHover: false,
        respondTo: 'window',
        responsive: null,
        rows: 1,
        rtl: false,
        slide: '',
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: true,
        swipeToSlide: false,
        touchMove: true,
        touchThreshold: 5,
        useCSS: true,
        useTransform: true,
        variableWidth: false,
        vertical: false,
        verticalSwiping: false,
        waitForAnimate: true,
        zIndex: 1000
      };
      _.initials = {
        animating: false,
        dragging: false,
        autoPlayTimer: null,
        currentDirection: 0,
        currentLeft: null,
        currentSlide: 0,
        direction: 1,
        $dots: null,
        listWidth: null,
        listHeight: null,
        loadIndex: 0,
        $nextArrow: null,
        $prevArrow: null,
        scrolling: false,
        slideCount: null,
        slideWidth: null,
        $slideTrack: null,
        $slides: null,
        sliding: false,
        slideOffset: 0,
        swipeLeft: null,
        swiping: false,
        $list: null,
        touchObject: {},
        transformsEnabled: false,
        unslicked: false
      };
      $.extend(_, _.initials);
      _.activeBreakpoint = null;
      _.animType = null;
      _.animProp = null;
      _.breakpoints = [];
      _.breakpointSettings = [];
      _.cssTransitions = false;
      _.focussed = false;
      _.interrupted = false;
      _.hidden = 'hidden';
      _.paused = true;
      _.positionProp = null;
      _.respondTo = null;
      _.rowCount = 1;
      _.shouldClick = true;
      _.$slider = $(element);
      _.$slidesCache = null;
      _.transformType = null;
      _.transitionType = null;
      _.visibilityChange = 'visibilitychange';
      _.windowWidth = 0;
      _.windowTimer = null;
      dataSettings = $(element).data('slick') || {};
      _.options = $.extend({}, _.defaults, settings, dataSettings);
      _.currentSlide = _.options.initialSlide;
      _.originalSettings = _.options;
      if (typeof document.mozHidden !== 'undefined') {
        _.hidden = 'mozHidden';
        _.visibilityChange = 'mozvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        _.hidden = 'webkitHidden';
        _.visibilityChange = 'webkitvisibilitychange';
      }
      _.autoPlay = $.proxy(_.autoPlay, _);
      _.autoPlayClear = $.proxy(_.autoPlayClear, _);
      _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
      _.changeSlide = $.proxy(_.changeSlide, _);
      _.clickHandler = $.proxy(_.clickHandler, _);
      _.selectHandler = $.proxy(_.selectHandler, _);
      _.setPosition = $.proxy(_.setPosition, _);
      _.swipeHandler = $.proxy(_.swipeHandler, _);
      _.dragHandler = $.proxy(_.dragHandler, _);
      _.keyHandler = $.proxy(_.keyHandler, _);
      _.instanceUid = instanceUid++;

      // A simple way to check for HTML strings
      // Strict HTML recognition (must start with <)
      // Extracted from jQuery v1.11 source
      _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
      _.registerBreakpoints();
      _.init(true);
    }
    return Slick;
  }();
  Slick.prototype.activateADA = function () {
    var _ = this;
    _.$slideTrack.find('.slick-active').attr({
      'aria-hidden': 'false'
    }).find('a, input, button, select').attr({
      'tabindex': '0'
    });
  };
  Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {
    var _ = this;
    if (typeof index === 'boolean') {
      addBefore = index;
      index = null;
    } else if (index < 0 || index >= _.slideCount) {
      return false;
    }
    _.unload();
    if (typeof index === 'number') {
      if (index === 0 && _.$slides.length === 0) {
        $(markup).appendTo(_.$slideTrack);
      } else if (addBefore) {
        $(markup).insertBefore(_.$slides.eq(index));
      } else {
        $(markup).insertAfter(_.$slides.eq(index));
      }
    } else {
      if (addBefore === true) {
        $(markup).prependTo(_.$slideTrack);
      } else {
        $(markup).appendTo(_.$slideTrack);
      }
    }
    _.$slides = _.$slideTrack.children(this.options.slide);
    _.$slideTrack.children(this.options.slide).detach();
    _.$slideTrack.append(_.$slides);
    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index);
    });
    _.$slidesCache = _.$slides;
    _.reinit();
  };
  Slick.prototype.animateHeight = function () {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.animate({
        height: targetHeight
      }, _.options.speed);
    }
  };
  Slick.prototype.animateSlide = function (targetLeft, callback) {
    var animProps = {},
      _ = this;
    _.animateHeight();
    if (_.options.rtl === true && _.options.vertical === false) {
      targetLeft = -targetLeft;
    }
    if (_.transformsEnabled === false) {
      if (_.options.vertical === false) {
        _.$slideTrack.animate({
          left: targetLeft
        }, _.options.speed, _.options.easing, callback);
      } else {
        _.$slideTrack.animate({
          top: targetLeft
        }, _.options.speed, _.options.easing, callback);
      }
    } else {
      if (_.cssTransitions === false) {
        if (_.options.rtl === true) {
          _.currentLeft = -_.currentLeft;
        }
        $({
          animStart: _.currentLeft
        }).animate({
          animStart: targetLeft
        }, {
          duration: _.options.speed,
          easing: _.options.easing,
          step: function step(now) {
            now = Math.ceil(now);
            if (_.options.vertical === false) {
              animProps[_.animType] = 'translate(' + now + 'px, 0px)';
              _.$slideTrack.css(animProps);
            } else {
              animProps[_.animType] = 'translate(0px,' + now + 'px)';
              _.$slideTrack.css(animProps);
            }
          },
          complete: function complete() {
            if (callback) {
              callback.call();
            }
          }
        });
      } else {
        _.applyTransition();
        targetLeft = Math.ceil(targetLeft);
        if (_.options.vertical === false) {
          animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
        } else {
          animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
        }
        _.$slideTrack.css(animProps);
        if (callback) {
          setTimeout(function () {
            _.disableTransition();
            callback.call();
          }, _.options.speed);
        }
      }
    }
  };
  Slick.prototype.getNavTarget = function () {
    var _ = this,
      asNavFor = _.options.asNavFor;
    if (asNavFor && asNavFor !== null) {
      asNavFor = $(asNavFor).not(_.$slider);
    }
    return asNavFor;
  };
  Slick.prototype.asNavFor = function (index) {
    var _ = this,
      asNavFor = _.getNavTarget();
    if (asNavFor !== null && _typeof(asNavFor) === 'object') {
      asNavFor.each(function () {
        var target = $(this).slick('getSlick');
        if (!target.unslicked) {
          target.slideHandler(index, true);
        }
      });
    }
  };
  Slick.prototype.applyTransition = function (slide) {
    var _ = this,
      transition = {};
    if (_.options.fade === false) {
      transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
    } else {
      transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
    }
    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };
  Slick.prototype.autoPlay = function () {
    var _ = this;
    _.autoPlayClear();
    if (_.slideCount > _.options.slidesToShow) {
      _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    }
  };
  Slick.prototype.autoPlayClear = function () {
    var _ = this;
    if (_.autoPlayTimer) {
      clearInterval(_.autoPlayTimer);
    }
  };
  Slick.prototype.autoPlayIterator = function () {
    var _ = this,
      slideTo = _.currentSlide + _.options.slidesToScroll;
    if (!_.paused && !_.interrupted && !_.focussed) {
      if (_.options.infinite === false) {
        if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
          _.direction = 0;
        } else if (_.direction === 0) {
          slideTo = _.currentSlide - _.options.slidesToScroll;
          if (_.currentSlide - 1 === 0) {
            _.direction = 1;
          }
        }
      }
      _.slideHandler(slideTo);
    }
  };
  Slick.prototype.buildArrows = function () {
    var _ = this;
    if (_.options.arrows === true) {
      _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
      _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
      if (_.slideCount > _.options.slidesToShow) {
        _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
        _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
        if (_.htmlExpr.test(_.options.prevArrow)) {
          _.$prevArrow.prependTo(_.options.appendArrows);
        }
        if (_.htmlExpr.test(_.options.nextArrow)) {
          _.$nextArrow.appendTo(_.options.appendArrows);
        }
        if (_.options.infinite !== true) {
          _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        }
      } else {
        _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
          'aria-disabled': 'true',
          'tabindex': '-1'
        });
      }
    }
  };
  Slick.prototype.buildDots = function () {
    var _ = this,
      i,
      dot;
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$slider.addClass('slick-dotted');
      dot = $('<ul />').addClass(_.options.dotsClass);
      for (i = 0; i <= _.getDotCount(); i += 1) {
        dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
      }
      _.$dots = dot.appendTo(_.options.appendDots);
      _.$dots.find('li').first().addClass('slick-active');
    }
  };
  Slick.prototype.buildOut = function () {
    var _ = this;
    _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
    _.slideCount = _.$slides.length;
    _.$slides.each(function (index, element) {
      $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
    });
    _.$slider.addClass('slick-slider');
    _.$slideTrack = _.slideCount === 0 ? $('<ul class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<ul class="slick-track"/>').parent();
    _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
    _.$slideTrack.css('opacity', 0);
    if (_.options.centerMode === true || _.options.swipeToSlide === true) {
      _.options.slidesToScroll = 1;
    }
    $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
    _.setupInfinite();
    _.buildArrows();
    _.buildDots();
    _.updateDots();
    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
    if (_.options.draggable === true) {
      _.$list.addClass('draggable');
    }
  };
  Slick.prototype.buildRows = function () {
    var _ = this,
      a,
      b,
      c,
      newSlides,
      numOfSlides,
      originalSlides,
      slidesPerSection;
    newSlides = document.createDocumentFragment();
    originalSlides = _.$slider.children();
    if (_.options.rows > 0) {
      slidesPerSection = _.options.slidesPerRow * _.options.rows;
      numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
      for (a = 0; a < numOfSlides; a++) {
        var slide = document.createElement('li');
        for (b = 0; b < _.options.rows; b++) {
          var row = document.createElement('div');
          for (c = 0; c < _.options.slidesPerRow; c++) {
            var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
            if (originalSlides.get(target)) {
              row.appendChild(originalSlides.get(target));
            }
          }
          slide.appendChild(row);
        }
        newSlides.appendChild(slide);
      }
      _.$slider.empty().append(newSlides);
      _.$slider.children().children().children().css({
        'width': 100 / _.options.slidesPerRow + '%',
        'display': 'inline-block'
      });
    }
  };
  Slick.prototype.checkResponsive = function (initial, forceUpdate) {
    var _ = this,
      breakpoint,
      targetBreakpoint,
      respondToWidth,
      triggerBreakpoint = false;
    var sliderWidth = _.$slider.width();
    var windowWidth = window.innerWidth || $(window).width();
    if (_.respondTo === 'window') {
      respondToWidth = windowWidth;
    } else if (_.respondTo === 'slider') {
      respondToWidth = sliderWidth;
    } else if (_.respondTo === 'min') {
      respondToWidth = Math.min(windowWidth, sliderWidth);
    }
    if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
      targetBreakpoint = null;
      for (breakpoint in _.breakpoints) {
        if (_.breakpoints.hasOwnProperty(breakpoint)) {
          if (_.originalSettings.mobileFirst === false) {
            if (respondToWidth < _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          } else {
            if (respondToWidth > _.breakpoints[breakpoint]) {
              targetBreakpoint = _.breakpoints[breakpoint];
            }
          }
        }
      }
      if (targetBreakpoint !== null) {
        if (_.activeBreakpoint !== null) {
          if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
            _.activeBreakpoint = targetBreakpoint;
            if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
              _.unslick(targetBreakpoint);
            } else {
              _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
              if (initial === true) {
                _.currentSlide = _.options.initialSlide;
              }
              _.refresh(initial);
            }
            triggerBreakpoint = targetBreakpoint;
          }
        } else {
          _.activeBreakpoint = targetBreakpoint;
          if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
            _.unslick(targetBreakpoint);
          } else {
            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
            if (initial === true) {
              _.currentSlide = _.options.initialSlide;
            }
            _.refresh(initial);
          }
          triggerBreakpoint = targetBreakpoint;
        }
      } else {
        if (_.activeBreakpoint !== null) {
          _.activeBreakpoint = null;
          _.options = _.originalSettings;
          if (initial === true) {
            _.currentSlide = _.options.initialSlide;
          }
          _.refresh(initial);
          triggerBreakpoint = targetBreakpoint;
        }
      }

      // only trigger breakpoints during an actual break. not on initialize.
      if (!initial && triggerBreakpoint !== false) {
        _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
      }
    }
  };
  Slick.prototype.changeSlide = function (event, dontAnimate) {
    var _ = this,
      $target = $(event.currentTarget),
      indexOffset,
      slideOffset,
      unevenOffset;

    // If target is a link, prevent default action.
    if ($target.is('a')) {
      event.preventDefault();
    }

    // If target is not the <li> element (ie: a child), find the <li>.
    if (!$target.is('li')) {
      $target = $target.closest('li');
    }
    unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
    switch (event.data.message) {
      case 'previous':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
        }
        break;
      case 'next':
        slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
        if (_.slideCount > _.options.slidesToShow) {
          _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
        }
        break;
      case 'index':
        var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
        _.slideHandler(_.checkNavigable(index), false, dontAnimate);
        $target.children().trigger('focus');
        break;
      default:
        return;
    }
  };
  Slick.prototype.checkNavigable = function (index) {
    var _ = this,
      navigables,
      prevNavigable;
    navigables = _.getNavigableIndexes();
    prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) {
      index = navigables[navigables.length - 1];
    } else {
      for (var n in navigables) {
        if (index < navigables[n]) {
          index = prevNavigable;
          break;
        }
        prevNavigable = navigables[n];
      }
    }
    return index;
  };
  Slick.prototype.cleanUpEvents = function () {
    var _ = this;
    if (_.options.dots && _.$dots !== null) {
      $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
      if (_.options.accessibility === true) {
        _.$dots.off('keydown.slick', _.keyHandler);
      }
    }
    _.$slider.off('focus.slick blur.slick');
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
      _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
      if (_.options.accessibility === true) {
        _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
        _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
      }
    }
    _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
    _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
    _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
    _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
    _.$list.off('click.slick', _.clickHandler);
    $(document).off(_.visibilityChange, _.visibility);
    _.cleanUpSlideEvents();
    if (_.options.accessibility === true) {
      _.$list.off('keydown.slick', _.keyHandler);
    }
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().off('click.slick', _.selectHandler);
    }
    $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
    $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
    $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
    $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
  };
  Slick.prototype.cleanUpSlideEvents = function () {
    var _ = this;
    _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
    _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
  };
  Slick.prototype.cleanUpRows = function () {
    var _ = this,
      originalSlides;
    if (_.options.rows > 1) {
      originalSlides = _.$slides.children().children().clone(true);
      originalSlides.removeAttr('style');
      _.$slider.get(0).innerHTML = '';
      _.$slider.empty().append(originalSlides);
    }
  };
  Slick.prototype.clickHandler = function (event) {
    var _ = this;
    if (_.shouldClick === false) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
    }
  };
  Slick.prototype.destroy = function (refresh) {
    var _ = this;
    _.autoPlayClear();
    _.touchObject = {};
    _.cleanUpEvents();
    $('.slick-cloned', _.$slider).detach();
    if (_.$dots) {
      _.$dots.remove();
    }
    if (_.$prevArrow && _.$prevArrow.length) {
      _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
      if (_.htmlExpr.test(_.options.prevArrow)) {
        _.$prevArrow.remove();
      }
    }
    if (_.$nextArrow && _.$nextArrow.length) {
      _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
      if (_.htmlExpr.test(_.options.nextArrow)) {
        _.$nextArrow.remove();
      }
    }
    if (_.$slides) {
      _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
        $(this).attr('style', $(this).data('originalStyling'));
      });
      _.$slideTrack.children(this.options.slide).detach();
      _.$slideTrack.detach();
      _.$list.detach();
      _.$slider.append(_.$slides);
    }
    _.cleanUpRows();
    _.$slider.removeClass('slick-slider');
    _.$slider.removeClass('slick-initialized');
    _.$slider.removeClass('slick-dotted');
    _.unslicked = true;
    if (!refresh) {
      _.$slider.trigger('destroy', [_]);
    }
  };
  Slick.prototype.disableTransition = function (slide) {
    var _ = this,
      transition = {};
    transition[_.transitionType] = '';
    if (_.options.fade === false) {
      _.$slideTrack.css(transition);
    } else {
      _.$slides.eq(slide).css(transition);
    }
  };
  Slick.prototype.fadeSlide = function (slideIndex, callback) {
    var _ = this;
    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).css({
        zIndex: _.options.zIndex
      });
      _.$slides.eq(slideIndex).animate({
        opacity: 1
      }, _.options.speed, _.options.easing, callback);
    } else {
      _.applyTransition(slideIndex);
      _.$slides.eq(slideIndex).css({
        opacity: 1,
        zIndex: _.options.zIndex
      });
      if (callback) {
        setTimeout(function () {
          _.disableTransition(slideIndex);
          callback.call();
        }, _.options.speed);
      }
    }
  };
  Slick.prototype.fadeSlideOut = function (slideIndex) {
    var _ = this;
    if (_.cssTransitions === false) {
      _.$slides.eq(slideIndex).animate({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      }, _.options.speed, _.options.easing);
    } else {
      _.applyTransition(slideIndex);
      _.$slides.eq(slideIndex).css({
        opacity: 0,
        zIndex: _.options.zIndex - 2
      });
    }
  };
  Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {
    var _ = this;
    if (filter !== null) {
      _.$slidesCache = _.$slides;
      _.unload();
      _.$slideTrack.children(this.options.slide).detach();
      _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
      _.reinit();
    }
  };
  Slick.prototype.focusHandler = function () {
    var _ = this;
    _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function (event) {
      event.stopImmediatePropagation();
      var $sf = $(this);
      setTimeout(function () {
        if (_.options.pauseOnFocus) {
          _.focussed = $sf.is(':focus');
          _.autoPlay();
        }
      }, 0);
    });
  };
  Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {
    var _ = this;
    return _.currentSlide;
  };
  Slick.prototype.getDotCount = function () {
    var _ = this;
    var breakPoint = 0;
    var counter = 0;
    var pagerQty = 0;
    if (_.options.infinite === true) {
      if (_.slideCount <= _.options.slidesToShow) {
        ++pagerQty;
      } else {
        while (breakPoint < _.slideCount) {
          ++pagerQty;
          breakPoint = counter + _.options.slidesToScroll;
          counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
      }
    } else if (_.options.centerMode === true) {
      pagerQty = _.slideCount;
    } else if (!_.options.asNavFor) {
      pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
    } else {
      while (breakPoint < _.slideCount) {
        ++pagerQty;
        breakPoint = counter + _.options.slidesToScroll;
        counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
      }
    }
    return pagerQty - 1;
  };
  Slick.prototype.getLeft = function (slideIndex) {
    var _ = this,
      targetLeft,
      verticalHeight,
      verticalOffset = 0,
      targetSlide,
      coef;
    _.slideOffset = 0;
    verticalHeight = _.$slides.first().outerHeight(true);
    if (_.options.infinite === true) {
      if (_.slideCount > _.options.slidesToShow) {
        _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
        coef = -1;
        if (_.options.vertical === true && _.options.centerMode === true) {
          if (_.options.slidesToShow === 2) {
            coef = -1.5;
          } else if (_.options.slidesToShow === 1) {
            coef = -2;
          }
        }
        verticalOffset = verticalHeight * _.options.slidesToShow * coef;
      }
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
          if (slideIndex > _.slideCount) {
            _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
            verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
          } else {
            _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
            verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
          }
        }
      }
    } else {
      if (slideIndex + _.options.slidesToShow > _.slideCount) {
        _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
        verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
      }
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.slideOffset = 0;
      verticalOffset = 0;
    }
    if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
      _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
    } else if (_.options.centerMode === true && _.options.infinite === true) {
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
    } else if (_.options.centerMode === true) {
      _.slideOffset = 0;
      _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
    }
    if (_.options.vertical === false) {
      targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
    } else {
      targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
    }
    if (_.options.variableWidth === true) {
      if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
      } else {
        targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
      }
      if (_.options.rtl === true) {
        if (targetSlide[0]) {
          targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
        } else {
          targetLeft = 0;
        }
      } else {
        targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
      }
      if (_.options.centerMode === true) {
        if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
        } else {
          targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
        }
        if (_.options.rtl === true) {
          if (targetSlide[0]) {
            targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
          } else {
            targetLeft = 0;
          }
        } else {
          targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
        }
        targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
      }
    }
    return targetLeft;
  };
  Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {
    var _ = this;
    return _.options[option];
  };
  Slick.prototype.getNavigableIndexes = function () {
    var _ = this,
      breakPoint = 0,
      counter = 0,
      indexes = [],
      max;
    if (_.options.infinite === false) {
      max = _.slideCount;
    } else {
      breakPoint = _.options.slidesToScroll * -1;
      counter = _.options.slidesToScroll * -1;
      max = _.slideCount * 2;
    }
    while (breakPoint < max) {
      indexes.push(breakPoint);
      breakPoint = counter + _.options.slidesToScroll;
      counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
    }
    return indexes;
  };
  Slick.prototype.getSlick = function () {
    return this;
  };
  Slick.prototype.getSlideCount = function () {
    var _ = this,
      slidesTraversed,
      swipedSlide,
      centerOffset;
    centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
    if (_.options.swipeToSlide === true) {
      _.$slideTrack.find('.slick-slide').each(function (index, slide) {
        if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      });
      slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
      return slidesTraversed;
    } else {
      return _.options.slidesToScroll;
    }
  };
  Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'index',
        index: parseInt(slide)
      }
    }, dontAnimate);
  };
  Slick.prototype.init = function (creation) {
    var _ = this;
    if (!$(_.$slider).hasClass('slick-initialized')) {
      $(_.$slider).addClass('slick-initialized');
      _.buildRows();
      _.buildOut();
      _.setProps();
      _.startLoad();
      _.loadSlider();
      _.initializeEvents();
      _.updateArrows();
      _.updateDots();
      _.checkResponsive(true);
      _.focusHandler();
    }
    if (creation) {
      _.$slider.trigger('init', [_]);
    }
    if (_.options.accessibility === true) {
      _.initADA();
    }
    if (_.options.autoplay) {
      _.paused = false;
      _.autoPlay();
    }
  };
  Slick.prototype.initADA = function () {
    var _ = this,
      numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
      tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
        return val >= 0 && val < _.slideCount;
      });
    _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
      'aria-hidden': 'true',
      'tabindex': '-1'
    }).find('a, input, button, select').attr({
      'tabindex': '-1'
    });
    if (_.$dots !== null) {
      _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
        var slideControlIndex = tabControlIndexes.indexOf(i);
        $(this).attr({
          'role': 'listitem',
          'id': 'slick-slide' + _.instanceUid + i,
          'tabindex': -1
        });
        if (slideControlIndex !== -1) {
          var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
          if ($('#' + ariaButtonControl).length) {
            $(this).attr({
              'aria-describedby': ariaButtonControl
            });
          }
        }
      });
      _.$dots.attr('role', 'tablist').find('li').each(function (i) {
        var mappedSlideIndex = tabControlIndexes[i];
        $(this).attr({
          'role': 'presentation'
        });
        $(this).find('button').first().attr({
          'role': 'tab',
          'id': 'slick-slide-control' + _.instanceUid + i,
          'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
          'aria-label': i + 1 + ' of ' + numDotGroups,
          'aria-selected': null,
          'tabindex': '-1'
        });
      }).eq(_.currentSlide).find('button').attr({
        'aria-selected': 'true',
        'tabindex': '0'
      }).end();
    }
    for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
      if (_.options.focusOnChange) {
        _.$slides.eq(i).attr({
          'tabindex': '0'
        });
      } else {
        _.$slides.eq(i).removeAttr('tabindex');
      }
    }
    _.activateADA();
  };
  Slick.prototype.initArrowEvents = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.off('click.slick').on('click.slick', {
        message: 'previous'
      }, _.changeSlide);
      _.$nextArrow.off('click.slick').on('click.slick', {
        message: 'next'
      }, _.changeSlide);
      if (_.options.accessibility === true) {
        _.$prevArrow.on('keydown.slick', _.keyHandler);
        _.$nextArrow.on('keydown.slick', _.keyHandler);
      }
    }
  };
  Slick.prototype.initDotEvents = function () {
    var _ = this;
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('click.slick', {
        message: 'index'
      }, _.changeSlide);
      if (_.options.accessibility === true) {
        _.$dots.on('keydown.slick', _.keyHandler);
      }
    }
    if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {
      $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };
  Slick.prototype.initSlideEvents = function () {
    var _ = this;
    if (_.options.pauseOnHover) {
      _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
      _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    }
  };
  Slick.prototype.initializeEvents = function () {
    var _ = this;
    _.initArrowEvents();
    _.initDotEvents();
    _.initSlideEvents();
    _.$list.on('touchstart.slick mousedown.slick', {
      action: 'start'
    }, _.swipeHandler);
    _.$list.on('touchmove.slick mousemove.slick', {
      action: 'move'
    }, _.swipeHandler);
    _.$list.on('touchend.slick mouseup.slick', {
      action: 'end'
    }, _.swipeHandler);
    _.$list.on('touchcancel.slick mouseleave.slick', {
      action: 'end'
    }, _.swipeHandler);
    _.$list.on('click.slick', _.clickHandler);
    $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
    if (_.options.accessibility === true) {
      _.$list.on('keydown.slick', _.keyHandler);
    }
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }
    $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
    $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
    $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
    $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
    $(_.setPosition);
  };
  Slick.prototype.initUI = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.show();
      _.$nextArrow.show();
    }
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.show();
    }
  };
  Slick.prototype.keyHandler = function (event) {
    var _ = this;
    //Dont slide if the cursor is inside the form fields and arrow keys are pressed
    if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
      if (event.keyCode === 37 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'next' : 'previous'
          }
        });
      } else if (event.keyCode === 39 && _.options.accessibility === true) {
        _.changeSlide({
          data: {
            message: _.options.rtl === true ? 'previous' : 'next'
          }
        });
      }
    }
  };
  Slick.prototype.lazyLoad = function () {
    var _ = this,
      loadRange,
      cloneRange,
      rangeStart,
      rangeEnd;
    function loadImages(imagesScope) {
      $('img[data-lazy]', imagesScope).each(function () {
        var image = $(this),
          imageSource = $(this).attr('data-lazy'),
          imageSrcSet = $(this).attr('data-srcset'),
          imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
          imageToLoad = document.createElement('img');
        imageToLoad.onload = function () {
          image.animate({
            opacity: 0
          }, 100, function () {
            if (imageSrcSet) {
              image.attr('srcset', imageSrcSet);
              if (imageSizes) {
                image.attr('sizes', imageSizes);
              }
            }
            image.attr('src', imageSource).animate({
              opacity: 1
            }, 200, function () {
              image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
            });
            _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
          });
        };
        imageToLoad.onerror = function () {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
        };
        if (imageSrcSet) {
          imageToLoad.srcset = imageSrcSet;
        }
        imageToLoad.src = imageSource;
      });
    }
    if (_.options.centerMode === true) {
      if (_.options.infinite === true) {
        rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
        rangeEnd = rangeStart + _.options.slidesToShow + 2;
      } else {
        rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
        rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
      }
    } else {
      rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
      rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
      if (_.options.fade === true) {
        if (rangeStart > 0) rangeStart--;
        if (rangeEnd <= _.slideCount) rangeEnd++;
      }
    }
    loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
    if (_.options.lazyLoad === 'anticipated') {
      var prevSlide = rangeStart - 1,
        nextSlide = rangeEnd,
        $slides = _.$slider.find('.slick-slide');
      for (var i = 0; i < _.options.slidesToScroll; i++) {
        if (prevSlide < 0) prevSlide = _.slideCount - 1;
        loadRange = loadRange.add($slides.eq(prevSlide));
        loadRange = loadRange.add($slides.eq(nextSlide));
        prevSlide--;
        nextSlide++;
      }
    }
    loadImages(loadRange);
    if (_.slideCount <= _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-slide');
      loadImages(cloneRange);
    } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
      cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
      loadImages(cloneRange);
    } else if (_.currentSlide === 0) {
      cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
      loadImages(cloneRange);
    }
  };
  Slick.prototype.loadSlider = function () {
    var _ = this;
    _.setPosition();
    _.$slideTrack.css({
      opacity: 1
    });
    _.$slider.removeClass('slick-loading');
    _.initUI();
    if (_.options.lazyLoad === 'progressive') {
      _.progressiveLazyLoad();
    }
  };
  Slick.prototype.next = Slick.prototype.slickNext = function () {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'next'
      }
    });
  };
  Slick.prototype.orientationChange = function () {
    var _ = this;
    _.checkResponsive();
    _.setPosition();
  };
  Slick.prototype.pause = Slick.prototype.slickPause = function () {
    var _ = this;
    _.autoPlayClear();
    _.paused = true;
  };
  Slick.prototype.play = Slick.prototype.slickPlay = function () {
    var _ = this;
    _.autoPlay();
    _.options.autoplay = true;
    _.paused = false;
    _.focussed = false;
    _.interrupted = false;
  };
  Slick.prototype.postSlide = function (index) {
    var _ = this;
    if (!_.unslicked) {
      _.$slider.trigger('afterChange', [_, index]);
      _.animating = false;
      if (_.slideCount > _.options.slidesToShow) {
        _.setPosition();
      }
      _.swipeLeft = null;
      if (_.options.autoplay) {
        _.autoPlay();
      }
      if (_.options.accessibility === true) {
        _.initADA();
        if (_.options.focusOnChange) {
          var $currentSlide = $(_.$slides.get(_.currentSlide));
          $currentSlide.attr('tabindex', 0).focus();
        }
      }
    }
  };
  Slick.prototype.prev = Slick.prototype.slickPrev = function () {
    var _ = this;
    _.changeSlide({
      data: {
        message: 'previous'
      }
    });
  };
  Slick.prototype.preventDefault = function (event) {
    event.preventDefault();
  };
  Slick.prototype.progressiveLazyLoad = function (tryCount) {
    tryCount = tryCount || 1;
    var _ = this,
      $imgsToLoad = $('img[data-lazy]', _.$slider),
      image,
      imageSource,
      imageSrcSet,
      imageSizes,
      imageToLoad;
    if ($imgsToLoad.length) {
      image = $imgsToLoad.first();
      imageSource = image.attr('data-lazy');
      imageSrcSet = image.attr('data-srcset');
      imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
      imageToLoad = document.createElement('img');
      imageToLoad.onload = function () {
        if (imageSrcSet) {
          image.attr('srcset', imageSrcSet);
          if (imageSizes) {
            image.attr('sizes', imageSizes);
          }
        }
        image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
        if (_.options.adaptiveHeight === true) {
          _.setPosition();
        }
        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
        _.progressiveLazyLoad();
      };
      imageToLoad.onerror = function () {
        if (tryCount < 3) {
          /**
           * try to load the image 3 times,
           * leave a slight delay so we don't get
           * servers blocking the request.
           */
          setTimeout(function () {
            _.progressiveLazyLoad(tryCount + 1);
          }, 500);
        } else {
          image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
          _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
          _.progressiveLazyLoad();
        }
      };
      if (imageSrcSet) {
        imageToLoad.srcset = imageSrcSet;
      }
      imageToLoad.src = imageSource;
    } else {
      _.$slider.trigger('allImagesLoaded', [_]);
    }
  };
  Slick.prototype.refresh = function (initializing) {
    var _ = this,
      currentSlide,
      lastVisibleIndex;
    lastVisibleIndex = _.slideCount - _.options.slidesToShow;

    // in non-infinite sliders, we don't want to go past the
    // last visible index.
    if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
      _.currentSlide = lastVisibleIndex;
    }

    // if less slides than to show, go to start.
    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }
    currentSlide = _.currentSlide;
    _.destroy(true);
    $.extend(_, _.initials, {
      currentSlide: currentSlide
    });
    _.init();
    if (!initializing) {
      _.changeSlide({
        data: {
          message: 'index',
          index: currentSlide
        }
      }, false);
    }
  };
  Slick.prototype.registerBreakpoints = function () {
    var _ = this,
      breakpoint,
      currentBreakpoint,
      l,
      responsiveSettings = _.options.responsive || null;
    if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
      _.respondTo = _.options.respondTo || 'window';
      for (breakpoint in responsiveSettings) {
        l = _.breakpoints.length - 1;
        if (responsiveSettings.hasOwnProperty(breakpoint)) {
          currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

          // loop through the breakpoints and cut out any existing
          // ones with the same breakpoint number, we don't want dupes.
          while (l >= 0) {
            if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
              _.breakpoints.splice(l, 1);
            }
            l--;
          }
          _.breakpoints.push(currentBreakpoint);
          _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
        }
      }
      _.breakpoints.sort(function (a, b) {
        return _.options.mobileFirst ? a - b : b - a;
      });
    }
  };
  Slick.prototype.reinit = function () {
    var _ = this;
    _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
    _.slideCount = _.$slides.length;
    if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
      _.currentSlide = _.currentSlide - _.options.slidesToScroll;
    }
    if (_.slideCount <= _.options.slidesToShow) {
      _.currentSlide = 0;
    }
    _.registerBreakpoints();
    _.setProps();
    _.setupInfinite();
    _.buildArrows();
    _.updateArrows();
    _.initArrowEvents();
    _.buildDots();
    _.updateDots();
    _.initDotEvents();
    _.cleanUpSlideEvents();
    _.initSlideEvents();
    _.checkResponsive(false, true);
    if (_.options.focusOnSelect === true) {
      $(_.$slideTrack).children().on('click.slick', _.selectHandler);
    }
    _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
    _.setPosition();
    _.focusHandler();
    _.paused = !_.options.autoplay;
    _.autoPlay();
    _.$slider.trigger('reInit', [_]);
  };
  Slick.prototype.resize = function () {
    var _ = this;
    if ($(window).width() !== _.windowWidth) {
      clearTimeout(_.windowDelay);
      _.windowDelay = window.setTimeout(function () {
        _.windowWidth = $(window).width();
        _.checkResponsive();
        if (!_.unslicked) {
          _.setPosition();
        }
      }, 50);
    }
  };
  Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {
    var _ = this;
    if (typeof index === 'boolean') {
      removeBefore = index;
      index = removeBefore === true ? 0 : _.slideCount - 1;
    } else {
      index = removeBefore === true ? --index : index;
    }
    if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
      return false;
    }
    _.unload();
    if (removeAll === true) {
      _.$slideTrack.children().remove();
    } else {
      _.$slideTrack.children(this.options.slide).eq(index).remove();
    }
    _.$slides = _.$slideTrack.children(this.options.slide);
    _.$slideTrack.children(this.options.slide).detach();
    _.$slideTrack.append(_.$slides);
    _.$slidesCache = _.$slides;
    _.reinit();
  };
  Slick.prototype.setCSS = function (position) {
    var _ = this,
      positionProps = {},
      x,
      y;
    if (_.options.rtl === true) {
      position = -position;
    }
    x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
    y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
    positionProps[_.positionProp] = position;
    if (_.transformsEnabled === false) {
      _.$slideTrack.css(positionProps);
    } else {
      positionProps = {};
      if (_.cssTransitions === false) {
        positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
        _.$slideTrack.css(positionProps);
      } else {
        positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
        _.$slideTrack.css(positionProps);
      }
    }
  };
  Slick.prototype.setDimensions = function () {
    var _ = this;
    if (_.options.vertical === false) {
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: '0px ' + _.options.centerPadding
        });
      }
    } else {
      _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
      if (_.options.centerMode === true) {
        _.$list.css({
          padding: _.options.centerPadding + ' 0px'
        });
      }
    }
    _.listWidth = _.$list.width();
    _.listHeight = _.$list.height();
    if (_.options.vertical === false && _.options.variableWidth === false) {
      _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
      _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
    } else if (_.options.variableWidth === true) {
      _.$slideTrack.width(5000 * _.slideCount);
    } else {
      _.slideWidth = Math.ceil(_.listWidth);
      _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
    }
    var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
    if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
  };
  Slick.prototype.setFade = function () {
    var _ = this,
      targetLeft;
    _.$slides.each(function (index, element) {
      targetLeft = _.slideWidth * index * -1;
      if (_.options.rtl === true) {
        $(element).css({
          position: 'relative',
          right: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      } else {
        $(element).css({
          position: 'relative',
          left: targetLeft,
          top: 0,
          zIndex: _.options.zIndex - 2,
          opacity: 0
        });
      }
    });
    _.$slides.eq(_.currentSlide).css({
      zIndex: _.options.zIndex - 1,
      opacity: 1
    });
  };
  Slick.prototype.setHeight = function () {
    var _ = this;
    if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
      var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
      _.$list.css('height', targetHeight);
    }
  };
  Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {
    /**
     * accepts arguments in format of:
     *
     *  - for changing a single option's value:
     *     .slick("setOption", option, value, refresh )
     *
     *  - for changing a set of responsive options:
     *     .slick("setOption", 'responsive', [{}, ...], refresh )
     *
     *  - for updating multiple values at once (not responsive)
     *     .slick("setOption", { 'option': value, ... }, refresh )
     */

    var _ = this,
      l,
      item,
      option,
      value,
      refresh = false,
      type;
    if ($.type(arguments[0]) === 'object') {
      option = arguments[0];
      refresh = arguments[1];
      type = 'multiple';
    } else if ($.type(arguments[0]) === 'string') {
      option = arguments[0];
      value = arguments[1];
      refresh = arguments[2];
      if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {
        type = 'responsive';
      } else if (typeof arguments[1] !== 'undefined') {
        type = 'single';
      }
    }
    if (type === 'single') {
      _.options[option] = value;
    } else if (type === 'multiple') {
      $.each(option, function (opt, val) {
        _.options[opt] = val;
      });
    } else if (type === 'responsive') {
      for (item in value) {
        if ($.type(_.options.responsive) !== 'array') {
          _.options.responsive = [value[item]];
        } else {
          l = _.options.responsive.length - 1;

          // loop through the responsive object and splice out duplicates.
          while (l >= 0) {
            if (_.options.responsive[l].breakpoint === value[item].breakpoint) {
              _.options.responsive.splice(l, 1);
            }
            l--;
          }
          _.options.responsive.push(value[item]);
        }
      }
    }
    if (refresh) {
      _.unload();
      _.reinit();
    }
  };
  Slick.prototype.setPosition = function () {
    var _ = this;
    _.setDimensions();
    _.setHeight();
    if (_.options.fade === false) {
      _.setCSS(_.getLeft(_.currentSlide));
    } else {
      _.setFade();
    }
    _.$slider.trigger('setPosition', [_]);
  };
  Slick.prototype.setProps = function () {
    var _ = this,
      bodyStyle = document.body.style;
    _.positionProp = _.options.vertical === true ? 'top' : 'left';
    if (_.positionProp === 'top') {
      _.$slider.addClass('slick-vertical');
    } else {
      _.$slider.removeClass('slick-vertical');
    }
    if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
      if (_.options.useCSS === true) {
        _.cssTransitions = true;
      }
    }
    if (_.options.fade) {
      if (typeof _.options.zIndex === 'number') {
        if (_.options.zIndex < 3) {
          _.options.zIndex = 3;
        }
      } else {
        _.options.zIndex = _.defaults.zIndex;
      }
    }
    if (bodyStyle.OTransform !== undefined) {
      _.animType = 'OTransform';
      _.transformType = '-o-transform';
      _.transitionType = 'OTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.MozTransform !== undefined) {
      _.animType = 'MozTransform';
      _.transformType = '-moz-transform';
      _.transitionType = 'MozTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.webkitTransform !== undefined) {
      _.animType = 'webkitTransform';
      _.transformType = '-webkit-transform';
      _.transitionType = 'webkitTransition';
      if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
    }
    if (bodyStyle.msTransform !== undefined) {
      _.animType = 'msTransform';
      _.transformType = '-ms-transform';
      _.transitionType = 'msTransition';
      if (bodyStyle.msTransform === undefined) _.animType = false;
    }
    if (bodyStyle.transform !== undefined && _.animType !== false) {
      _.animType = 'transform';
      _.transformType = 'transform';
      _.transitionType = 'transition';
    }
    _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
  };
  Slick.prototype.setSlideClasses = function (index) {
    var _ = this,
      centerOffset,
      allSlides,
      indexOffset,
      remainder;
    allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
    _.$slides.eq(index).addClass('slick-current');
    if (_.options.centerMode === true) {
      var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
      centerOffset = Math.floor(_.options.slidesToShow / 2);
      if (_.options.infinite === true) {
        if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
          _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          indexOffset = _.options.slidesToShow + index;
          allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
        }
        if (index === 0) {
          allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
        } else if (index === _.slideCount - 1) {
          allSlides.eq(_.options.slidesToShow).addClass('slick-center');
        }
      }
      _.$slides.eq(index).addClass('slick-center');
    } else {
      if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {
        _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
      } else if (allSlides.length <= _.options.slidesToShow) {
        allSlides.addClass('slick-active').attr('aria-hidden', 'false');
      } else {
        remainder = _.slideCount % _.options.slidesToShow;
        indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
        if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {
          allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
        } else {
          allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
        }
      }
    }
    if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
      _.lazyLoad();
    }
  };
  Slick.prototype.setupInfinite = function () {
    var _ = this,
      i,
      slideIndex,
      infiniteCount;
    if (_.options.fade === true) {
      _.options.centerMode = false;
    }
    if (_.options.infinite === true && _.options.fade === false) {
      slideIndex = null;
      if (_.slideCount > _.options.slidesToShow) {
        if (_.options.centerMode === true) {
          infiniteCount = _.options.slidesToShow + 1;
        } else {
          infiniteCount = _.options.slidesToShow;
        }
        for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
          slideIndex = i - 1;
          $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
        }
        for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
          slideIndex = i;
          $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
        }
        _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
          $(this).attr('id', '');
        });
      }
    }
  };
  Slick.prototype.interrupt = function (toggle) {
    var _ = this;
    if (!toggle) {
      _.autoPlay();
    }
    _.interrupted = toggle;
  };
  Slick.prototype.selectHandler = function (event) {
    var _ = this;
    var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
    var index = parseInt(targetElement.attr('data-slick-index'));
    if (!index) index = 0;
    if (_.slideCount <= _.options.slidesToShow) {
      _.slideHandler(index, false, true);
      return;
    }
    _.slideHandler(index);
  };
  Slick.prototype.slideHandler = function (index, sync, dontAnimate) {
    var targetSlide,
      animSlide,
      oldSlide,
      slideLeft,
      targetLeft = null,
      _ = this,
      navTarget;
    sync = sync || false;
    if (_.animating === true && _.options.waitForAnimate === true) {
      return;
    }
    if (_.options.fade === true && _.currentSlide === index) {
      return;
    }
    if (sync === false) {
      _.asNavFor(index);
    }
    targetSlide = index;
    targetLeft = _.getLeft(targetSlide);
    slideLeft = _.getLeft(_.currentSlide);
    _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
    if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
      if (_.options.fade === false) {
        targetSlide = _.currentSlide;
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
          _.animateSlide(slideLeft, function () {
            _.postSlide(targetSlide);
          });
        } else {
          _.postSlide(targetSlide);
        }
      }
      return;
    }
    if (_.options.autoplay) {
      clearInterval(_.autoPlayTimer);
    }
    if (targetSlide < 0) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
      } else {
        animSlide = _.slideCount + targetSlide;
      }
    } else if (targetSlide >= _.slideCount) {
      if (_.slideCount % _.options.slidesToScroll !== 0) {
        animSlide = 0;
      } else {
        animSlide = targetSlide - _.slideCount;
      }
    } else {
      animSlide = targetSlide;
    }
    _.animating = true;
    _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);
    oldSlide = _.currentSlide;
    _.currentSlide = animSlide;
    _.setSlideClasses(_.currentSlide);
    if (_.options.asNavFor) {
      navTarget = _.getNavTarget();
      navTarget = navTarget.slick('getSlick');
      if (navTarget.slideCount <= navTarget.options.slidesToShow) {
        navTarget.setSlideClasses(_.currentSlide);
      }
    }
    _.updateDots();
    _.updateArrows();
    if (_.options.fade === true) {
      if (dontAnimate !== true) {
        _.fadeSlideOut(oldSlide);
        _.fadeSlide(animSlide, function () {
          _.postSlide(animSlide);
        });
      } else {
        _.postSlide(animSlide);
      }
      _.animateHeight();
      return;
    }
    if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
      _.animateSlide(targetLeft, function () {
        _.postSlide(animSlide);
      });
    } else {
      _.postSlide(animSlide);
    }
  };
  Slick.prototype.startLoad = function () {
    var _ = this;
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
      _.$prevArrow.hide();
      _.$nextArrow.hide();
    }
    if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
      _.$dots.hide();
    }
    _.$slider.addClass('slick-loading');
  };
  Slick.prototype.swipeDirection = function () {
    var xDist,
      yDist,
      r,
      swipeAngle,
      _ = this;
    xDist = _.touchObject.startX - _.touchObject.curX;
    yDist = _.touchObject.startY - _.touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) {
      swipeAngle = 360 - Math.abs(swipeAngle);
    }
    if (swipeAngle <= 45 && swipeAngle >= 0) {
      return _.options.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle <= 360 && swipeAngle >= 315) {
      return _.options.rtl === false ? 'left' : 'right';
    }
    if (swipeAngle >= 135 && swipeAngle <= 225) {
      return _.options.rtl === false ? 'right' : 'left';
    }
    if (_.options.verticalSwiping === true) {
      if (swipeAngle >= 35 && swipeAngle <= 135) {
        return 'down';
      } else {
        return 'up';
      }
    }
    return 'vertical';
  };
  Slick.prototype.swipeEnd = function (event) {
    var _ = this,
      slideCount,
      direction;
    _.dragging = false;
    _.swiping = false;
    if (_.scrolling) {
      _.scrolling = false;
      return false;
    }
    _.interrupted = false;
    _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
    if (_.touchObject.curX === undefined) {
      return false;
    }
    if (_.touchObject.edgeHit === true) {
      _.$slider.trigger('edge', [_, _.swipeDirection()]);
    }
    if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
      direction = _.swipeDirection();
      switch (direction) {
        case 'left':
        case 'down':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
          _.currentDirection = 0;
          break;
        case 'right':
        case 'up':
          slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
          _.currentDirection = 1;
          break;
        default:
      }
      if (direction != 'vertical') {
        _.slideHandler(slideCount);
        _.touchObject = {};
        _.$slider.trigger('swipe', [_, direction]);
      }
    } else {
      if (_.touchObject.startX !== _.touchObject.curX) {
        _.slideHandler(_.currentSlide);
        _.touchObject = {};
      }
    }
  };
  Slick.prototype.swipeHandler = function (event) {
    var _ = this;
    if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
      return;
    } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
      return;
    }
    _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
    _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
    if (_.options.verticalSwiping === true) {
      _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
    }
    switch (event.data.action) {
      case 'start':
        _.swipeStart(event);
        break;
      case 'move':
        _.swipeMove(event);
        break;
      case 'end':
        _.swipeEnd(event);
        break;
    }
  };
  Slick.prototype.swipeMove = function (event) {
    var _ = this,
      edgeWasHit = false,
      curLeft,
      swipeDirection,
      swipeLength,
      positionOffset,
      touches,
      verticalSwipeLength;
    touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
    if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
      return false;
    }
    curLeft = _.getLeft(_.currentSlide);
    _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
    _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
    _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
    verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
    if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
      _.scrolling = true;
      return false;
    }
    if (_.options.verticalSwiping === true) {
      _.touchObject.swipeLength = verticalSwipeLength;
    }
    swipeDirection = _.swipeDirection();
    if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
      _.swiping = true;
      event.preventDefault();
    }
    positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
    if (_.options.verticalSwiping === true) {
      positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
    }
    swipeLength = _.touchObject.swipeLength;
    _.touchObject.edgeHit = false;
    if (_.options.infinite === false) {
      if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
        swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
        _.touchObject.edgeHit = true;
      }
    }
    if (_.options.vertical === false) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    } else {
      _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
    }
    if (_.options.verticalSwiping === true) {
      _.swipeLeft = curLeft + swipeLength * positionOffset;
    }
    if (_.options.fade === true || _.options.touchMove === false) {
      return false;
    }
    if (_.animating === true) {
      _.swipeLeft = null;
      return false;
    }
    _.setCSS(_.swipeLeft);
  };
  Slick.prototype.swipeStart = function (event) {
    var _ = this,
      touches;
    _.interrupted = true;
    if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
      _.touchObject = {};
      return false;
    }
    if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
      touches = event.originalEvent.touches[0];
    }
    _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
    _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
    _.dragging = true;
  };
  Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {
    var _ = this;
    if (_.$slidesCache !== null) {
      _.unload();
      _.$slideTrack.children(this.options.slide).detach();
      _.$slidesCache.appendTo(_.$slideTrack);
      _.reinit();
    }
  };
  Slick.prototype.unload = function () {
    var _ = this;
    $('.slick-cloned', _.$slider).remove();
    if (_.$dots) {
      _.$dots.remove();
    }
    if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
      _.$prevArrow.remove();
    }
    if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
      _.$nextArrow.remove();
    }
    _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
  };
  Slick.prototype.unslick = function (fromBreakpoint) {
    var _ = this;
    _.$slider.trigger('unslick', [_, fromBreakpoint]);
    _.destroy();
  };
  Slick.prototype.updateArrows = function () {
    var _ = this,
      centerOffset;
    centerOffset = Math.floor(_.options.slidesToShow / 2);
    if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
      _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      if (_.currentSlide === 0) {
        _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
        _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
        _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
      }
    }
  };
  Slick.prototype.updateDots = function () {
    var _ = this;
    if (_.$dots !== null) {
      _.$dots.find('li').removeClass('slick-active').end();
      _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
    }
  };
  Slick.prototype.visibility = function () {
    var _ = this;
    if (_.options.autoplay) {
      if (document[_.hidden]) {
        _.interrupted = true;
      } else {
        _.interrupted = false;
      }
    }
  };
  $.fn.slick = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (_typeof(opt) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  };
});

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(4);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(150),
    baseAssignValue = __webpack_require__(151);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DOT_CLASS */
/* harmony export (immutable) */ __webpack_exports__["a"] = customPaging;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/**
 * Defines the className of the dot button
 * @type {string}
 */
var DOT_CLASS = 'image-carousel__dot-button';

/**
 * Allows us to customize the "dot buttons"
 * @param {jQuery} $slides - slick slides (from slick)
 * @param {number} i - iterator, used to select current slide from $slides
 * @see DEFAULT_OPTIONS
 * @return {jQuery} "dot button"
 */
function customPaging(slickInstance, i) {
  var showAsNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // Check if the pagination should be shown as "1 of 5" or as dots
  var $slides = slickInstance.$slides;
  var total_images = $slides.length;
  var totalDots = slickInstance.getDotCount();
  var currentPage = i + 1;
  if (showAsNumber) {
    // Show "1 of X" in a <p> tag if showAsNumber is true
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("\n      <p class=\"carousel__dot-text\">\n        <span class=\"u-screen-reader\">Page ".concat(currentPage, " of ").concat(totalDots + 1, "</span>\n        ").concat(currentPage, " of ").concat(totalDots + 1, "\n      </p>\n    "));
  } else {
    // Default to button if showAsNumber is false
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("\n      <button class=\"".concat(DOT_CLASS, "\" data-role=\"none\">\n        <span class=\"u-screen-reader\">Showing <span class=\"slide-image-count\"></span> images, page ").concat(currentPage, " of <span class=\"slides-to-show\">").concat(total_images, "</span><span class=\"image-carousel__dots-active-text\">, currently selected</span></span>\n      </button>\n    "));
  }
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!function(a,b,c,d){function e(){for(var a=m[p.value].on,b=a.length,c=m[p.value].off,d=c.length,e=0;e<b;e++)n[a[e]].active||(n[a[e]].fn(),n[a[e]].active=!0);for(var e=0;e<d;e++)n[c[e]].active=!1}function f(c,d){return a.getComputedStyle(b.querySelector(c),":"+d).getPropertyValue("content").replace(/\"/g,"").replace(/\'/g,"")}function g(a){l++,n[l]={},n[l].fn=a,n[l].active=!1}function h(a,b){if(Array.prototype.indexOf)return a.indexOf(b);for(var c=0,d=a.length;c<d;c++)if(b===a[c])return c}function i(a,b,c){for(var d=h(o,a),f=h(o,c),g=0;g<o.length;g++)g==d&&"at"==b||g<=d&&"below"==b||g>=d&&"above"==b||d<=g&&g<=f&&"between"==b?m[o[g]].on.push(l):m[o[g]].off.push(l);e()}function j(){for(var a=o.length,b=0;b<a;b++)m[o[b]]={},m[o[b]].on=[],m[o[b]].off=[]}function k(a,b,c,d){g(a),i(b,c,d)}var l=0,m={},n={},o=[],p={below:function(a,b){k(b,a,"below")},above:function(a,b){k(b,a,"above")},between:function(a,b,c){k(c,a,"between",b)},at:function(a,b){k(b,a,"at")},initIE8:function(b,c){a.getComputedStyle||(o=b,j(),p.value=c)},init:function(){o=f("html","before").split(","),j(),p.value=f("body","before"),a.onresize=function(){p.value!==f("body","before")&&(p.value=f("body","before"),e())}}};b.body?a.getComputedStyle&&p.init():"function"==typeof jQuery?jQuery(function(){a.getComputedStyle&&p.init()}):b.addEventListener("DOMContentLoaded",function(b){a.getComputedStyle&&p.init()}),(void 0!==a?a:"undefined"!=typeof self?self:{}).breaky=p, true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return p}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?module.exports=p:a[c]=p}(window,document,"breaky");

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logEngagement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logEngagementWithDetails; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/**
 *
 * @param url
 * @param module
 * @param action
 * @param params - appends key-value pairs to URL as query parameters for tracking purposes.
 */
var logEngagement = function logEngagement(url, module, action, params) {
  if (params) {
    url += (url.indexOf('?') >= 0 ? '&' : '?') + __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param(params);
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      url: url,
      module: module,
      action: action
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
};

/**
 * Logs engagement to engagement_tracking with details column data
 * @param url - string
 * @param module - string
 * @param action - string
 * @param details - string
 */
var logEngagementWithDetails = function logEngagementWithDetails(url, module, action, details) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      url: url,
      module: module,
      action: action,
      details: details
    }),
    url: '/r/ajax/LogEngagement.jsp'
  });
};

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var initInfluencerShareLink = function () {
  function openInfluenceShareModal(data) {
    var json = parseRtn(data);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: '/r/dialog/InfluencerShare.jsp?product=' + influencerShareLink.singleProduct + '&surl=' + encodeURIComponent(json.surl) + '&wurl=' + encodeURIComponent(json.wurl),
      triggerOpen: true,
      type: 'small',
      returnFocus: '#rShareLinkButton'
    });
  }
  var ambassadorActiveCopyLink = false;
  var influencerShareLink = window.rcProps.influencerShareLink;
  function copyToClipboardIS() {
    if (ambassadorActiveCopyLink) {
      return;
    }
    ambassadorActiveCopyLink = true;
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#bShareLinkURL").val() === '') {
      var callURL = influencerShareLink.endpoint + '?l=' + encodeURIComponent(window.location.href);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        type: 'GET',
        data: {
          shareProducts: influencerShareLink.shareProducts
        },
        url: callURL,
        async: false,
        success: function success(data) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#bShareLinkURL").val(data.toString());
          openInfluenceShareModal(data.toString());
        }
      });
    } else {
      var newval = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#bShareLinkURL").val();
      openInfluenceShareModal(newval);
    }
    ambassadorActiveCopyLink = false;
  }
  return function () {
    window.copyToClipboardIS = copyToClipboardIS;
  };
}();
/* harmony default export */ __webpack_exports__["a"] = (initInfluencerShareLink);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return revieveTryOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return revieveAddToBag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(2);


var DEFAULTS = {};
var CONTAINER_CLASS = '.js-revieve-container';
var BUTTON_CLASS = '.js-revieve-try-on';
var revieveTryOn = function revieveTryOn(options) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(BUTTON_CLASS);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  if ($el.length) {
    window.activateRevieveFullLook(function () {
      try {
        if (opts.isPlp) {
          if (opts.checkAvailability) {
            var codes = [];
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('li.js-plp-container').each(function (index, element) {
              var $element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
              $element.attr('data-loader', 'tryOnLoader');
            });
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()('li.js-plp-container').Lazy({
              tryOnLoader: function tryOnLoader(element, response) {
                var $element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
                var code = $element.attr('id');
                Revieve.API.liveAR.isTryOnAvailable({
                  product_id: code
                }, function (available) {
                  if (available) {
                    $element.find(CONTAINER_CLASS).removeClass('u-hide');
                    codes.push(code);
                  }
                });
              }
            });
            Revieve.API.liveAR.loadTryOnProducts(codes);
          }
        } else {
          Revieve.API.liveAR.isTryOnAvailable({
            product_id: opts.code
          }, function (available) {
            if (available) {
              __WEBPACK_IMPORTED_MODULE_0_jquery___default()(CONTAINER_CLASS).removeAttr('style');
            }
          });
        }
      } catch (ignored) {}
      setEventListeners($el);
    });
  }
};
var revieveAddToBag = function revieveAddToBag() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('revieveAddToBag', function (e, data) {
    data.products.forEach(function (product) {
      addProductWithData({
        productCode: product.id,
        size: 'all',
        sectionURL: data.sectionUrl,
        csrfHash: data.csrfHash,
        useReferrer: true,
        isPopup: false,
        hotlistQuickView: false,
        count: 1,
        closeWindowAfterAddingToCart: true,
        src: 'revieve_atc'
      });
      if (typeof insertFacebookAddToCart === 'function') {
        insertFacebookAddToCart(null, product.id, product.price, 'all');
      }
      if (typeof addToCartReddit === 'function') {
        var cartItems = [{
          productCode: product.id,
          productName: product.name,
          productCategory: 'Beauty'
        }];
        addToCartReddit(cartItems, product.price, product.id, product.name, product.category);
      }
      if (typeof spanglePixelAddToCart === 'function') {
        spanglePixelAddToCart(product.id, product.price, 1);
      }
    });
  });
};
function setEventListeners($el) {
  $el.on('click', function (e) {
    e.preventDefault();
    var productCode = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target).data('code');
    if (window.rcProps.activeRevievePlugin === 'FULL_LOOK') {
      openPlugin(productCode);
    } else {
      window.activateRevieveFullLook(function () {
        openPlugin(productCode);
      });
    }
  });
}
function openPlugin(code) {
  Revieve.API.liveAR.addTryOnProduct(code);
  Revieve.API.show();
  // VTO stands for Virtual Try On
  logEngagement(window.location.href, 'VTO', 'Open');
}

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return renderPdpSocialProof; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return renderPlpSocialProof; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return renderCartSocialProof; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var DEFAULT_ANIMATE_PARAMS = {
  outCss: {
    opacity: 0
  },
  inCss: {
    opacity: 1
  },
  fade: 750,
  hold: 1500,
  keep: true
};
var PageType = Object.freeze({
  PDP: {
    name: 'PDP',
    getContainer: function getContainer(code) {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-info .sp-wrapper');
    },
    animateParams: {
      keep: false
    }
  },
  PLP: {
    name: 'PLP',
    getContainer: function getContainer(code) {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#".concat(code, " .sp-wrapper"));
    }
  },
  CART: {
    name: 'CART',
    getContainer: function getContainer(code) {
      return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("tr[data-code='".concat(code, "'] .sp-wrapper"));
    }
  }
});
function render(pageType, codes) {
  var urlParams = new URLSearchParams(window.location.search);
  var forceParam = window.rcProps.socialProof.forceParam;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: "".concat(window.rcProps.socialProof.href, "?").concat(forceParam, "=").concat(urlParams.get(forceParam) || ''),
    method: 'POST',
    data: JSON.stringify({
      type: pageType.name,
      codes: Array.isArray(codes) ? codes : [codes]
    }),
    dataType: 'json',
    contentType: 'application/json'
  }).done(function (result) {
    var animateParams = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(DEFAULT_ANIMATE_PARAMS, pageType.animateParams);
    result.forEach(function (socialProof) {
      if (socialProof.productCode) {
        var promise = Promise.resolve();
        var _loop = function _loop() {
          var message = socialProof.messages[i];
          var $container = pageType.getContainer(socialProof.productCode).first();
          if ($container.length) {
            promise = promise.then(function () {
              return new Promise(function (resolve) {
                var $message = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(message.message).css(animateParams.outCss);
                var containerHtml = $container.html().trim();
                if (containerHtml.length === 0) {
                  $container.append($message.animate(animateParams.inCss, animateParams.fade, function () {
                    if (!animateParams.keep) {
                      setTimeout(function () {
                        $message.css(animateParams.outCss);
                        setTimeout(function () {
                          $container.empty();
                          resolve();
                        }, animateParams.fade);
                      }, animateParams.hold);
                    }
                  }));
                }
              });
            });
          }
        };
        for (var i = 0; i < socialProof.messages.length; i++) {
          _loop();
        }
      }
    });
  }).fail(function (error) {
    console.error(error);
  });
}
var renderPdpSocialProof = function renderPdpSocialProof(codes) {
  return render(PageType.PDP, codes);
};
var renderPlpSocialProof = function renderPlpSocialProof(codes) {
  return render(PageType.PLP, codes);
};
var renderCartSocialProof = function renderCartSocialProof(codes) {
  return render(PageType.CART, codes);
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(11);

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(14);
var IE8_DOM_DEFINE = __webpack_require__(125);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(138);
var anObject = __webpack_require__(41);
var toPropertyKey = __webpack_require__(135);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(57);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(187),
    isLength = __webpack_require__(95);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(424);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addToBagWithData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var addToBagWithData = function addToBagWithData(data, callback) {
  if (!data) {
    return;
  }
  var rcProps = window.rcProps || {};
  if (!data.sectionURL) {
    data.sectionURL = rcProps.sectionUrl;
  }
  if (!data.csrfHash) {
    data.csrfHash = rcProps.csrfHash;
  }
  if (!data.d) {
    data.d = rcProps.department;
  }
  if (!data.contextReferrer) {
    data.contextReferrer = document.referrer;
  }
  data.successCallback = callback;
  addProductWithData(data);
  var pdpData = rcProps.pdp || {};
  if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.isEmptyObject(pdpData)) {
    var googleRemarketing = rcProps.googleRemarketing || {};
    var fitPredictor = rcProps.fitPredictor || {};
    if (typeof insertFacebookAddToCart === 'function') {
      insertFacebookAddToCart(null, data.productCode, pdpData.retailPrice, data.size);
    }
    if (typeof addToCartReddit === 'function') {
      var cartItems = new Array();
      {
        var cartItem = {};
        cartItem.productCode = data.productCode;
        cartItem.productName = pdpData.productName;
        cartItem.productCategory = pdpData.categoryName;
        cartItems.push(cartItem);
      }
      addToCartReddit(cartItems, pdpData.retailPrice, data.productCode, pdpData.productName, pdpData.categoryName);
    }
    if (typeof spanglePixelAddToCart === 'function') {
      spanglePixelAddToCart(data.productCode, pdpData.retailPrice, 1);
    }
    if (googleRemarketing.isAllowed) {
      try {
        // Google Remarketing Script add to bag start
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.getScript("//www.googleadservices.com/pagead/conversion_async.js", function () {
          if (typeof window.google_trackConversion === 'function') {
            window.google_trackConversion({
              google_conversion_id: googleRemarketing.conversionId,
              google_custom_params: {
                ecomm_pagetype: 'cart',
                prodid: googleRemarketing.cartString,
                ecomm_totalvalue: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#addtobagbutton').data('totalCart'),
                google_crm_id: googleRemarketing.crmId,
                purchaser: googleRemarketing.purchaser,
                orders: googleRemarketing.orderTotal
              },
              google_conversion_label: 'bP-DCMus-AIQ-fuh_wM',
              google_remarketing_only: true
            });
          }
        });
        // Google Remarketing Script add to bag end
      } catch (googleRemarketingBagException) {
        console.log('Google remarketing bag exception' + googleRemarketingBagException);
      }
    }
    if (fitPredictor.show) {
      // fit predictor
      ssp('track', 'addVariantToCart', {
        variantId: pdpData.code,
        productId: fitPredictor.code,
        quantity: 1
      });
    }
  }
};

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENTS; });
/* unused harmony export EVENT_NS */
/* unused harmony export VALIDATE_TRIGGER */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_partial__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_partial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_partial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_error_scroller__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validate_missing__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validate_same_as__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__validate_email__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validator_constants__ = __webpack_require__(62);
/* unused harmony reexport DEFAULT_MESSAGE */
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for performing form validation via the Constraint Validation API.
 * It provides both custom data attributes as well leverage any fields in a
 * given area (form or any container with elements) that are seen as invalid.
 * @module elements/fields/validator
 */












var PLUGIN_NAME = 'validator';
var placeholder = __WEBPACK_IMPORTED_MODULE_2_lodash_partial___default.a.placeholder;

/**
 * Defines default options for a validator.
 * @type {Object}
 */
var VALIDATOR_OPTIONS = {
  /**
   * Allows for a form to be validated only upon submission.
   */
  validateOnlyOnSubmit: false,
  /**
   * Called when a submission is valid
   * @param {Array} validElements - An array of valid HTML elements
   */
  successCallback: function successCallback(validElements) {
    return validElements;
  },
  /**
   * Called when a submission was unsuccessful
   * @param {Array} invalidElements - An array of invalid HTML elements
   */
  errorCallback: function errorCallback(invalidElements) {
    return invalidElements;
  },
  /**
   * Provides baseline implementation of where/how the page should scroll to
   * when an error has been found.
   * @param {number} x - The x coordinate to scroll to
   * @param {number} y - The y coordinate to scroll to
   */
  scrollTrigger: function scrollTrigger(x, y) {
    return window.scrollTo(x, y);
  },
  /**
   * Allows for custom scrolling when an error occurs.
   */
  useCustomFormErrorScroll: __WEBPACK_IMPORTED_MODULE_4__form_error_scroller__["a" /* default */]
};

/**
 * Defines all validator related events.
 * @type {Object}
 */
var EVENTS = {
  INVALID_SCROLL_POSITION: 'validator:invalid-scroll-position',
  VALIDATOR_SUBMIT: 'validator:submit',
  VALIDATOR_SUCCESS: 'validator:success',
  VALIDATOR_ERROR: 'validator:error',
  VALIDATOR_POST_SUCCESS: 'validator:post-success',
  VALIDATOR_POST_ERROR: 'validator:post-error'
};
var EVENT_NS = 'validator';

/**
 * Defines the data attribute for triggering an element.
 * @type {string}
 */
var VALIDATE_TRIGGER = 'data-validate-trigger';

/**
 * Defines a number of custom data attributes used for validating.
 * @private
 * @type {Object}
 */
var validators = {
  /**
   * Ensures that an element is not empty. This is different from a required
   * attribute as the validation occurs on submit by the validator verses
   * natively in the browser.
   *
   * @example
   * <form>
   *   <input type="text" data-validate-not-empty="true" />
   *   <button>Submit</button>
   * </form>
   *
   * @param {jQuery} $el - Elements checked to be not empty
   * @returns {string} Value used for setting custom validity
   */
  validateNotEmpty: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__validate_missing__["a" /* makeValidateMissing */])('validateNotEmpty'),
  /**
   * Ensures that an element has a value or that is required. This is different
   * from a required attribute as the validation occurs on submit by the
   * validator verses natively in the browser.
   *
   * @example
   * <form>
   *   <input type="text" data-validate-required="true" />
   *   <button>Submit</button>
   * </form>
   *
   * @param {jQuery} $el - Elements checked to be required or have a value
   * @returns {string} Value used for setting custom validity
   */
  validateRequired: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__validate_missing__["a" /* makeValidateMissing */])('validateRequired'),
  /**
   * Ensure that an element value is not set to the provided value. When it has
   * been set to the value provided, the element will be set as invalid.
   *
   * @example
   * <form>
   *   <input type="text" data-validate-not="walter" />
   *   <button>Submit</button>
   * </form>
   *
   * @param {jQuery} $el - Elements checked to be not empty
   * @param {string} dataVal - Elements checked to be not empty
   * @returns {string} Value used for setting custom validity
   */
  validateNot: function validateNot($el, dataVal) {
    if ($el.val() === dataVal) {
      return $el.data('errorMessage') || __WEBPACK_IMPORTED_MODULE_9__validator_constants__["a" /* DEFAULT_MESSAGE */];
    }
    return '';
  },
  validateEmail: __WEBPACK_IMPORTED_MODULE_8__validate_email__["a" /* validateEmail */],
  validateSameAs: __WEBPACK_IMPORTED_MODULE_7__validate_same_as__["a" /* validateSameAs */]
};
var createEvent = function createEvent(name) {
  return "".concat(name, ".").concat(EVENT_NS);
};

/**
 * Simple helper that will determine the top position of an element on the page.
 * @private
 * @param {HTMLElement} el - Element under question to find top position
 * @returns {number} The total distance from the top for an element
 */
var getTop = function getTop(el) {
  var bodyTop = document.body.getBoundingClientRect().top;
  var elTop = el.getBoundingClientRect().top;
  return elTop - bodyTop;
};

/**
 * Figures out the highest elements found in the DOM based on an array of HTML
 * elements.
 * @private
 * @param {Array} invalidElements - A list of HTML elements
 * @returns {HTMLElement} Highest HTML element on the page
 */
var findHighestEl = function findHighestEl(invalidElements) {
  var _invalidElements = _slicedToArray(invalidElements, 1),
    initial = _invalidElements[0];
  return invalidElements.reduce(function (prev, curr) {
    return getTop(curr) < getTop(prev) ? curr : prev;
  }, initial);
};

/**
 * Determines where in the form to scroll to when an error has been found, so
 * that the user has some context about what in the form has been filled in
 * incorrectly.
 * @private
 * @param {Array} invalidElements - A list of invalid elements
 * @param {Function} scrollTrigger - Called on to determine where to scroll to.
 */
var setInvalidScrollPosition = function setInvalidScrollPosition(invalidElements, scrollTrigger) {
  var highestEl = findHighestEl(invalidElements);
  var yAxis = getTop(highestEl);
  var isDelegatedScroll = false;
  var dict = {
    detail: {
      highestEl: highestEl,
      setElement: function setElement(el) {
        yAxis = getTop(el);
      },
      setPosition: function setPosition(pos) {
        yAxis = window.scrollY + pos;
      },
      setRawPosition: function setRawPosition(pos) {
        yAxis = pos;
      },
      delegateScroll: function delegateScroll(fn) {
        fn(highestEl);
        isDelegatedScroll = true;
      }
    }
  };
  var evt = new CustomEvent(EVENTS.INVALID_SCROLL_POSITION, dict);
  highestEl.dispatchEvent(evt);
  if (!isDelegatedScroll) {
    scrollTrigger(0, yAxis);
  }
};

/**
 * Validates for form field based on whether it contains a custom data
 * attribute as specified by any validators. It's purpose is to set the proper
 * validity if the field's requirements haven't been met. It will return true
 * if the element was found invalid.
 * @private
 * @see validators
 * @param {HTMLSelectElement|HTMLInputElement} el - Form element
 * @returns {boolean|undefined} Determines if element is invalid
 */
var validateField = function validateField(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  if ($el.is(':hidden')) {
    return false;
  }
  var dataAttrs = $el.data();
  var validatorList = Object.keys(validators);
  for (var i = 0, len = validatorList.length; i < len; i += 1) {
    var name = validatorList[i];
    var dataVal = dataAttrs[name];
    if (!!dataVal && !!validators[name]) {
      var message = validators[name]($el, dataVal, dataAttrs);
      if (message) {
        $el.attr('aria-invalid', true);
        el.setCustomValidity(message);
        return true;
      }
      $el.attr('aria-invalid', false);
      el.setCustomValidity('');
    }
  }
  return false;
};

/**
 * Helper that determines all the elements that contain data validator
 * attributes and applies a function to interact with each element.
 * @private
 * @param {jQuery} $wrapper - Container for the form elements
 * @param {Function} fn - Called and passed along a form element
 */
var forEachFormField = function forEachFormField($wrapper, fn) {
  var dataSelector = Object.keys(validators).map(function (name) {
    return "[data-".concat(__WEBPACK_IMPORTED_MODULE_1_lodash_kebabCase___default()(name), "]");
  }).join(',');
  $wrapper.find(dataSelector).each(function iterateElement() {
    fn(this);
  });
};

/**
 * Responsible for queries invalid elements in a container.
 * @param {jQuery} $wrapper - Container with form elements
 * @returns {Array} List of invalid elements
 */
var getInvalidElementList = function getInvalidElementList($wrapper) {
  return $wrapper.find(':invalid').not(':hidden,fieldset').toArray();
};

/**
 * Responsible for queries valid elements in a container.
 * @param {jQuery} $wrapper - Container with form elements
 * @returns {Array} List of valid elements
 */
var getValidElementList = function getValidElementList($wrapper) {
  var $validEls = $wrapper.find(':valid');
  var els = $validEls.not('button,fieldset,input[type="submit"],input[type="radio"],input[type="checkbox"]').toArray();
  var checkedEls = $validEls.filter('input[type="radio"],input[type="checkbox"]').toArray();
  var validCheckedEls = checkedEls.reduce(function (acc, input) {
    var valid = __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(input, 'validity.valid');
    if (input.checked && valid) {
      return [].concat(_toConsumableArray(acc), [input]);
    }
    return acc;
  }, []);
  return els.concat(validCheckedEls);
};

/**
 * Responsible for verifying a set of elements.
 * @param {Array} elements - List of elements
 */
var verifyElementsValidity = function verifyElementsValidity(elements) {
  elements.forEach(function (el) {
    el.checkValidity();
  });
};

/**
 * Responsible for triggering a native CustomEvent so that native event
 * listeners ((add|remove)EventListener) and external listeners (such as jQuery)
 * can work in unison.
 * @param {jQuery} $el - Wrapper element
 * @param {string} evtName - Name of the event
 * @param {Object} detail - Custom data for the event
 */
var triggerEvent = function triggerEvent($el, evtName, detail) {
  var errorEvt = new CustomEvent(evtName, {
    detail: detail
  });
  $el[0].dispatchEvent(errorEvt);
};

/**
 * Retrieves a value for a form element. This can be different based on the
 * type of the element and conditions around it.
 * @param {jQuery} $el - Element looking for value
 */
var getFormFieldValue = function getFormFieldValue($el) {
  var type = $el.prop('type');
  if (type === 'radio') {
    return $el.is(':checked') ? $el.val() : null;
  }
  return $el.val();
};

/**
 * Responsible for taking a list of form elements and creating an object that
 * is keyed by the form element name and with a value of the form element.
 * @param {Array} elements - List of form elements
 * @returns {Object} Keyed form element name by value
 */
var createValuesMap = function createValuesMap(elements) {
  return elements.reduce(function (acc, el) {
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    var name = $el.attr('name') || $el.attr('id');
    var value = getFormFieldValue($el);
    if (acc[name]) {
      var values = acc[name].values || [acc[name].value];
      var els = acc[name].els || [acc[name].el];
      var combinedEls = [].concat(_toConsumableArray(els), [el]);
      var combinedValues = [].concat(_toConsumableArray(values), [value]);
      return Object.assign({}, acc, _defineProperty({}, name, {
        values: combinedValues,
        els: combinedEls,
        $el: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(combinedEls)
      }));
    }
    return Object.assign({}, acc, _defineProperty({}, name, {
      $el: $el,
      el: $el[0],
      value: value
    }));
  }, {});
};

/**
 * Responsible for detecting whether the submission failed or was successful
 * and run through the proper processing/notifying.
 * @param {jQuery} $wrapper - Wrapper element
 * @param {Function} successCallback - Fired off if submission was successful
 * @param {Function} errorCallback - Fired off if submissions was unsuccessful
 * @param {Function} useCustomFormErrorScroll - Called on when an error has
 * been found
 * @param {Function} scrollTrigger - Called on to go a position on the page
 * @param {boolean} disableErrorScroll - Disables a form error from scrolling
 * to the error on the screen.
 * @returns {Function} Called on when the submission should be finalized
 */
var processSubmission = function processSubmission($wrapper, successCallback, errorCallback, useCustomFormErrorScroll, scrollTrigger, disableErrorScroll) {
  return function (detail, _ref) {
    var success = _ref.success,
      error = _ref.error;
    var invalidElements = getInvalidElementList($wrapper);
    var validElements = getValidElementList($wrapper);
    var invalidValues = createValuesMap(invalidElements);
    var validValues = createValuesMap(validElements);
    var updatedDetail = Object.assign({}, detail, {
      invalidElements: invalidElements,
      invalidValues: invalidValues,
      validElements: validElements,
      validValues: validValues
    });
    verifyElementsValidity(invalidElements);
    if (!invalidElements.length) {
      successCallback(validElements);
      triggerEvent($wrapper, success, updatedDetail);
      return;
    }
    var shouldDisableErrorScroll = function shouldDisableErrorScroll() {
      return !disableErrorScroll && !$wrapper.data('validateDisableErrorScroll');
    };
    if (!useCustomFormErrorScroll($wrapper, scrollTrigger) && shouldDisableErrorScroll()) {
      setInvalidScrollPosition(invalidElements, scrollTrigger);
    }
    detail.srcEvent.preventDefault();
    errorCallback(invalidElements);
    triggerEvent($wrapper, error, updatedDetail);
  };
};

/**
 * Performs the submit handler used for verifying the fields within an element.
 * @private
 * @param {Event} evt - DOM event
 * @param {jQuery} $wrapper - The element containing form elements
 * @param {Function} successCallback - Fired off if submission was successful
 * @param {Function} errorCallback - Fired off if submissions was unsuccessful
 * @param {Function} useCustomFormErrorScroll - Called on when an error has
 * been found
 * @param {Function} scrollTrigger - Called on to go a position on the page
 * @param {boolean} disableErrorScroll - Disables a form error from scrolling
 * to the error on the screen.
 */
var submitHandler = function submitHandler(evt, $wrapper, successCallback, errorCallback, useCustomFormErrorScroll, scrollTrigger, disableErrorScroll) {
  forEachFormField($wrapper, validateField);
  var invalidElements = getInvalidElementList($wrapper);
  var validElements = getValidElementList($wrapper);
  verifyElementsValidity(invalidElements);
  var detail = {
    srcEvent: evt,
    validElements: validElements,
    validValues: createValuesMap(validElements),
    invalidElements: invalidElements,
    invalidValues: createValuesMap(invalidElements),
    pause: function pause() {
      evt.preventDefault();
    }
  };
  var processSubmissionFunc = processSubmission($wrapper, successCallback, errorCallback, useCustomFormErrorScroll, scrollTrigger, disableErrorScroll);
  detail = Object.assign({}, detail, {
    revalidate: function revalidate() {
      processSubmissionFunc(detail, {
        success: EVENTS.VALIDATOR_POST_SUCCESS,
        error: EVENTS.VALIDATOR_POST_ERROR
      });
    },
    proceed: function proceed() {
      processSubmissionFunc(detail, {
        success: EVENTS.VALIDATOR_POST_SUCCESS,
        error: EVENTS.VALIDATOR_POST_ERROR
      });
      var updatedInvalidElements = getInvalidElementList($wrapper);
      if (!updatedInvalidElements.length) {
        $wrapper[0].submit();
      }
    }
  });
  processSubmissionFunc(detail, {
    success: EVENTS.VALIDATOR_SUCCESS,
    error: EVENTS.VALIDATOR_ERROR
  });
  triggerEvent($wrapper, EVENTS.VALIDATOR_SUBMIT, Object.assign({}, detail, {
    hasErrors: !!invalidElements.length
  }));
};

/**
 * Responsible for allowing a single handler to be called on to avoid a handler
 * to be called on multiple times.
 * @param {Function} handler - Func to call on
 * @returns {Function} An event callback
 */
var makeSingleEventCall = function makeSingleEventCall(handler) {
  var called;
  return function (evt) {
    if (!called) {
      called = evt.type;
    }
    if (evt.type === called) {
      handler(evt);
    }
  };
};

/**
 * Based on the type of element, will apply an event listener whenever a value
 * has been finalized on the form element.
 * @private
 * @param {jQuery} $el - The form or container for form fields
 */
var listenForFieldChange = function listenForFieldChange($el) {
  forEachFormField($el, function (formField) {
    var $formField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(formField);
    var callback = function callback() {
      validateField(formField);
      formField.checkValidity();
    };
    $formField.on(createEvent('blur'), callback);
    if (formField.tagName.toLowerCase() === 'select') {
      $formField.on(createEvent('change'), callback);
    }
  });
};

/**
 * Responsible for setting a form element to not have native form validation.
 * Ideally, we would want to use native form validation. However, native form
 * validation does not meet the product/design requirements so we need to have
 * custom functionality for form validation.
 *
 * Here are some of the major differences between native form validation and
 * product requirements:
 *
 * Native Form Validation
 * - When an error is found upon submitting a form, no submit event is fired
 *   off. It's almost as though the browser is calling event.stopPropagation().
 * - Upon submitting the form, the browser will fire off an invalid event on
 *   the first found form field error.
 * - The first found error will be in focus
 *
 * Product Requirements:
 * - All fields must be validated upon submitting a form
 * - There are custom page position rules based on how the form has been
 *   configured
 *
 * An important thing to note, by setting novalidate, the form submission will
 * not be validated by the browser. However, the validation of the individual
 * fields can be performed independently from the native form validation, which
 * allows for this custom validation to occur.
 * @param {jQuery} $el - The container or form being validated
 */
var setNovalidate = function setNovalidate($el) {
  var isForm = $el.prop('tagName').toLowerCase() === 'form';
  var hasValidateAttr = !!$el.data('validateNative');
  if (isForm && !hasValidateAttr) {
    $el.attr('novalidate', 'novalidate');
  }
};

/**
 * Validates fields within an element, most likely a form based on what is
 * passed in. The validation of fields is done by a couple of ways:
 *
 * 1. By using browser defaults around validity. For example, if a form element
 * is using a required attribute, has a type that uses built in validation, has
 * a patter attribute, or is controlling validity programmatically by
 * JavaScript.
 * 2. By leveraging data attributes that are coming from within. Think of these
 * attributes as additional configuration that extends the capabilities of
 * validation that isn't supported by the browser.
 * 3. A combination of two.
 *
 * Whether either of these conditions are met, they are finally triggered by
 * either a form submission or a click event applied to an element that
 * contains a data-validate-trigger attribute. This would allow for form
 * submissions to be applied to an element other than a input[type="submit"] or
 * button, in case it's needed. When any form elements are found invalid, a
 * pseudo class of invalid is set and can be styled by CSS.
 *
 * The goal of this work is to leverage as much from within the browser and
 * remove the need for as much custom work as possible.
 * @see validators
 * @see VALIDATOR_OPTIONS
 * @param {HTMLElement} el - An element containing fields used for validating
 * @param {Object} [options={}] - Options used for overriding
 */
function validator(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref2.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $triggers = $el.find("[".concat(VALIDATE_TRIGGER, "]"));
  var _Object$assign3 = Object.assign({}, VALIDATOR_OPTIONS, options, $el.data()),
    validateOnlyOnSubmit = _Object$assign3.validateOnlyOnSubmit,
    successCallback = _Object$assign3.successCallback,
    errorCallback = _Object$assign3.errorCallback,
    scrollTrigger = _Object$assign3.scrollTrigger,
    useCustomFormErrorScroll = _Object$assign3.useCustomFormErrorScroll,
    disableErrorScroll = _Object$assign3.validateDisableErrorScroll;
  setNovalidate($el);
  var partialSubmitHandler = __WEBPACK_IMPORTED_MODULE_2_lodash_partial___default()(submitHandler, placeholder, $el, successCallback, errorCallback, useCustomFormErrorScroll, scrollTrigger, disableErrorScroll);
  var submitHandlerFunc = makeSingleEventCall(partialSubmitHandler);
  $el.on(createEvent('submit'), submitHandlerFunc);
  if ($triggers.length) {
    $triggers.on(createEvent('click'), submitHandlerFunc);
  }
  if (!validateOnlyOnSubmit) {
    listenForFieldChange($el);
  }
  return {
    destroy: function destroy() {
      $el.off(createEvent('submit'));
      $triggers.off(createEvent('click'));
      forEachFormField($el, function (formField) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(formField).off(createEvent('blur')).off(createEvent('change'));
        var evt = new Event('valid');
        formField.dispatchEvent(evt);
        formField.setCustomValidity('');
        formField.checkValidity();
        deregister();
      });
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, validator);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export updateStore */
/* unused harmony export clearStore */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return get; });
/* unused harmony export set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_property__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clone__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_clone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_clone__);
/**
 * Responsible for setting up page specific properties. These properties are
 * intended to be used for environment specific properties such as URLs or
 * values that are used throughout multiple pages.
 * @module lib/props
 */



var props = window.rcProps || {};

/**
 * Responsible for overriding the existing store.
 * @param {Object} obj - Values used for replacing the store
 */
var updateStore = function updateStore(obj) {
  props = obj;
};

/**
 * Responsible for clearing or wiping out a store.
 */
var clearStore = function clearStore() {
  props = {};
};

/**
 * Responsible for obtaining a value from a store of properties. It will accept
 * a defaultValue if no value is found in the store. To ensure safety in
 * obtaining a value, the name takes a string in dot notation in order of
 * object nesting.
 *
 * @example
 * get('character');
 * get('character.bowls.onShabbos');
 * get('character.bowls.onShabbos', true);
 * @param {string} name - Property name looked up
 * @param {string} defaultValue - Provided if no property exists
 * @return {*} The value coming from the store
 */
var get = function get(name, defaultValue) {
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(name)) {
    throw new Error('A property name is required when getting a property value');
  }
  /**
   * props represents window.rcProps
   * checks for if name has rcProps and removes it
   */
  var rcPropsPrefix = 'rcProps.';
  var nameHasRCProps = name.indexOf(rcPropsPrefix) === 0;
  var finalName = nameHasRCProps ? name.slice(rcPropsPrefix.length) : name;
  var value = __WEBPACK_IMPORTED_MODULE_1_lodash_property___default()(finalName)(props);
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(value)) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash_clone___default()(value);
  }
  return defaultValue;
};

/**
 * Responsible for setting a value in the store. In most cases, properties
 * will already be predefined, but this exists in case any properties need to
 * set dynamically or on demand. It will ensure that values overridden are
 * intentional by providing a flag.
 * @param {string} name - Property name used for setting
 * @param {*} value - The value of the property
 * @param {boolean} [override=false] - Allows a property to be overriden
 */
var set = function set(name, value) {
  var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(name)) {
    throw new Error('A property name is required when setting a property');
  }
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(value)) {
    throw new Error('A property value is required when setting a property');
  }
  var existingValue = get(name);
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(existingValue) && !override) {
    throw new Error('Cannot override an existing property. If this is intentional, then pass the override flag.');
  }
  props[name] = value;
};

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

var exp = /\{\{\s*(.*?)\s*\}\}/g;
var filters = {
  pluralize: function pluralize(varName, filterValue, data) {
    var _filterValue$split = filterValue.split(','),
      _filterValue$split2 = _slicedToArray(_filterValue$split, 2),
      singular = _filterValue$split2[0],
      plural = _filterValue$split2[1];
    if (!plural) {
      return '';
    }
    var value = data[varName];
    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(value)) {
      return '';
    }
    return +value === 1 ? singular : plural;
  }
};
var renderFilter = function renderFilter(templateVar, data) {
  // For the time being, does not support chaining unless needed
  var _ref = templateVar.match(/^([\w-]+)\|([^]+)$/) || [],
    _ref2 = _slicedToArray(_ref, 3),
    varName = _ref2[1],
    filterStr = _ref2[2];
  if (!varName) {
    return '';
  }
  var _ref3 = filterStr.match(/^([\w]+):"([^]+)"$/) || [],
    _ref4 = _slicedToArray(_ref3, 3),
    _ref4$ = _ref4[1],
    filterName = _ref4$ === void 0 ? '' : _ref4$,
    filterValue = _ref4[2];
  var filterFn = filters[filterName.toLowerCase()];
  if (!filterFn) {
    return '';
  }
  return filterFn(varName, filterValue, data);
};
var stache = function stache(template) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return template.replace(exp, function (match, submatch) {
    var filterValue = renderFilter(submatch, data);
    if (filterValue) {
      return filterValue;
    }
    var value = data[submatch];
    return !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(value) ? value : '';
  });
};
/* harmony default export */ __webpack_exports__["a"] = (stache);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(31);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw new $TypeError($String(argument) + ' is not an object');
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(346);
var requireObjectCoercible = __webpack_require__(130);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue         = __webpack_require__(192)
  , isPlainFunction = __webpack_require__(539)
  , assign          = __webpack_require__(371)
  , normalizeOpts   = __webpack_require__(377)
  , contains        = __webpack_require__(379);

var d = (module.exports = function (dscr, value/*, options*/) {
	var c, e, w, options, desc;
	if (arguments.length < 2 || typeof dscr !== "string") {
		options = value;
		value = dscr;
		dscr = null;
	} else {
		options = arguments[2];
	}
	if (isValue(dscr)) {
		c = contains.call(dscr, "c");
		e = contains.call(dscr, "e");
		w = contains.call(dscr, "w");
	} else {
		c = w = true;
		e = false;
	}

	desc = { value: value, configurable: c, enumerable: e, writable: w };
	return !options ? desc : assign(normalizeOpts(options), desc);
});

d.gs = function (dscr, get, set/*, options*/) {
	var c, e, options, desc;
	if (typeof dscr !== "string") {
		options = set;
		set = get;
		get = dscr;
		dscr = null;
	} else {
		options = arguments[3];
	}
	if (!isValue(get)) {
		get = undefined;
	} else if (!isPlainFunction(get)) {
		options = get;
		get = set = undefined;
	} else if (!isValue(set)) {
		set = undefined;
	} else if (!isPlainFunction(set)) {
		options = set;
		set = undefined;
	}
	if (isValue(dscr)) {
		c = contains.call(dscr, "c");
		e = contains.call(dscr, "e");
	} else {
		c = true;
		e = false;
	}

	desc = { get: get, set: set, configurable: c, enumerable: e };
	return !options ? desc : assign(normalizeOpts(options), desc);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(389)() ? globalThis : __webpack_require__(388);


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * jquery.mask.js
 * @version: v1.14.16
 * @author: Igor Escobar
 *
 * Created by Igor Escobar on 2012-03-10. Please report any bug at github.com/igorescobar/jQuery-Mask-Plugin
 *
 * Copyright (c) 2012 Igor Escobar http://igorescobar.com
 *
 * The MIT License (http://www.opensource.org/licenses/mit-license.php)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

/* jshint laxbreak: true */
/* jshint maxcomplexity:17 */
/* global define */

// UMD (Universal Module Definition) patterns for JavaScript modules that work everywhere.
// https://github.com/umdjs/umd/blob/master/templates/jqueryPlugin.js
(function (factory, jQuery, Zepto) {

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object' && typeof Meteor === 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery || Zepto);
    }

}(function ($) {
    'use strict';

    var Mask = function (el, mask, options) {

        var p = {
            invalid: [],
            getCaret: function () {
                try {
                    var sel,
                        pos = 0,
                        ctrl = el.get(0),
                        dSel = document.selection,
                        cSelStart = ctrl.selectionStart;

                    // IE Support
                    if (dSel && navigator.appVersion.indexOf('MSIE 10') === -1) {
                        sel = dSel.createRange();
                        sel.moveStart('character', -p.val().length);
                        pos = sel.text.length;
                    }
                    // Firefox support
                    else if (cSelStart || cSelStart === '0') {
                        pos = cSelStart;
                    }

                    return pos;
                } catch (e) {}
            },
            setCaret: function(pos) {
                try {
                    if (el.is(':focus')) {
                        var range, ctrl = el.get(0);

                        // Firefox, WebKit, etc..
                        if (ctrl.setSelectionRange) {
                            ctrl.setSelectionRange(pos, pos);
                        } else { // IE
                            range = ctrl.createTextRange();
                            range.collapse(true);
                            range.moveEnd('character', pos);
                            range.moveStart('character', pos);
                            range.select();
                        }
                    }
                } catch (e) {}
            },
            events: function() {
                el
                .on('keydown.mask', function(e) {
                    el.data('mask-keycode', e.keyCode || e.which);
                    el.data('mask-previus-value', el.val());
                    el.data('mask-previus-caret-pos', p.getCaret());
                    p.maskDigitPosMapOld = p.maskDigitPosMap;
                })
                .on($.jMaskGlobals.useInput ? 'input.mask' : 'keyup.mask', p.behaviour)
                .on('paste.mask drop.mask', function() {
                    setTimeout(function() {
                        el.keydown().keyup();
                    }, 100);
                })
                .on('change.mask', function(){
                    el.data('changed', true);
                })
                .on('blur.mask', function(){
                    if (oldValue !== p.val() && !el.data('changed')) {
                        el.trigger('change');
                    }
                    el.data('changed', false);
                })
                // it's very important that this callback remains in this position
                // otherwhise oldValue it's going to work buggy
                .on('blur.mask', function() {
                    oldValue = p.val();
                })
                // select all text on focus
                .on('focus.mask', function (e) {
                    if (options.selectOnFocus === true) {
                        $(e.target).select();
                    }
                })
                // clear the value if it not complete the mask
                .on('focusout.mask', function() {
                    if (options.clearIfNotMatch && !regexMask.test(p.val())) {
                       p.val('');
                   }
                });
            },
            getRegexMask: function() {
                var maskChunks = [], translation, pattern, optional, recursive, oRecursive, r;

                for (var i = 0; i < mask.length; i++) {
                    translation = jMask.translation[mask.charAt(i)];

                    if (translation) {

                        pattern = translation.pattern.toString().replace(/.{1}$|^.{1}/g, '');
                        optional = translation.optional;
                        recursive = translation.recursive;

                        if (recursive) {
                            maskChunks.push(mask.charAt(i));
                            oRecursive = {digit: mask.charAt(i), pattern: pattern};
                        } else {
                            maskChunks.push(!optional && !recursive ? pattern : (pattern + '?'));
                        }

                    } else {
                        maskChunks.push(mask.charAt(i).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'));
                    }
                }

                r = maskChunks.join('');

                if (oRecursive) {
                    r = r.replace(new RegExp('(' + oRecursive.digit + '(.*' + oRecursive.digit + ')?)'), '($1)?')
                         .replace(new RegExp(oRecursive.digit, 'g'), oRecursive.pattern);
                }

                return new RegExp(r);
            },
            destroyEvents: function() {
                el.off(['input', 'keydown', 'keyup', 'paste', 'drop', 'blur', 'focusout', ''].join('.mask '));
            },
            val: function(v) {
                var isInput = el.is('input'),
                    method = isInput ? 'val' : 'text',
                    r;

                if (arguments.length > 0) {
                    if (el[method]() !== v) {
                        el[method](v);
                    }
                    r = el;
                } else {
                    r = el[method]();
                }

                return r;
            },
            calculateCaretPosition: function(oldVal) {
                var newVal = p.getMasked(),
                    caretPosNew = p.getCaret();
                if (oldVal !== newVal) {
                    var caretPosOld = el.data('mask-previus-caret-pos') || 0,
                        newValL = newVal.length,
                        oldValL = oldVal.length,
                        maskDigitsBeforeCaret = 0,
                        maskDigitsAfterCaret = 0,
                        maskDigitsBeforeCaretAll = 0,
                        maskDigitsBeforeCaretAllOld = 0,
                        i = 0;

                    for (i = caretPosNew; i < newValL; i++) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsAfterCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (!p.maskDigitPosMap[i]) {
                            break;
                        }
                        maskDigitsBeforeCaret++;
                    }

                    for (i = caretPosNew - 1; i >= 0; i--) {
                        if (p.maskDigitPosMap[i]) {
                            maskDigitsBeforeCaretAll++;
                        }
                    }

                    for (i = caretPosOld - 1; i >= 0; i--) {
                        if (p.maskDigitPosMapOld[i]) {
                            maskDigitsBeforeCaretAllOld++;
                        }
                    }

                    // if the cursor is at the end keep it there
                    if (caretPosNew > oldValL) {
                      caretPosNew = newValL * 10;
                    } else if (caretPosOld >= caretPosNew && caretPosOld !== oldValL) {
                        if (!p.maskDigitPosMapOld[caretPosNew])  {
                          var caretPos = caretPosNew;
                          caretPosNew -= maskDigitsBeforeCaretAllOld - maskDigitsBeforeCaretAll;
                          caretPosNew -= maskDigitsBeforeCaret;
                          if (p.maskDigitPosMap[caretPosNew])  {
                            caretPosNew = caretPos;
                          }
                        }
                    }
                    else if (caretPosNew > caretPosOld) {
                        caretPosNew += maskDigitsBeforeCaretAll - maskDigitsBeforeCaretAllOld;
                        caretPosNew += maskDigitsAfterCaret;
                    }
                }
                return caretPosNew;
            },
            behaviour: function(e) {
                e = e || window.event;
                p.invalid = [];

                var keyCode = el.data('mask-keycode');

                if ($.inArray(keyCode, jMask.byPassKeys) === -1) {
                    var newVal = p.getMasked(),
                        caretPos = p.getCaret(),
                        oldVal = el.data('mask-previus-value') || '';

                    // this is a compensation to devices/browsers that don't compensate
                    // caret positioning the right way
                    setTimeout(function() {
                      p.setCaret(p.calculateCaretPosition(oldVal));
                    }, $.jMaskGlobals.keyStrokeCompensation);

                    p.val(newVal);
                    p.setCaret(caretPos);
                    return p.callbacks(e);
                }
            },
            getMasked: function(skipMaskChars, val) {
                var buf = [],
                    value = val === undefined ? p.val() : val + '',
                    m = 0, maskLen = mask.length,
                    v = 0, valLen = value.length,
                    offset = 1, addMethod = 'push',
                    resetPos = -1,
                    maskDigitCount = 0,
                    maskDigitPosArr = [],
                    lastMaskChar,
                    check;

                if (options.reverse) {
                    addMethod = 'unshift';
                    offset = -1;
                    lastMaskChar = 0;
                    m = maskLen - 1;
                    v = valLen - 1;
                    check = function () {
                        return m > -1 && v > -1;
                    };
                } else {
                    lastMaskChar = maskLen - 1;
                    check = function () {
                        return m < maskLen && v < valLen;
                    };
                }

                var lastUntranslatedMaskChar;
                while (check()) {
                    var maskDigit = mask.charAt(m),
                        valDigit = value.charAt(v),
                        translation = jMask.translation[maskDigit];

                    if (translation) {
                        if (valDigit.match(translation.pattern)) {
                            buf[addMethod](valDigit);
                             if (translation.recursive) {
                                if (resetPos === -1) {
                                    resetPos = m;
                                } else if (m === lastMaskChar && m !== resetPos) {
                                    m = resetPos - offset;
                                }

                                if (lastMaskChar === resetPos) {
                                    m -= offset;
                                }
                            }
                            m += offset;
                        } else if (valDigit === lastUntranslatedMaskChar) {
                            // matched the last untranslated (raw) mask character that we encountered
                            // likely an insert offset the mask character from the last entry; fall
                            // through and only increment v
                            maskDigitCount--;
                            lastUntranslatedMaskChar = undefined;
                        } else if (translation.optional) {
                            m += offset;
                            v -= offset;
                        } else if (translation.fallback) {
                            buf[addMethod](translation.fallback);
                            m += offset;
                            v -= offset;
                        } else {
                          p.invalid.push({p: v, v: valDigit, e: translation.pattern});
                        }
                        v += offset;
                    } else {
                        if (!skipMaskChars) {
                            buf[addMethod](maskDigit);
                        }

                        if (valDigit === maskDigit) {
                            maskDigitPosArr.push(v);
                            v += offset;
                        } else {
                            lastUntranslatedMaskChar = maskDigit;
                            maskDigitPosArr.push(v + maskDigitCount);
                            maskDigitCount++;
                        }

                        m += offset;
                    }
                }

                var lastMaskCharDigit = mask.charAt(lastMaskChar);
                if (maskLen === valLen + 1 && !jMask.translation[lastMaskCharDigit]) {
                    buf.push(lastMaskCharDigit);
                }

                var newVal = buf.join('');
                p.mapMaskdigitPositions(newVal, maskDigitPosArr, valLen);
                return newVal;
            },
            mapMaskdigitPositions: function(newVal, maskDigitPosArr, valLen) {
              var maskDiff = options.reverse ? newVal.length - valLen : 0;
              p.maskDigitPosMap = {};
              for (var i = 0; i < maskDigitPosArr.length; i++) {
                p.maskDigitPosMap[maskDigitPosArr[i] + maskDiff] = 1;
              }
            },
            callbacks: function (e) {
                var val = p.val(),
                    changed = val !== oldValue,
                    defaultArgs = [val, e, el, options],
                    callback = function(name, criteria, args) {
                        if (typeof options[name] === 'function' && criteria) {
                            options[name].apply(this, args);
                        }
                    };

                callback('onChange', changed === true, defaultArgs);
                callback('onKeyPress', changed === true, defaultArgs);
                callback('onComplete', val.length === mask.length, defaultArgs);
                callback('onInvalid', p.invalid.length > 0, [val, e, el, p.invalid, options]);
            }
        };

        el = $(el);
        var jMask = this, oldValue = p.val(), regexMask;

        mask = typeof mask === 'function' ? mask(p.val(), undefined, el,  options) : mask;

        // public methods
        jMask.mask = mask;
        jMask.options = options;
        jMask.remove = function() {
            var caret = p.getCaret();
            if (jMask.options.placeholder) {
                el.removeAttr('placeholder');
            }
            if (el.data('mask-maxlength')) {
                el.removeAttr('maxlength');
            }
            p.destroyEvents();
            p.val(jMask.getCleanVal());
            p.setCaret(caret);
            return el;
        };

        // get value without mask
        jMask.getCleanVal = function() {
           return p.getMasked(true);
        };

        // get masked value without the value being in the input or element
        jMask.getMaskedVal = function(val) {
           return p.getMasked(false, val);
        };

       jMask.init = function(onlyMask) {
            onlyMask = onlyMask || false;
            options = options || {};

            jMask.clearIfNotMatch  = $.jMaskGlobals.clearIfNotMatch;
            jMask.byPassKeys       = $.jMaskGlobals.byPassKeys;
            jMask.translation      = $.extend({}, $.jMaskGlobals.translation, options.translation);

            jMask = $.extend(true, {}, jMask, options);

            regexMask = p.getRegexMask();

            if (onlyMask) {
                p.events();
                p.val(p.getMasked());
            } else {
                if (options.placeholder) {
                    el.attr('placeholder' , options.placeholder);
                }

                // this is necessary, otherwise if the user submit the form
                // and then press the "back" button, the autocomplete will erase
                // the data. Works fine on IE9+, FF, Opera, Safari.
                if (el.data('mask')) {
                  el.attr('autocomplete', 'off');
                }

                // detect if is necessary let the user type freely.
                // for is a lot faster than forEach.
                for (var i = 0, maxlength = true; i < mask.length; i++) {
                    var translation = jMask.translation[mask.charAt(i)];
                    if (translation && translation.recursive) {
                        maxlength = false;
                        break;
                    }
                }

                if (maxlength) {
                    el.attr('maxlength', mask.length).data('mask-maxlength', true);
                }

                p.destroyEvents();
                p.events();

                var caret = p.getCaret();
                p.val(p.getMasked());
                p.setCaret(caret);
            }
        };

        jMask.init(!el.is('input'));
    };

    $.maskWatchers = {};
    var HTMLAttributes = function () {
        var input = $(this),
            options = {},
            prefix = 'data-mask-',
            mask = input.attr('data-mask');

        if (input.attr(prefix + 'reverse')) {
            options.reverse = true;
        }

        if (input.attr(prefix + 'clearifnotmatch')) {
            options.clearIfNotMatch = true;
        }

        if (input.attr(prefix + 'selectonfocus') === 'true') {
           options.selectOnFocus = true;
        }

        if (notSameMaskObject(input, mask, options)) {
            return input.data('mask', new Mask(this, mask, options));
        }
    },
    notSameMaskObject = function(field, mask, options) {
        options = options || {};
        var maskObject = $(field).data('mask'),
            stringify = JSON.stringify,
            value = $(field).val() || $(field).text();
        try {
            if (typeof mask === 'function') {
                mask = mask(value);
            }
            return typeof maskObject !== 'object' || stringify(maskObject.options) !== stringify(options) || maskObject.mask !== mask;
        } catch (e) {}
    },
    eventSupported = function(eventName) {
        var el = document.createElement('div'), isSupported;

        eventName = 'on' + eventName;
        isSupported = (eventName in el);

        if ( !isSupported ) {
            el.setAttribute(eventName, 'return;');
            isSupported = typeof el[eventName] === 'function';
        }
        el = null;

        return isSupported;
    };

    $.fn.mask = function(mask, options) {
        options = options || {};
        var selector = this.selector,
            globals = $.jMaskGlobals,
            interval = globals.watchInterval,
            watchInputs = options.watchInputs || globals.watchInputs,
            maskFunction = function() {
                if (notSameMaskObject(this, mask, options)) {
                    return $(this).data('mask', new Mask(this, mask, options));
                }
            };

        $(this).each(maskFunction);

        if (selector && selector !== '' && watchInputs) {
            clearInterval($.maskWatchers[selector]);
            $.maskWatchers[selector] = setInterval(function(){
                $(document).find(selector).each(maskFunction);
            }, interval);
        }
        return this;
    };

    $.fn.masked = function(val) {
        return this.data('mask').getMaskedVal(val);
    };

    $.fn.unmask = function() {
        clearInterval($.maskWatchers[this.selector]);
        delete $.maskWatchers[this.selector];
        return this.each(function() {
            var dataMask = $(this).data('mask');
            if (dataMask) {
                dataMask.remove().removeData('mask');
            }
        });
    };

    $.fn.cleanVal = function() {
        return this.data('mask').getCleanVal();
    };

    $.applyDataMask = function(selector) {
        selector = selector || $.jMaskGlobals.maskElements;
        var $selector = (selector instanceof $) ? selector : $(selector);
        $selector.filter($.jMaskGlobals.dataMaskAttr).each(HTMLAttributes);
    };

    var globals = {
        maskElements: 'input,td,span,div',
        dataMaskAttr: '*[data-mask]',
        dataMask: true,
        watchInterval: 300,
        watchInputs: true,
        keyStrokeCompensation: 10,
        // old versions of chrome dont work great with input event
        useInput: !/Chrome\/[2-4][0-9]|SamsungBrowser/.test(window.navigator.userAgent) && eventSupported('input'),
        watchDataMask: false,
        byPassKeys: [9, 16, 17, 18, 36, 37, 38, 39, 40, 91],
        translation: {
            '0': {pattern: /\d/},
            '9': {pattern: /\d/, optional: true},
            '#': {pattern: /\d/, recursive: true},
            'A': {pattern: /[a-zA-Z0-9]/},
            'S': {pattern: /[a-zA-Z]/}
        }
    };

    $.jMaskGlobals = $.jMaskGlobals || {};
    globals = $.jMaskGlobals = $.extend(true, {}, globals, $.jMaskGlobals);

    // looking for inputs with data-mask attribute
    if (globals.dataMask) {
        $.applyDataMask();
    }

    setInterval(function() {
        if ($.jMaskGlobals.watchDataMask) {
            $.applyDataMask();
        }
    }, globals.watchInterval);
}, window.jQuery, window.Zepto));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(473),
    listCacheDelete = __webpack_require__(474),
    listCacheGet = __webpack_require__(475),
    listCacheHas = __webpack_require__(476),
    listCacheSet = __webpack_require__(477);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(56);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(7),
    isKey = __webpack_require__(87),
    stringToPath = __webpack_require__(501),
    toString = __webpack_require__(36);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(48),
    isObject = __webpack_require__(9);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(470);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(394),
    Map = __webpack_require__(73),
    Promise = __webpack_require__(396),
    Set = __webpack_require__(143),
    WeakMap = __webpack_require__(146),
    baseGetTag = __webpack_require__(15),
    toSource = __webpack_require__(185);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(15),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(419),
    basePropertyDeep = __webpack_require__(420),
    isKey = __webpack_require__(87),
    toKey = __webpack_require__(33);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(190);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 60 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return revieveMakeupAdvisor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var revieveMakeupAdvisor = function revieveMakeupAdvisor() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-makeup-advisor').on('click', function () {
    if (window.rcProps.activeRevievePlugin === 'MAKEUP_ADVISOR' || window.rcProps.activeRevievePlugin === 'FOUNDATION_FINDER') {
      openPlugin();
    } else {
      window.activateRevieveMakeupAdvisor(openPlugin);
    }
  });
};
function openPlugin() {
  Revieve.API.show();
  logEngagement(window.location.href, window.rcProps.activeRevievePlugin, 'Open');
}

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_MESSAGE; });
/* eslint import/prefer-default-export: 0 */

/**
 * Defines default value for when a field is invalid
 * @type string
 */
var DEFAULT_MESSAGE = 'Valid entry required';

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_times__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_times___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_times__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_random__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_random___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_random__);



/**
 * Responsible for generating a random set of characters
 * @param {Object} options - Configurable options for generating a random string
 * @param {string} [options.prefix=''] - Prefix added to random characters
 * @param {string} [options.length=30] - The amount of characters
 * @returns {string} A set of randomly generated characters
 */
var generateRandom = function generateRandom() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$prefix = options.prefix,
    prefix = _options$prefix === void 0 ? '' : _options$prefix,
    _options$length = options.length,
    length = _options$length === void 0 ? 30 : _options$length;
  var chars = __WEBPACK_IMPORTED_MODULE_0_lodash_times___default()(length, function () {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_random___default()(35).toString(36);
  }).join('');
  return prefix ? "".concat(prefix, "-").concat(chars) : chars;
};
/* harmony default export */ __webpack_exports__["a"] = (generateRandom);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export STATUS_CLASS */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slick_counter__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_throttle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_throttle__);







// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'slickSlider';
var STATUS_CLASS = 'js-slides-status';
var DEFAULTS = {
  infinite: false,
  accessiblePaging: false,
  hasQuickview: false,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [],
  lazyLoad: 'ondemand',
  type: '',
  rtl: __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(window, 'rcProps.isRtl', false),
  showStatus: false
};
var slickID = 1;

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - The container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
var mergeOptions = function mergeOptions($el, $carouselPrevHTML, $carouselNextHTML) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var customPagingOpt = {};
  if (options.accessiblePaging) {
    customPagingOpt = {
      customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */]
    };
  }
  var updateOpts = {
    nextArrow: $carouselNextHTML,
    prevArrow: $carouselPrevHTML
  };
  var opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, $el.data(), updateOpts, customPagingOpt, options);
  return opts;
};
var initSlick = function initSlick($carouselTrack) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (options.showStatus) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__slick_counter__["a" /* default */])($carouselTrack);
  }
  $carouselTrack.on('afterChange', function (event, slick, currentSlide) {
    var carouselEvent = new CustomEvent('carouselChange');
    carouselEvent.tracking = {
      type: options.type,
      currentSlide: currentSlide,
      pageUrl: window.location.href,
      pageTitle: document.title,
      element: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this)
    };
    window.dispatchEvent(carouselEvent);
  });
  $carouselTrack.slick(options);
};
var getViewportBottomFoldPos = function getViewportBottomFoldPos() {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop() + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).height();
};
var getSlickTopPos = function getSlickTopPos($el) {
  if ($el.length) {
    var slickPos = $el.offset();
    return slickPos.top;
  }
  return;
};
var checkSlickInit = function checkSlickInit($el) {
  return $el.hasClass('slick-initialized');
};

/**
 * Remove any sort of event handlers for the modal.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 */
var destroySlick = function destroySlick($carouselTrack) {
  var isInitialized = $carouselTrack.hasClass('slick-initialized');
  if (isInitialized) {
    $carouselTrack.slick('unslick');
  }
};

/**
 * Remove any sort of event handlers for the modal.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 */
var removeEventListeners = function removeEventListeners(thisSlickID) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off("scroll.slickslider".concat(thisSlickID));
};

/**
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Function} deregister - teardown method from register jquery plugin
 */
var _destroy = function destroy($carouselTrack, thisSlickID, deregister) {
  removeEventListeners(thisSlickID);
  destroySlick($carouselTrack);
  deregister();
};

// For slick carousels that have Quickviews, adds tabindex=-1 to .js-slick-no-focus elements
var checkForQuickview = function checkForQuickview($el) {
  $el.on('init', function (event, slick) {
    setTimeout(function () {
      slick.$slides.filter('.slick-active').find('.js-slick-no-focus').attr('tabindex', '-1');
      slick.$nextArrow.addClass('active');
      slick.$prevArrow.addClass('active');
    }, 200);
  });
  $el.on('afterChange', function (event, slick, currentSlide, nextSlide) {
    setTimeout(function () {
      slick.$slides.filter('.slick-active').find('.js-slick-no-focus').attr('tabindex', '-1');
    }, 200);
  });
};
var checkScrollPosition = function checkScrollPosition($el, thisSlickID, $carouselTrack) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var offsetLazyLoad = 150;
  var viewportBottomFoldPos = getViewportBottomFoldPos();
  var slickTopPos = getSlickTopPos($carouselTrack);
  var isSlickInit = checkSlickInit($carouselTrack);
  if (slickTopPos < viewportBottomFoldPos + offsetLazyLoad && !isSlickInit) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off("scroll.slickslider".concat(thisSlickID));
    initSlick($carouselTrack, options);
  }
};
var setSlidesToShow = function setSlidesToShow($el, $carouselTrack, opts) {
  var updateSlideNumber = opts.slidesToShow;
  $carouselTrack.on('init', function (event, slick) {
    if (updateSlideNumber > 1) {
      $el.find('.slides-to-show').text(updateSlideNumber);
    }
  });
};
var getTrack = function getTrack($el) {
  return $el.find(".js-carousel__track").css({
    'display': 'block'
  });
};
var getPrev = function getPrev($el) {
  return $el.find(".js-carousel__prev");
};
var getNext = function getNext($el) {
  return $el.find('.js-carousel__next');
};
function slickSlider(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noopActions,
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $carouselTrack = getTrack($el);
  var $carouselPrevHTML = getPrev($el);
  var $carouselNextHTML = getNext($el);
  var opts = mergeOptions($el, $carouselPrevHTML, $carouselNextHTML, options);
  var thisSlickID = slickID;
  checkForQuickview($carouselTrack);
  setSlidesToShow($el, $carouselTrack, opts);
  checkScrollPosition($el, thisSlickID, $carouselTrack, opts);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on("scroll.slickslider".concat(thisSlickID), __WEBPACK_IMPORTED_MODULE_6_lodash_throttle___default()(function () {
    checkScrollPosition($el, thisSlickID, $carouselTrack, opts);
  }, 50));
  slickID++;
  return {
    checkPosition: function checkPosition() {
      return checkScrollPosition($el, thisSlickID, $carouselTrack, opts);
    },
    destroy: function destroy() {
      return _destroy($carouselTrack, thisSlickID, deregister);
    }
  };
}
// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, slickSlider);

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(8);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(globalThis, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis[key] = value;
  } return value;
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(124);

var call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(8);
var isCallable = __webpack_require__(11);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis[namespace]) : globalThis[namespace] && globalThis[namespace][method];
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = {};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(350);
var globalThis = __webpack_require__(8);
var defineGlobalProperty = __webpack_require__(65);

var SHARED = '__core-js_shared__';
var store = module.exports = globalThis[SHARED] || defineGlobalProperty(SHARED, {});

(store.versions || (store.versions = [])).push({
  version: '3.49.0',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2013–2025 Denis Pushkarev (zloirock.ru), 2025–2026 CoreJS Company (core-js.io). All rights reserved.',
  license: 'https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _undefined = __webpack_require__(370)(); // Support ES3 engines

module.exports = function (val) { return val !== _undefined && val !== null; };


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(48),
    baseLodash = __webpack_require__(80);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(478),
    mapCacheDelete = __webpack_require__(479),
    mapCacheGet = __webpack_require__(480),
    mapCacheHas = __webpack_require__(481),
    mapCacheSet = __webpack_require__(482);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(46),
    stackClear = __webpack_require__(494),
    stackDelete = __webpack_require__(495),
    stackGet = __webpack_require__(496),
    stackHas = __webpack_require__(497),
    stackSet = __webpack_require__(498);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(49),
    toKey = __webpack_require__(33);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 80 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(145);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 83 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(180);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(397),
    stubArray = __webpack_require__(189);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(7),
    isSymbol = __webpack_require__(57);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 88 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(170);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module)))

/***/ }),
/* 90 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(423),
    shortOut = __webpack_require__(184);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(444),
    findIndex = __webpack_require__(186);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(407),
    isObjectLike = __webpack_require__(10);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(4),
    stubFalse = __webpack_require__(526);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module)))

/***/ }),
/* 95 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 96 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(15),
    isArray = __webpack_require__(7),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(165);

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

module.exports = kebabCase;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(149),
    baseKeysIn = __webpack_require__(416),
    isArrayLike = __webpack_require__(35);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;
function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    throw new TypeError('This library (validator.js) validates strings only');
  }
}
module.exports = exports['default'];

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export SLICK_CLASS */
/* unused harmony export STATUS_CLASS */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slick_carousel__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_counter__ = __webpack_require__(119);




// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'slides';
var SLICK_CLASS = 'js-slides-slick';
var STATUS_CLASS = 'js-slides-status';
var DEFAULTS = {
  slidesToShow: 1,
  showStatus: false,
  lazyLoad: 'ondemand',
  arrows: true,
  delay: 1000,
  showZoomTab: false,
  productZoomBtn: '.product-zoom__btn',
  productZoomBtnActive: 'product-zoom__btn--active',
  adjacentSlidesBorder: false // https://revolve.atlassian.net/browse/AB-586
};

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - slides wrap
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
var mergeOptions = function mergeOptions($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.assign({}, DEFAULTS, $el.data(), options);
};
var zoomHover = function zoomHover($zoomContainer, opts) {
  var zoomImg = '.zoomImg';
  var delay = opts.delay;
  var hideClass = 'u-hide';
  var timer;
  $zoomContainer.hover(function () {
    timer = setTimeout(function () {
      $zoomContainer.find(zoomImg).removeClass(hideClass);
    }, delay);
  }, function () {
    clearTimeout(timer);
    $zoomContainer.find(zoomImg).addClass(hideClass);
  });
};
var initZoom = function initZoom($slidesWrap, opts) {
  var $zoomContainer = $slidesWrap.find('.slick-active').find('.js-pdp-image-zoom');
  var zoomImgUrl = $zoomContainer.data('zoom-img');
  var hasActiveClass = $zoomContainer.hasClass('zoom-active');
  if (!hasActiveClass && __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.zoom) {
    $zoomContainer.zoom({
      url: zoomImgUrl,
      callback: function callback() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('u-hide');
      }
    });
    $zoomContainer.addClass('zoom-active');
  }
  zoomHover($zoomContainer, opts);
};
var triggerZoom = function triggerZoom($slidesWrap, $slides, opts) {
  $slides.on('init', function (event, slick, currentSlide, nextSlide) {
    initZoom($slidesWrap, opts);
    a11yKeyboardTriggerZoom($slidesWrap);
  }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
    initZoom($slidesWrap, opts);
    a11yKeyboardTriggerZoom($slidesWrap);
  });
};
var a11yKeyboardTriggerZoom = function a11yKeyboardTriggerZoom($slidesWrap) {
  $slidesWrap.find('.pdp__image').removeAttr('tabindex');
  $slidesWrap.find('.slick-active .pdp__image').attr('tabindex', '0');
};
var initSlick = function initSlick($slidesWrap, $slides, opts) {
  if (opts.showStatus) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__slick_counter__["a" /* default */])($slidesWrap);
  }
  if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').hasClass('touch') && opts.zoomImg) {
    triggerZoom($slidesWrap, $slides, opts);
  }
  if (opts.adjacentSlidesBorder) {
    outlineAdjacentSlides($slides);
  }
  $slides.slick(opts);
  if ($slides.find('video').length) {
    videoA11y($slides);
  }
};
/**
 * Adds border class to the nav slides matching the images currently visible in
 * the main carousel. https://revolve.atlassian.net/browse/UX-21082
 *
 * Driven off the main carousel because the nav is `infinite: false` — when the
 * main carousel wraps past its last slide, slick clamps the nav and re-fires
 * the nav's `afterChange` with its previous (stale) index.
 * @param {Object} navSlick - slick instance for the nav (thumbnails)
 * @param {Object} mainSlick - slick instance for the main carousel
 */
var outlineVisibleNavSlides = function outlineVisibleNavSlides(navSlick, mainSlick) {
  var BORDER_CLASS = 'border-current';
  var navSlideCount = navSlick.slideCount;
  if (!navSlideCount) {
    return;
  }
  // main's options.slidesToShow already reflects the active breakpoint
  var slidesShowing = Math.min(mainSlick.options.slidesToShow, mainSlick.slideCount, navSlideCount);
  navSlick.$slideTrack.find('.slick-slide').removeClass(BORDER_CLASS);
  for (var i = 0; i < slidesShowing; i += 1) {
    var navIndex = (mainSlick.currentSlide + i) % navSlideCount;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(navSlick.$slides.get(navIndex)).addClass(BORDER_CLASS);
  }
};
var outlineAdjacentSlides = function outlineAdjacentSlides($slides) {
  var resetPosition = function resetPosition(moreSlidesThanSlideToShow) {
    $slides.on('setPosition', function (event) {
      if (!moreSlidesThanSlideToShow) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.currentTarget).find('.slick-track').css({
          transform: "translate3d(0px, 0px, 0px)"
        });
      }
    });
  };
  $slides.on('init', function (event, navSlick) {
    var $mainSlickCarousel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(navSlick.originalSettings.asNavFor);
    resetPosition(navSlick.slideCount > navSlick.options.slidesToShow);
    if (!$mainSlickCarousel.hasClass('slick-initialized')) {
      return;
    }
    outlineVisibleNavSlides(navSlick, $mainSlickCarousel.slick('getSlick'));
    // both events pass the main slick instance as their first extra arg;
    // `breakpoint` fires after slick swaps in the new options, so
    // slidesToShow is already up to date by the time we read it
    $mainSlickCarousel.on('afterChange breakpoint reInit', function (mainEvent, mainSlick) {
      outlineVisibleNavSlides(navSlick, mainSlick);
    });
  });
};
/**
  * remove active class to hide btn
  */
var hideBtn = function hideBtn(opts) {
  opts.$btn.removeClass(opts.productZoomBtnActive);
  opts.$btn.one('transitionend', function () {
    opts.$btn.hide();
  });
};

/**
  * add active class to show btn
  */
var showBtn = function showBtn(opts) {
  opts.$btn.addClass(opts.productZoomBtnActive);
};

/**
  * show and hide button on load
  */
var toggleProductZoomBtn = function toggleProductZoomBtn(opts) {
  opts.$btn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.productZoomBtn); // cache once, reuse downstream
  showBtn(opts);
  setTimeout(function () {
    hideBtn(opts);
  }, 1500);
};

/**
 * Adds and removes tabindex and aria-hidden based on slide being active
 * @param {jQuery} $slides - the slides to iterate over
 */
var videoA11y = function videoA11y($slides) {
  $slides.find('.slick-slide').each(function () {
    var $slide = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var $video = $slide.find('video');
    if (!$slide.hasClass('slick-active')) {
      $video.attr({
        tabIndex: '-1',
        'aria-hidden': 'true'
      });
    }
  });
  $slides.on('afterChange', function (event, slick, currentSlide) {
    $slides.find('.slick-slide').each(function () {
      var $slide = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      var $video = $slide.find('video');
      if ($slide.hasClass('slick-active')) {
        $video.attr({
          tabIndex: '0',
          'aria-hidden': 'false'
        });
      }
    });
  });
};

/**
 * Initializes slides
 * @param {HTMLElement} el - tab link
 * @param {Object} [options] - Object containing override options
 */
function slides(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $slidesWrap = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $slides = $slidesWrap.find(".".concat(SLICK_CLASS));
  var opts = mergeOptions($slidesWrap, options);
  initSlick($slidesWrap, $slides, opts);
  if (opts.showZoomTab) {
    toggleProductZoomBtn(opts);
  }
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, slides);

/***/ }),
/* 107 */
/***/ (function(module, exports) {

/*!
 * jQuery & Zepto Lazy - v1.7.10
 * http://jquery.eisbehr.de/lazy/
 *
 * Copyright 2012 - 2018, Daniel 'Eisbehr' Kern
 *
 * Dual licensed under the MIT and GPL-2.0 licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl-2.0.html
 *
 * $("img.lazy").lazy();
 */

;(function(window, undefined) {
    "use strict";

    // noinspection JSUnresolvedVariable
    /**
     * library instance - here and not in construct to be shorter in minimization
     * @return void
     */
    var $ = window.jQuery || window.Zepto,

    /**
     * unique plugin instance id counter
     * @type {number}
     */
    lazyInstanceId = 0,

    /**
     * helper to register window load for jQuery 3
     * @type {boolean}
     */    
    windowLoaded = false;

    /**
     * make lazy available to jquery - and make it a bit more case-insensitive :)
     * @access public
     * @type {function}
     * @param {object} settings
     * @return {LazyPlugin}
     */
    $.fn.Lazy = $.fn.lazy = function(settings) {
        return new LazyPlugin(this, settings);
    };

    /**
     * helper to add plugins to lazy prototype configuration
     * @access public
     * @type {function}
     * @param {string|Array} names
     * @param {string|Array|function} [elements]
     * @param {function} loader
     * @return void
     */
    $.Lazy = $.lazy = function(names, elements, loader) {
        // make second parameter optional
        if ($.isFunction(elements)) {
            loader = elements;
            elements = [];
        }

        // exit here if parameter is not a callable function
        if (!$.isFunction(loader)) {
            return;
        }

        // make parameters an array of names to be sure
        names = $.isArray(names) ? names : [names];
        elements = $.isArray(elements) ? elements : [elements];

        var config = LazyPlugin.prototype.config,
            forced = config._f || (config._f = {});

        // add the loader plugin for every name
        for (var i = 0, l = names.length; i < l; i++) {
            if (config[names[i]] === undefined || $.isFunction(config[names[i]])) {
                config[names[i]] = loader;
            }
        }

        // add forced elements loader
        for (var c = 0, a = elements.length; c < a; c++) {
            forced[elements[c]] = names[0];
        }
    };

    /**
     * contains all logic and the whole element handling
     * is packed in a private function outside class to reduce memory usage, because it will not be created on every plugin instance
     * @access private
     * @type {function}
     * @param {LazyPlugin} instance
     * @param {object} config
     * @param {object|Array} items
     * @param {object} events
     * @param {string} namespace
     * @return void
     */
    function _executeLazy(instance, config, items, events, namespace) {
        /**
         * a helper to trigger the 'onFinishedAll' callback after all other events
         * @access private
         * @type {number}
         */
        var _awaitingAfterLoad = 0,

        /**
         * visible content width
         * @access private
         * @type {number}
         */
        _actualWidth = -1,

        /**
         * visible content height
         * @access private
         * @type {number}
         */
        _actualHeight = -1,

        /**
         * determine possibly detected high pixel density
         * @access private
         * @type {boolean}
         */
        _isRetinaDisplay = false, 

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _afterLoad = 'afterLoad',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _load = 'load',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _error = 'error',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _img = 'img',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _src = 'src',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _srcset = 'srcset',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _sizes = 'sizes',

        /**
         * dictionary entry for better minimization
         * @access private
         * @type {string}
         */
        _backgroundImage = 'background-image';

        /**
         * initialize plugin
         * bind loading to events or set delay time to load all items at once
         * @access private
         * @return void
         */
        function _initialize() {
            // detect actual device pixel ratio
            // noinspection JSUnresolvedVariable
            _isRetinaDisplay = window.devicePixelRatio > 1;

            // prepare all initial items
            items = _prepareItems(items);

            // if delay time is set load all items at once after delay time
            if (config.delay >= 0) {
                setTimeout(function() {
                    _lazyLoadItems(true);
                }, config.delay);
            }

            // if no delay is set or combine usage is active bind events
            if (config.delay < 0 || config.combined) {
                // create unique event function
                events.e = _throttle(config.throttle, function(event) {
                    // reset detected window size on resize event
                    if (event.type === 'resize') {
                        _actualWidth = _actualHeight = -1;
                    }

                    // execute 'lazy magic'
                    _lazyLoadItems(event.all);
                });

                // create function to add new items to instance
                events.a = function(additionalItems) {
                    additionalItems = _prepareItems(additionalItems);
                    items.push.apply(items, additionalItems);
                };

                // create function to get all instance items left
                events.g = function() {
                    // filter loaded items before return in case internal filter was not running until now
                    return (items = $(items).filter(function() {
                        return !$(this).data(config.loadedName);
                    }));
                };

                // create function to force loading elements
                events.f = function(forcedItems) {
                    for (var i = 0; i < forcedItems.length; i++) {
                        // only handle item if available in current instance
                        // use a compare function, because Zepto can't handle object parameter for filter
                        // var item = items.filter(forcedItems[i]);
                        /* jshint loopfunc: true */
                        var item = items.filter(function() {
                            return this === forcedItems[i];
                        });

                        if (item.length) {
                            _lazyLoadItems(false, item);   
                        }
                    }
                };

                // load initial items
                _lazyLoadItems();

                // bind lazy load functions to scroll and resize event
                // noinspection JSUnresolvedVariable
                $(config.appendScroll).on('scroll.' + namespace + ' resize.' + namespace, events.e);
            }
        }

        /**
         * prepare items before handle them
         * @access private
         * @param {Array|object|jQuery} items
         * @return {Array|object|jQuery}
         */
        function _prepareItems(items) {
            // fetch used configurations before loops
            var defaultImage = config.defaultImage,
                placeholder = config.placeholder,
                imageBase = config.imageBase,
                srcsetAttribute = config.srcsetAttribute,
                loaderAttribute = config.loaderAttribute,
                forcedTags = config._f || {};

            // filter items and only add those who not handled yet and got needed attributes available
            items = $(items).filter(function() {
                var element = $(this),
                    tag = _getElementTagName(this);

                return !element.data(config.handledName) && 
                       (element.attr(config.attribute) || element.attr(srcsetAttribute) || element.attr(loaderAttribute) || forcedTags[tag] !== undefined);
            })

            // append plugin instance to all elements
            .data('plugin_' + config.name, instance);

            for (var i = 0, l = items.length; i < l; i++) {
                var element = $(items[i]),
                    tag = _getElementTagName(items[i]),
                    elementImageBase = element.attr(config.imageBaseAttribute) || imageBase;

                // generate and update source set if an image base is set
                if (tag === _img && elementImageBase && element.attr(srcsetAttribute)) {
                    element.attr(srcsetAttribute, _getCorrectedSrcSet(element.attr(srcsetAttribute), elementImageBase));
                }

                // add loader to forced element types
                if (forcedTags[tag] !== undefined && !element.attr(loaderAttribute)) {
                    element.attr(loaderAttribute, forcedTags[tag]);
                }

                // set default image on every element without source
                if (tag === _img && defaultImage && !element.attr(_src)) {
                    element.attr(_src, defaultImage);
                }

                // set placeholder on every element without background image
                else if (tag !== _img && placeholder && (!element.css(_backgroundImage) || element.css(_backgroundImage) === 'none')) {
                    element.css(_backgroundImage, "url('" + placeholder + "')");
                }
            }

            return items;
        }

        /**
         * the 'lazy magic' - check all items
         * @access private
         * @param {boolean} [allItems]
         * @param {object} [forced]
         * @return void
         */
        function _lazyLoadItems(allItems, forced) {
            // skip if no items where left
            if (!items.length) {
                // destroy instance if option is enabled
                if (config.autoDestroy) {
                    // noinspection JSUnresolvedFunction
                    instance.destroy();
                }

                return;
            }

            var elements = forced || items,
                loadTriggered = false,
                imageBase = config.imageBase || '',
                srcsetAttribute = config.srcsetAttribute,
                handledName = config.handledName;

            // loop all available items
            for (var i = 0; i < elements.length; i++) {
                // item is at least in loadable area
                if (allItems || forced || _isInLoadableArea(elements[i])) {
                    var element = $(elements[i]),
                        tag = _getElementTagName(elements[i]),
                        attribute = element.attr(config.attribute),
                        elementImageBase = element.attr(config.imageBaseAttribute) || imageBase,
                        customLoader = element.attr(config.loaderAttribute);

                        // is not already handled 
                    if (!element.data(handledName) &&
                        // and is visible or visibility doesn't matter
                        (!config.visibleOnly || element.is(':visible')) && (
                        // and image source or source set attribute is available
                        (attribute || element.attr(srcsetAttribute)) && (
                            // and is image tag where attribute is not equal source or source set
                            (tag === _img && (elementImageBase + attribute !== element.attr(_src) || element.attr(srcsetAttribute) !== element.attr(_srcset))) ||
                            // or is non image tag where attribute is not equal background
                            (tag !== _img && elementImageBase + attribute !== element.css(_backgroundImage))
                        ) ||
                        // or custom loader is available
                        customLoader))
                    {
                        // mark element always as handled as this point to prevent double handling
                        loadTriggered = true;
                        element.data(handledName, true);

                        // load item
                        _handleItem(element, tag, elementImageBase, customLoader);
                    }
                }
            }

            // when something was loaded remove them from remaining items
            if (loadTriggered) {
                items = $(items).filter(function() {
                    return !$(this).data(handledName);
                });
            }
        }

        /**
         * load the given element the lazy way
         * @access private
         * @param {object} element
         * @param {string} tag
         * @param {string} imageBase
         * @param {function} [customLoader]
         * @return void
         */
        function _handleItem(element, tag, imageBase, customLoader) {
            // increment count of items waiting for after load
            ++_awaitingAfterLoad;

            // extended error callback for correct 'onFinishedAll' handling
            var errorCallback = function() {
                _triggerCallback('onError', element);
                _reduceAwaiting();

                // prevent further callback calls
                errorCallback = $.noop;
            };

            // trigger function before loading image
            _triggerCallback('beforeLoad', element);

            // fetch all double used data here for better code minimization
            var srcAttribute = config.attribute,
                srcsetAttribute = config.srcsetAttribute,
                sizesAttribute = config.sizesAttribute,
                retinaAttribute = config.retinaAttribute,
                removeAttribute = config.removeAttribute,
                loadedName = config.loadedName,
                elementRetina = element.attr(retinaAttribute);

            // handle custom loader
            if (customLoader) {
                // on load callback
                var loadCallback = function() {
                    // remove attribute from element
                    if (removeAttribute) {
                        element.removeAttr(config.loaderAttribute);
                    }

                    // mark element as loaded
                    element.data(loadedName, true);

                    // call after load event
                    _triggerCallback(_afterLoad, element);

                    // remove item from waiting queue and possibly trigger finished event
                    // it's needed to be asynchronous to run after filter was in _lazyLoadItems
                    setTimeout(_reduceAwaiting, 1);

                    // prevent further callback calls
                    loadCallback = $.noop;
                };

                // bind error event to trigger callback and reduce waiting amount
                element.off(_error).one(_error, errorCallback)

                // bind after load callback to element
                .one(_load, loadCallback);

                // trigger custom loader and handle response
                if (!_triggerCallback(customLoader, element, function(response) {
                    if(response) {
                        element.off(_load);
                        loadCallback();
                    }
                    else {
                        element.off(_error);
                        errorCallback();
                    }
                })) {
                    element.trigger(_error);
                }
            }

            // handle images
            else {
                // create image object
                var imageObj = $(new Image());

                // bind error event to trigger callback and reduce waiting amount
                imageObj.one(_error, errorCallback)

                // bind after load callback to image
                .one(_load, function() {
                    // remove element from view
                    element.hide();

                    // set image back to element
                    // do it as single 'attr' calls, to be sure 'src' is set after 'srcset'
                    if (tag === _img) {
                        element.attr(_sizes, imageObj.attr(_sizes))
                               .attr(_srcset, imageObj.attr(_srcset))
                               .attr(_src, imageObj.attr(_src));
                    }
                    else {
                        element.css(_backgroundImage, "url('" + imageObj.attr(_src) + "')");
                    }

                    // bring it back with some effect!
                    element[config.effect](config.effectTime);

                    // remove attribute from element
                    if (removeAttribute) {
                        element.removeAttr(srcAttribute + ' ' + srcsetAttribute + ' ' + retinaAttribute + ' ' + config.imageBaseAttribute);

                        // only remove 'sizes' attribute, if it was a custom one
                        if (sizesAttribute !== _sizes) {
                            element.removeAttr(sizesAttribute);
                        }
                    }

                    // mark element as loaded
                    element.data(loadedName, true);

                    // call after load event
                    _triggerCallback(_afterLoad, element);

                    // cleanup image object
                    imageObj.remove();

                    // remove item from waiting queue and possibly trigger finished event
                    _reduceAwaiting();
                });

                // set sources
                // do it as single 'attr' calls, to be sure 'src' is set after 'srcset'
                var imageSrc = (_isRetinaDisplay && elementRetina ? elementRetina : element.attr(srcAttribute)) || '';
                imageObj.attr(_sizes, element.attr(sizesAttribute))
                        .attr(_srcset, element.attr(srcsetAttribute))
                        .attr(_src, imageSrc ? imageBase + imageSrc : null);

                // call after load even on cached image
                imageObj.complete && imageObj.trigger(_load); // jshint ignore : line
            }
        }

        /**
         * check if the given element is inside the current viewport or threshold
         * @access private
         * @param {object} element
         * @return {boolean}
         */
        function _isInLoadableArea(element) {
            var elementBound = element.getBoundingClientRect(),
                direction    = config.scrollDirection,
                threshold    = config.threshold,
                vertical     = // check if element is in loadable area from top
                               ((_getActualHeight() + threshold) > elementBound.top) &&
                               // check if element is even in loadable are from bottom
                               (-threshold < elementBound.bottom),
                horizontal   = // check if element is in loadable area from left
                               ((_getActualWidth() + threshold) > elementBound.left) &&
                               // check if element is even in loadable area from right
                               (-threshold < elementBound.right);

            if (direction === 'vertical') {
                return vertical;
            }
            else if (direction === 'horizontal') {
                return horizontal;
            }

            return vertical && horizontal;
        }

        /**
         * receive the current viewed width of the browser
         * @access private
         * @return {number}
         */
        function _getActualWidth() {
            return _actualWidth >= 0 ? _actualWidth : (_actualWidth = $(window).width());
        }

        /**
         * receive the current viewed height of the browser
         * @access private
         * @return {number}
         */
        function _getActualHeight() {
            return _actualHeight >= 0 ? _actualHeight : (_actualHeight = $(window).height());
        }

        /**
         * get lowercase tag name of an element
         * @access private
         * @param {object} element
         * @returns {string}
         */
        function _getElementTagName(element) {
            return element.tagName.toLowerCase();
        }

        /**
         * prepend image base to all srcset entries
         * @access private
         * @param {string} srcset
         * @param {string} imageBase
         * @returns {string}
         */
        function _getCorrectedSrcSet(srcset, imageBase) {
            if (imageBase) {
                // trim, remove unnecessary spaces and split entries
                var entries = srcset.split(',');
                srcset = '';

                for (var i = 0, l = entries.length; i < l; i++) {
                    srcset += imageBase + entries[i].trim() + (i !== l - 1 ? ',' : '');
                }
            }

            return srcset;
        }

        /**
         * helper function to throttle down event triggering
         * @access private
         * @param {number} delay
         * @param {function} callback
         * @return {function}
         */
        function _throttle(delay, callback) {
            var timeout,
                lastExecute = 0;

            return function(event, ignoreThrottle) {
                var elapsed = +new Date() - lastExecute;

                function run() {
                    lastExecute = +new Date();
                    // noinspection JSUnresolvedFunction
                    callback.call(instance, event);
                }

                timeout && clearTimeout(timeout); // jshint ignore : line

                if (elapsed > delay || !config.enableThrottle || ignoreThrottle) {
                    run();
                }
                else {
                    timeout = setTimeout(run, delay - elapsed);
                }
            };
        }

        /**
         * reduce count of awaiting elements to 'afterLoad' event and fire 'onFinishedAll' if reached zero
         * @access private
         * @return void
         */
        function _reduceAwaiting() {
            --_awaitingAfterLoad;

            // if no items were left trigger finished event
            if (!items.length && !_awaitingAfterLoad) {
                _triggerCallback('onFinishedAll');
            }
        }

        /**
         * single implementation to handle callbacks, pass element and set 'this' to current instance
         * @access private
         * @param {string|function} callback
         * @param {object} [element]
         * @param {*} [args]
         * @return {boolean}
         */
        function _triggerCallback(callback, element, args) {
            if ((callback = config[callback])) {
                // jQuery's internal '$(arguments).slice(1)' are causing problems at least on old iPads
                // below is shorthand of 'Array.prototype.slice.call(arguments, 1)'
                callback.apply(instance, [].slice.call(arguments, 1));
                return true;
            }

            return false;
        }

        // if event driven or window is already loaded don't wait for page loading
        if (config.bind === 'event' || windowLoaded) {
            _initialize();
        }

        // otherwise load initial items and start lazy after page load
        else {
            // noinspection JSUnresolvedVariable
            $(window).on(_load + '.' + namespace, _initialize);
        }  
    }

    /**
     * lazy plugin class constructor
     * @constructor
     * @access private
     * @param {object} elements
     * @param {object} settings
     * @return {object|LazyPlugin}
     */
    function LazyPlugin(elements, settings) {
        /**
         * this lazy plugin instance
         * @access private
         * @type {object|LazyPlugin|LazyPlugin.prototype}
         */
        var _instance = this,

        /**
         * this lazy plugin instance configuration
         * @access private
         * @type {object}
         */
        _config = $.extend({}, _instance.config, settings),

        /**
         * instance generated event executed on container scroll or resize
         * packed in an object to be referenceable and short named because properties will not be minified
         * @access private
         * @type {object}
         */
        _events = {},

        /**
         * unique namespace for instance related events
         * @access private
         * @type {string}
         */
        _namespace = _config.name + '-' + (++lazyInstanceId);

        // noinspection JSUndefinedPropertyAssignment
        /**
         * wrapper to get or set an entry from plugin instance configuration
         * much smaller on minify as direct access
         * @access public
         * @type {function}
         * @param {string} entryName
         * @param {*} [value]
         * @return {LazyPlugin|*}
         */
        _instance.config = function(entryName, value) {
            if (value === undefined) {
                return _config[entryName];
            }

            _config[entryName] = value;
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * add additional items to current instance
         * @access public
         * @param {Array|object|string} items
         * @return {LazyPlugin}
         */
        _instance.addItems = function(items) {
            _events.a && _events.a($.type(items) === 'string' ? $(items) : items); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * get all left items of this instance
         * @access public
         * @returns {object}
         */
        _instance.getItems = function() {
            return _events.g ? _events.g() : {};
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force lazy to load all items in loadable area right now
         * by default without throttle
         * @access public
         * @type {function}
         * @param {boolean} [useThrottle]
         * @return {LazyPlugin}
         */
        _instance.update = function(useThrottle) {
            _events.e && _events.e({}, !useThrottle); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force element(s) to load directly, ignoring the viewport
         * @access public
         * @param {Array|object|string} items
         * @return {LazyPlugin}
         */
        _instance.force = function(items) {
            _events.f && _events.f($.type(items) === 'string' ? $(items) : items); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * force lazy to load all available items right now
         * this call ignores throttling
         * @access public
         * @type {function}
         * @return {LazyPlugin}
         */
        _instance.loadAll = function() {
            _events.e && _events.e({all: true}, true); // jshint ignore : line
            return _instance;
        };

        // noinspection JSUndefinedPropertyAssignment
        /**
         * destroy this plugin instance
         * @access public
         * @type {function}
         * @return undefined
         */
        _instance.destroy = function() {
            // unbind instance generated events
            // noinspection JSUnresolvedFunction, JSUnresolvedVariable
            $(_config.appendScroll).off('.' + _namespace, _events.e);
            // noinspection JSUnresolvedVariable
            $(window).off('.' + _namespace);

            // clear events
            _events = {};

            return undefined;
        };

        // start using lazy and return all elements to be chainable or instance for further use
        // noinspection JSUnresolvedVariable
        _executeLazy(_instance, _config, elements, _events, _namespace);
        return _config.chainable ? elements : _instance;
    }

    /**
     * settings and configuration data
     * @access public
     * @type {object|*}
     */
    LazyPlugin.prototype.config = {
        // general
        name               : 'lazy',
        chainable          : true,
        autoDestroy        : true,
        bind               : 'load',
        threshold          : 500,
        visibleOnly        : false,
        appendScroll       : window,
        scrollDirection    : 'both',
        imageBase          : null,
        defaultImage       : 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
        placeholder        : null,
        delay              : -1,
        combined           : false,

        // attributes
        attribute          : 'data-src',
        srcsetAttribute    : 'data-srcset',
        sizesAttribute     : 'data-sizes',
        retinaAttribute    : 'data-retina',
        loaderAttribute    : 'data-loader',
        imageBaseAttribute : 'data-imagebase',
        removeAttribute    : true,
        handledName        : 'handled',
        loadedName         : 'loaded',

        // effect
        effect             : 'show',
        effectTime         : 0,

        // throttle
        enableThrottle     : true,
        throttle           : 250,

        // callbacks
        beforeLoad         : undefined,
        afterLoad          : undefined,
        onError            : undefined,
        onFinishedAll      : undefined
    };

    // register window load event globally to prevent not loading elements
    // since jQuery 3.X ready state is fully async and may be executed after 'load' 
    $(window).on('load', function() {
        windowLoaded = true;
    });
})(window);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var DEFAULT_ACTIVE_CLASS = 'favorite-button--active';
var rcProps = window.rcProps || {};
var hearts = rcProps.hearts || {};
// rcProps may be absent; fall back to the limit the server enforces rather than silently passing
var maxFavoritesCount = typeof hearts.maxCount === 'number' ? hearts.maxCount : 1999;
var maxFavoritesCountGuest = typeof hearts.maxCountGuest === 'number' ? hearts.maxCountGuest : 49;
var mensHeart = hearts.mensHeart === 'true';
window.productHearts = {};
var productHearts = window.productHearts;
function initHeart($element) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each($element, function (i, e) {
    var events = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a._data(e, 'events');
    if (events && events.click) return;
    if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e).hasClass(DEFAULT_ACTIVE_CLASS)) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e).attr('aria-pressed', 'false');
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e).attr('aria-pressed', 'true');
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e).click(function (e) {
      e.preventDefault();
      var element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      var productCode = element.data('code');
      heartProductUpdated(element, productCode, function () {
        if (typeof itemUnHearted == "function") {
          itemUnHearted(element, productCode);
        }
      });
    });
  });
}
function updateHeartCount(count, totalFavoriteCount) {
  var $favoriteCount = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#heart_total_count");
  if ($favoriteCount.length) {
    $favoriteCount.data('count', count);
    // keep the limit-check count fresh; it is otherwise only set on page load
    if (typeof totalFavoriteCount !== 'undefined') {
      $favoriteCount.data('totalFavoriteCount', totalFavoriteCount);
    }
    var favoritesTotal = count > 99 ? "99+" : count;
    $favoriteCount.empty().text(favoritesTotal);
    if (parseInt(favoritesTotal) <= 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fav-count--ab').hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#js-recent-favorites").empty();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#js-recent-favorites").removeClass('js-dropdown__menu popover__content dropdown__menu recent-favorites');
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fav-count--ab').show();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#js-recent-favorites").addClass('js-dropdown__menu popover__content dropdown__menu recent-favorites');
      if (typeof loadRecentFavourites == "function") {
        loadRecentFavourites();
      }
    }
  }
}
function heartProductUpdated(element, productCode, callback) {
  var container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
  var $favoriteNotify = element.next('.js-favorite-notify');
  var unfavoritedMessageNotif = element.data('unfavorite-notification');
  var favoritedMessageNotif = element.data('favorite-notification');
  var unfavoriteMessage = element.data('unfavorite-message');
  var favoriteMessage = element.data('favorite-message');
  var messageContainer = '.u-screen-reader';
  var properActiveClass = window.rcProps && window.rcProps.favoriteActiveClass || DEFAULT_ACTIVE_CLASS;
  if (container.hasClass(properActiveClass)) {
    submitHeart('product', productCode, 'remove', undefined, undefined, undefined, undefined, function () {
      container.removeClass(properActiveClass);
      container.attr('aria-pressed', 'false');
      $favoriteNotify.text(unfavoritedMessageNotif);
      container.find(messageContainer).text(favoriteMessage);
    }, callback);
    productHearts[productCode] = false;
  } else {
    var isGuest = rcProps.isGuest;
    var isGuestHeartingEnabled = hearts.enabledForGuest;
    var guestMaxFavoriteCount = maxFavoritesCountGuest;
    var productSize = 0;
    var favItemCount = Number(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#heart_total_count').data('totalFavoriteCount'));
    if (!Number.isNaN(favItemCount)) {
      productSize = favItemCount;
    }
    if (isGuest && !(isGuestHeartingEnabled && productSize <= guestMaxFavoriteCount)) {
      showFavLimitPopupModal(hearts.favMaxPopupHref, isGuest, productCode);
      return;
    } else if (!isGuest && productSize > maxFavoritesCount) {
      showFavLimitPopupModal(hearts.favMaxPopupHref, isGuest);
      return;
    }
    submitHeart('product', productCode, 'add', undefined, undefined, undefined, undefined, function () {
      container.addClass(properActiveClass);
      container.attr('aria-pressed', 'true');
      $favoriteNotify.text(favoritedMessageNotif);
      container.find(messageContainer).text(unfavoriteMessage);
    });
    productHearts[productCode] = true;
  }
}
function submitHeart(paramtype, paramvalue) {
  if (typeof paramtype === "undefined" || typeof paramvalue === "undefined") return;
  if (typeof arguments[2] === "undefined") return;
  var psize = "";
  // optional argument
  if (typeof arguments[3] !== "undefined") {
    psize = arguments[3];
  }
  var sectionUrl = "";
  if (typeof arguments[4] !== "undefined") {
    sectionUrl = arguments[4];
  }
  var callback = null;
  if (typeof arguments[6] !== 'undefined') {
    callback = arguments[6];
  }
  var onSuccess = arguments[7];
  var itemUnHearted = arguments[8];
  var dataToSend = "";
  var department = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#header-jsp').data('department');
  if (paramtype === "product") {
    dataToSend += "&pcode=" + encodeURIComponent(paramvalue);
  } else if (paramtype === "brand") {
    dataToSend += "&bcode=" + encodeURIComponent(paramvalue);
  }
  dataToSend += "&action_T=" + encodeURIComponent(arguments[2]);
  if (mensHeart) dataToSend += "&mensBrand=" + encodeURIComponent("true");else dataToSend += "&mensBrand=" + encodeURIComponent("false");
  if (psize !== "") dataToSend += "&psize=" + encodeURIComponent(psize);
  if (sectionUrl !== "") dataToSend += "&sectionURL=" + encodeURIComponent(sectionUrl);
  if (department) dataToSend += "&d=" + encodeURIComponent(department);
  var selectedSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#sizeValue').val();
  if (selectedSize) {
    dataToSend += "&psize=" + encodeURIComponent(selectedSize);
  }
  var action_T = arguments[2];
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    url: '/r/ajaxHeartProduct.jsp',
    data: dataToSend,
    success: function success(response) {
      /*
       // alert("jsp response="+res);
       res = res.replace(/^\s+|\s+$/g,"");
       // alert("jsp response="+res);
       */
      if (paramtype === "product") {
        if (response.exceedsLimit) {
          showFavLimitPopupModal(hearts.favMaxPopupHref, window.rcProps.isGuest, paramvalue);
        } else if (response.success) {
          updateHeartCount(response.count, response.totalFavoriteCount);
          if (typeof itemUnHearted === 'function') {
            itemUnHearted();
          }
        }
        if (response.action === 'add') {
          if (typeof insertCordialUpdateHeartItem === 'function') {
            insertCordialUpdateHeartItem('add', paramvalue);
          }
          if (typeof iPinYouHeartItem === 'function') {
            iPinYouHeartItem(paramvalue);
          }
          if (typeof insertRTBHouseHeartItem === 'function') {
            insertRTBHouseHeartItem(paramvalue);
          }
        } else if (response.action === 'remove') {
          if (typeof insertCordialUpdateHeartItem === 'function') {
            insertCordialUpdateHeartItem('remove', paramvalue);
          }
        }
        if (typeof taboolaWishListAction === 'function') {
          taboolaWishListAction(response.action, paramvalue);
        }
        if (typeof cfyWishListAction === 'function') {
          cfyWishListAction(response.action, response.code, response.price);
        }
        if (typeof brazeAddToFavorites === 'function') {
          brazeAddToFavorites(response.action, response.code, response.name, response.size, response.imageUrl, response.productUrl, response.price, response.currency, response.department, response.color, response.brandName, response.category, response.cat1);
        }
      } else if (paramtype === "brand") {
        if (typeof brazeBrandFavorites === 'function') {
          brazeBrandFavorites(response.action, response.brandName, response.brandId);
        }
      }
      if (typeof callback === 'function') {
        callback();
      }
      if (response.success) {
        if (typeof onSuccess === 'function') {
          onSuccess();
        }
      }
    }
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({
  initHeart: initHeart,
  updateHeartCount: updateHeartCount
});

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 * typeahead.js 0.11.1
 * https://github.com/twitter/typeahead.js
 * Copyright 2013-2015 Twitter, Inc. and other contributors; Licensed MIT
 */
// Minified using: https://javascript-minifier.com/
(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
      return root["Bloodhound"] = factory(a0);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object") {
    module.exports = factory(require("jquery"));
  } else {
    root["Bloodhound"] = factory(jQuery);
  }
})(this, function ($) {
  var _ = function () {
    "use strict";

    return {
      isMsie: function isMsie() {
        return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
      },
      isBlankString: function isBlankString(str) {
        return !str || /^\s*$/.test(str);
      },
      escapeRegExChars: function escapeRegExChars(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      },
      isString: function isString(obj) {
        return typeof obj === "string";
      },
      isNumber: function isNumber(obj) {
        return typeof obj === "number";
      },
      isArray: $.isArray,
      isFunction: $.isFunction,
      isObject: $.isPlainObject,
      isUndefined: function isUndefined(obj) {
        return typeof obj === "undefined";
      },
      isElement: function isElement(obj) {
        return !!(obj && obj.nodeType === 1);
      },
      isJQuery: function isJQuery(obj) {
        return obj instanceof $;
      },
      toStr: function toStr(s) {
        return _.isUndefined(s) || s === null ? "" : s + "";
      },
      bind: $.proxy,
      each: function each(collection, cb) {
        $.each(collection, reverseArgs);
        function reverseArgs(index, value) {
          return cb(value, index);
        }
      },
      map: $.map,
      filter: $.grep,
      every: function every(obj, test) {
        var result = true;
        if (!obj) {
          return result;
        }
        $.each(obj, function (key, val) {
          if (!(result = test.call(null, val, key, obj))) {
            return false;
          }
        });
        return !!result;
      },
      some: function some(obj, test) {
        var result = false;
        if (!obj) {
          return result;
        }
        $.each(obj, function (key, val) {
          if (result = test.call(null, val, key, obj)) {
            return false;
          }
        });
        return !!result;
      },
      mixin: $.extend,
      identity: function identity(x) {
        return x;
      },
      clone: function clone(obj) {
        return $.extend(true, {}, obj);
      },
      getIdGenerator: function getIdGenerator() {
        var counter = 0;
        return function () {
          return counter++;
        };
      },
      templatify: function templatify(obj) {
        return $.isFunction(obj) ? obj : template;
        function template() {
          return String(obj);
        }
      },
      defer: function defer(fn) {
        setTimeout(fn, 0);
      },
      debounce: function debounce(func, wait, immediate) {
        var timeout, result;
        return function () {
          var context = this,
            args = arguments,
            later,
            callNow;
          later = function later() {
            timeout = null;
            if (!immediate) {
              result = func.apply(context, args);
            }
          };
          callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) {
            result = func.apply(context, args);
          }
          return result;
        };
      },
      throttle: function throttle(func, wait) {
        var context, args, timeout, result, previous, later;
        previous = 0;
        later = function later() {
          previous = new Date();
          timeout = null;
          result = func.apply(context, args);
        };
        return function () {
          var now = new Date(),
            remaining = wait - (now - previous);
          context = this;
          args = arguments;
          if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
          } else if (!timeout) {
            timeout = setTimeout(later, remaining);
          }
          return result;
        };
      },
      stringify: function stringify(val) {
        return _.isString(val) ? val : JSON.stringify(val);
      },
      noop: function noop() {}
    };
  }();
  var VERSION = "0.11.1";
  var tokenizers = function () {
    "use strict";

    return {
      nonword: nonword,
      whitespace: whitespace,
      obj: {
        nonword: getObjTokenizer(nonword),
        whitespace: getObjTokenizer(whitespace)
      }
    };
    function whitespace(str) {
      str = _.toStr(str);
      return str ? str.split(/\s+/) : [];
    }
    function nonword(str) {
      str = _.toStr(str);
      return str ? str.split(/\W+/) : [];
    }
    function getObjTokenizer(tokenizer) {
      return function setKey(keys) {
        keys = _.isArray(keys) ? keys : [].slice.call(arguments, 0);
        return function tokenize(o) {
          var tokens = [];
          _.each(keys, function (k) {
            tokens = tokens.concat(tokenizer(_.toStr(o[k])));
          });
          return tokens;
        };
      };
    }
  }();
  var LruCache = function () {
    "use strict";

    function LruCache(maxSize) {
      this.maxSize = _.isNumber(maxSize) ? maxSize : 100;
      this.reset();
      if (this.maxSize <= 0) {
        this.set = this.get = $.noop;
      }
    }
    _.mixin(LruCache.prototype, {
      set: function set(key, val) {
        var tailItem = this.list.tail,
          node;
        if (this.size >= this.maxSize) {
          this.list.remove(tailItem);
          delete this.hash[tailItem.key];
          this.size--;
        }
        if (node = this.hash[key]) {
          node.val = val;
          this.list.moveToFront(node);
        } else {
          node = new Node(key, val);
          this.list.add(node);
          this.hash[key] = node;
          this.size++;
        }
      },
      get: function get(key) {
        var node = this.hash[key];
        if (node) {
          this.list.moveToFront(node);
          return node.val;
        }
      },
      reset: function reset() {
        this.size = 0;
        this.hash = {};
        this.list = new List();
      }
    });
    function List() {
      this.head = this.tail = null;
    }
    _.mixin(List.prototype, {
      add: function add(node) {
        if (this.head) {
          node.next = this.head;
          this.head.prev = node;
        }
        this.head = node;
        this.tail = this.tail || node;
      },
      remove: function remove(node) {
        node.prev ? node.prev.next = node.next : this.head = node.next;
        node.next ? node.next.prev = node.prev : this.tail = node.prev;
      },
      moveToFront: function moveToFront(node) {
        this.remove(node);
        this.add(node);
      }
    });
    function Node(key, val) {
      this.key = key;
      this.val = val;
      this.prev = this.next = null;
    }
    return LruCache;
  }();
  var PersistentStorage = function () {
    "use strict";

    var LOCAL_STORAGE;
    try {
      LOCAL_STORAGE = window.localStorage;
      LOCAL_STORAGE.setItem("~~~", "!");
      LOCAL_STORAGE.removeItem("~~~");
    } catch (err) {
      LOCAL_STORAGE = null;
    }
    function PersistentStorage(namespace, override) {
      this.prefix = ["__", namespace, "__"].join("");
      this.ttlKey = "__ttl__";
      this.keyMatcher = new RegExp("^" + _.escapeRegExChars(this.prefix));
      this.ls = override || LOCAL_STORAGE;
      !this.ls && this._noop();
    }
    _.mixin(PersistentStorage.prototype, {
      _prefix: function _prefix(key) {
        return this.prefix + key;
      },
      _ttlKey: function _ttlKey(key) {
        return this._prefix(key) + this.ttlKey;
      },
      _noop: function _noop() {
        this.get = this.set = this.remove = this.clear = this.isExpired = _.noop;
      },
      _safeSet: function _safeSet(key, val) {
        try {
          this.ls.setItem(key, val);
        } catch (err) {
          if (err.name === "QuotaExceededError") {
            this.clear();
            this._noop();
          }
        }
      },
      get: function get(key) {
        if (this.isExpired(key)) {
          this.remove(key);
        }
        return decode(this.ls.getItem(this._prefix(key)));
      },
      set: function set(key, val, ttl) {
        if (_.isNumber(ttl)) {
          this._safeSet(this._ttlKey(key), encode(now() + ttl));
        } else {
          this.ls.removeItem(this._ttlKey(key));
        }
        return this._safeSet(this._prefix(key), encode(val));
      },
      remove: function remove(key) {
        this.ls.removeItem(this._ttlKey(key));
        this.ls.removeItem(this._prefix(key));
        return this;
      },
      clear: function clear() {
        var i,
          keys = gatherMatchingKeys(this.keyMatcher);
        for (i = keys.length; i--;) {
          this.remove(keys[i]);
        }
        return this;
      },
      isExpired: function isExpired(key) {
        var ttl = decode(this.ls.getItem(this._ttlKey(key)));
        return _.isNumber(ttl) && now() > ttl ? true : false;
      }
    });
    return PersistentStorage;
    function now() {
      return new Date().getTime();
    }
    function encode(val) {
      return JSON.stringify(_.isUndefined(val) ? null : val);
    }
    function decode(val) {
      return $.parseJSON(val);
    }
    function gatherMatchingKeys(keyMatcher) {
      var i,
        key,
        keys = [],
        len = LOCAL_STORAGE.length;
      for (i = 0; i < len; i++) {
        if ((key = LOCAL_STORAGE.key(i)).match(keyMatcher)) {
          keys.push(key.replace(keyMatcher, ""));
        }
      }
      return keys;
    }
  }();
  var Transport = function () {
    "use strict";

    var pendingRequestsCount = 0,
      pendingRequests = {},
      maxPendingRequests = 6,
      sharedCache = new LruCache(10);
    function Transport(o) {
      o = o || {};
      this.cancelled = false;
      this.lastReq = null;
      this._send = o.transport;
      this._get = o.limiter ? o.limiter(this._get) : this._get;
      this._cache = o.cache === false ? new LruCache(0) : sharedCache;
    }
    Transport.setMaxPendingRequests = function setMaxPendingRequests(num) {
      maxPendingRequests = num;
    };
    Transport.resetCache = function resetCache() {
      sharedCache.reset();
    };
    _.mixin(Transport.prototype, {
      _fingerprint: function fingerprint(o) {
        o = o || {};
        return o.url + o.type + $.param(o.data || {});
      },
      _get: function _get(o, cb) {
        var that = this,
          fingerprint,
          jqXhr;
        fingerprint = this._fingerprint(o);
        if (this.cancelled || fingerprint !== this.lastReq) {
          return;
        }
        if (jqXhr = pendingRequests[fingerprint]) {
          jqXhr.done(done).fail(fail);
        } else if (pendingRequestsCount < maxPendingRequests) {
          pendingRequestsCount++;
          pendingRequests[fingerprint] = this._send(o).done(done).fail(fail).always(always);
        } else {
          this.onDeckRequestArgs = [].slice.call(arguments, 0);
        }
        function done(resp) {
          cb(null, resp);
          that._cache.set(fingerprint, resp);
        }
        function fail() {
          cb(true);
        }
        function always() {
          pendingRequestsCount--;
          delete pendingRequests[fingerprint];
          if (that.onDeckRequestArgs) {
            that._get.apply(that, that.onDeckRequestArgs);
            that.onDeckRequestArgs = null;
          }
        }
      },
      get: function get(o, cb) {
        var resp, fingerprint;
        cb = cb || $.noop;
        o = _.isString(o) ? {
          url: o
        } : o || {};
        fingerprint = this._fingerprint(o);
        this.cancelled = false;
        this.lastReq = fingerprint;
        if (resp = this._cache.get(fingerprint)) {
          cb(null, resp);
        } else {
          this._get(o, cb);
        }
      },
      cancel: function cancel() {
        this.cancelled = true;
      }
    });
    return Transport;
  }();
  var SearchIndex = window.SearchIndex = function () {
    "use strict";

    var CHILDREN = "c",
      IDS = "i";
    function SearchIndex(o) {
      o = o || {};
      if (!o.datumTokenizer || !o.queryTokenizer) {
        $.error("datumTokenizer and queryTokenizer are both required");
      }
      this.identify = o.identify || _.stringify;
      this.datumTokenizer = o.datumTokenizer;
      this.queryTokenizer = o.queryTokenizer;
      this.reset();
    }
    _.mixin(SearchIndex.prototype, {
      bootstrap: function bootstrap(o) {
        this.datums = o.datums;
        this.trie = o.trie;
      },
      add: function add(data) {
        var that = this;
        data = _.isArray(data) ? data : [data];
        _.each(data, function (datum) {
          var id, tokens;
          that.datums[id = that.identify(datum)] = datum;
          tokens = normalizeTokens(that.datumTokenizer(datum));
          _.each(tokens, function (token) {
            var node, chars, ch;
            node = that.trie;
            chars = token.split("");
            while (ch = chars.shift()) {
              node = node[CHILDREN][ch] || (node[CHILDREN][ch] = newNode());
              node[IDS].push(id);
            }
          });
        });
      },
      get: function get(ids) {
        var that = this;
        return _.map(ids, function (id) {
          return that.datums[id];
        });
      },
      search: function search(query) {
        var that = this,
          tokens,
          matches;
        tokens = normalizeTokens(this.queryTokenizer(query));
        _.each(tokens, function (token) {
          var node, chars, ch, ids;
          if (matches && matches.length === 0) {
            return false;
          }
          node = that.trie;
          chars = token.split("");
          while (node && (ch = chars.shift())) {
            node = node[CHILDREN][ch];
          }
          if (node && chars.length === 0) {
            ids = node[IDS].slice(0);
            matches = matches ? getIntersection(matches, ids) : ids;
          } else {
            matches = [];
            return false;
          }
        });
        return matches ? _.map(unique(matches), function (id) {
          return that.datums[id];
        }) : [];
      },
      all: function all() {
        var values = [];
        for (var key in this.datums) {
          values.push(this.datums[key]);
        }
        return values;
      },
      reset: function reset() {
        this.datums = {};
        this.trie = newNode();
      },
      serialize: function serialize() {
        return {
          datums: this.datums,
          trie: this.trie
        };
      }
    });
    return SearchIndex;
    function normalizeTokens(tokens) {
      tokens = _.filter(tokens, function (token) {
        return !!token;
      });
      tokens = _.map(tokens, function (token) {
        return token.toLowerCase();
      });
      return tokens;
    }
    function newNode() {
      var node = {};
      node[IDS] = [];
      node[CHILDREN] = {};
      return node;
    }
    function unique(array) {
      var seen = {},
        uniques = [];
      for (var i = 0, len = array.length; i < len; i++) {
        if (!seen[array[i]]) {
          seen[array[i]] = true;
          uniques.push(array[i]);
        }
      }
      return uniques;
    }
    function getIntersection(arrayA, arrayB) {
      var ai = 0,
        bi = 0,
        intersection = [];
      arrayA = arrayA.sort();
      arrayB = arrayB.sort();
      var lenArrayA = arrayA.length,
        lenArrayB = arrayB.length;
      while (ai < lenArrayA && bi < lenArrayB) {
        if (arrayA[ai] < arrayB[bi]) {
          ai++;
        } else if (arrayA[ai] > arrayB[bi]) {
          bi++;
        } else {
          intersection.push(arrayA[ai]);
          ai++;
          bi++;
        }
      }
      return intersection;
    }
  }();
  var Prefetch = function () {
    "use strict";

    var keys;
    keys = {
      data: "data",
      protocol: "protocol",
      thumbprint: "thumbprint"
    };
    function Prefetch(o) {
      this.url = o.url;
      this.ttl = o.ttl;
      this.cache = o.cache;
      this.prepare = o.prepare;
      this.transform = o.transform;
      this.transport = o.transport;
      this.thumbprint = o.thumbprint;
      this.storage = new PersistentStorage(o.cacheKey);
    }
    _.mixin(Prefetch.prototype, {
      _settings: function settings() {
        return {
          url: this.url,
          type: "GET",
          dataType: "json"
        };
      },
      store: function store(data) {
        if (!this.cache) {
          return;
        }
        this.storage.set(keys.data, data, this.ttl);
        this.storage.set(keys.protocol, location.protocol, this.ttl);
        this.storage.set(keys.thumbprint, this.thumbprint, this.ttl);
      },
      fromCache: function fromCache() {
        var stored = {},
          isExpired;
        if (!this.cache) {
          return null;
        }
        stored.data = this.storage.get(keys.data);
        stored.protocol = this.storage.get(keys.protocol);
        stored.thumbprint = this.storage.get(keys.thumbprint);
        isExpired = stored.thumbprint !== this.thumbprint || stored.protocol !== location.protocol;
        return stored.data && !isExpired ? stored.data : null;
      },
      fromNetwork: function fromNetwork(cb) {
        var that = this,
          settings;
        if (!cb) {
          return;
        }
        settings = this.prepare(this._settings());
        this.transport(settings).fail(onError).done(onResponse);
        function onError() {
          cb(true);
        }
        function onResponse(resp) {
          cb(null, that.transform(resp));
        }
      },
      clear: function clear() {
        this.storage.clear();
        return this;
      }
    });
    return Prefetch;
  }();
  var Remote = function () {
    "use strict";

    function Remote(o) {
      this.url = o.url;
      this.prepare = o.prepare;
      this.transform = o.transform;
      this.transport = new Transport({
        cache: o.cache,
        limiter: o.limiter,
        transport: o.transport
      });
    }
    _.mixin(Remote.prototype, {
      _settings: function settings() {
        return {
          url: this.url,
          type: "GET",
          dataType: "json"
        };
      },
      get: function get(query, cb) {
        var that = this,
          settings;
        if (!cb) {
          return;
        }
        query = query || "";
        settings = this.prepare(query, this._settings());
        return this.transport.get(settings, onResponse);
        function onResponse(err, resp) {
          err ? cb([]) : cb(that.transform(resp));
        }
      },
      cancelLastRequest: function cancelLastRequest() {
        this.transport.cancel();
      }
    });
    return Remote;
  }();
  var oParser = function () {
    "use strict";

    return function parse(o) {
      var defaults, sorter;
      defaults = {
        initialize: true,
        identify: _.stringify,
        datumTokenizer: null,
        queryTokenizer: null,
        sufficient: 5,
        sorter: null,
        local: [],
        prefetch: null,
        remote: null
      };
      o = _.mixin(defaults, o || {});
      !o.datumTokenizer && $.error("datumTokenizer is required");
      !o.queryTokenizer && $.error("queryTokenizer is required");
      sorter = o.sorter;
      o.sorter = sorter ? function (x) {
        return x.sort(sorter);
      } : _.identity;
      o.local = _.isFunction(o.local) ? o.local() : o.local;
      o.prefetch = parsePrefetch(o.prefetch);
      o.remote = parseRemote(o.remote);
      return o;
    };
    function parsePrefetch(o) {
      var defaults;
      if (!o) {
        return null;
      }
      defaults = {
        url: null,
        ttl: 24 * 60 * 60 * 1e3,
        cache: true,
        cacheKey: null,
        thumbprint: "",
        prepare: _.identity,
        transform: _.identity,
        transport: null
      };
      o = _.isString(o) ? {
        url: o
      } : o;
      o = _.mixin(defaults, o);
      !o.url && $.error("prefetch requires url to be set");
      o.transform = o.filter || o.transform;
      o.cacheKey = o.cacheKey || o.url;
      o.thumbprint = VERSION + o.thumbprint;
      o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
      return o;
    }
    function parseRemote(o) {
      var defaults;
      if (!o) {
        return;
      }
      defaults = {
        url: null,
        cache: true,
        prepare: null,
        replace: null,
        wildcard: null,
        limiter: null,
        rateLimitBy: "debounce",
        rateLimitWait: 300,
        transform: _.identity,
        transport: null
      };
      o = _.isString(o) ? {
        url: o
      } : o;
      o = _.mixin(defaults, o);
      !o.url && $.error("remote requires url to be set");
      o.transform = o.filter || o.transform;
      o.prepare = toRemotePrepare(o);
      o.limiter = toLimiter(o);
      o.transport = o.transport ? callbackToDeferred(o.transport) : $.ajax;
      delete o.replace;
      delete o.wildcard;
      delete o.rateLimitBy;
      delete o.rateLimitWait;
      return o;
    }
    function toRemotePrepare(o) {
      var prepare, replace, wildcard;
      prepare = o.prepare;
      replace = o.replace;
      wildcard = o.wildcard;
      if (prepare) {
        return prepare;
      }
      if (replace) {
        prepare = prepareByReplace;
      } else if (o.wildcard) {
        prepare = prepareByWildcard;
      } else {
        prepare = idenityPrepare;
      }
      return prepare;
      function prepareByReplace(query, settings) {
        settings.url = replace(settings.url, query);
        return settings;
      }
      function prepareByWildcard(query, settings) {
        settings.url = settings.url.replace(wildcard, encodeURIComponent(query));
        return settings;
      }
      function idenityPrepare(query, settings) {
        return settings;
      }
    }
    function toLimiter(o) {
      var limiter, method, wait;
      limiter = o.limiter;
      method = o.rateLimitBy;
      wait = o.rateLimitWait;
      if (!limiter) {
        limiter = /^throttle$/i.test(method) ? throttle(wait) : debounce(wait);
      }
      return limiter;
      function debounce(wait) {
        return function debounce(fn) {
          return _.debounce(fn, wait);
        };
      }
      function throttle(wait) {
        return function throttle(fn) {
          return _.throttle(fn, wait);
        };
      }
    }
    function callbackToDeferred(fn) {
      return function wrapper(o) {
        var deferred = $.Deferred();
        fn(o, onSuccess, onError);
        return deferred;
        function onSuccess(resp) {
          _.defer(function () {
            deferred.resolve(resp);
          });
        }
        function onError(err) {
          _.defer(function () {
            deferred.reject(err);
          });
        }
      };
    }
  }();
  var Bloodhound = function () {
    "use strict";

    var old;
    old = window && window.Bloodhound;
    function Bloodhound(o) {
      o = oParser(o);
      this.sorter = o.sorter;
      this.identify = o.identify;
      this.sufficient = o.sufficient;
      this.local = o.local;
      this.remote = o.remote ? new Remote(o.remote) : null;
      this.prefetch = o.prefetch ? new Prefetch(o.prefetch) : null;
      this.index = new SearchIndex({
        identify: this.identify,
        datumTokenizer: o.datumTokenizer,
        queryTokenizer: o.queryTokenizer
      });
      o.initialize !== false && this.initialize();
    }
    Bloodhound.noConflict = function noConflict() {
      window && (window.Bloodhound = old);
      return Bloodhound;
    };
    Bloodhound.tokenizers = tokenizers;
    _.mixin(Bloodhound.prototype, {
      __ttAdapter: function ttAdapter() {
        var that = this;
        return this.remote ? withAsync : withoutAsync;
        function withAsync(query, sync, async) {
          return that.search(query, sync, async);
        }
        function withoutAsync(query, sync) {
          return that.search(query, sync);
        }
      },
      _loadPrefetch: function loadPrefetch() {
        var that = this,
          deferred,
          serialized;
        deferred = $.Deferred();
        if (!this.prefetch) {
          deferred.resolve();
        } else if (serialized = this.prefetch.fromCache()) {
          this.index.bootstrap(serialized);
          deferred.resolve();
        } else {
          this.prefetch.fromNetwork(done);
        }
        return deferred.promise();
        function done(err, data) {
          if (err) {
            return deferred.reject();
          }
          that.add(data);
          that.prefetch.store(that.index.serialize());
          deferred.resolve();
        }
      },
      _initialize: function initialize() {
        var that = this,
          deferred;
        this.clear();
        (this.initPromise = this._loadPrefetch()).done(addLocalToIndex);
        return this.initPromise;
        function addLocalToIndex() {
          that.add(that.local);
        }
      },
      initialize: function initialize(force) {
        return !this.initPromise || force ? this._initialize() : this.initPromise;
      },
      add: function add(data) {
        this.index.add(data);
        return this;
      },
      get: function get(ids) {
        ids = _.isArray(ids) ? ids : [].slice.call(arguments);
        return this.index.get(ids);
      },
      search: function search(query, sync, async) {
        var that = this,
          local;
        local = this.sorter(this.index.search(query));
        sync(this.remote ? local.slice() : local);
        if (this.remote && local.length < this.sufficient) {
          this.remote.get(query, processRemote);
        } else if (this.remote) {
          this.remote.cancelLastRequest();
        }
        return this;
        function processRemote(remote) {
          var nonDuplicates = [];
          _.each(remote, function (r) {
            !_.some(local, function (l) {
              return that.identify(r) === that.identify(l);
            }) && nonDuplicates.push(r);
          });
          async && async(nonDuplicates);
        }
      },
      all: function all() {
        return this.index.all();
      },
      clear: function clear() {
        this.index.reset();
        return this;
      },
      clearPrefetchCache: function clearPrefetchCache() {
        this.prefetch && this.prefetch.clear();
        return this;
      },
      clearRemoteCache: function clearRemoteCache() {
        Transport.resetCache();
        return this;
      },
      ttAdapter: function ttAdapter() {
        return this.__ttAdapter();
      }
    });
    return Bloodhound;
  }();
  return Bloodhound;
});
(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (a0) {
      return factory(a0);
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object") {
    module.exports = factory(require("jquery"));
  } else {
    factory(jQuery);
  }
})(this, function ($) {
  var _ = function () {
    "use strict";

    return {
      isMsie: function isMsie() {
        return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
      },
      isBlankString: function isBlankString(str) {
        return !str || /^\s*$/.test(str);
      },
      escapeRegExChars: function escapeRegExChars(str) {
        return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      },
      isString: function isString(obj) {
        return typeof obj === "string";
      },
      isNumber: function isNumber(obj) {
        return typeof obj === "number";
      },
      isArray: $.isArray,
      isFunction: $.isFunction,
      isObject: $.isPlainObject,
      isUndefined: function isUndefined(obj) {
        return typeof obj === "undefined";
      },
      isElement: function isElement(obj) {
        return !!(obj && obj.nodeType === 1);
      },
      isJQuery: function isJQuery(obj) {
        return obj instanceof $;
      },
      toStr: function toStr(s) {
        return _.isUndefined(s) || s === null ? "" : s + "";
      },
      bind: $.proxy,
      each: function each(collection, cb) {
        $.each(collection, reverseArgs);
        function reverseArgs(index, value) {
          return cb(value, index);
        }
      },
      map: $.map,
      filter: $.grep,
      every: function every(obj, test) {
        var result = true;
        if (!obj) {
          return result;
        }
        $.each(obj, function (key, val) {
          if (!(result = test.call(null, val, key, obj))) {
            return false;
          }
        });
        return !!result;
      },
      some: function some(obj, test) {
        var result = false;
        if (!obj) {
          return result;
        }
        $.each(obj, function (key, val) {
          if (result = test.call(null, val, key, obj)) {
            return false;
          }
        });
        return !!result;
      },
      mixin: $.extend,
      identity: function identity(x) {
        return x;
      },
      clone: function clone(obj) {
        return $.extend(true, {}, obj);
      },
      getIdGenerator: function getIdGenerator() {
        var counter = 0;
        return function () {
          return counter++;
        };
      },
      templatify: function templatify(obj) {
        return $.isFunction(obj) ? obj : template;
        function template() {
          return String(obj);
        }
      },
      defer: function defer(fn) {
        setTimeout(fn, 0);
      },
      debounce: function debounce(func, wait, immediate) {
        var timeout, result;
        return function () {
          var context = this,
            args = arguments,
            later,
            callNow;
          later = function later() {
            timeout = null;
            if (!immediate) {
              result = func.apply(context, args);
            }
          };
          callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) {
            result = func.apply(context, args);
          }
          return result;
        };
      },
      throttle: function throttle(func, wait) {
        var context, args, timeout, result, previous, later;
        previous = 0;
        later = function later() {
          previous = new Date();
          timeout = null;
          result = func.apply(context, args);
        };
        return function () {
          var now = new Date(),
            remaining = wait - (now - previous);
          context = this;
          args = arguments;
          if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
          } else if (!timeout) {
            timeout = setTimeout(later, remaining);
          }
          return result;
        };
      },
      stringify: function stringify(val) {
        return _.isString(val) ? val : JSON.stringify(val);
      },
      noop: function noop() {}
    };
  }();
  var WWW = function () {
    "use strict";

    var defaultClassNames = {
      wrapper: "twitter-typeahead",
      input: "tt-input",
      hint: "tt-hint",
      menu: "tt-menu",
      dataset: "tt-dataset",
      suggestion: "tt-suggestion",
      selectable: "tt-selectable",
      empty: "tt-empty",
      open: "tt-open",
      cursor: "tt-cursor",
      highlight: "tt-highlight"
    };
    return build;
    function build(o) {
      var www, classes;
      classes = _.mixin({}, defaultClassNames, o);
      www = {
        css: buildCss(),
        classes: classes,
        html: buildHtml(classes),
        selectors: buildSelectors(classes)
      };
      return {
        css: www.css,
        html: www.html,
        classes: www.classes,
        selectors: www.selectors,
        mixin: function mixin(o) {
          _.mixin(o, www);
        }
      };
    }
    function buildHtml(c) {
      return {
        wrapper: '<span class="' + c.wrapper + '"></span>',
        menu: '<div class="' + c.menu + '"></div>'
      };
    }
    function buildSelectors(classes) {
      var selectors = {};
      _.each(classes, function (v, k) {
        selectors[k] = "." + v;
      });
      return selectors;
    }
    function buildCss() {
      var css = {
        wrapper: {
          position: "relative",
          display: "inline-block"
        },
        hint: {
          position: "absolute",
          top: "0",
          left: "0",
          borderColor: "transparent",
          boxShadow: "none",
          opacity: "1"
        },
        input: {
          position: "relative",
          verticalAlign: "top",
          backgroundColor: "transparent"
        },
        inputWithNoHint: {
          position: "relative",
          verticalAlign: "top"
        },
        menu: {
          position: "absolute",
          top: "100%",
          left: "0",
          zIndex: "100",
          display: "none"
        },
        ltr: {
          left: "0",
          right: "auto"
        },
        rtl: {
          left: "auto",
          right: " 0"
        }
      };
      if (_.isMsie()) {
        _.mixin(css.input, {
          backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7)"
        });
      }
      return css;
    }
  }();
  var EventBus = function () {
    "use strict";

    var namespace, deprecationMap;
    namespace = "typeahead:";
    deprecationMap = {
      render: "rendered",
      cursorchange: "cursorchanged",
      select: "selected",
      autocomplete: "autocompleted"
    };
    function EventBus(o) {
      if (!o || !o.el) {
        $.error("EventBus initialized without el");
      }
      this.$el = $(o.el);
    }
    _.mixin(EventBus.prototype, {
      _trigger: function _trigger(type, args) {
        var $e;
        $e = $.Event(namespace + type);
        (args = args || []).unshift($e);
        this.$el.trigger.apply(this.$el, args);
        return $e;
      },
      before: function before(type) {
        var args, $e;
        args = [].slice.call(arguments, 1);
        $e = this._trigger("before" + type, args);
        return $e.isDefaultPrevented();
      },
      trigger: function trigger(type) {
        var deprecatedType;
        this._trigger(type, [].slice.call(arguments, 1));
        if (deprecatedType = deprecationMap[type]) {
          this._trigger(deprecatedType, [].slice.call(arguments, 1));
        }
      }
    });
    return EventBus;
  }();
  var EventEmitter = function () {
    "use strict";

    var splitter = /\s+/,
      nextTick = getNextTick();
    return {
      onSync: onSync,
      onAsync: onAsync,
      off: off,
      trigger: trigger
    };
    function on(method, types, cb, context) {
      var type;
      if (!cb) {
        return this;
      }
      types = types.split(splitter);
      cb = context ? bindContext(cb, context) : cb;
      this._callbacks = this._callbacks || {};
      while (type = types.shift()) {
        this._callbacks[type] = this._callbacks[type] || {
          sync: [],
          async: []
        };
        this._callbacks[type][method].push(cb);
      }
      return this;
    }
    function onAsync(types, cb, context) {
      return on.call(this, "async", types, cb, context);
    }
    function onSync(types, cb, context) {
      return on.call(this, "sync", types, cb, context);
    }
    function off(types) {
      var type;
      if (!this._callbacks) {
        return this;
      }
      types = types.split(splitter);
      while (type = types.shift()) {
        delete this._callbacks[type];
      }
      return this;
    }
    function trigger(types) {
      var type, callbacks, args, syncFlush, asyncFlush;
      if (!this._callbacks) {
        return this;
      }
      types = types.split(splitter);
      args = [].slice.call(arguments, 1);
      while ((type = types.shift()) && (callbacks = this._callbacks[type])) {
        syncFlush = getFlush(callbacks.sync, this, [type].concat(args));
        asyncFlush = getFlush(callbacks.async, this, [type].concat(args));
        syncFlush() && nextTick(asyncFlush);
      }
      return this;
    }
    function getFlush(callbacks, context, args) {
      return flush;
      function flush() {
        var cancelled;
        for (var i = 0, len = callbacks.length; !cancelled && i < len; i += 1) {
          cancelled = callbacks[i].apply(context, args) === false;
        }
        return !cancelled;
      }
    }
    function getNextTick() {
      var nextTickFn;
      if (window.setImmediate) {
        nextTickFn = function nextTickSetImmediate(fn) {
          setImmediate(function () {
            fn();
          });
        };
      } else {
        nextTickFn = function nextTickSetTimeout(fn) {
          setTimeout(function () {
            fn();
          }, 0);
        };
      }
      return nextTickFn;
    }
    function bindContext(fn, context) {
      return fn.bind ? fn.bind(context) : function () {
        fn.apply(context, [].slice.call(arguments, 0));
      };
    }
  }();
  var highlight = function (doc) {
    "use strict";

    var defaults = {
      node: null,
      pattern: null,
      tagName: "strong",
      className: null,
      wordsOnly: false,
      caseSensitive: false
    };
    return function hightlight(o) {
      var regex;
      o = _.mixin({}, defaults, o);
      if (!o.node || !o.pattern) {
        return;
      }
      o.pattern = _.isArray(o.pattern) ? o.pattern : [o.pattern];
      regex = getRegex(o.pattern, o.caseSensitive, o.wordsOnly);
      traverse(o.node, hightlightTextNode);
      function hightlightTextNode(textNode) {
        var match, patternNode, wrapperNode;
        if (match = regex.exec(textNode.data)) {
          wrapperNode = doc.createElement(o.tagName);
          o.className && (wrapperNode.className = o.className);
          patternNode = textNode.splitText(match.index);
          patternNode.splitText(match[0].length);
          wrapperNode.appendChild(patternNode.cloneNode(true));
          textNode.parentNode.replaceChild(wrapperNode, patternNode);
        }
        return !!match;
      }
      function traverse(el, hightlightTextNode) {
        var childNode,
          TEXT_NODE_TYPE = 3;
        for (var i = 0; i < el.childNodes.length; i++) {
          childNode = el.childNodes[i];
          if (childNode.nodeType === TEXT_NODE_TYPE) {
            i += hightlightTextNode(childNode) ? 1 : 0;
          } else {
            traverse(childNode, hightlightTextNode);
          }
        }
      }
    };
    function getRegex(patterns, caseSensitive, wordsOnly) {
      var escapedPatterns = [],
        regexStr;
      for (var i = 0, len = patterns.length; i < len; i++) {
        escapedPatterns.push(_.escapeRegExChars(patterns[i]));
      }
      regexStr = wordsOnly ? "\\b(" + escapedPatterns.join("|") + ")\\b" : "(" + escapedPatterns.join("|") + ")";
      return caseSensitive ? new RegExp(regexStr) : new RegExp(regexStr, "i");
    }
  }(window.document);
  var Input = function () {
    "use strict";

    var specialKeyCodeMap;
    specialKeyCodeMap = {
      9: "tab",
      27: "esc",
      37: "left",
      39: "right",
      13: "enter",
      38: "up",
      40: "down"
    };
    function Input(o, www) {
      o = o || {};
      if (!o.input) {
        $.error("input is missing");
      }
      www.mixin(this);
      this.$hint = $(o.hint);
      this.$input = $(o.input);
      this.query = this.$input.val();
      this.queryWhenFocused = this.hasFocus() ? this.query : null;
      this.$overflowHelper = buildOverflowHelper(this.$input);
      this._checkLanguageDirection();
      if (this.$hint.length === 0) {
        this.setHint = this.getHint = this.clearHint = this.clearHintIfInvalid = _.noop;
      }
    }
    Input.normalizeQuery = function (str) {
      return _.toStr(str).replace(/^\s*/g, "").replace(/\s{2,}/g, " ");
    };
    _.mixin(Input.prototype, EventEmitter, {
      _onBlur: function onBlur() {
        this.resetInputValue();
        this.trigger("blurred");
      },
      _onFocus: function onFocus() {
        this.queryWhenFocused = this.query;
        this.trigger("focused");
      },
      _onKeydown: function onKeydown($e) {
        var keyName = specialKeyCodeMap[$e.which || $e.keyCode];
        if (keyName === "right") {
          return;
        }
        this._managePreventDefault(keyName, $e);
        if (keyName && this._shouldTrigger(keyName, $e)) {
          this.trigger(keyName + "Keyed", $e);
        }
      },
      _onInput: function onInput() {
        this._setQuery(this.getInputValue());
        this.clearHintIfInvalid();
        this._checkLanguageDirection();
      },
      _managePreventDefault: function managePreventDefault(keyName, $e) {
        var preventDefault;
        switch (keyName) {
          case "up":
          case "down":
            preventDefault = !withModifier($e);
            break;
          default:
            preventDefault = false;
        }
        preventDefault && $e.preventDefault();
      },
      _shouldTrigger: function shouldTrigger(keyName, $e) {
        var trigger;
        switch (keyName) {
          case "tab":
            trigger = !withModifier($e);
            break;
          default:
            trigger = true;
        }
        return trigger;
      },
      _checkLanguageDirection: function checkLanguageDirection() {
        var dir = (this.$input.css("direction") || "ltr").toLowerCase();
        if (this.dir !== dir) {
          this.dir = dir;
          this.$hint.attr("dir", dir);
          this.trigger("langDirChanged", dir);
        }
      },
      _setQuery: function setQuery(val, silent) {
        var areEquivalent, hasDifferentWhitespace;
        areEquivalent = areQueriesEquivalent(val, this.query);
        hasDifferentWhitespace = areEquivalent ? this.query.length !== val.length : false;
        this.query = val;
        if (!silent && !areEquivalent) {
          this.trigger("queryChanged", this.query);
        } else if (!silent && hasDifferentWhitespace) {
          this.trigger("whitespaceChanged", this.query);
        }
      },
      bind: function bind() {
        var that = this,
          onBlur,
          onFocus,
          onKeydown,
          onInput;
        onBlur = _.bind(this._onBlur, this);
        onFocus = _.bind(this._onFocus, this);
        onKeydown = _.bind(this._onKeydown, this);
        onInput = _.bind(this._onInput, this);
        this.$input.on("blur.tt", onBlur).on("focus.tt", onFocus).on("keydown.tt", onKeydown);
        if (!_.isMsie() || _.isMsie() > 9) {
          this.$input.on("input.tt", onInput);
        } else {
          this.$input.on("keydown.tt keypress.tt cut.tt paste.tt", function ($e) {
            if (specialKeyCodeMap[$e.which || $e.keyCode]) {
              return;
            }
            _.defer(_.bind(that._onInput, that, $e));
          });
        }
        return this;
      },
      focus: function focus() {
        this.$input.focus();
      },
      blur: function blur() {
        this.$input.blur();
      },
      getLangDir: function getLangDir() {
        return this.dir;
      },
      getQuery: function getQuery() {
        return this.query || "";
      },
      setQuery: function setQuery(val, silent) {
        this.setInputValue(val);
        this._setQuery(val, silent);
      },
      hasQueryChangedSinceLastFocus: function hasQueryChangedSinceLastFocus() {
        return this.query !== this.queryWhenFocused;
      },
      getInputValue: function getInputValue() {
        return this.$input.val();
      },
      setInputValue: function setInputValue(value) {
        this.$input.val(value);
        this.clearHintIfInvalid();
        this._checkLanguageDirection();
      },
      resetInputValue: function resetInputValue() {
        this.setInputValue(this.query);
      },
      getHint: function getHint() {
        return this.$hint.val();
      },
      setHint: function setHint(value) {
        this.$hint.val(value);
      },
      clearHint: function clearHint() {
        this.setHint("");
      },
      clearHintIfInvalid: function clearHintIfInvalid() {
        var val, hint, valIsPrefixOfHint, isValid;
        val = this.getInputValue();
        hint = this.getHint();
        valIsPrefixOfHint = val !== hint && hint.indexOf(val) === 0;
        isValid = val !== "" && valIsPrefixOfHint && !this.hasOverflow();
        !isValid && this.clearHint();
      },
      hasFocus: function hasFocus() {
        return this.$input.is(":focus");
      },
      hasOverflow: function hasOverflow() {
        var constraint = this.$input.width() - 2;
        this.$overflowHelper.text(this.getInputValue());
        return this.$overflowHelper.width() >= constraint;
      },
      isCursorAtEnd: function isCursorAtEnd() {
        var valueLength, selectionStart, range;
        valueLength = this.$input.val().length;
        selectionStart = this.$input[0].selectionStart;
        if (_.isNumber(selectionStart)) {
          return selectionStart === valueLength;
        } else if (document.selection) {
          range = document.selection.createRange();
          range.moveStart("character", -valueLength);
          return valueLength === range.text.length;
        }
        return true;
      },
      destroy: function destroy() {
        this.$hint.off(".tt");
        this.$input.off(".tt");
        this.$overflowHelper.remove();
        this.$hint = this.$input = this.$overflowHelper = $("<div>");
      }
    });
    return Input;
    function buildOverflowHelper($input) {
      return $('<pre aria-hidden="true"></pre>').css({
        position: "absolute",
        visibility: "hidden",
        whiteSpace: "pre",
        fontFamily: $input.css("font-family"),
        fontSize: $input.css("font-size"),
        fontStyle: $input.css("font-style"),
        fontVariant: $input.css("font-variant"),
        fontWeight: $input.css("font-weight"),
        wordSpacing: $input.css("word-spacing"),
        letterSpacing: $input.css("letter-spacing"),
        textIndent: $input.css("text-indent"),
        textRendering: $input.css("text-rendering"),
        textTransform: $input.css("text-transform")
      }).insertAfter($input);
    }
    function areQueriesEquivalent(a, b) {
      return Input.normalizeQuery(a) === Input.normalizeQuery(b);
    }
    function withModifier($e) {
      return $e.altKey || $e.ctrlKey || $e.metaKey || $e.shiftKey;
    }
  }();
  var Dataset = function () {
    "use strict";

    var keys, nameGenerator;
    keys = {
      val: "tt-selectable-display",
      obj: "tt-selectable-object"
    };
    nameGenerator = _.getIdGenerator();
    function Dataset(o, www) {
      o = o || {};
      o.templates = o.templates || {};
      o.templates.notFound = o.templates.notFound || o.templates.empty;
      if (!o.source) {
        $.error("missing source");
      }
      if (!o.node) {
        $.error("missing node");
      }
      if (o.name && !isValidName(o.name)) {
        $.error("invalid dataset name:" + o.name);
      }
      www.mixin(this);
      this.highlight = !!o.highlight;
      this.name = o.name || nameGenerator();
      this.limit = o.limit || 5;
      this.displayFn = getDisplayFn(o.display || o.displayKey);
      this.templates = getTemplates(o.templates, this.displayFn);
      this.source = o.source.__ttAdapter ? o.source.__ttAdapter() : o.source;
      this.async = _.isUndefined(o.async) ? this.source.length > 2 : !!o.async;
      this._resetLastSuggestion();
      this.$el = $(o.node).addClass(this.classes.dataset).addClass(this.classes.dataset + "-" + this.name);
    }
    Dataset.extractData = function extractData(el) {
      var $el = $(el);
      if ($el.data(keys.obj)) {
        return {
          val: $el.data(keys.val) || "",
          obj: $el.data(keys.obj) || null
        };
      }
      return null;
    };
    _.mixin(Dataset.prototype, EventEmitter, {
      _overwrite: function overwrite(query, suggestions) {
        suggestions = suggestions || [];
        if (suggestions.length) {
          this._renderSuggestions(query, suggestions);
        } else if (this.async && this.templates.pending) {
          this._renderPending(query);
        } else if (!this.async && this.templates.notFound) {
          this._renderNotFound(query);
        } else {
          this._empty();
        }
        this.trigger("rendered", this.name, suggestions, false);
      },
      _append: function append(query, suggestions) {
        suggestions = suggestions || [];
        if (suggestions.length && this.$lastSuggestion.length) {
          this._appendSuggestions(query, suggestions);
        } else if (suggestions.length) {
          this._renderSuggestions(query, suggestions);
        } else if (!this.$lastSuggestion.length && this.templates.notFound) {
          this._renderNotFound(query);
        }
        this.trigger("rendered", this.name, suggestions, true);
      },
      _renderSuggestions: function renderSuggestions(query, suggestions) {
        var $fragment;
        $fragment = this._getSuggestionsFragment(query, suggestions);
        this.$lastSuggestion = $fragment.children().last();
        this.$el.html($fragment).prepend(this._getHeader(query, suggestions)).append(this._getFooter(query, suggestions));
      },
      _appendSuggestions: function appendSuggestions(query, suggestions) {
        var $fragment, $lastSuggestion;
        $fragment = this._getSuggestionsFragment(query, suggestions);
        $lastSuggestion = $fragment.children().last();
        this.$lastSuggestion.after($fragment);
        this.$lastSuggestion = $lastSuggestion;
      },
      _renderPending: function renderPending(query) {
        var template = this.templates.pending;
        this._resetLastSuggestion();
        template && this.$el.html(template({
          query: query,
          dataset: this.name
        }));
      },
      _renderNotFound: function renderNotFound(query) {
        var template = this.templates.notFound;
        this._resetLastSuggestion();
        template && this.$el.html(template({
          query: query,
          dataset: this.name
        }));
      },
      _empty: function empty() {
        this.$el.empty();
        this._resetLastSuggestion();
      },
      _getSuggestionsFragment: function getSuggestionsFragment(query, suggestions) {
        var that = this,
          fragment;
        fragment = document.createDocumentFragment();
        _.each(suggestions, function getSuggestionNode(suggestion) {
          var $el, context;
          context = that._injectQuery(query, suggestion);
          $el = $(that.templates.suggestion(context)).data(keys.obj, suggestion).data(keys.val, that.displayFn(suggestion)).addClass(that.classes.suggestion + " " + that.classes.selectable);
          fragment.appendChild($el[0]);
        });
        this.highlight && highlight({
          className: this.classes.highlight,
          node: fragment,
          pattern: query
        });
        return $(fragment);
      },
      _getFooter: function getFooter(query, suggestions) {
        return this.templates.footer ? this.templates.footer({
          query: query,
          suggestions: suggestions,
          dataset: this.name
        }) : null;
      },
      _getHeader: function getHeader(query, suggestions) {
        return this.templates.header ? this.templates.header({
          query: query,
          suggestions: suggestions,
          dataset: this.name
        }) : null;
      },
      _resetLastSuggestion: function resetLastSuggestion() {
        this.$lastSuggestion = $();
      },
      _injectQuery: function injectQuery(query, obj) {
        return _.isObject(obj) ? _.mixin({
          _query: query
        }, obj) : obj;
      },
      update: function update(query) {
        var that = this,
          canceled = false,
          syncCalled = false,
          rendered = 0;
        this.cancel();
        this.cancel = function cancel() {
          canceled = true;
          that.cancel = $.noop;
          that.async && that.trigger("asyncCanceled", query);
        };
        this.source(query, sync, async);
        !syncCalled && sync([]);
        function sync(suggestions) {
          if (syncCalled) {
            return;
          }
          syncCalled = true;
          suggestions = (suggestions || []).slice(0, that.limit);
          rendered = suggestions.length;
          that._overwrite(query, suggestions);
          if (rendered < that.limit && that.async) {
            that.trigger("asyncRequested", query);
          }
        }
        function async(suggestions) {
          suggestions = suggestions || [];
          if (!canceled && rendered < that.limit) {
            that.cancel = $.noop;
            rendered += suggestions.length;
            var num = that.limit - rendered;
            if (num == 0) {
              num = rendered;
            }
            that._append(query, suggestions.slice(0, num));
            that.async && that.trigger("asyncReceived", query);
          }
        }
      },
      cancel: $.noop,
      clear: function clear() {
        this._empty();
        this.cancel();
        this.trigger("cleared");
      },
      isEmpty: function isEmpty() {
        return this.$el.is(":empty");
      },
      destroy: function destroy() {
        this.$el = $("<div>");
      }
    });
    return Dataset;
    function getDisplayFn(display) {
      display = display || _.stringify;
      return _.isFunction(display) ? display : displayFn;
      function displayFn(obj) {
        return obj[display];
      }
    }
    function getTemplates(templates, displayFn) {
      return {
        notFound: templates.notFound && _.templatify(templates.notFound),
        pending: templates.pending && _.templatify(templates.pending),
        header: templates.header && _.templatify(templates.header),
        footer: templates.footer && _.templatify(templates.footer),
        suggestion: templates.suggestion || suggestionTemplate
      };
      function suggestionTemplate(context) {
        return $("<div>").text(displayFn(context));
      }
    }
    function isValidName(str) {
      return /^[_a-zA-Z0-9-]+$/.test(str);
    }
  }();
  var Menu = function () {
    "use strict";

    function Menu(o, www) {
      var that = this;
      o = o || {};
      if (!o.node) {
        $.error("node is required");
      }
      www.mixin(this);
      this.$node = $(o.node);
      this.query = null;
      this.datasets = _.map(o.datasets, initializeDataset);
      function initializeDataset(oDataset) {
        var node = that.$node.find(oDataset.node).first();
        oDataset.node = node.length ? node : $("<div>").appendTo(that.$node);
        return new Dataset(oDataset, www);
      }
    }
    _.mixin(Menu.prototype, EventEmitter, {
      _onSelectableClick: function onSelectableClick($e) {
        this.trigger("selectableClicked", $($e.currentTarget));
      },
      _onRendered: function onRendered(type, dataset, suggestions, async) {
        this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
        this.trigger("datasetRendered", dataset, suggestions, async);
      },
      _onCleared: function onCleared() {
        this.$node.toggleClass(this.classes.empty, this._allDatasetsEmpty());
        this.trigger("datasetCleared");
      },
      _propagate: function propagate() {
        this.trigger.apply(this, arguments);
      },
      _allDatasetsEmpty: function allDatasetsEmpty() {
        return _.every(this.datasets, isDatasetEmpty);
        function isDatasetEmpty(dataset) {
          return dataset.isEmpty();
        }
      },
      _getSelectables: function getSelectables() {
        return this.$node.find(this.selectors.selectable);
      },
      _removeCursor: function _removeCursor() {
        var $selectable = this.getActiveSelectable();
        if ($selectable) {
          var $searchResultsLinks = $selectable.find('a');
          $searchResultsLinks.css('text-decoration', 'none');
          $selectable.removeClass(this.classes.cursor);
        }
      },
      _ensureVisible: function ensureVisible($el) {
        var elTop, elBottom, nodeScrollTop, nodeHeight;
        elTop = $el.position().top;
        elBottom = elTop + $el.outerHeight(true);
        nodeScrollTop = this.$node.scrollTop();
        nodeHeight = this.$node.height() + parseInt(this.$node.css("paddingTop"), 10) + parseInt(this.$node.css("paddingBottom"), 10);
        if (elTop < 0) {
          this.$node.scrollTop(nodeScrollTop + elTop);
        } else if (nodeHeight < elBottom) {
          this.$node.scrollTop(nodeScrollTop + (elBottom - nodeHeight));
        }
      },
      bind: function bind() {
        var that = this,
          onSelectableClick;
        onSelectableClick = _.bind(this._onSelectableClick, this);
        this.$node.on("click.tt", this.selectors.selectable, onSelectableClick);
        _.each(this.datasets, function (dataset) {
          dataset.onSync("asyncRequested", that._propagate, that).onSync("asyncCanceled", that._propagate, that).onSync("asyncReceived", that._propagate, that).onSync("rendered", that._onRendered, that).onSync("cleared", that._onCleared, that);
        });
        return this;
      },
      isOpen: function isOpen() {
        return this.$node.hasClass(this.classes.open);
      },
      open: function open() {
        this.$node.addClass(this.classes.open);
      },
      close: function close() {
        this.$node.removeClass(this.classes.open);
        this._removeCursor();
      },
      setLanguageDirection: function setLanguageDirection(dir) {
        this.$node.attr("dir", dir);
      },
      selectableRelativeToCursor: function selectableRelativeToCursor(delta) {
        var $selectables, $oldCursor, oldIndex, newIndex;
        $oldCursor = this.getActiveSelectable();
        $selectables = this._getSelectables();
        oldIndex = $oldCursor ? $selectables.index($oldCursor) : -1;
        newIndex = oldIndex + delta;
        newIndex = (newIndex + 1) % ($selectables.length + 1) - 1;
        newIndex = newIndex < -1 ? $selectables.length - 1 : newIndex;
        return newIndex === -1 ? null : $selectables.eq(newIndex);
      },
      setCursor: function setCursor($selectable) {
        this._removeCursor();
        if ($selectable = $selectable && $selectable.first()) {
          $selectable.addClass(this.classes.cursor);
          var $searchResultsLinks = $selectable.find('a');
          $searchResultsLinks.css('text-decoration', 'underline');
          this._ensureVisible($selectable);
        }
      },
      getSelectableData: function getSelectableData($el) {
        return $el && $el.length ? Dataset.extractData($el) : null;
      },
      getActiveSelectable: function getActiveSelectable() {
        var $selectable = this._getSelectables().filter(this.selectors.cursor).first();
        return $selectable.length ? $selectable : null;
      },
      getTopSelectable: function getTopSelectable() {
        var $selectable = this._getSelectables().first();
        return $selectable.length ? $selectable : null;
      },
      update: function update(query) {
        var isValidUpdate = query !== this.query;
        if (isValidUpdate) {
          this.query = query;
          _.each(this.datasets, updateDataset);
        }
        return isValidUpdate;
        function updateDataset(dataset) {
          dataset.update(query);
        }
      },
      empty: function empty() {
        _.each(this.datasets, clearDataset);
        this.query = null;
        this.$node.addClass(this.classes.empty);
        function clearDataset(dataset) {
          dataset.clear();
        }
      },
      destroy: function destroy() {
        this.$node.off(".tt");
        this.$node = $("<div>");
        _.each(this.datasets, destroyDataset);
        function destroyDataset(dataset) {
          dataset.destroy();
        }
      }
    });
    return Menu;
  }();
  var DefaultMenu = function () {
    "use strict";

    var s = Menu.prototype;
    function DefaultMenu() {
      Menu.apply(this, [].slice.call(arguments, 0));
    }
    _.mixin(DefaultMenu.prototype, Menu.prototype, {
      open: function open() {
        !this._allDatasetsEmpty() && this._show();
        return s.open.apply(this, [].slice.call(arguments, 0));
      },
      close: function close() {
        this._hide();
        return s.close.apply(this, [].slice.call(arguments, 0));
      },
      _onRendered: function onRendered() {
        if (this._allDatasetsEmpty()) {
          this._hide();
        } else {
          this.isOpen() && this._show();
        }
        return s._onRendered.apply(this, [].slice.call(arguments, 0));
      },
      _onCleared: function onCleared() {
        if (this._allDatasetsEmpty()) {
          this._hide();
        } else {
          this.isOpen() && this._show();
        }
        return s._onCleared.apply(this, [].slice.call(arguments, 0));
      },
      setLanguageDirection: function setLanguageDirection(dir) {
        this.$node.css(dir === "ltr" ? this.css.ltr : this.css.rtl);
        return s.setLanguageDirection.apply(this, [].slice.call(arguments, 0));
      },
      _hide: function hide() {
        this.$node.hide();
        this.$node.removeAttr("tabindex");
      },
      _show: function show() {
        this.$node.css("display", "block");
        this.$node.attr("tabindex", "0");
      }
    });
    return DefaultMenu;
  }();
  var Typeahead = function () {
    "use strict";

    function Typeahead(o, www) {
      var onFocused, onBlurred, onEnterKeyed, onTabKeyed, onEscKeyed, onUpKeyed, onDownKeyed, onLeftKeyed, onRightKeyed, onQueryChanged, onWhitespaceChanged;
      o = o || {};
      if (!o.input) {
        $.error("missing input");
      }
      if (!o.menu) {
        $.error("missing menu");
      }
      if (!o.eventBus) {
        $.error("missing event bus");
      }
      www.mixin(this);
      this.eventBus = o.eventBus;
      this.minLength = _.isNumber(o.minLength) ? o.minLength : 1;
      this.input = o.input;
      this.menu = o.menu;
      this.enabled = true;
      this.active = false;
      this.input.hasFocus() && this.activate();
      this.dir = this.input.getLangDir();
      this._hacks();
      this.menu.bind().onSync("selectableClicked", this._onSelectableClicked, this).onSync("asyncRequested", this._onAsyncRequested, this).onSync("asyncCanceled", this._onAsyncCanceled, this).onSync("asyncReceived", this._onAsyncReceived, this).onSync("datasetRendered", this._onDatasetRendered, this).onSync("datasetCleared", this._onDatasetCleared, this);
      onFocused = c(this, "activate", "open", "_onFocused");
      onBlurred = c(this, "deactivate", "_onBlurred");
      onEnterKeyed = c(this, "isActive", "isOpen", "_onEnterKeyed");
      onTabKeyed = c(this, "isActive", "isOpen", "_onTabKeyed");
      onEscKeyed = c(this, "isActive", "_onEscKeyed");
      onUpKeyed = c(this, "isActive", "open", "_onUpKeyed");
      onDownKeyed = c(this, "isActive", "open", "_onDownKeyed");
      onLeftKeyed = c(this, "isActive", "isOpen", "_onLeftKeyed");
      onRightKeyed = c(this, "isActive", "isOpen", "_onRightKeyed");
      onQueryChanged = c(this, "_openIfActive", "_onQueryChanged");
      onWhitespaceChanged = c(this, "_openIfActive", "_onWhitespaceChanged");
      this.input.bind().onSync("focused", onFocused, this).onSync("blurred", onBlurred, this).onSync("enterKeyed", onEnterKeyed, this).onSync("tabKeyed", onTabKeyed, this).onSync("escKeyed", onEscKeyed, this).onSync("upKeyed", onUpKeyed, this).onSync("downKeyed", onDownKeyed, this).onSync("leftKeyed", onLeftKeyed, this).onSync("rightKeyed", onRightKeyed, this).onSync("queryChanged", onQueryChanged, this).onSync("whitespaceChanged", onWhitespaceChanged, this).onSync("langDirChanged", this._onLangDirChanged, this);
    }
    _.mixin(Typeahead.prototype, {
      _hacks: function hacks() {
        var $input, $menu;
        $input = this.input.$input || $("<div>");
        $menu = this.menu.$node || $("<div>");
        $input.on("blur.tt", function ($e) {
          var active, isActive, hasActive;
          active = document.activeElement;
          isActive = $menu.is(active);
          hasActive = $menu.has(active).length > 0;
          if (_.isMsie() && (isActive || hasActive)) {
            $e.preventDefault();
            $e.stopImmediatePropagation();
            _.defer(function () {
              $input.focus();
            });
          }
        });
        $menu.on("mousedown.tt", function ($e) {
          $e.preventDefault();
        });
      },
      _onSelectableClicked: function onSelectableClicked(type, $el) {
        this.select($el);
      },
      _onDatasetCleared: function onDatasetCleared() {
        this._updateHint();
      },
      _onDatasetRendered: function onDatasetRendered(type, dataset, suggestions, async) {
        this._updateHint();
        this.eventBus.trigger("render", suggestions, async, dataset);
      },
      _onAsyncRequested: function onAsyncRequested(type, dataset, query) {
        this.eventBus.trigger("asyncrequest", query, dataset);
      },
      _onAsyncCanceled: function onAsyncCanceled(type, dataset, query) {
        this.eventBus.trigger("asynccancel", query, dataset);
      },
      _onAsyncReceived: function onAsyncReceived(type, dataset, query) {
        this.eventBus.trigger("asyncreceive", query, dataset);
      },
      _onFocused: function onFocused() {
        this._minLengthMet() && this.menu.update(this.input.getQuery());
      },
      _onBlurred: function onBlurred() {
        if (this.input.hasQueryChangedSinceLastFocus()) {
          this.eventBus.trigger("change", this.input.getQuery());
        }
      },
      _onEnterKeyed: function onEnterKeyed(type, $e) {
        var $selectable;
        if ($selectable = this.menu.getActiveSelectable()) {
          this.select($selectable) && $e.preventDefault();
        }
      },
      _onTabKeyed: function onTabKeyed(type, $e) {
        var $selectable;
        if ($selectable = this.menu.getActiveSelectable()) {
          this.select($selectable) && $e.preventDefault();
        } else if ($selectable = this.menu.getTopSelectable()) {
          this.autocomplete($selectable) && $e.preventDefault();
        }
      },
      _onEscKeyed: function onEscKeyed() {
        this.close();
      },
      _onUpKeyed: function onUpKeyed() {
        this.moveCursor(-1);
      },
      _onDownKeyed: function onDownKeyed() {
        this.moveCursor(+1);
      },
      _onLeftKeyed: function onLeftKeyed() {
        if (this.dir === "rtl" && this.input.isCursorAtEnd()) {
          this.autocomplete(this.menu.getTopSelectable());
        }
      },
      _onRightKeyed: function onRightKeyed() {
        if (this.dir === "ltr" && this.input.isCursorAtEnd()) {
          this.autocomplete(this.menu.getTopSelectable());
        }
      },
      _onQueryChanged: function onQueryChanged(e, query) {
        this._minLengthMet(query) ? this.menu.update(query) : this.menu.empty();
      },
      _onWhitespaceChanged: function onWhitespaceChanged() {
        this._updateHint();
      },
      _onLangDirChanged: function onLangDirChanged(e, dir) {
        if (this.dir !== dir) {
          this.dir = dir;
          this.menu.setLanguageDirection(dir);
        }
      },
      _openIfActive: function openIfActive() {
        this.isActive() && this.open();
      },
      _minLengthMet: function minLengthMet(query) {
        query = _.isString(query) ? query : this.input.getQuery() || "";
        return query.length >= this.minLength;
      },
      _updateHint: function updateHint() {
        var $selectable, data, val, query, escapedQuery, frontMatchRegEx, match;
        $selectable = this.menu.getTopSelectable();
        data = this.menu.getSelectableData($selectable);
        val = this.input.getInputValue();
        if (data && !_.isBlankString(val) && !this.input.hasOverflow()) {
          query = Input.normalizeQuery(val);
          escapedQuery = _.escapeRegExChars(query);
          frontMatchRegEx = new RegExp("^(?:" + escapedQuery + ")(.+$)", "i");
          match = frontMatchRegEx.exec(data.val);
          match && this.input.setHint(val + match[1]);
        } else {
          this.input.clearHint();
        }
      },
      isEnabled: function isEnabled() {
        return this.enabled;
      },
      enable: function enable() {
        this.enabled = true;
      },
      disable: function disable() {
        this.enabled = false;
      },
      isActive: function isActive() {
        return this.active;
      },
      activate: function activate() {
        if (this.isActive()) {
          return true;
        } else if (!this.isEnabled() || this.eventBus.before("active")) {
          return false;
        } else {
          this.active = true;
          this.eventBus.trigger("active");
          return true;
        }
      },
      deactivate: function deactivate() {
        if (!this.isActive()) {
          return true;
        } else if (this.eventBus.before("idle")) {
          return false;
        } else {
          this.active = false;
          this.close();
          this.eventBus.trigger("idle");
          return true;
        }
      },
      isOpen: function isOpen() {
        return this.menu.isOpen();
      },
      open: function open() {
        if (!this.isOpen() && !this.eventBus.before("open")) {
          this.menu.open();
          this._updateHint();
          this.eventBus.trigger("open");
        }
        return this.isOpen();
      },
      close: function close() {
        if (this.isOpen() && !this.eventBus.before("close")) {
          this.menu.close();
          this.input.clearHint();
          this.input.resetInputValue();
          this.eventBus.trigger("close");
        }
        return !this.isOpen();
      },
      setVal: function setVal(val) {
        this.input.setQuery(_.toStr(val));
      },
      getVal: function getVal() {
        return this.input.getQuery();
      },
      select: function select($selectable) {
        var data = this.menu.getSelectableData($selectable);
        if (data && !this.eventBus.before("select", data.obj)) {
          this.input.setQuery(data.val, true);
          this.eventBus.trigger("select", data.obj);
          this.close();
          return true;
        }
        return false;
      },
      autocomplete: function autocomplete($selectable) {
        var query, data, isValid;
        query = this.input.getQuery();
        data = this.menu.getSelectableData($selectable);
        isValid = data && query !== data.val;
        if (isValid && !this.eventBus.before("autocomplete", data.obj)) {
          this.input.setQuery(data.val);
          this.eventBus.trigger("autocomplete", data.obj);
          return true;
        }
        return false;
      },
      moveCursor: function moveCursor(delta) {
        var query, $candidate, data, payload, cancelMove;
        query = this.input.getQuery();
        $candidate = this.menu.selectableRelativeToCursor(delta);
        data = this.menu.getSelectableData($candidate);
        payload = data ? data.obj : null;
        cancelMove = this._minLengthMet() && this.menu.update(query);
        if (!cancelMove && !this.eventBus.before("cursorchange", payload)) {
          this.menu.setCursor($candidate);
          if (data) {
            this.input.setInputValue(data.val);
          } else {
            this.input.resetInputValue();
            this._updateHint();
          }
          this.eventBus.trigger("cursorchange", payload);
          return true;
        }
        return false;
      },
      destroy: function destroy() {
        this.input.destroy();
        this.menu.destroy();
      }
    });
    return Typeahead;
    function c(ctx) {
      var methods = [].slice.call(arguments, 1);
      return function () {
        var args = [].slice.call(arguments);
        _.each(methods, function (method) {
          return ctx[method].apply(ctx, args);
        });
      };
    }
  }();
  (function () {
    "use strict";

    var old, keys, methods;
    old = $.fn.typeahead;
    keys = {
      www: "tt-www",
      attrs: "tt-attrs",
      typeahead: "tt-typeahead"
    };
    methods = {
      initialize: function initialize(o, datasets) {
        var www;
        datasets = _.isArray(datasets) ? datasets : [].slice.call(arguments, 1);
        o = o || {};
        www = WWW(o.classNames);
        return this.each(attach);
        function attach() {
          var $input, $wrapper, $hint, $menu, defaultHint, defaultMenu, eventBus, input, menu, typeahead, MenuConstructor;
          _.each(datasets, function (d) {
            d.highlight = !!o.highlight;
          });
          $input = $(this);
          $wrapper = $(www.html.wrapper);
          $hint = $elOrNull(o.hint);
          $menu = $elOrNull(o.menu);
          defaultHint = o.hint !== false && !$hint;
          defaultMenu = o.menu !== false && !$menu;
          defaultHint && ($hint = buildHintFromInput($input, www));
          defaultMenu && ($menu = $(www.html.menu).css(www.css.menu));
          $hint && $hint.val("");
          $input = prepInput($input, www);
          if (defaultHint || defaultMenu) {
            $wrapper.css(www.css.wrapper);
            $input.css(defaultHint ? www.css.input : www.css.inputWithNoHint);
            $input.wrap($wrapper).parent().prepend(defaultHint ? $hint : null).append(defaultMenu ? $menu : null);
          }
          MenuConstructor = defaultMenu ? DefaultMenu : Menu;
          eventBus = new EventBus({
            el: $input
          });
          input = new Input({
            hint: $hint,
            input: $input
          }, www);
          menu = new MenuConstructor({
            node: $menu,
            datasets: datasets
          }, www);
          typeahead = new Typeahead({
            input: input,
            menu: menu,
            eventBus: eventBus,
            minLength: o.minLength
          }, www);
          $input.data(keys.www, www);
          $input.data(keys.typeahead, typeahead);
        }
      },
      isEnabled: function isEnabled() {
        var enabled;
        ttEach(this.first(), function (t) {
          enabled = t.isEnabled();
        });
        return enabled;
      },
      enable: function enable() {
        ttEach(this, function (t) {
          t.enable();
        });
        return this;
      },
      disable: function disable() {
        ttEach(this, function (t) {
          t.disable();
        });
        return this;
      },
      isActive: function isActive() {
        var active;
        ttEach(this.first(), function (t) {
          active = t.isActive();
        });
        return active;
      },
      activate: function activate() {
        ttEach(this, function (t) {
          t.activate();
        });
        return this;
      },
      deactivate: function deactivate() {
        ttEach(this, function (t) {
          t.deactivate();
        });
        return this;
      },
      isOpen: function isOpen() {
        var open;
        ttEach(this.first(), function (t) {
          open = t.isOpen();
        });
        return open;
      },
      open: function open() {
        ttEach(this, function (t) {
          t.open();
        });
        return this;
      },
      close: function close() {
        ttEach(this, function (t) {
          t.close();
        });
        return this;
      },
      select: function select(el) {
        var success = false,
          $el = $(el);
        ttEach(this.first(), function (t) {
          success = t.select($el);
        });
        return success;
      },
      autocomplete: function autocomplete(el) {
        var success = false,
          $el = $(el);
        ttEach(this.first(), function (t) {
          success = t.autocomplete($el);
        });
        return success;
      },
      moveCursor: function moveCursoe(delta) {
        var success = false;
        ttEach(this.first(), function (t) {
          success = t.moveCursor(delta);
        });
        return success;
      },
      val: function val(newVal) {
        var query;
        if (!arguments.length) {
          ttEach(this.first(), function (t) {
            query = t.getVal();
          });
          return query;
        } else {
          ttEach(this, function (t) {
            t.setVal(newVal);
          });
          return this;
        }
      },
      destroy: function destroy() {
        ttEach(this, function (typeahead, $input) {
          revert($input);
          typeahead.destroy();
        });
        return this;
      }
    };
    $.fn.typeahead = function (method) {
      if (methods[method]) {
        return methods[method].apply(this, [].slice.call(arguments, 1));
      } else {
        return methods.initialize.apply(this, arguments);
      }
    };
    $.fn.typeahead.noConflict = function noConflict() {
      $.fn.typeahead = old;
      return this;
    };
    function ttEach($els, fn) {
      $els.each(function () {
        var $input = $(this),
          typeahead;
        (typeahead = $input.data(keys.typeahead)) && fn(typeahead, $input);
      });
    }
    function buildHintFromInput($input, www) {
      return $input.clone().addClass(www.classes.hint).removeData().css(www.css.hint).css(getBackgroundStyles($input)).prop("readonly", true).removeAttr("id name placeholder required").attr({
        autocomplete: "off",
        spellcheck: "false",
        tabindex: -1
      });
    }
    function prepInput($input, www) {
      $input.data(keys.attrs, {
        dir: $input.attr("dir"),
        autocomplete: $input.attr("autocomplete"),
        spellcheck: $input.attr("spellcheck"),
        style: $input.attr("style")
      });
      $input.addClass(www.classes.input).attr({
        autocomplete: "off",
        spellcheck: false
      });
      try {
        !$input.attr("dir") && $input.attr("dir", "auto");
      } catch (e) {}
      return $input;
    }
    function getBackgroundStyles($el) {
      return {
        backgroundAttachment: $el.css("background-attachment"),
        backgroundClip: $el.css("background-clip"),
        backgroundColor: $el.css("background-color"),
        backgroundImage: $el.css("background-image"),
        backgroundOrigin: $el.css("background-origin"),
        backgroundPosition: $el.css("background-position"),
        backgroundRepeat: $el.css("background-repeat"),
        backgroundSize: $el.css("background-size")
      };
    }
    function revert($input) {
      var www, $wrapper;
      www = $input.data(keys.www);
      $wrapper = $input.parent().filter(www.selectors.wrapper);
      _.each($input.data(keys.attrs), function (val, key) {
        _.isUndefined(val) ? $input.removeAttr(key) : $input.attr(key, val);
      });
      $input.removeData(keys.typeahead).removeData(keys.www).removeData(keys.attr).removeClass(www.classes.input);
      if ($wrapper.length) {
        $input.detach().insertAfter($wrapper);
        $wrapper.remove();
      }
    }
    function $elOrNull(obj) {
      var isValid, $el;
      isValid = _.isJQuery(obj) || _.isElement(obj);
      $el = isValid ? $(obj).first() : [];
      return $el.length ? $el : null;
    }
  })();
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(536).setImmediate))

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOAD */
/* unused harmony export BLUR */
/* unused harmony export FOCUS */
/* unused harmony export INVALID */
/* unused harmony export INPUT */
/* unused harmony export CHANGE */
/* unused harmony export VALID */
/* unused harmony export CONTAINER */
/* unused harmony export INVALID_SCROLL_POSITION */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_symbol__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_random__ = __webpack_require__(63);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for rendering an error within a form field behavior.
 * @module elements/fields/floatingError
 */







var LOAD = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].LOAD,
  BLUR = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].BLUR,
  FOCUS = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].FOCUS,
  INVALID = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].INVALID,
  INPUT = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].INPUT,
  CHANGE = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].CHANGE,
  VALID = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["c" /* EVENTS */].VALID;

var CONTAINER = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["b" /* TYPES */].CONTAINER,
  FIELD = __WEBPACK_IMPORTED_MODULE_4__form_field_behaviors__["b" /* TYPES */].FIELD;

var INVALID_SCROLL_POSITION = __WEBPACK_IMPORTED_MODULE_5__validator__["a" /* EVENTS */].INVALID_SCROLL_POSITION;

var FLOATING_ERROR_OPTIONS = {
  floatingErrorContainerClassName: 'floating-label--floating-error',
  floatingErrorElement: 'p',
  floatingErrorClassName: 'floating-error'
};
var KEY = __WEBPACK_IMPORTED_MODULE_1_es6_symbol___default()('error-el');
/**
 * Creates an error element to later on be appended to the DOM.
 * @private
 * @param {string} errorElement - Name of error element to create the element
 * @param {string} className - Optional class name applied when error is present
 * @param {string} message - Message used when an error has occurred
 * @returns {Element} An element containing the floating error
 */
var createErrorEl = function createErrorEl(errorElement, id, className, message) {
  var el = document.createElement(errorElement);
  if (className) {
    el.classList.add(className);
  }
  el.id = id;
  el.textContent = " ".concat(message);
  el.prepend(__WEBPACK_IMPORTED_MODULE_0_jquery___default()("\n    <span class=\"icon icon--xs icon--exclamation-point\">\n      <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\">\n        <path d=\"M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15.2A7.17 7.17 0 0 1 .8 8 7.17 7.17 0 0 1 8 .8 7.17 7.17 0 0 1 15.2 8 7.17 7.17 0 0 1 8 15.2zm0-5.6c.4 0 .6-.3.6-.7l.3-4.3c0-.4-.4-.7-.8-.7s-1 .2-1 .7l.3 4.3c0 .4.2.7.6.7z\"/><circle cx=\"8\" cy=\"11.3\" r=\".9\"/>\n      </svg>\n    </span>\n  ")[0]);
  return el;
};
/**
 * Renders an error element into the DOM.
 * @private
 * @param {HTMLElement} container - The container with the label/form field
 * @param {string} errorElement - Name of error element to create the element
 * @param {string} className - Optional class name applied when error is present
 * @param {string} message - Message used when an error has occurred
 * @returns {HTMLElement} - The error element
 */
var renderErrorEl = function renderErrorEl(container, errorElement, id, className, message) {
  var errorEl = createErrorEl(errorElement, id, className, message);
  container.appendChild(errorEl);
  return errorEl;
};
/**
 * Responsible for removing an error element if it exists.
 * @private
 * @param {HTMLElement} container - The container with the label/form field
 * @param {HTMLElement} errorElement - Element containing the error
 * @param {Map} state - Contains state info around error
 * @param {string} className - className interacting with container
 */
var removeErrorEl = function removeErrorEl(container, errorElement, state, className) {
  if (errorElement) {
    container.classList.remove(className);
    if (errorElement.parentNode) {
      errorElement.parentNode.removeChild(errorElement);
      state["delete"](KEY);
    }
  }
};
/**
 * Sets up a listener for when an invalid formField has been found so it can
 * set the position of where to scroll to in the DOM.
 * @private
 * @param {HTMLElement} formField - The form field element
 */
var listenForInvalid = function listenForInvalid(formField) {
  formField.addEventListener(INVALID_SCROLL_POSITION, function (_ref) {
    var delegateScroll = _ref.detail.delegateScroll;
    delegateScroll(function (highestEl) {
      highestEl.scrollIntoView({
        block: 'center'
      });
    });
  });
};
/**
 * Responsibility for resolving a field id for the purpose of uniquely
 * identifying an aria-describedby.
 * @param {HTMLElement} el - Form element receiving error
 * @returns {string} The id assigned to the field if one doesn't exist
 */
var resolveFieldId = function resolveFieldId(el) {
  var ariaIdAttr = 'aria-describedby';
  var existingId = el.getAttribute(ariaIdAttr);
  if (existingId) {
    return existingId;
  }
  var elements = __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(el, 'form.elements', []);
  var index = Array.from(elements).findIndex(function (formEl) {
    return formEl === el;
  });
  var suffix = __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default()(index) ? index : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_random__["a" /* default */])();
  var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_random__["a" /* default */])({
    prefix: "err-".concat(suffix)
  });
  el.setAttribute(ariaIdAttr, id);
  return id;
};
/**
 * Responds to any errors that occur on a form field by rendering a
 * "floating error" or an error that accompanies the field in question.
 * @private
 * @param {string} type - Type of event
 * @param {HTMLElement} target - Element receiving the event
 * @param {HTMLElement} container - The container with the label/form field
 * @param {Map} state - Acts as a state container
 * @param {boolean} validateOnlyOnSubmit - Instructs to only validate on submit
 * @param {string} containerClassName - Class name appended to the container if
 * an error occurs
 * @param {string} errorElement - Name of error element to create the element
 * @param {string} className - Optional class name applied when error is present
 * @param {string} message - Message used when an error has occurred
 */
var respond = function respond(type, target, container, state, validateOnlyOnSubmit, _ref2) {
  var containerClassName = _ref2.floatingErrorContainerClassName,
    errorElement = _ref2.floatingErrorElement,
    className = _ref2.floatingErrorClassName,
    _ref2$floatingErrorMe = _ref2.floatingErrorMessage,
    message = _ref2$floatingErrorMe === void 0 ? '' : _ref2$floatingErrorMe;
  var errorEl = state.get(KEY);
  var errorMessage = message || target.validationMessage;
  var fieldId;
  switch (type) {
    case INPUT:
      // The error message should stick around when the user focuses on the
      // element. However, when the user interacts with the element, we want to
      // remove the error, if it exists. Therefore the error message will be
      // announced to the user upon focusing without the need of having to
      // accounce every time the element has been interacted with if it's
      // considered invalid.
      if (state.get(KEY)) {
        removeErrorEl(container, errorEl, state, containerClassName);
      }
      break;
    case LOAD:
    case BLUR:
    case CHANGE:
      if (!validateOnlyOnSubmit) {
        // Assume there is no error for a clean slate
        removeErrorEl(container, errorEl, state, containerClassName);
        // This may feel redundant since there's a chance the form element
        // may already have an error. However, in the case where the blur
        // event only occurs or where the floating error is the only listener,
        // then this is necessary. Otherwise, it is redundant, but it doesn't
        // hurt anything or have any performance issues to reset the validity.
        if (container.querySelector(':invalid') === target) {
          target.setCustomValidity(errorMessage);
        }
        target.checkValidity();
      }
      break;
    case VALID:
      removeErrorEl(container, errorEl, state, containerClassName);
      break;
    case INVALID:
      removeErrorEl(container, errorEl, state, containerClassName);
      // Supercedes the applied validity for one that may be more relevant
      // to the field.
      target.setCustomValidity(errorMessage);
      container.classList.add(containerClassName);
      fieldId = resolveFieldId(target);
      state.set(KEY, renderErrorEl(container, errorElement, fieldId, className, errorMessage));
      break;
    default:
      break;
  }
};
/**
 * Responsible for rendering an error message when an error occurs on a form
 * field. To avoid any weirdness with CSS positioning, the error message is
 * rendered to the screen around the field or floats hence a floating error.
 *
 * In order to activate this functionality, the container must contain the
 * following data attribute:
 *
 * - data-floating-error-message
 *
 * Other options include:
 *
 * - `data-floating-error-element`: The name of the element used for the floating
 *   error. Defaults to a `p` (for paragraph).
 * - `data-floating-error-class-name`: An additional className added to the
 *   floating error message element. Defaults to `''`.
 * - `data-floating-container-class-name`: A className applied to the container
 *   container when the floating error is shown. Defaults to `floating-label--floating-error`.
 *
 * @example
 * <div class="floating-label" data-floating-error-message="Hey dummy!">
 *  <label for="dude" class="floating-label__label">Something</label>
 *  <input
 *    required
 *    id="dude"
 *    type="text"
 *    class="floating-label__input"
 *    placeholder="Enter something">
 * </div>
 * @see FLOATING_ERROR_OPTIONS
 * @param {Object} options - Configurable options
 * @returns {Function} Used to setup and respond to events from the form field
 * behavior
 */
var floatingError = function floatingError() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
      nodes[_key] = arguments[_key];
    }
    var _nodes$filter = nodes.filter(function (_ref3) {
        var type = _ref3.type;
        return type === CONTAINER;
      }),
      _nodes$filter2 = _slicedToArray(_nodes$filter, 1),
      container = _nodes$filter2[0].node;
    var _nodes$filter3 = nodes.filter(function (_ref4) {
        var type = _ref4.type;
        return type === FIELD;
      }),
      _nodes$filter4 = _slicedToArray(_nodes$filter3, 1),
      formField = _nodes$filter4[0].node;
    var opts = Object.assign({}, FLOATING_ERROR_OPTIONS, options, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container).data());
    var state = new Map();
    if (container.dataset.disableFloatingError) {
      return function () {};
    }
    listenForInvalid(formField, state);
    return function (type, _ref5, _ref6) {
      var target = _ref5.target;
      var validateOnlyOnSubmit = _ref6.validateOnlyOnSubmit;
      return respond(type, target, container, state, validateOnlyOnSubmit, opts);
    };
  };
};
/* harmony default export */ __webpack_exports__["a"] = (floatingError);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export iconList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iconify_setup__ = __webpack_require__(112);
/* unused harmony reexport TYPES */
/* unused harmony reexport EVENTS */
/* unused harmony reexport VISIBLE_CLASS_NAME */
/* unused harmony reexport ICON_CLASS_NAME */
/**
 * Responsible for covering icon related behavior within a form field behavior.
 * @module elements/fields/iconifyBehaviors
 */



var CLEARED_TYPES = ['text', 'email'];

/**
 * Defines available icons for iconify behaviors.
 * @type {Object}
 */
var iconList = [{
  name: 'invalid',
  iconId: 'exclamation-point'
}, {
  name: 'valid',
  iconId: 'check-mark'
}, {
  name: 'clear',
  iconId: 'clear',
  rule: function rule(_ref) {
    var type = _ref.formField.type;
    return CLEARED_TYPES.indexOf(type) > -1;
  }
}];

/**
 * Responsible for clearing out the value of a form field.
 * @private
 * @param {HTMLFormElement} formField - The form element in the container
 */
var clearValue = function clearValue(formField) {
  /* eslint-disable no-param-reassign */
  // This is here to remove the placeholder which is visible
  // between the blur and focus event.
  var placeholder = formField.placeholder;
  formField.placeholder = '';
  formField.focus();
  formField.value = '';
  formField.placeholder = placeholder;
  /* eslint-enable no-param-reassign */
};

/**
 * Responsible for exposing methods used for clearing a form field based on
 * when events are fired off. For example, `attach` would be fired off during
 * focus, where `detach` would be fired off during blur. The tricky bit here
 * is using an event that won't trigger the blur event, hence why mousedown or
 * the preferred touchend event to ensure this event happens without disrupting
 * the blur event.
 *
 * There is a cleaner version here that uses touchend that minimizes a good
 * deal of this code and it's cleaner. However, in the interest of someone
 * saying, "This is broken" because they aren't on a mobile/touch device.
 * Therefore mousedown is used to ensure clear occurs before the blur event
 * can take affect.
 * @private
 * @param {HTMLElement} clearIcon
 * @returns {Object} Contains methods used for coordinating of clearing a field
 */
var coordinateClearEvents = function coordinateClearEvents(clearIcon) {
  var evtName = 'mousedown';
  var handler;
  var shouldClearForm;
  return {
    attach: function attach() {
      clearIcon.addEventListener(evtName, handler = function handler() {
        shouldClearForm = true;
      });
    },
    detach: function detach(formField) {
      if (shouldClearForm) {
        clearValue(formField);
        clearIcon.removeEventListener(evtName, handler);
        shouldClearForm = false;
      }
    }
  };
};

/**
 * hides all icons by removing the visibility className.
 * @private
 * @param {HTMLElement} container - The icon container
 */
var hideAll = function hideAll(container) {
  Array.from(container.querySelectorAll(".".concat(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["a" /* ICON_CLASS_NAME */]))).forEach(function (el) {
    el.classList.remove(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
  });
};

/**
 * Responsible for showing the clear icon and hiding the rest of the icons.
 * @private
 * @param {HTMLElement} container - The icon container
 * @param {HTMLFormElement} target - The form field in the container
 * @param {HTMLElement} clearIcon - The clear icon element
 * @param {boolean} clearShown - Whether the clear icon has been shown
 * @returns {boolean|undefined} Determines whether the clear icon was shown,
 * otherwise returns undefined.
 */
var editable = function editable(container, target, clearIcon, clearShown) {
  if (clearShown && target.value) {
    return true;
  }
  hideAll(container);
  if (clearIcon && target.value) {
    clearIcon.classList.add(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
    return true;
  }
  return false;
};

/**
 * Responsible for firing off a set of rules when the field has been completed.
 * This would happen when the field has initially loaded or on blur.
 * @private
 * @param {HTMLElement} iconContainer - The icon container
 * @param {HTMLElement} container - The element containing the label/form field
 * @param {HTMLFormElement} formField - The form element in the conatiner
 * @param {HTMLElement} invalidIcon - The invalid icon element
 * @param {HTMLElement} validIcon - The valid icon element
 * @param {boolean} shouldValidate - Instructs to only validate on submit
 */
var completed = function completed(iconContainer, container, formField, invalidIcon, validIcon, shouldValidate) {
  hideAll(iconContainer);
  if (shouldValidate) {
    if (invalidIcon && container.querySelector(':invalid') === formField) {
      invalidIcon.classList.add(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
    } else if (validIcon && formField.value) {
      validIcon.classList.add(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
    }
  }
};

/**
 * Runs logic based on when an invalid event has been fired off.
 * @private
 * @param {HTMLElement} iconContainer - The icon container
 * @param {HTMLElement} invalidIcon - The invalid icon element
 */
var invalidated = function invalidated(iconContainer, invalidIcon) {
  hideAll(iconContainer);
  if (invalidIcon) {
    invalidIcon.classList.add(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
  }
};

/**
 * Responds to the event received from the form field behavior. The logic for
 * this is as follows:
 *
 * - focus: check to see if the clear icon should be shown
 * - input: show the clear icon if it already isn't shown
 * - blur: remove clear icon, show valid or invalid icon based on the state
 * formField of the form field
 * - invalid: show the invalid icon
 *
 * There are other optimizations taken for performance, but you get the idea.
 * @private
 * @param {HTMLElement} iconContainer - The icon container
 * @param {HTMLElement} container - The element containing the label/form field
 * @param {HTMLFormElement} formField - The form field
 * @param {Object} icons - Contains icon elements keyed by icon
 * @returns {Function} The inner function called on by form field behavior
 */
var respond = function respond(iconContainer, container, formField, icons) {
  var clearShown = false;
  var clearIcon = icons.clear,
    invalidIcon = icons.invalid,
    validIcon = icons.valid;
  var FOCUS = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].FOCUS,
    BLUR = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].BLUR,
    INVALID = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].INVALID,
    INPUT = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].INPUT;
  // By going one level higher in scope, we can control the state of the clear
  // icon in terms of when it was bound and when it needs to be unbound.
  var coordinate = coordinateClearEvents(clearIcon);

  // At this point, the page has loaded without any events so there's a chance
  // a field could already have values. Therefore, apply any completed
  // behaviors, i.e. invalid or valid.
  completed(iconContainer, container, formField, invalidIcon, validIcon, true);
  return function (type) {
    var _ = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref2 = arguments.length > 2 ? arguments[2] : undefined,
      validateOnlyOnSubmit = _ref2.validateOnlyOnSubmit;
    switch (type) {
      case FOCUS:
        // Attaches clear events upon focus since it's the first time the field
        // has been interacted with. This will apply any event handlers used
        // for clearing the field.
        coordinate.attach(formField, function () {
          clearShown = false;
        });

        // Checks to see if we are in an edited state when the focus event
        // occurs. We don't about the return value because the input event
        // manages that portion of the lifecycle.
        editable(iconContainer, formField, clearIcon, clearShown);
        break;
      case INPUT:
        // At this point, the user is inputting values into the field. We call
        // on editable, so that we know how to treat the clear icon, i.e. should
        // it be shown or hidden. By returning back clearShown, we can cache
        // the state and limit the amount of DOM manipulation upon interaction.
        clearShown = editable(iconContainer, formField, clearIcon, clearShown);
        break;
      case BLUR:
        // At this point, the user is done with the field. We reset anything
        // that has state, i.e. clearShown and any event handlers. We also
        // apply the final completed state to the form, i.e. invalid or valid.
        clearShown = false;
        // Release the clear related events from memory.
        coordinate.detach(formField);
        completed(iconContainer, container, formField, invalidIcon, validIcon, !validateOnlyOnSubmit);
        break;
      case INVALID:
        invalidated(iconContainer, invalidIcon);
        break;
      default:
        break;
    }
  };
};

/**
 * Responsible for rendering out icons that will be used for a form field
 * behavior. The rendering is happening internally for a number of reasons:
 *
 * - Minimize the payload in the HTML (that is, if this was coming from there)
 * - Keep configuring from a consumer side as simple as possible.
 * - Since the icons are dependent on JavaScript, inlining them within allows
 *   for the HTML to operate in isolation with little external factors
 *
 * It's also responsible for doing the following:
 *
 * - Showing the correct icon based on the state of the input
 * - Attach/detach any events applied to the icon
 *
 * As for usage, iconify looks for data attributes denoting the different icons
 * to render where the value is used to populate the title of the SVG for
 * i18n/accessibility purposes. Here are the support data attributes:
 *
 * - data-iconify-clear
 * - data-iconify-invalid
 * - data-iconify-valid
 *
 * Any of these options can be used at different times. Therefore, if only clear
 * should be used, then only configure data-iconify-clear and nothing else.
 * Here's an example of the expected markup:
 *
 * @example
 * <div
 *     class="floating-label"
 *     data-iconify-clear="Clear"
 *     data-iconify-invalid="Invalid"
 *     data-iconify-valid="Valid">
 *   <label for="the-dude" class="floating-label__label">The Dude</label>
 *   <input id="the-dude" class="floating-label__input">
 * </div>
 *
 * @param {Object} options - Configurable options
 * @returns {Function} Used to setup and respond to events from the form field
 * behavior
 */
var iconify = function iconify() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
      nodes[_key] = arguments[_key];
    }
    var _setup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["c" /* default */])(iconList, nodes, options),
      container = _setup.container,
      formField = _setup.formField,
      iconContainer = _setup.iconContainer,
      iconNodes = _setup.iconNodes;
    if (iconNodes) {
      return respond(iconContainer, container, formField, iconNodes);
    }
    return function () {};
  };
};
/* harmony default export */ __webpack_exports__["a"] = (iconify);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CONTAINER_CLASS_NAME */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICON_CLASS_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VISIBLE_CLASS_NAME; });
/* unused harmony export HIDDEN_CLASS_NAME */
/* unused harmony export appendIconContainer */
/* harmony export (immutable) */ __webpack_exports__["c"] = setupIconify;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_camelCase__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_camelCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_camelCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_field_behaviors__ = __webpack_require__(16);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for doing the baseline setup for an iconify form field behavior.
 * @module iconifySetup
 */




/**
 * Defines default configuration for iconify.
 * @type {Object}
 */
var DEFAULT_ICONIFY_OPTIONS = {
  prefix: 'iconify',
  containerClassName: 'floating-label__iconify',
  containerModifier: '',
  containerElementName: 'div'
};

/**
 * CSS className used for the container.
 * @type {string}
 */
var CONTAINER_CLASS_NAME = 'iconify';

/**
 * CSS className for an icon element.
 * @type {string}
 */
var ICON_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__icon");

/**
 * CSS className for a visible modifier.
 * @type {string}
 */
var VISIBLE_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__icon--visible");

/**
 * CSS className for a hidden modifier.
 * @type {string}
 */
var HIDDEN_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__icon--hidden");

/**
 * Obtains all the available icons based on how the data-iconify-* attributes
 * have been configured.
 * @private
 * @param {Array} acceptedIcons - List of icons with affiliated data
 * @param {Object} dataset - Data attributes on the container
 * @param {string} prefix - Prepended name applied to the data attributes
 * @param {Object} fieldInfo - Map of elements related to the field
 * @returns {Array} All available icons based on name, text, and the unique ID
 */
var getAvailableIcons = function getAvailableIcons(acceptedIcons, dataset, prefix, fieldInfo) {
  return acceptedIcons.map(function (_ref) {
    var name = _ref.name,
      iconId = _ref.iconId,
      rule = _ref.rule;
    return {
      name: name,
      iconId: iconId,
      rule: rule,
      text: dataset[__WEBPACK_IMPORTED_MODULE_1_lodash_camelCase___default()("".concat(prefix, "-").concat(name))]
    };
  }).filter(function (_ref2) {
    var text = _ref2.text,
      rule = _ref2.rule;
    if (rule && !rule(fieldInfo)) {
      return false;
    }
    return !!text;
  });
};

/**
 * Creates the icon container with the selected icons.
 * @private
 * @param {Object} icons - Set of icons that will be rendered
 * @param {string} containerClassName - CSS className for the icon container
 * @param {string} iconClassName - CSS className applied to a single icon
 * @param {string} hiddenClassName - CSS className used to hide an icon
 * @returns {string} String representation of rendered icons
 */
var renderIcons = function renderIcons(_ref3) {
  var icons = _ref3.icons,
    containerClassName = _ref3.containerClassName,
    iconClassName = _ref3.iconClassName,
    hiddenClassName = _ref3.hiddenClassName;
  return "\n  <div class=\"".concat(containerClassName, "\">\n    ").concat(icons.map(function (_ref4) {
    var text = _ref4.text,
      iconId = _ref4.iconId;
    return "\n      <span class=\"".concat(iconClassName, " ").concat(hiddenClassName, " icon ").concat(iconClassName, "--").concat(iconId, "\">\n        <svg>\n          <title>").concat(text, "</title>\n          <use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"#icon-").concat(iconId, "\"></use>\n        </svg>\n      </span>\n    ");
  }).join(''), "\n  </div>\n");
};

/**
 * Append the icon container to the DOM.
 * @private
 * @param {HTMLElement} container - Contains the label/form field
 * @param {Object} icons - Set of icons that will be rendered
 * @param {string} elementName - Name of the element for the appended element
 * @param {string} className - CSS className for the appended element
 * @param {string} modifier - Optional BEM Modifier appended to the container
 * @returns {Element} The icon container
 */
var appendIconContainer = function appendIconContainer(container, icons, elementName, className, modifier) {
  var iconContainer = document.createElement(elementName);
  iconContainer.classList.add(className);
  if (modifier) {
    iconContainer.classList.add("".concat(className, "--").concat(modifier));
  }
  iconContainer.innerHTML = renderIcons({
    icons: icons,
    containerClassName: CONTAINER_CLASS_NAME,
    iconClassName: ICON_CLASS_NAME,
    hiddenClassName: HIDDEN_CLASS_NAME
  });
  container.appendChild(iconContainer);
  return iconContainer;
};

/**
 * Looks for all icon related nodes and creates an object based on the name of
 * the icon. This will allow for the consumers of this code to easily reference
 * icons based on what has been passed in by the consumers.
 * @private
 * @param {HTMLElement} iconContainer - Element with icon container
 * @param {Array} icons - Reference to passed in icons from consumer
 * @returns {Object} Contains icons keyed by icon name with icon HTML element
 */
var findIconNodes = function findIconNodes(iconContainer, icons) {
  return icons.reduce(function (acc, _ref5) {
    var name = _ref5.name,
      iconId = _ref5.iconId;
    return Object.assign({}, acc, _defineProperty({}, name, iconContainer.querySelector(".".concat(ICON_CLASS_NAME, "--").concat(iconId))));
  }, {});
};

/**
 * Responsible for taking a list of icons, HTML elements, and options with the
 * intention of rendering a icon contains and the icons that have been passed
 * in. This is a common piece of functionality that covers a couple of different
 * iconify form field behavior scenarios. The goal here is to ensure iconify
 * form field behaviors can focus on their functionality without having to
 * worry about doing this type of setup and expose all the available elements
 * created so they can be leveraged by the consumers.
 * @see DEFAULT_ICONIFY_OPTIONS
 * @param {Array} possibleIcons - Icons that might be available
 * @param {Array} nodes - All form field behavior related elements
 * @param {Object} options - Used for overriding any options
 * @returns {Object} HTML elements pertaining to the icons being rendered
 */
function setupIconify(possibleIcons, nodes) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _Object$assign2 = Object.assign({}, DEFAULT_ICONIFY_OPTIONS, options),
    prefix = _Object$assign2.prefix,
    className = _Object$assign2.containerClassName,
    modifier = _Object$assign2.containerModifier,
    elementName = _Object$assign2.containerElementName;
  var _nodes$filter = nodes.filter(function (_ref6) {
      var type = _ref6.type;
      return __WEBPACK_IMPORTED_MODULE_2__form_field_behaviors__["b" /* TYPES */].CONTAINER === type;
    }),
    _nodes$filter2 = _slicedToArray(_nodes$filter, 1),
    container = _nodes$filter2[0].node;
  var _nodes$filter3 = nodes.filter(function (_ref7) {
      var type = _ref7.type;
      return __WEBPACK_IMPORTED_MODULE_2__form_field_behaviors__["b" /* TYPES */].FIELD === type;
    }),
    _nodes$filter4 = _slicedToArray(_nodes$filter3, 1),
    formField = _nodes$filter4[0].node;
  var fieldInfo = {
    formField: formField,
    container: container
  };
  var availableIcons = getAvailableIcons(possibleIcons, container.dataset, prefix, fieldInfo);
  if (!availableIcons.length) {
    return {};
  }
  var iconContainer = appendIconContainer(container, availableIcons, elementName, className, modifier);
  var iconNodes = findIconNodes(iconContainer, availableIcons);
  return {
    container: container,
    formField: formField,
    iconContainer: iconContainer,
    iconNodes: iconNodes
  };
}

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__ = __webpack_require__(16);
/* unused harmony reexport EVENTS */
/* unused harmony reexport TYPES */
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for applying classes in the form of modifiers to form field
 * behaviors based on the current state, i.e. filled, invalid, selected, and
 * so on.
 * @module elements/fields/stateModifiers
 */



/**
 * Defines default options for state modifiers
 * @type {Object}
 */
var DEFAULT_STATE_MODIFIERS = {
  filledModifier: 'filled',
  invalidModifier: 'invalid',
  selectedModifier: 'selected',
  suppressErrorModifier: 'suppress-error'
};

/**
 * Adds modifier CSS class names to any of the elements.
 * @private
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {...string} modifiers - Modifier names
 */
var addClassNames = function addClassNames(nodes) {
  for (var _len = arguments.length, modifiers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    modifiers[_key - 1] = arguments[_key];
  }
  nodes.forEach(function (_ref) {
    var name = _ref.name,
      node = _ref.node;
    modifiers.forEach(function (modifierName) {
      node.classList.add("".concat(name, "--").concat(modifierName));
    });
  });
};

/**
 * Removes modifier CSS class names to any of the elements.
 * @private
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {...string} modifiers - Modifier names
 */
var removeClassNames = function removeClassNames(nodes) {
  for (var _len2 = arguments.length, modifiers = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    modifiers[_key2 - 1] = arguments[_key2];
  }
  nodes.forEach(function (_ref2) {
    var name = _ref2.name,
      node = _ref2.node;
    modifiers.forEach(function (modifierName) {
      node.classList.remove("".concat(name, "--").concat(modifierName));
    });
  });
};

/**
 * Ran whenever a FIELD is in a completed state, i.e. when the page first loads
 * or when a blur event occurred.
 * @private
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {HTMLElement} target - The element receiving the event
 * @param {boolean} shouldApplyInvalid - Allow for applying invalid modifiers
 * @param {string} selected - The selected modifier value
 * @param {string} filled - The filled modifier value
 * @param {string} invalid - The invalid modifier value
 * @param {string} suppressError - The suppress error modifier value
 */
var completed = function completed(nodes, target, shouldApplyInvalid, _ref3) {
  var selected = _ref3.selected,
    filled = _ref3.filled,
    invalid = _ref3.invalid,
    suppressError = _ref3.suppressError;
  var _nodes$filter = nodes.filter(function (_ref4) {
      var type = _ref4.type;
      return type === __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["b" /* TYPES */].CONTAINER;
    }),
    _nodes$filter2 = _slicedToArray(_nodes$filter, 1),
    container = _nodes$filter2[0].node;
  removeClassNames(nodes, selected, filled, invalid, suppressError);

  // Denotes that within a container a field has an error
  if (container.querySelector(':invalid') === target) {
    // Make sure to apply an invalid error if instructed to apply an invalid
    // modifier
    if (shouldApplyInvalid) {
      addClassNames(nodes, invalid);
    } else {
      // Otherwise, we are looking to suppress an error. Since the browser has
      // built in invalidity, we apply this class to ensure that the default
      // browser invalid behavior gets overridden.
      addClassNames(nodes, suppressError);
    }
  }
  if (target.value) {
    addClassNames(nodes, filled);
  }
};

/**
 * Responds to any event based on the type of event.
 * @private
 * @param {string} type - The type of event, i.e. focus, blur
 * @param {HTMLElement} target - The element receiving the event
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {boolean} validateOnlyOnSubmit - Instructs to only validate on submit
 * @param {Object} modifiers - Contains modifier names
 */
var respond = function respond(type, target, nodes, _ref5, modifiers) {
  var validateOnlyOnSubmit = _ref5.validateOnlyOnSubmit;
  var FOCUS = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].FOCUS,
    BLUR = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].BLUR,
    INVALID = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].INVALID,
    CHANGE = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].CHANGE,
    VALID = __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["c" /* EVENTS */].VALID;
  var selected = modifiers.selected,
    filled = modifiers.filled,
    invalid = modifiers.invalid,
    suppressError = modifiers.suppressError;
  switch (type) {
    case FOCUS:
    case VALID:
      addClassNames(nodes, selected);
      removeClassNames(nodes, filled, invalid, suppressError);
      break;
    case BLUR:
    case CHANGE:
      completed(nodes, target, !validateOnlyOnSubmit, modifiers);
      break;
    case INVALID:
      removeClassNames(nodes, suppressError);
      addClassNames(nodes, invalid);
      break;
    default:
      break;
  }
};

/**
 * Responsible for initializing state modifiers. More specifically, it'll apply
 * any modifiers (i.e. CSS class names in form of BEM) when the page first
 * loads. For example, when a page initially loads and an element is invalid,
 * it'll apply any modifiers. It'll do the same when responding to events based
 * on user interaction.
 * @private
 * @see DEFAULT_STATE_MODIFIERS
 * @param {Array} nodes - An array of objects containing a name and element
 * @param {Object} options - Options initially passed in
 * @returns {Function} - Used for firing off events
 */
var initialize = function initialize(nodes) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _Object$assign = Object.assign({}, DEFAULT_STATE_MODIFIERS, options),
    filled = _Object$assign.filledModifier,
    invalid = _Object$assign.invalidModifier,
    selected = _Object$assign.selectedModifier,
    suppressError = _Object$assign.suppressErrorModifier;
  var modifiers = {
    filled: filled,
    invalid: invalid,
    selected: selected,
    suppressError: suppressError
  };
  var _nodes$filter3 = nodes.filter(function (_ref6) {
      var type = _ref6.type;
      return type === __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["b" /* TYPES */].FIELD;
    }),
    _nodes$filter4 = _slicedToArray(_nodes$filter3, 1),
    formField = _nodes$filter4[0].node;
  completed(nodes, formField, true, modifiers);
  return function (type, _ref7, data) {
    var target = _ref7.target;
    return respond(type, target, nodes, data, modifiers);
  };
};

/**
 * Provides modifiers, i.e. CSS class names in the form of BEM to a block and
 * two child block elements. These elements are coming from the nodes.
 * @see DEFAULT_STATE_MODIFIERS
 * @param options
 */
var stateModifiers = function stateModifiers() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    for (var _len3 = arguments.length, nodes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      nodes[_key3] = arguments[_key3];
    }
    return initialize(nodes, options);
  };
};
/* harmony default export */ __webpack_exports__["a"] = (stateModifiers);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Floating Video Module
 * @module customVideoPlayer
 */





// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'customVideoPlayer';
var DEFAULTS = {
  videoMuted: true,
  hideMute: false,
  $originalTrigger: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(),
  titleClass: 'floating-video__title',
  captionClass: 'floating-video__caption'
};

// Helper function to format time in minutes:seconds
function formatTime(seconds) {
  var minutes = Math.floor(seconds / 60);
  var seconds = Math.floor(seconds % 60);
  return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
}
function enterFullScreen(playerContainer) {
  if (playerContainer.requestFullscreen) {
    playerContainer.requestFullscreen();
  } else if (playerContainer.mozRequestFullScreen) {
    // Firefox
    playerContainer.mozRequestFullScreen();
  } else if (playerContainer.webkitRequestFullscreen) {
    // Chrome, Safari
    playerContainer.webkitRequestFullscreen();
  } else if (playerContainer.msRequestFullscreen) {
    // IE/Edge
    playerContainer.msRequestFullscreen();
  }
}
function isVideoPlaying(videoElement) {
  return !videoElement.paused && !videoElement.ended;
}
var createVideoWrapper = function createVideoWrapper() {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<div class="custom-video__container"></div>');
};
var createVideoControls = function createVideoControls(_ref, title, caption) {
  var hideMute = _ref.hideMute;
  return "\n    <div class=\"js-floating-video-controls custom-video__controls\">\n      <div class=\"js-custom-video__play custom-video__play\">\n        <span class=\"icon icon--play\" style=\"width:84px;height:84px;\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 38 38\">\n            <circle cx=\"19\" cy=\"19\" r=\"8.5\" fill=\"#fff\" stroke=\"#f5f5f5\" />\n            <path d=\"M16,22c0,.4.5.7.9.5l6.1-3c.4-.2.4-.9,0-1.1l-6.1-3c-.4-.2-.9,0-.9.5v6.1Z\" fill=\"#3b3b3b\" />\n          </svg>\n        </span>\n        <span class=\"icon icon--pause\" style=\"width:40px;height:40px;display: none\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 32 32\">\n            <path fill=\"#f5f5f5\" d=\"M5.5,28h6.9V4h-6.9v24ZM19.2,4v24h6.9V4h-6.9Z\" />\n          </svg>\n        </span>\n      </div>\n      <div class=\"custom-video__bottom-controls\">\n        <div class=\"custom-video__bottom-controls-container\">\n          ".concat(title && caption ? "<div class=\"js-custom-video__caption\">\n              <div class=\"u-flex\" style=\"justify-content: space-between;\">\n                <div><strong class=\"u-text--md\">".concat(title, "</strong></div>\n                <button class=\"custom-video__caption-button\">\n                  <span class=\"icon icon--arrow-up u-color--white\">\n                    <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n                      <path d=\"M11.25 10.5a.748.748 0 0 1-.55-.24L8 7.352 5.3 10.26a.75.75 0 0 1-1.1-1.02l3.25-3.5a.774.774 0 0 1 1.1 0l3.25 3.5a.75.75 0 0 1-.55 1.26z\"/>\n                    </svg>\n                  </span>\n                </button>\n              </div>\n              <p>").concat(caption, "</p>\n          </div>") : "", "\n          <div class=\"custom-video__bottom-controls-wrap\">\n            <div class=\"js-custom-video__current-time-container custom-video__current-time-container\">\n                <span class=\"js-custom-video__current-time custom-video__current-time\">0:00</span> / <span\n                  class=\"js-custom-video__total-time\">0:00</span>\n            </div>\n            <div class=\"u-flex\" style=\"align-items: center;\">\n              <div style=\"flex-grow:1;\">\n                \n                <div class=\"js-custom-video__progress-bar-container custom-video__progress-bar-container\">\n                  <div class=\"js-custom-video__progress-bar custom-video__progress-bar\">\n                    <div class=\"js-custom-video__progress custom-video__progress\"></div>\n                    <div class=\"js-custom-video__thumb custom-video__thumb\"></div>\n                  </div>\n                </div>\n              </div>\n              <div class=\"u-flex\">\n                <div class=\"js-custom-video__fullscreen custom-video__fullscreen\">\n                  <span class=\"icon icon--fullscreen icon--md\">\n                    <svg xmlns=\"http://www.w3.org/2000/svg\" version=\"1.1\" viewBox=\"0 0 24 24\">\n                      <path\n                        d=\"M6,19c-.3,0-.5,0-.7-.3-.2-.2-.3-.4-.3-.7v-3c0-.3,0-.5.3-.7.2-.2.4-.3.7-.3s.5,0,.7.3c.2.2.3.4.3.7v2h2c.3,0,.5,0,.7.3.2.2.3.4.3.7s0,.5-.3.7c-.2.2-.4.3-.7.3h-3ZM6,10c-.3,0-.5,0-.7-.3-.2-.2-.3-.4-.3-.7v-3c0-.3,0-.5.3-.7.2-.2.4-.3.7-.3h3c.3,0,.5,0,.7.3.2.2.3.4.3.7s0,.5-.3.7c-.2.2-.4.3-.7.3h-2v2c0,.3,0,.5-.3.7-.2.2-.4.3-.7.3ZM15,19c-.3,0-.5,0-.7-.3-.2-.2-.3-.4-.3-.7s0-.5.3-.7c.2-.2.4-.3.7-.3h2v-2c0-.3,0-.5.3-.7.2-.2.4-.3.7-.3s.5,0,.7.3c.2.2.3.4.3.7v3c0,.3,0,.5-.3.7-.2.2-.4.3-.7.3h-3ZM18,10c-.3,0-.5,0-.7-.3-.2-.2-.3-.4-.3-.7v-2h-2c-.3,0-.5,0-.7-.3-.2-.2-.3-.4-.3-.7s0-.5.3-.7c.2-.2.4-.3.7-.3h3c.3,0,.5,0,.7.3.2.2.3.4.3.7v3c0,.3,0,.5-.3.7-.2.2-.4.3-.7.3Z\" />\n                    </svg>\n                  </span>\n                </div>\n                ").concat(hideMute ? "<div class=\"js-custom-video__mute\">\n                    <span class=\"icon icon--unmute icon--md\">\n                      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n                        <path\n                          d=\"M14.2,6.4c.2-.3.6-.5.9-.3,2.3,1.1,3.9,3.3,3.9,5.9s-1.6,4.8-3.9,5.9c-.3.2-.8,0-.9-.3-.2-.3,0-.7.3-.9,1.8-.9,3.1-2.7,3.1-4.7s-1.3-3.9-3.1-4.7c-.3-.2-.5-.6-.3-.9Z\" />\n                        <path\n                          d=\"M7.8,9.3h-1.4c-.8,0-1.4.6-1.4,1.3v2.6c0,.7.6,1.3,1.4,1.3h1.4l3.1,2.4c.5.4,1.1,0,1.1-.5V7.5c0-.6-.7-.9-1.1-.5l-3.1,2.4Z\" />\n                        <path\n                          d=\"M15.4,9.6c-.2-.3-.7-.4-1-.1-.3.2-.4.6-.1.9.3.4.6,1,.6,1.6s-.2,1.1-.6,1.6c-.2.3-.2.7.1.9.3.2.7.2,1-.1.5-.7.8-1.5.8-2.4s-.3-1.7-.8-2.4Z\" />\n                      </svg>\n                    </span>\n                    <span class=\"icon icon--mute icon--md\" style=\"display: none\">\n                      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n                        <path\n                          d=\"M17.6128 18.7968L15.9153 17.0792C15.7449 17.1777 15.5745 17.273 15.4042 17.3651C15.2338 17.4577 15.0574 17.5409 14.8748 17.6148C14.6315 17.7133 14.4063 17.6825 14.1995 17.5224C13.9926 17.3624 13.8892 17.1407 13.8892 16.8575C13.8892 16.7221 13.9288 16.6021 14.0082 16.4977C14.087 16.3928 14.1873 16.3157 14.309 16.2665C14.4063 16.2296 14.5008 16.1894 14.5923 16.1461C14.6833 16.1032 14.7714 16.0572 14.8566 16.0079L12.4289 13.5515V15.6016C12.4289 15.934 12.2798 16.1648 11.9814 16.2938C11.6835 16.4234 11.4189 16.3712 11.1877 16.1372L8.77836 13.6992H6.58801C6.38114 13.6992 6.20786 13.6283 6.06816 13.4864C5.92798 13.3451 5.85789 13.1697 5.85789 12.9604V10.0053C5.85789 9.79595 5.92798 9.62037 6.06816 9.47852C6.20786 9.33717 6.38114 9.26649 6.58801 9.26649H8.19426L5.20078 6.23747C5.06693 6.10202 5 5.92964 5 5.72032C5 5.51099 5.06693 5.33861 5.20078 5.20317C5.33464 5.06772 5.505 5 5.71186 5C5.91873 5 6.08909 5.06772 6.22295 5.20317L18.6349 17.7625C18.7688 17.898 18.8357 18.0704 18.8357 18.2797C18.8357 18.489 18.7688 18.6614 18.6349 18.7968C18.5011 18.9323 18.3307 19 18.1239 19C17.917 19 17.7466 18.9323 17.6128 18.7968ZM14.8748 5.31398C16.116 5.81882 17.1139 6.62533 17.8683 7.73351C18.6228 8.84169 19 10.0853 19 11.4644C19 12.117 18.9119 12.7449 18.7357 13.3483C18.559 13.9516 18.3064 14.5119 17.9778 15.029L16.9192 13.9578C17.126 13.5761 17.2813 13.1759 17.385 12.7573C17.4882 12.3386 17.5398 11.9077 17.5398 11.4644C17.5398 10.3808 17.2448 9.40809 16.6549 8.54617C16.0644 7.68426 15.2825 7.05629 14.309 6.66227C14.1751 6.61302 14.0717 6.53298 13.9987 6.42216C13.9257 6.31135 13.8892 6.18821 13.8892 6.05277C13.8892 5.78188 13.9926 5.5664 14.1995 5.40633C14.4063 5.24626 14.6315 5.21548 14.8748 5.31398ZM15.5319 12.5541L13.8892 10.8918V8.49077C14.4611 8.76165 14.9084 9.16799 15.2311 9.70976C15.5534 10.2515 15.7145 10.8426 15.7145 11.4829C15.7145 11.6675 15.6994 11.8493 15.6692 12.0281C15.6385 12.2064 15.5928 12.3817 15.5319 12.5541ZM12.4289 9.41425L10.5306 7.4934L11.1877 6.8285C11.4189 6.59455 11.6835 6.54209 11.9814 6.67113C12.2798 6.80067 12.4289 7.03166 12.4289 7.36412V9.41425Z\" />\n                      </svg>\n                    </span>\n                  </div>" : "", "\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n");
};

/**
 * Sets the calculated attributes to each of the <circle> elements in the
 * progress ring module
 * @param  {jQuery} $video - video element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var applyVideoSkin = function applyVideoSkin($video, options) {
  // const videoUrl = $video.data('videoUrl');
  // const videoPosterUrl = $video.data('videoPosterUrl');
  // const $videoControls = returnVideoContainerHTML(videoUrl, videoPosterUrl);
  var videoWrapper = createVideoWrapper();
  $video.wrap(videoWrapper);
  var $videoWrapper = $video.parent();
  var $titleHidden = options.$originalTrigger.find(".".concat(options.titleClass));
  var $captionHidden = options.$originalTrigger.find(".".concat(options.captionClass));
  var $videoControls = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(createVideoControls(options, $titleHidden.text(), $captionHidden.text()));
  $videoWrapper.prepend($videoControls);

  // remove existing player if one already exists
  // $('#js-floating-video-container').remove();
  // $('body').append($videoWrapper);

  // const $closeButton = $videoWrapper.find('.js-custom-video__close');
  var $playPauseButton = $videoWrapper.find('.js-custom-video__play');
  var $muteButton = $videoWrapper.find('.js-custom-video__mute');
  var $captionButton = $videoWrapper.find('.js-custom-video__caption');
  var $currentTimeContainer = $videoWrapper.find('.js-custom-video__current-time-container');
  var $currentTimeDisplay = $videoWrapper.find('.js-custom-video__current-time');
  var $totalTimeDisplay = $videoWrapper.find('.js-custom-video__total-time');
  var $progressBarContainer = $videoWrapper.find('.js-custom-video__progress-bar-container');
  var $progressBar = $videoWrapper.find('.js-custom-video__progress-bar');
  var $progress = $videoWrapper.find('.js-custom-video__progress');
  var $thumb = $videoWrapper.find('.js-custom-video__thumb');
  var $fullscreenIcon = $videoWrapper.find('.js-custom-video__fullscreen');
  var $muteIcon = $videoWrapper.find('.icon--mute');
  var $unmuteIcon = $videoWrapper.find('.icon--unmute');
  var $playIcon = $videoWrapper.find('.icon--play');
  var $pauseIcon = $videoWrapper.find('.icon--pause');
  var isScrubbing = false;
  // const $video = $videoWrapper.find('video');
  var video = $video[0];
  var videoMuted = options.videoMuted;
  $captionButton.on('click', function () {
    $captionButton.toggleClass('expanded');
    $videoWrapper.toggleClass('custom-video__controls-caption--expanded');
  });
  video.volume = 1;
  // Initialize sound from the videoMuted option (data-video-muted). Default is
  // sound on so autoplay plays with audio (QA UX-20630).
  video.muted = videoMuted;
  video.removeAttribute('controls');
  updateMuteIcon();
  $playPauseButton.on('click', function () {
    if (isVideoPlaying(video)) {
      video.pause();
    } else {
      var playPromise = video.play();
      if (playPromise && playPromise["catch"]) {
        playPromise["catch"](function () {});
      }
    }
  });
  var syncPlayPauseIcons = function syncPlayPauseIcons(videoEl, isPlaying) {
    var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(videoEl).closest('.custom-video__container');
    $container.find('.icon--play').toggle(!isPlaying);
    $container.find('.icon--pause').toggle(isPlaying);
    $container.toggleClass('is-playing', isPlaying);
  };

  // The poster's ratio often differs from the video's (e.g. 3:4 poster on a 9:16 video),
  // so `contain` letterboxes it with white bands. Cover the poster until the first
  // frame renders, then fall back to `contain` for the video itself. [UX-21375]
  if (video.paused && video.currentTime === 0) {
    $videoWrapper.addClass('custom-video__container--poster');
  }
  $video.one('playing', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).closest('.custom-video__container').removeClass('custom-video__container--poster');
  });
  $video.on('play', function () {
    syncPlayPauseIcons(this, true);
  });
  $video.on('pause', function () {
    syncPlayPauseIcons(this, false);
  });
  var updateTotalTime = function updateTotalTime() {
    if (isFinite(video.duration) && video.duration > 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(video).closest('.custom-video__container').find('.js-custom-video__total-time').text(formatTime(video.duration));
    }
  };
  var setNaturalRatio = function setNaturalRatio() {
    if (video.videoWidth && video.videoHeight) {
      var wrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(video).closest('.custom-video__container')[0];
      if (wrapper) {
        wrapper.style.setProperty('--video-ar', "".concat(video.videoWidth, " / ").concat(video.videoHeight));
      }
    }
  };
  if (video.readyState >= 1) {
    updateTotalTime();
    setNaturalRatio();
  }
  video.addEventListener('loadedmetadata', updateTotalTime);
  video.addEventListener('loadedmetadata', setNaturalRatio);
  video.addEventListener('durationchange', updateTotalTime);
  video.ontimeupdate = function () {
    $currentTimeDisplay.text(formatTime(video.currentTime));
    updateProgressBar();
  };
  $progressBarContainer.on('mousedown.customVideoPlayer', function (e) {
    isScrubbing = true;
    updateCurrentTime(e);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('mousemove.customVideoPlayer', updateCurrentTime);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('mouseup.customVideoPlayer', function () {
      isScrubbing = false;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).off('mousemove.customVideoPlayer', updateCurrentTime);
      window.setTimeout(function () {
        return $currentTimeContainer.removeClass('show');
      }, 1000);
    });
  });
  $progressBarContainer.on('mouseenter', function () {
    $currentTimeContainer.addClass('show');
  });
  $progressBarContainer.on('mouseleave', function () {
    $currentTimeContainer.removeClass('show');
  });
  function updateCurrentTime(e) {
    e.stopPropagation();
    var offsetX = e.pageX - $progressBar.offset().left;
    var width = $progressBar.width();
    var clickPosition = Math.max(0, Math.min(offsetX / width, 1));
    video.currentTime = clickPosition * video.duration;
    updateProgressBar();
    $currentTimeDisplay.text(formatTime(video.currentTime));
  }

  // Function to update the progress bar width
  function updateProgressBar() {
    var progressPercentage = video.currentTime / video.duration * 100;
    $progress.css('width', progressPercentage + '%');

    // Position the thumb at the end of the progress bar
    var thumbPosition = progressPercentage / 100 * $progressBar.width();
    $thumb.css('left', thumbPosition + 'px');
  }

  // toggle volume
  $muteButton.on('click', function () {
    video.muted = !video.muted;
    updateMuteIcon();
  });

  // Sync the mute/unmute icon with the video's current muted state (no toggle).
  function updateMuteIcon() {
    if (video.muted) {
      $muteIcon.show();
      $unmuteIcon.hide();
    } else {
      $muteIcon.hide();
      $unmuteIcon.show();
    }
  }

  // Full screen button
  $fullscreenIcon.on('click', function () {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      enterFullScreen($videoWrapper[0]);
      $videoWrapper.addClass('is-fullscreen');
    }
  });

  // Exiting full screen button
  document.addEventListener('fullscreenchange', function () {
    if (!document.fullscreenElement) {
      $videoWrapper.removeClass('is-fullscreen');
    }
  });
};

/**
 * Initializes customVideoPlayer
 * @param {HTMLElement} el - progress ring element
 * @param {Object} options - Options used for wiring up the customVideoPlayer
 * @see DEFAULTS
 */
function customVideoPlayer(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $video = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $video);
  if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).hasClass('ab3461')) {
    applyVideoSkin($video, opts);
  }
  return {
    // rerender: (filled, pending) => rerender($video, filled, pending, opts),
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, customVideoPlayer);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Handles close banners
 * @module closeBanner
 */



var PLUGIN_NAME = 'closeBanner';
var closeBannerEventHandlers = function closeBannerEventHandlers($el) {
  var closeBannerParent = $el.parents('.js-close-parent');
  $el.on('click', function () {
    closeBannerParent.hide();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').scroll();

    // cls cookie update
    var cookie = $el.data('cookie');
    if (cookie) {
      updateClsCookieObject(cookie, 0);
    }
  });
};
function bannerCloseBtn(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  closeBannerEventHandlers($el);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, bannerCloseBtn);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SECOND */
/* unused harmony export MINUTE */
/* unused harmony export HOUR */
/* unused harmony export DAY */
/* unused harmony export DAY_CONTAINER */
/* unused harmony export HOURS_AS_DAYS_CONTAINER */
/* unused harmony export HOUR_CONTAINER */
/* unused harmony export MINUTE_CONTAINER */
/* unused harmony export SECOND_CONTAINER */
/* unused harmony export DAY_LABEL */
/* unused harmony export HOURS_AS_DAYS_LABEL */
/* unused harmony export HOUR_LABEL */
/* unused harmony export MINUTE_LABEL */
/* unused harmony export SECOND_LABEL */
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Countdown days, hours, minutes and seconds
 * @module countdown
 */

// Styleguide documenation URL: /r/r_src/main/styleguide/site/modules.html#countdown




var SECOND = 1000;
var MINUTE = SECOND * 60;
var HOUR = MINUTE * 60;
var DAY = HOUR * 24;
var DAY_CONTAINER = '.js-countdown-day';
var HOURS_AS_DAYS_CONTAINER = '.js-countdown-hours-as-days';
var HOUR_CONTAINER = '.js-countdown-hour';
var MINUTE_CONTAINER = '.js-countdown-minute';
var SECOND_CONTAINER = '.js-countdown-second';
var DAY_LABEL = '.js-countdown-day-label';
var HOURS_AS_DAYS_LABEL = '.js-countdown-hours-as-days-label';
var HOUR_LABEL = '.js-countdown-hour-label';
var MINUTE_LABEL = '.js-countdown-minute-label';
var SECOND_LABEL = '.js-countdown-second-label';

// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'countdown';
var DEFAULTS = {
  targetDateTime: '2029-12-01T00:00:00-08:00',
  countdownEndText: null,
  countdownRemove: false,
  stripLeadingZero: false,
  labels: {
    day: ['day', 'days'],
    hour: ['hour', 'hours'],
    minute: ['minute', 'minutes'],
    second: ['second', 'seconds']
  }
};
/**
 * Update countdown heading or remove when time expires
 * @param  {jQuery} $el - link
 * @param  {Object} [opts] - Any options provided upon initialization
 */
var updateCountdownHeading = function updateCountdownHeading($el, opts) {
  // Get the countdown heading
  var $countdownHed = $el.find('.js-countdown__hed');
  // Get data-countdown-end-text value - must be set on parent
  var countdownEndText = opts.countdownEndText;
  // If countdown heading exists and there is a countdownEndText value
  if ($countdownHed.length && countdownEndText !== null) {
    $countdownHed.text(countdownEndText);
  }
};
/**
 * Boolean to see if seconds should be displayed
 * @param  {Object} [opts] - Any options provided upon initialization
 */
var getThreshold = function getThreshold(opts) {
  return !opts.displaySeconds ? 60 : 0;
};
/**
 * Boolean to see if time has expired
 * @param  {Object} [opts] - Any options provided upon initialization
 */
var initialTimeCheck = function initialTimeCheck(target, opts) {
  var now = new Date().getTime();
  var initialTimeLeft = target - now;
  var initialSecondsRemaining = Math.floor(initialTimeLeft / 1000);
  // Check it time remaining is more than the thershold
  return initialSecondsRemaining > getThreshold(opts);
};
/**
* Creates an object to cach countdown elements
* @param  {jQuery} $el - link
*/
var queryElements = function queryElements($el) {
  return {
    dayContainer: $el.find(DAY_CONTAINER),
    hourContainer: $el.find(HOUR_CONTAINER),
    hourAsDaysContainer: $el.find(HOURS_AS_DAYS_CONTAINER),
    minuteContainer: $el.find(MINUTE_CONTAINER),
    secondContainer: $el.find(SECOND_CONTAINER),
    dayLabel: $el.find(DAY_LABEL),
    hourLabel: $el.find(HOUR_LABEL),
    hourAsDaysLabel: $el.find(HOURS_AS_DAYS_LABEL),
    minuteLabel: $el.find(MINUTE_LABEL),
    secondLabel: $el.find(SECOND_LABEL)
  };
};
var getCountdownLabel = function getCountdownLabel(unit, value, opts) {
  var labels = opts.labels || DEFAULTS.labels;
  var unitLabels = labels[unit] || DEFAULTS.labels[unit];
  var _unitLabels = _slicedToArray(unitLabels, 2),
    singular = _unitLabels[0],
    plural = _unitLabels[1];
  return parseInt(value, 10) === 1 ? singular : plural;
};
/**
 * Updates the countdown display elements
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {number} timeLeft - amount of time still left in the countdown
 */
var updateCountdownDisplay = function updateCountdownDisplay($el, $elements, opts, timeLeft) {
  var rawDays = Math.floor(timeLeft / DAY);
  var rawHoursDays = Math.floor(timeLeft % DAY / HOUR + (rawDays === 0 ? 0 : rawDays * 24));
  var pad = function pad(value) {
    return opts.stripLeadingZero ? "".concat(value) : value < 10 ? "0".concat(value).slice(-2) : value;
  };
  var daysLeft = pad(rawDays);
  var hoursDaysLeft = pad(rawHoursDays);
  var hoursLeft = pad(Math.floor(timeLeft % DAY / HOUR));
  var minutesLeft = pad(Math.floor(timeLeft % HOUR / MINUTE));
  var secondsLeft = pad(Math.floor(timeLeft % MINUTE / SECOND));
  $elements.dayContainer.text(daysLeft);
  $elements.hourContainer.text(hoursLeft);
  $elements.hourAsDaysContainer.text(hoursDaysLeft);
  $elements.minuteContainer.text(minutesLeft);
  $elements.secondContainer.text(secondsLeft);
  $elements.dayLabel.text(getCountdownLabel('day', daysLeft, opts));
  $elements.hourLabel.text(getCountdownLabel('hour', hoursLeft, opts));
  $elements.hourAsDaysLabel.text(getCountdownLabel('hour', hoursDaysLeft, opts));
  $elements.minuteLabel.text(getCountdownLabel('minute', minutesLeft, opts));
  $elements.secondLabel.text(getCountdownLabel('second', secondsLeft, opts));
};
/**
 * Runs the countdown and sets the interval
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var runCountdown = function runCountdown($el, $elements, opts) {
  var target = new Date(opts.targetDateTime).getTime();
  // initial check to see if any time remains
  var timeRemains = initialTimeCheck(target, opts);
  // if no time remains
  if (!timeRemains) {
    // Check if countdown should be removed otherwise zero it out
    if (opts.countdownRemove) {
      $el.children().not('.js-countdown__hed').remove();
    } else {
      updateCountdownDisplay($el, $elements, opts, 0);
    }
    // Display end text if provided
    updateCountdownHeading($el, opts);
    // Show countdown markup
    $el.removeClass('u-hide');
    return;
  }
  $el.removeClass('u-hide');
  var intervalId = setInterval(function () {
    var now = new Date().getTime();
    var timeLeft = target - now;
    var secondsRemaining = Math.floor(timeLeft / 1000);
    // Check if countdown has expired
    if (secondsRemaining <= getThreshold(opts)) {
      clearInterval(intervalId);
      updateCountdownDisplay($el, $elements, opts, 0);
      // Display end text if provided
      updateCountdownHeading($el, opts);
      // Remove countdown elements if option is enabled
      if (opts.countdownRemove) {
        $el.children().not('.js-countdown__hed').remove();
      }
      return;
    }
    updateCountdownDisplay($el, $elements, opts, timeLeft);
  }, SECOND);
};
/**
 * Initializes countdown
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function countdown(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  // Check boolean options on initialization for countdown removal
  opts.countdownRemove = opts.countdownRemove === true || opts.countdownRemove === "";
  var $elements = queryElements($el);
  // Check if seconds markup is present
  opts.displaySeconds = $el.find('.js-countdown-second').length;
  runCountdown($el, $elements, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, countdown);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* harmony export (immutable) */ __webpack_exports__["a"] = modal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_array_includes_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scriptjs__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scriptjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scriptjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_register_jquery_plugin__ = __webpack_require__(1);

/**
 * Handles all modals
 * @module modal
 */







var HAMMERJS_FALLBACK = 'https://ajax.googleapis.com/ajax/libs/hammerjs/2.0.8/hammer.min.js';

/**
 * AB840 for R Main Faster Modal
 */
var isFasterModal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.fasterModals', false);
if (isFasterModal) {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()(function () {
    return __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').addClass('modal--faster');
  });
}

/**
 * Makes a request for HammerJS.
 * @private
 * @return {Promise} Denotes when the request has been successfully executed
 */
var loadHammerJSFunc = function loadHammerJSFunc() {
  return new Promise(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_scriptjs___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('scripts.hammerJS', HAMMERJS_FALLBACK), function () {
      resolve(window.Hammer);
    });
  });
};

// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'modal';
var DEFAULTS = {
  url: '',
  type: '',
  open: null,
  data: '',
  animation: true,
  returnFocus: '',
  notificationAutoClose: true,
  notificationDuration: 5000,
  cache: true,
  closeButton: true,
  overlayClose: true,
  triggerOpen: false,
  triggerElement: '',
  padding: true,
  video: false,
  portrait: false,
  fullHeight: false,
  windowHeight: false,
  transparent: false,
  showProgressBar: true,
  scrolling: true,
  triggerByClick: true,
  // Use `false` when needed to trigger a modal and have swipe functionality, ex, pdp product 2 column
  loadHammerJS: loadHammerJSFunc,
  onOpen: function onOpen() {},
  onComplete: function onComplete() {},
  onLoad: function onLoad() {},
  onCleanup: function onCleanup() {},
  onClose: function onClose() {},
  onSuccess: function onSuccess(data) {},
  onPrepend: function onPrepend() {},
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */]),
  srLinkText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.translations.openModalSRText', 'Opens in a modal window'),
  addModifierClass: ''
};
var modalOpenerStack = [];
var $window = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window);

/**
 * Check if options.url is define, if it is create an empty modal
 * for ajax content. Otherwise, assign with options.open or $el's data attribute
 * @return {jQuery} modal element
 */
var appendModal = function appendModal() {
  var $modalHTML = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<div/>', {
    id: 'modal',
    "class": 'modal'
  });
  return $modalHTML;
};

/**
 * Set Aria
 * @param  {jQuery} $el - button /element that opens modal
 */
var setA11yAttr = function setA11yAttr($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.attr('aria-haspopup', 'dialog');
  if ($el.is('a')) {
    $el.attr('role', 'button');
  } else if ($el.is('button')) {
    $el.attr('type', 'button');
  }
};

/**
 * Get Modal
 * Target modal via options.open / data-open(legacy)
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {jQuery} modal element
 */
var getModal = function getModal($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $modal;
  if (options.open) {
    $modal = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#".concat(options.open));
  } else if (options.url || $el.data('url')) {
    if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#modal').length) {
      $modal = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#modal');
    } else {
      $modal = appendModal();
    }
  } else if ($el.data('open')) {
    $modal = __WEBPACK_IMPORTED_MODULE_1_jquery___default()("#".concat($el.data('open')));
  }
  return $modal;
};
/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
var mergeOptions = function mergeOptions($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Assign $modal to modal element either by options {} or $el's data attribute
  var $modal = getModal($el, options);
  var opts = {};
  var modalData = !$modal ? {} : $modal.data();
  if (!$modal) return false;
  opts = Object.assign({}, DEFAULTS, $el.data(), options);
  if (!options.url) {
    opts = Object.assign({}, DEFAULTS, modalData, $el.data(), options);
  }
  return opts;
};

/**
 * Check if options.url is define, if it is create an empty modal
 * otherwise target options.open or $el's data attribute
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {jQuery} modal element
 */
var setModal = function setModal($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Assign $modal to modal element either by options {} or $el's data attribute
  var $modal = getModal($el, options);
  $modal.appendTo('body');
  return $modal;
};
/**
 * @param  {jQuery} $overlay - modal overlay
 */
var appendLoadingBar = function appendLoadingBar($overlay) {
  if (!__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal-overlay__progress-bar').length) {
    var ajaxLoadingMessage;
    try {
      ajaxLoadingMessage = window.rcProps.translations.ajaxLoadingMessage;
    } catch (e) {
      ajaxLoadingMessage = 'Content is loading';
    }
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()("<div class=\"modal-overlay__progress-bar modal-overlay__progress-bar--hidden progress-bar progress-bar--center\" tabindex=\"-1\">\n        <div class=\"u-screen-reader\">\n            ".concat(ajaxLoadingMessage, "\n        </div>\n     </div>")).appendTo($overlay);
  }
};
/**
 * @return {jQuery} modal overlay element
 */
var appendModalOverlay = function appendModalOverlay(options) {
  if (!__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal-overlay').length) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<div class="modal-overlay"></div>').appendTo('body');
  }
  if (!options.animation) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal-overlay').addClass('modal-overlay--no-animation');
  }
  return __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal-overlay');
};
/**
 * Check if options.url is define, if it is create an empty modal
 * otherwise target options.open or $el's data attribute
 * @param  {jQuery} $el - modal element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {jQuery} modal content element
 */
var wrapModalContent = function wrapModalContent($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!$el.find('.modal__content').length) {
    $el.wrapInner('<div role="dialog" tabindex="-1" class="modal__content"></div>');
  }
  if (!options.padding) {
    $el.find('.modal__content').addClass('u-padding-a--none');
  }
  if (!options.animation) {
    $el.find('.modal__content').addClass('modal__content--no-animation');
  }
  if (options.video) {
    $el.find('.modal__content').addClass('modal__content--video');
  }
  if (options.portrait) {
    $el.find('.modal__content').addClass('modal__content--video__portrait');
  }
  if (options.fullHeight) {
    $el.find('.modal__content').addClass('modal__content--full-height');
  }
  if (!options.scrolling) {
    $el.find('.modal__content').addClass('u-overflow--hidden');
  }

  // used when you need to have the modal full window height
  if (options.windowHeight) {
    $el.find('.modal__content').addClass('u-height--full');
    setTimeout(function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#modal').addClass('u-padding-a--none');
    });
  }
  return $el.find('.modal__content');
};
/**
 * Adjust and set classes and options for appropriate modal type
 * @param  {jQuery} $el - modal element
 * @param  {string} type - modifier
 */
var addModalModifiers = function addModalModifiers($el, type, classModifier) {
  var modalTypeClass = "modal--".concat(type);
  if (type) {
    $el.addClass(modalTypeClass);
  }
  if (classModifier) {
    $el.addClass(classModifier);
  }
};
/**
 * Adjust and set classes and options for appropriate modal type
 * @param  {jQuery} $el - modal element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable modal settings
 */
var adjustToModalType = function adjustToModalType($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var typeAdjust = {
    pageScroll: false,
    overlay: true
  };
  addModalModifiers($el, options.type, options.addModifierClass);
  switch (options.type) {
    case 'notification':
      typeAdjust = {
        pageScroll: true,
        overlay: false
      };
      break;
    case 'notification-bubble':
      typeAdjust = {
        pageScroll: true,
        overlay: false
      };
      break;
    default:
  }
  return typeAdjust;
};
/**
 * Remove active class on elements
 * @param  {rest}
 */
var removeActiveClass = function removeActiveClass() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args.forEach(function ($el) {
    $el.removeClass('is-active');
  });
};
/**
 * @param  {jQuery} $el - modal element
 */
var removeModalModifiers = function removeModalModifiers($el) {
  var classArray = Array.from($el[0].classList);
  var modifers = classArray.filter(function (modalClass) {
    return modalClass.includes('--');
  });
  modifers.forEach(function (modClass) {
    $el.removeClass(modClass);
  });
};
/**
 * Reset modal for next ajax loaded content
 */
var resetAjaxModal = function resetAjaxModal() {
  var $ajaxModal = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('#modal');
  if ($ajaxModal.length) {
    removeModalModifiers($ajaxModal);
    $ajaxModal.find('.modal__content *:not(".modal__close, .modal__close *")').remove();
  }
};
/**
 * Ensure one modal is open at a time
 * @param  {jQuery} $modal
 * @param  {jQuery} $overlay
 */
var closeAllModals = function closeAllModals() {
  clearTimeout(window.modalCloseTimeout);
  resetAjaxModal();
  removeActiveClass(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal-overlay'), __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal'));
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal__content[aria-modal="true"]').attr('aria-modal', false);
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').removeClass('body--modal-overflow-hidden');
};
/**
 * Add active class on elements
 * @param  {rest}
 */
var addActiveClass = function addActiveClass() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  // Delay to allow for css animation
  setTimeout(function () {
    args.forEach(function ($el) {
      $el.addClass('is-active');
    });
  }, 1);
};
/**
 * Callback after css animation
 * @param {jQuery} $el - css animated element
 */
var afterAnimation = function afterAnimation($el, cb) {
  var animationDone = false;
  $el.on('transitionend', function (e) {
    if (e.propertyName === 'transform' && !animationDone) {
      animationDone = true;
      cb();
    }
  });
  setTimeout(function () {
    if (!animationDone) {
      animationDone = true;
      cb();
    }
  }, 500);
};
/**
 * Return to last focusable element
 * @param  {jQuery} $content
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var returnToLastFocus = function returnToLastFocus($content) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (options.returnFocus) {
    options.releaseFocusFunc($content, __WEBPACK_IMPORTED_MODULE_1_jquery___default()(options.returnFocus));
  } else {
    options.releaseFocusFunc($content, __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).data('lastFocus'));
  }
};
/**
 * Handles the click event to close the modal
 * @param  {event} event
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var closeModal = function closeModal(evt, $el, $modal, $content, $overlay, typeAdjust) {
  var options = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  clearTimeout(window.modalCloseTimeout);
  if (evt) {
    evt.preventDefault();
  }
  if (typeAdjust.overlay) {
    removeActiveClass($overlay);
  }
  if (!typeAdjust.pageScroll) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').removeClass('body--modal-overflow-hidden');
  }
  removeActiveClass($modal);
  options.onCleanup({
    target: $el,
    options: options
  });
  afterAnimation($content, function () {
    $content.find('.modal__close').remove();
    if (modalOpenerStack.length > 0) {
      modalOpenerStack[0].prop('disabled', false);
    }
    options.onClose({
      target: $el,
      options: options
    });
    if (options.url) {
      resetAjaxModal();
    }
    returnToLastFocus($content, options);
    modalOpenerStack.length = 0;
  });

  // to ensure the event isn't get bound multiple times
  $content.off('mousedown.modal');
  $content.attr('aria-modal', false);
  if (options.overlayClose) {
    // to ensure the event isn't get bound multiple times
    $modal.off('mousedown');
  }
};
/**
 * Set timeout for notification modal
 * @param  {jQuery} $el
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 */
var setNotificationDuration = function setNotificationDuration($el, $modal, $content, $overlay, typeAdjust, options) {
  var minDuration = options.notificationDuration;
  window.modalCloseTimeout = setTimeout(function () {
    closeModal(false, $el, $modal, $content, $overlay, typeAdjust, options);
  }, minDuration);
};
/**
 * Add aria-labelledby to modal content for accessible
 * audible title that corresponds with modal's heading
 * @param  {jQuery} $content
 */
var addHedAria = function addHedAria($content) {
  var $modalHed = __WEBPACK_IMPORTED_MODULE_1_jquery___default()($content.find('.modal__hed'));
  if (!$modalHed.length) {
    $modalHed = $content.find('.modal__focus-element');
  }
  if ($modalHed.length) {
    var modalHedID = $modalHed.attr('id') ? $modalHed.attr('id') : "modal-hed-".concat(Math.ceil(Math.random() * 10000000000));
    $content.attr('aria-labelledby', modalHedID);
    $content.attr('aria-modal', true);
    $modalHed.attr('id', modalHedID).attr('tabindex', '-1');
  }
};
/**
 * Save last focus element that's not inside modal
 * @param  {jQuery} $el - last focusable element
 */
var saveLastFocus = function saveLastFocus($el) {
  if (!$el.parents('.modal__content').length) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(document).data('lastFocus', $el);
  }
};
/**
 * Give each <a> a unique href value, in order to avoid users hearing
 * "visited" on links they've yet to visit.
 * @param  {jQuery} $modal
 */
var uniqueCloseHref = function uniqueCloseHref($modal) {
  $modal.find('.js-modal-close').each(function eachCloseLink() {
    var $closeLink = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this);
    if ($closeLink.is('a')) {
      $closeLink.attr('href', "#modal-uid-".concat(Math.ceil(Math.random() * 10000000000)));
    }
  });
};

/**
 * Lazy loading images
 * @param {jQuery} $content
 */
var imgLazy = function imgLazy($content) {
  if ($content.find('img').length > 0 && $content.find("[data-src]").length > 0) {
    $content.find('img').each(function (i, el) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).attr('src', __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el).data('src'));
    });
  }
};

/**
 * Open modal
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var openModal = function openModal($el, $modal, $content, $overlay, typeAdjust) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  modalOpenerStack.push($el);
  modalOpenerStack[0].prop('disabled', true);
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal-overlay__progress-bar').addClass('modal-overlay__progress-bar--hidden');
  options.onOpen({
    target: $el,
    options: options
  });
  addActiveClass($modal);
  addHedAria($content);
  saveLastFocus($el);
  uniqueCloseHref($modal);
  imgLazy($content);
  $content.scrollTop(0);
  if (typeAdjust.overlay) {
    addActiveClass($overlay);
  }
  if (!typeAdjust.pageScroll) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').addClass('body--modal-overflow-hidden');
  }
  if (!options.closeButton) {
    $content.find('.modal__close').remove();
  }
  if (!$content.find('.modal__inner').length) {
    $content.wrapInner('<div class="modal__inner"></div>');
  }
  addCloseButton($content, options);
  if (!options.video) {
    $content.removeClass('modal__content--video');
  }
  if (options.type === 'notification') {
    if ($content.find('.js-close-link--notification').length < 1 && options.closeButton) {
      $content.append("\n        <div class=\"js-close-link--notification u-center u-margin-t--sm\">\n          <button class=\"js-modal-close link link--light link--hover-white u-text--md\" type=\"button\">Close</button>\n          <span class=\"u-screen-reader\">Close notification modal</span>\n        </div>\n      ");
    }
    if (options.notificationAutoClose) {
      setNotificationDuration($el, $modal, $content, $overlay, typeAdjust, options);
    }
  }
  // Shift and trap focus to modal after animation
  afterAnimation($content, function () {
    options.trapFocusFunc($content);
    if ($content.find('.modal__hed').length) {
      $content.find('.modal__hed').focus();
    } else {
      $content.find('.modal__focus-element').focus();
    }
    options.onComplete({
      target: $el,
      options: options,
      content: $content
    });
  });
};
/**
 * Handles the click event when modal trigger/ button is clicked
 * @param  {jQuery} $el - control
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {event} evt
 */
var openModalEventHandler = function openModalEventHandler($el, $modal, $content, $overlay) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var evt = arguments.length > 5 ? arguments[5] : undefined;
  var typeAdjust = adjustToModalType($modal, options);
  if (evt) {
    evt.preventDefault();
  }
  closeAllModals();
  $content
  // To ensure the event isn't get bound multiple times
  .off('keydown.modalEscape')
  // escape event to close modal
  .on('keydown.modalEscape', function (evt) {
    return escapeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options);
  }).data('modalEscape', true)
  // Add listener to modal close button keyboard users hitting the enter key for a11y
  .on('keydown.modalClose', '.js-modal-close', function (event) {
    return keyboardCloseModal(event, $el, $modal, $content, $overlay, typeAdjust, options);
  }).data('modalEscape', true)
  // Add listener modal content for modalCloseClass to close modal
  .on('mousedown.modal', '.js-modal-close', function (evt) {
    return closeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options);
  })
  // Prevents href getting added to end of URL
  .on('click.modal', '.js-modal-close', function (evt) {
    return evt.preventDefault();
  })
  // Stop the clicks from bubbling up
  .on('mousedown.modal', function (evt) {
    return evt.stopPropagation();
  });
  if (options.overlayClose) {
    $modal
    // Add listener to outside of the modal if set true
    .on('mousedown.modal', function (evt) {
      return closeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options);
    });
  } else {
    $modal
    // Remove listener to outside of the modal if set false
    .off('mousedown.modal');
  }

  // If url is passed then attempt to load ajax.
  if (options.url) {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal-overlay__progress-bar').removeClass('modal-overlay__progress-bar--hidden');
    options.onLoad({
      target: $el,
      options: options
    });
    addModalModifiers($modal, options.type, options.addModifierClass);
    if (options.type !== 'notification' && options.type !== 'notification-bubble') {
      addActiveClass($overlay);
    }
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal-overlay__progress-bar').focus();
    __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.ajax({
      url: options.url,
      method: options.method || 'POST',
      cache: options.cache,
      data: options.data,
      timeout: 60000,
      success: function success(data) {
        options.onSuccess(data);
      }
    }).fail(function (jqXHR) {
      $content.prepend("<h3 class=\"modal__hed\">".concat(jqXHR.statusText, "</h3>"));
      openModal($el, $modal, $content, $overlay, typeAdjust, options);
    }).done(function (content) {
      $content.prepend(content);
      options.onPrepend();
      openModal($el, $modal, $content, $overlay, typeAdjust, options);
    });
  } else {
    openModal($el, $modal, $content, $overlay, typeAdjust, options);
  }

  // if bg needs to be transparent
  if (options.transparent) {
    $content.addClass('modal__content--bg-transparent');
  }
};
/**
 * @param  {jQuery} evt - key event
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var escapeModal = function escapeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options) {
  if (__WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].keys.ESCAPE) {
    closeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options);
  }
};
/**
 * @param  {jQuery} evt - key event
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [typeAdjust={}] - Modal Settings define by modal type
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var keyboardCloseModal = function keyboardCloseModal(evt, $el, $modal, $content, $overlay, typeAdjust, options) {
  if (__WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].keys.ENTER) {
    closeModal(evt, $el, $modal, $content, $overlay, typeAdjust, options);
  }
};
/**
 * Applies any sort of event handlers for the modal.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, $modal, $content, $overlay) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  // Add escape key down feature
  // Add listener to button to open modal
  // Track mouse movement to prevent click on slick swipe
  if (!options.triggerOpen) {
    if (options.triggerByClick) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()($el).on('click.modal', function (evt) {
        return openModalEventHandler($el, $modal, $content, $overlay, options, evt);
      });
    } else {
      // This block of code ensures that the modal doesn't open when a user is swiping through slick carousel.
      // A dragging flag was added and also a flag was added, "wasInitialMouseDownOnEl", to ensure that the modal
      // only opens if the initial mouse down and mouse up were done on the same $el element.
      var isDragging = false;
      var wasInitialMouseDownOnEl = false;
      $window.on('mousedown.modal', function (evt) {
        isDragging = false;
        wasInitialMouseDownOnEl = false;

        // Mousedown was done initially on the el
        if (__WEBPACK_IMPORTED_MODULE_1_jquery___default()(evt.target).closest($el).length > 0) {
          wasInitialMouseDownOnEl = true;
        }
        $window.on('mousemove.modal', function () {
          isDragging = true;
          $window.off("mousemove.modal");
        });
      });
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()($el).on('mouseup.modal', function (evt) {
        if (!isDragging && wasInitialMouseDownOnEl) {
          openModalEventHandler($el, $modal, $content, $overlay, options, evt);
        }
      });
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()($el).on('keydown.modal', function (evt) {
        if (__WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_5__keyboard__["a" /* default */].keys.ENTER) {
          openModalEventHandler($el, $modal, $content, $overlay, options, evt);
        }
      });
    }
  }
  if ($content[0] && options.type === 'notification') {
    options.loadHammerJS().then(function (Hammer) {
      var hammertime = new Hammer($content[0]);
      hammertime.get('swipe').set({
        direction: Hammer.DIRECTION_VERTICAL
      });
      hammertime.on('swipeup', function (evt) {
        return closeModal(evt, $el, $modal, $content, $overlay, options);
      });
    });
  }
};
/**
 * Remove any sort of event handlers for the modal.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 */
var removeEventListeners = function removeEventListeners($el, $modal, $content) {
  $el.off('click.modal');
  $content.off('mousedown.modal').off('keydown.modalClose').off('keydown.modalEscape');
  $modal.off('mousedown.modal');
};
/**
 * If triggerOpen option is set true open modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {jQuery} $overlay
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var checkTriggerOpen = function checkTriggerOpen($el, $modal, $content, $overlay) {
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  if (options.triggerOpen) {
    openModalEventHandler($el, $modal, $content, $overlay, options, false);
  }
};
/**
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {jQuery} $modal
 * @param  {jQuery} $content
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Function} deregister - teardown method from register jquery plugin
 */
var _destroy = function destroy($el, $modal, $content) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var deregister = arguments.length > 4 ? arguments[4] : undefined;
  removeEventListeners($el, $modal, $content);
  removeActiveClass(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal-overlay'), __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.modal'));
  removeModalModifiers($modal);
  deregister();
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').removeClass('body--modal-overflow-hidden');
  if (options.url) {
    $modal.remove();
  }
};
/* Add Close Button to modal
 * @param  {jQuery} $content
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var addCloseButton = function addCloseButton($content) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (options.closeButton && !$content.find('.modal__close').length && options.type !== 'notification') {
    $content.prepend("\n      <button class=\"js-modal-close modal__close modal__close--notification\" type=\"button\">\n        <span class=\"icon icon--x\">\n        <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\" role=\"presentation\">\n          <path d=\"M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28 4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8 9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z\"/>\n        </svg>\n        <div class=\"u-screen-reader\">Close Modal</div>\n        </span>\n      </button>\n    ");
  }
};
var setA11y = function setA11y($el, opts) {
  setA11yAttr($el);
};
/**
 * Initializes modal.
 * @param {HTMLElement} el - button /element that opens modal
 * @param {Object} options - Options used for wiring up the modal
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function modal(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_6__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref.deregister;
  var $el = options.triggerElement ? __WEBPACK_IMPORTED_MODULE_1_jquery___default()(options.triggerElement) : __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
  var opts = mergeOptions($el, options);
  if (opts) {
    var $modal = setModal($el, opts);
    var $overlay = appendModalOverlay(opts);
    var $content = wrapModalContent($modal, opts);
    setA11y($el, opts);
    if (opts.showProgressBar) {
      appendLoadingBar($overlay);
    }
    setEventListeners($el, $modal, $content, $overlay, opts, deregister);
    checkTriggerOpen($el, $modal, $content, $overlay, opts, deregister);
    return {
      destroy: function destroy() {
        return _destroy($el, $modal, $content, opts, deregister);
      }
    };
  }
  return true;
}
/**
 * Utility Function for Modal
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal = function (options) {
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('<div/>').modal(options);
};
/**
 * Utility Function for Closing Modal
 */
__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal.close = function () {
  closeAllModals();
};
/**
 * Utility Function for accessibility
 */
__WEBPACK_IMPORTED_MODULE_1_jquery___default.a.modal.a11y = function () {
  var $els = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('.js-modal-utility');
  var options = {
    srLinkText: DEFAULTS.srLinkText
  };
  $els.each(function applyA11y() {
    setA11y(__WEBPACK_IMPORTED_MODULE_1_jquery___default()(this), options);
  });
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, modal);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Toggle Text on click
 * @module toggleText
 */




var PLUGIN_NAME = 'productFilterCount';
var DEFAULTS = {};
var countChecked = function countChecked($checkboxes) {
  return $checkboxes.filter(':checked').length;
};
var renderCount = function renderCount($checkboxes, $count) {
  var count = countChecked($checkboxes);
  $count.text("(".concat(count, ")"));
  if (count === 0) $count.text('');
};
var onChangeListener = function onChangeListener($checkboxes, $count) {
  return $checkboxes.on('change', function () {
    return renderCount($checkboxes, $count);
  });
};

/**
 * Initializes productFilterCount.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
function productFilterCount(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $container);
  var $count = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.filterCount);
  var $checkboxes = $container.find('input[type="checkbox"]');
  if ($count.length === 0) console.warn('There is no $count selector.');
  renderCount($checkboxes, $count);
  onChangeListener($checkboxes, $count);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterCount);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DOT_CLASS */
/* harmony export (immutable) */ __webpack_exports__["a"] = createCounter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


/**
 * Defines the className of the dot button
 * @type {string}
 */
var DOT_CLASS = 'image-carousel__dot-button';

/**
 * Allows us to customize the "dot buttons"
 * @param {jQuery} $slides - slick slides (from slick)
 * @param {number} i - iterator, used to select current slide from $slides
 * @see DEFAULT_OPTIONS
 * @return {jQuery} "dot button"
 */

var updateCounterMarkup = function updateCounterMarkup(e, slick, $el) {
  $el.find('.carousel__counter').html(slick.currentSlide + 1 + ' / ' + slick.slideCount);
};
var counterMarkup = function counterMarkup(e, slick, $el) {
  $el.append('<div class="carousel__counter">' + parseInt(slick.currentSlide + 1, 10) + ' / ' + slick.slideCount + '</div>');
};
function createCounter($el) {
  $el.on('init', function (e, slick) {
    counterMarkup(e, slick, $el);
  });
  $el.on('afterChange', function (e, slick) {
    updateCounterMarkup(e, slick, $el);
  });
}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(42);
var toAbsoluteIndex = __webpack_require__(363);
var lengthOfArrayLike = __webpack_require__(351);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(14);
var definePropertyModule = __webpack_require__(32);
var createPropertyDescriptor = __webpack_require__(122);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(8);
var isObject = __webpack_require__(31);

var document = globalThis.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(12);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = function () { /* empty */ }.bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(14);
var fails = __webpack_require__(12);
var createElement = __webpack_require__(123);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(68);
var isCallable = __webpack_require__(11);
var isPrototypeOf = __webpack_require__(358);
var USE_SYMBOL_AS_UID = __webpack_require__(137);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(14);
var call = __webpack_require__(67);
var propertyIsEnumerableModule = __webpack_require__(360);
var createPropertyDescriptor = __webpack_require__(122);
var toIndexedObject = __webpack_require__(42);
var toPropertyKey = __webpack_require__(135);
var hasOwn = __webpack_require__(17);
var IE8_DOM_DEFINE = __webpack_require__(125);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(13);
var hasOwn = __webpack_require__(17);
var toIndexedObject = __webpack_require__(42);
var indexOf = __webpack_require__(120).indexOf;
var hiddenKeys = __webpack_require__(69);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__(126);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__(132);
var uid = __webpack_require__(136);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var store = __webpack_require__(70);

module.exports = function (key, value) {
  return store[key] || (store[key] = value || {});
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(341);
var fails = __webpack_require__(12);
var globalThis = __webpack_require__(8);

var $String = globalThis.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__(353);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(366);
var isSymbol = __webpack_require__(127);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(13);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.1.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(133);

module.exports = NATIVE_SYMBOL &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(14);
var fails = __webpack_require__(12);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(8);
var shared = __webpack_require__(132);
var hasOwn = __webpack_require__(17);
var uid = __webpack_require__(136);
var NATIVE_SYMBOL = __webpack_require__(133);
var USE_SYMBOL_AS_UID = __webpack_require__(137);

var Symbol = globalThis.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(382)()
	? __webpack_require__(44).Symbol
	: __webpack_require__(387);


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isSymbol = __webpack_require__(383);

module.exports = function (value) {
	if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
	return value;
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(48),
    baseLodash = __webpack_require__(80);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(74),
    setCacheAdd = __webpack_require__(492),
    setCacheHas = __webpack_require__(493);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(4);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(155);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(161),
    isArguments = __webpack_require__(93),
    isArray = __webpack_require__(7),
    isBuffer = __webpack_require__(94),
    isIndex = __webpack_require__(53),
    isTypedArray = __webpack_require__(188);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(151),
    eq = __webpack_require__(56);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(168);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(75),
    arrayEach = __webpack_require__(147),
    assignValue = __webpack_require__(150),
    baseAssign = __webpack_require__(403),
    baseAssignIn = __webpack_require__(404),
    cloneBuffer = __webpack_require__(431),
    copyArray = __webpack_require__(83),
    copySymbols = __webpack_require__(436),
    copySymbolsIn = __webpack_require__(437),
    getAllKeys = __webpack_require__(171),
    getAllKeysIn = __webpack_require__(172),
    getTag = __webpack_require__(52),
    initCloneArray = __webpack_require__(465),
    initCloneByTag = __webpack_require__(466),
    initCloneObject = __webpack_require__(467),
    isArray = __webpack_require__(7),
    isBuffer = __webpack_require__(94),
    isMap = __webpack_require__(516),
    isObject = __webpack_require__(9),
    isSet = __webpack_require__(519),
    keys = __webpack_require__(20),
    keysIn = __webpack_require__(100);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(78),
    isArray = __webpack_require__(7);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(153),
    baseIsNaN = __webpack_require__(411),
    strictIndexOf = __webpack_require__(499);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(408),
    isObjectLike = __webpack_require__(10);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(417),
    baseMatchesProperty = __webpack_require__(418),
    identity = __webpack_require__(34),
    isArray = __webpack_require__(7),
    property = __webpack_require__(58);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(34),
    overRest = __webpack_require__(181),
    setToString = __webpack_require__(91);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(34),
    metaMap = __webpack_require__(179);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 160 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 162 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 164 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(399),
    deburr = __webpack_require__(512),
    words = __webpack_require__(531);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(163),
    composeArgsRight = __webpack_require__(164),
    countHolders = __webpack_require__(439),
    createCtor = __webpack_require__(50),
    createRecurry = __webpack_require__(167),
    getHolder = __webpack_require__(84),
    reorder = __webpack_require__(491),
    replaceHolders = __webpack_require__(55),
    root = __webpack_require__(4);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(471),
    setData = __webpack_require__(182),
    setWrapToString = __webpack_require__(183);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(144),
    arraySome = __webpack_require__(400),
    cacheHas = __webpack_require__(162);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(154),
    getSymbols = __webpack_require__(86),
    keys = __webpack_require__(20);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(154),
    getSymbolsIn = __webpack_require__(174),
    keysIn = __webpack_require__(100);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(179),
    noop = __webpack_require__(101);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(78),
    getPrototype = __webpack_require__(85),
    getSymbols = __webpack_require__(86),
    stubArray = __webpack_require__(189);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(56),
    isArrayLike = __webpack_require__(35),
    isIndex = __webpack_require__(53),
    isObject = __webpack_require__(9);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(146);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(76);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(159),
    shortOut = __webpack_require__(184);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(457),
    insertWrapDetails = __webpack_require__(468),
    setToString = __webpack_require__(91),
    updateWrapDetails = __webpack_require__(505);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 184 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(153),
    baseIteratee = __webpack_require__(157),
    toInteger = __webpack_require__(59);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(15),
    isObject = __webpack_require__(9);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(414),
    baseUnary = __webpack_require__(81),
    nodeUtil = __webpack_require__(89);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 189 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(191);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(425),
    isObject = __webpack_require__(9),
    isSymbol = __webpack_require__(57);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ES3 safe
var _undefined = void 0;

module.exports = function (value) { return value !== _undefined && value !== null; };


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFDQN;

var _assertString = __webpack_require__(102);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(194);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFDQN(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_fqdn_options);

  /* Remove the optional trailing dot before checking validity */
  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }
  var parts = str.split('.');
  if (options.require_tld) {
    var tld = parts.pop();
    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    }
    // disallow spaces
    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }
  for (var part, i = 0; i < parts.length; i++) {
    part = parts[i];
    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }
    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    }
    // disallow full-width chars
    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }
    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }
  return true;
}
module.exports = exports['default'];

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;
function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments[1];

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }
  return obj;
}
module.exports = exports['default'];

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLSThresholds */
/* unused harmony export FCPThresholds */
/* unused harmony export FIDThresholds */
/* unused harmony export INPThresholds */
/* unused harmony export LCPThresholds */
/* unused harmony export TTFBThresholds */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return S; });
/* unused harmony export getFCP */
/* unused harmony export getFID */
/* unused harmony export getINP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return W; });
/* unused harmony export getTTFB */
/* unused harmony export onCLS */
/* unused harmony export onFCP */
/* unused harmony export onFID */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Q; });
/* unused harmony export onLCP */
/* unused harmony export onTTFB */
var e,n,t,i,r,a=-1,o=function(e){addEventListener("pageshow",(function(n){n.persisted&&(a=n.timeStamp,e(n))}),!0)},c=function(){return window.performance&&performance.getEntriesByType&&performance.getEntriesByType("navigation")[0]},u=function(){var e=c();return e&&e.activationStart||0},f=function(e,n){var t=c(),i="navigate";a>=0?i="back-forward-cache":t&&(document.prerendering||u()>0?i="prerender":document.wasDiscarded?i="restore":t.type&&(i=t.type.replace(/_/g,"-")));return{name:e,value:void 0===n?-1:n,rating:"good",delta:0,entries:[],id:"v3-".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12),navigationType:i}},s=function(e,n,t){try{if(PerformanceObserver.supportedEntryTypes.includes(e)){var i=new PerformanceObserver((function(e){Promise.resolve().then((function(){n(e.getEntries())}))}));return i.observe(Object.assign({type:e,buffered:!0},t||{})),i}}catch(e){}},d=function(e,n,t,i){var r,a;return function(o){n.value>=0&&(o||i)&&((a=n.value-(r||0))||void 0===r)&&(r=n.value,n.delta=a,n.rating=function(e,n){return e>n[1]?"poor":e>n[0]?"needs-improvement":"good"}(n.value,t),e(n))}},l=function(e){requestAnimationFrame((function(){return requestAnimationFrame((function(){return e()}))}))},p=function(e){var n=function(n){"pagehide"!==n.type&&"hidden"!==document.visibilityState||e(n)};addEventListener("visibilitychange",n,!0),addEventListener("pagehide",n,!0)},v=function(e){var n=!1;return function(t){n||(e(t),n=!0)}},m=-1,h=function(){return"hidden"!==document.visibilityState||document.prerendering?1/0:0},g=function(e){"hidden"===document.visibilityState&&m>-1&&(m="visibilitychange"===e.type?e.timeStamp:0,T())},y=function(){addEventListener("visibilitychange",g,!0),addEventListener("prerenderingchange",g,!0)},T=function(){removeEventListener("visibilitychange",g,!0),removeEventListener("prerenderingchange",g,!0)},E=function(){return m<0&&(m=h(),y(),o((function(){setTimeout((function(){m=h(),y()}),0)}))),{get firstHiddenTime(){return m}}},C=function(e){document.prerendering?addEventListener("prerenderingchange",(function(){return e()}),!0):e()},L=[1800,3e3],w=function(e,n){n=n||{},C((function(){var t,i=E(),r=f("FCP"),a=s("paint",(function(e){e.forEach((function(e){"first-contentful-paint"===e.name&&(a.disconnect(),e.startTime<i.firstHiddenTime&&(r.value=Math.max(e.startTime-u(),0),r.entries.push(e),t(!0)))}))}));a&&(t=d(e,r,L,n.reportAllChanges),o((function(i){r=f("FCP"),t=d(e,r,L,n.reportAllChanges),l((function(){r.value=performance.now()-i.timeStamp,t(!0)}))})))}))},b=[.1,.25],S=function(e,n){n=n||{},w(v((function(){var t,i=f("CLS",0),r=0,a=[],c=function(e){e.forEach((function(e){if(!e.hadRecentInput){var n=a[0],t=a[a.length-1];r&&e.startTime-t.startTime<1e3&&e.startTime-n.startTime<5e3?(r+=e.value,a.push(e)):(r=e.value,a=[e])}})),r>i.value&&(i.value=r,i.entries=a,t())},u=s("layout-shift",c);u&&(t=d(e,i,b,n.reportAllChanges),p((function(){c(u.takeRecords()),t(!0)})),o((function(){r=0,i=f("CLS",0),t=d(e,i,b,n.reportAllChanges),l((function(){return t()}))})),setTimeout(t,0))})))},A={passive:!0,capture:!0},I=new Date,P=function(i,r){e||(e=r,n=i,t=new Date,k(removeEventListener),F())},F=function(){if(n>=0&&n<t-I){var r={entryType:"first-input",name:e.type,target:e.target,cancelable:e.cancelable,startTime:e.timeStamp,processingStart:e.timeStamp+n};i.forEach((function(e){e(r)})),i=[]}},M=function(e){if(e.cancelable){var n=(e.timeStamp>1e12?new Date:performance.now())-e.timeStamp;"pointerdown"==e.type?function(e,n){var t=function(){P(e,n),r()},i=function(){r()},r=function(){removeEventListener("pointerup",t,A),removeEventListener("pointercancel",i,A)};addEventListener("pointerup",t,A),addEventListener("pointercancel",i,A)}(n,e):P(n,e)}},k=function(e){["mousedown","keydown","touchstart","pointerdown"].forEach((function(n){return e(n,M,A)}))},D=[100,300],x=function(t,r){r=r||{},C((function(){var a,c=E(),u=f("FID"),l=function(e){e.startTime<c.firstHiddenTime&&(u.value=e.processingStart-e.startTime,u.entries.push(e),a(!0))},m=function(e){e.forEach(l)},h=s("first-input",m);a=d(t,u,D,r.reportAllChanges),h&&p(v((function(){m(h.takeRecords()),h.disconnect()}))),h&&o((function(){var o;u=f("FID"),a=d(t,u,D,r.reportAllChanges),i=[],n=-1,e=null,k(addEventListener),o=l,i.push(o),F()}))}))},B=0,R=1/0,H=0,N=function(e){e.forEach((function(e){e.interactionId&&(R=Math.min(R,e.interactionId),H=Math.max(H,e.interactionId),B=H?(H-R)/7+1:0)}))},O=function(){return r?B:performance.interactionCount||0},q=function(){"interactionCount"in performance||r||(r=s("event",N,{type:"event",buffered:!0,durationThreshold:0}))},j=[200,500],_=0,z=function(){return O()-_},G=[],J={},K=function(e){var n=G[G.length-1],t=J[e.interactionId];if(t||G.length<10||e.duration>n.latency){if(t)t.entries.push(e),t.latency=Math.max(t.latency,e.duration);else{var i={id:e.interactionId,latency:e.duration,entries:[e]};J[i.id]=i,G.push(i)}G.sort((function(e,n){return n.latency-e.latency})),G.splice(10).forEach((function(e){delete J[e.id]}))}},Q=function(e,n){n=n||{},C((function(){var t;q();var i,r=f("INP"),a=function(e){e.forEach((function(e){(e.interactionId&&K(e),"first-input"===e.entryType)&&(!G.some((function(n){return n.entries.some((function(n){return e.duration===n.duration&&e.startTime===n.startTime}))}))&&K(e))}));var n,t=(n=Math.min(G.length-1,Math.floor(z()/50)),G[n]);t&&t.latency!==r.value&&(r.value=t.latency,r.entries=t.entries,i())},c=s("event",a,{durationThreshold:null!==(t=n.durationThreshold)&&void 0!==t?t:40});i=d(e,r,j,n.reportAllChanges),c&&("PerformanceEventTiming"in window&&"interactionId"in PerformanceEventTiming.prototype&&c.observe({type:"first-input",buffered:!0}),p((function(){a(c.takeRecords()),r.value<0&&z()>0&&(r.value=0,r.entries=[]),i(!0)})),o((function(){G=[],_=O(),r=f("INP"),i=d(e,r,j,n.reportAllChanges)})))}))},U=[2500,4e3],V={},W=function(e,n){n=n||{},C((function(){var t,i=E(),r=f("LCP"),a=function(e){var n=e[e.length-1];n&&n.startTime<i.firstHiddenTime&&(r.value=Math.max(n.startTime-u(),0),r.entries=[n],t())},c=s("largest-contentful-paint",a);if(c){t=d(e,r,U,n.reportAllChanges);var m=v((function(){V[r.id]||(a(c.takeRecords()),c.disconnect(),V[r.id]=!0,t(!0))}));["keydown","click"].forEach((function(e){addEventListener(e,(function(){return setTimeout(m,0)}),!0)})),p(m),o((function(i){r=f("LCP"),t=d(e,r,U,n.reportAllChanges),l((function(){r.value=performance.now()-i.timeStamp,V[r.id]=!0,t(!0)}))}))}}))},X=[800,1800],Y=function e(n){document.prerendering?C((function(){return e(n)})):"complete"!==document.readyState?addEventListener("load",(function(){return e(n)}),!0):setTimeout(n,0)},Z=function(e,n){n=n||{};var t=f("TTFB"),i=d(e,t,X,n.reportAllChanges);Y((function(){var r=c();if(r){var a=r.responseStart;if(a<=0||a>performance.now())return;t.value=Math.max(a-u(),0),t.entries=[r],i(!0),o((function(){t=f("TTFB",0),(i=d(e,t,X,n.reportAllChanges))(!0)}))}}))};


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__touch__ = __webpack_require__(233);

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__touch__["a" /* default */])();

/***/ }),
/* 197 */
/***/ (function(module, exports) {

$(function () {
  //app download popup
  $('.app-download-sms-link').click(function (e) {
    e.preventDefault();
    var deviceType = $(this).data('deviceType');
    $.modal({
      url: "/r/dialog/AppDownload.jsp?deviceType=" + $(this).data('deviceType'),
      triggerOpen: true,
      type: "small",
      returnFocus: '#' + deviceType,
      onComplete: function onComplete() {
        $(".js-accordion").accordion();
      }
    });
  });

  /*
  * Accessibility - add aria-current="page" to active navigation link
  */
  if ($('.js-left-nav-container')[0]) {
    var lastActiveItem = $('.js-left-nav-container a.active:last');
    lastActiveItem.attr('aria-current', 'page');
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_modules_global_cookies__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_web_vitals__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_modules_heart_product__ = __webpack_require__(108);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }



var addToGlobal = function addToGlobal() {
  for (var _len = arguments.length, propTuple = new Array(_len), _key = 0; _key < _len; _key++) {
    propTuple[_key] = arguments[_key];
  }
  propTuple.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      value = _ref2[1];
    window[name] = value;
  });
};
addToGlobal(['docCookies', __WEBPACK_IMPORTED_MODULE_0_modules_global_cookies__["a" /* default */]], ['setCookie', __WEBPACK_IMPORTED_MODULE_0_modules_global_cookies__["b" /* setCookie */]], ['getCookie', __WEBPACK_IMPORTED_MODULE_0_modules_global_cookies__["c" /* getCookie */]], ['removeCookie', __WEBPACK_IMPORTED_MODULE_0_modules_global_cookies__["d" /* removeCookie */]], ['updateHeartCount', __WEBPACK_IMPORTED_MODULE_2_modules_heart_product__["a" /* default */].updateHeartCount], ['getLCP', __WEBPACK_IMPORTED_MODULE_1_web_vitals__["b" /* getLCP */]], ['getCLS', __WEBPACK_IMPORTED_MODULE_1_web_vitals__["a" /* getCLS */]], ['updateClsCookieObject', __WEBPACK_IMPORTED_MODULE_0_modules_global_cookies__["e" /* updateClsCookieObject */]], ['onINP', __WEBPACK_IMPORTED_MODULE_1_web_vitals__["c" /* onINP */]]);

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_web_vitals__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styleguide_modules_close_banner_js__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styleguide_modules_countdown_js__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_modules_heart_product__ = __webpack_require__(108);





window.bindHeartEvent = __WEBPACK_IMPORTED_MODULE_4_modules_heart_product__["a" /* default */].initHeart;
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  var rcProps = window.rcProps || {};
  var headerProps = rcProps.header || {};
  var accountLoginHref = headerProps.accountLoginHref || '/content/header/accountLogin?signInReturnPage=';
  var headerBannerHref = headerProps.headerBannerHref || '/content/banner/header';
  var headerWebVitals = rcProps.webVitals || {};
  __WEBPACK_IMPORTED_MODULE_4_modules_heart_product__["a" /* default */].initHeart(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-favorite-button'));

  //logic for skip link content
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()("#main-content").length !== 1) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".skip-link").remove();
  }
  function trackCloseAndDisableGlobalBanner() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-close-banner").on('click', function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.post("/r/ajax/SetRevolveSessionParam.jsp", __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        "key": "rglobalbannerdismiss",
        "value": "disableglobalbanner"
      }), function () {});
      if (typeof window.logEngagement === "function") {
        window.logEngagement(window.location.href, "main_global_banner", "close");
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#globalTopBannerCarouselMarkup').removeClass('cls-tgb--active');
    });
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: headerBannerHref,
    success: function success(data) {
      if (data.banner) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#headerBannerMarkup').html(data.banner);
      }
      if (data.globalTopBannerCarousel) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#globalTopBannerCarouselMarkup').html(data.globalTopBannerCarousel);
        updateClsCookieObject("topGlobalBanner", 1);
      } else {
        updateClsCookieObject("topGlobalBanner", 0);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#globalTopBannerCarouselMarkup").removeClass('cls-tgb--active');
      }
      if (data.cookieBanner) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#cookieTopBannerMarkup').html(data.cookieBanner);
        updateClsCookieObject("cookieTopGlobalBanner", 1);
      } else {
        updateClsCookieObject("cookieTopGlobalBanner", 0);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cookieTopBannerMarkup").removeClass('cls-cpgb--active');
      }
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slideshow').each(function () {
        var $bannerSlideshow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        var language = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').attr('lang');
        var rtlBool = language === "ar";
        if ($bannerSlideshow.children('.banner--slider-list__item').length > 1) {
          $bannerSlideshow.slick({
            autoplay: true,
            autoplaySpeed: 6000,
            prevArrow: $bannerSlideshow.siblings('.banner__slick-prev'),
            nextArrow: $bannerSlideshow.siblings('.banner__slick-next'),
            rtl: rtlBool
          });
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner__slick-next, .banner__slick-prev').on('click', function () {
            $bannerSlideshow.slick('slickPause');
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner__slick-next, .banner__slick-prev').hide();
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner--slider-list').show();
        }
      });
      // The global top banner is AJAX-injected after the page-level countdown init in
      // modules.js has already run, so initialize the IRC expiry countdown here.
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#globalTopBannerCarouselMarkup').find('.js-countdown').countdown();
      trackCloseAndDisableGlobalBanner();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-close-banner').closeBanner();
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: accountLoginHref,
    success: function success(data) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#header-account-login').html(data);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-dropdown').dropdown();
    }
  });
  if (headerWebVitals.increaseCounterAndCheck === 'true' && headerWebVitals.collectEndPoint.length) {
    window.addEventListener('load', function () {
      var queue = new Set();
      function addToQueue(metric) {
        queue.add({
          metricId: metric.id,
          name: metric.name,
          value: metric.value,
          delta: metric.delta,
          address: window.location.href
        });
      }
      function flushQueue() {
        if (queue.size > 0) {
          var dataArray = [];
          queue.forEach(function (value) {
            dataArray.push(value);
          });
          var body = JSON.stringify(dataArray);
          navigator.sendBeacon && navigator.sendBeacon(headerWebVitals.collectEndPoint, new Blob([body], {
            type: 'application/json'
          })) || fetch(headerWebVitals.collectEndPoint, {
            body: body,
            method: 'POST',
            keepalive: true,
            headers: new Headers({
              'content-type': 'application/json'
            })
          });
          queue.clear();
        }
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_web_vitals__["a" /* getCLS */])(addToQueue);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_web_vitals__["b" /* getLCP */])(addToQueue);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_web_vitals__["c" /* onINP */])(addToQueue);

      // Collect metrics on common browsers
      addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          flushQueue();
        }
      });

      // Collect metrics on Safari browser
      addEventListener('pagehide', flushQueue);
    });
  }
  if (rcProps.logClientMetrics === 'true') {
    var observer = new PerformanceObserver(navigationCallback);
    observer.observe({
      entryTypes: ["navigation"]
    });
  }
  function navigationCallback(list, observer) {
    list.getEntries().forEach(function (performance) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        type: "POST",
        contentType: "application/json",
        url: rcProps.clientMetricsEndpoint,
        data: JSON.stringify({
          domLoadTime: Math.round(performance.domContentLoadedEventEnd - performance.startTime),
          pageLoadTime: Math.round(performance.loadEventEnd - performance.startTime),
          networkTime: Math.round(performance.responseStart - performance.startTime),
          responseEndTime: Math.round(performance.responseEnd - performance.startTime),
          address: performance.name
        }),
        dataType: 'json'
      });
    });
  }
  function calculateMainNavGap() {
    var flexItems = document.querySelectorAll('.nav__wrapper > .nav__item');
    if (flexItems.length < 2) return 0;
    var firstRect = flexItems[0].getBoundingClientRect();
    var secondRect = flexItems[1].getBoundingClientRect();
    var gap = secondRect.left - firstRect.right;

    // Set CSS custom property
    document.documentElement.style.setProperty('--nav-gap', gap + 'px');
    return gap;
  }
  calculateMainNavGap();
  window.addEventListener('resize', throttle(function () {
    return calculateMainNavGap();
  }, 100));
});

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var rcProps = window.rcProps || {};
var hearts = rcProps.hearts || {};
// rcProps may be absent; fall back to the limit the server enforces rather than silently passing
var maxFavoritesCount = typeof hearts.maxCount === 'number' ? hearts.maxCount : 1999;
var mensHeart = hearts.mensHeart === 'true';
window.heartBrand = heartBrand;
window.heartProductUpdated = heartProductUpdated;
window.showFavLimitPopupModal = showFavLimitPopupModal;
window.heartBrandUpdated = heartBrandUpdated;
window.clearOldFavItems = clearOldFavItems;
window.heartProduct = heartProduct;
window.submitHeart = submitHeart;
window.reloadHearts = reloadHearts;
function heartBrand(elem, bcode) {
  heartProduct(elem, bcode, "brand");
}
function heartProductUpdated(element, productCode, callback) {
  var container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);
  var activeHeartClass = window.rcProps && window.rcProps.favoriteActiveClass || 'favorite-button--active';
  var productName = container.data('product-name');
  if (container.hasClass(activeHeartClass)) {
    submitHeart('product', productCode, 'remove', undefined, undefined, undefined, undefined, function () {
      container.removeClass(activeHeartClass);
    });
  } else {
    var productSize = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#heart_total_count").data('totalFavoriteCount');
    if (rcProps.isGuest || productSize > maxFavoritesCount) {
      showFavLimitPopupModal(isGuest, productCode);
      return;
    }
    submitHeart('product', productCode, 'add', undefined, undefined, undefined, undefined, function () {
      container.addClass(activeHeartClass);
    });
  }
  if (typeof callback === 'function') {
    callback(element, productCode);
  }
}
function showFavLimitPopupModal(isGuest, productCode) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
    triggerOpen: true,
    url: rcProps.hearts.favMaxPopupHref,
    type: "small",
    onComplete: function onComplete() {
      if (isGuest) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#guestLimitPop, #fav-create-link').attr('href', "/r/SignIn.jsp?favcode=" + productCode + "&page=" + encodeURIComponent(window.location.pathname + window.location.search));
      }
    }
  });
}
function heartBrandUpdated(elem, bcode, callback) {
  if (hearts.isGuestButHeartingDisabled === 'true') {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#favorite-designer-modal').find('a').attr('href', '/r/SignIn.jsp?favbrand=' + encodeURIComponent(bcode) + '&d=' + '<%=p.department%>' + '&page=' + '<%=CommonFromJSP.getCurrentPageURLEncoded(request, true)%>');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      triggerOpen: true,
      open: "favorite-designer-modal"
    });
  } else {
    var container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem);
    var $favoriteNotify = container.next('.js-favorite-notify');
    var unfavoritedMessageNotif = container.data('unfavorite-notification');
    var favoritedMessageNotif = container.data('favorite-notification');
    var unfavoriteMessage = container.data('unfavorite-message');
    var favoriteMessage = container.data('favorite-message');
    var messageContainer = '.u-screen-reader';
    var activeHeartClass = window.rcProps && window.rcProps.favoriteActiveClass || 'favorite-button--active';
    if (container.hasClass(activeHeartClass) || container.data('is-active')) {
      submitHeart('brand', bcode, 'remove', undefined, undefined, undefined, function () {
        container.removeClass(activeHeartClass);
        $favoriteNotify.text(unfavoritedMessageNotif);
        container.find(messageContainer).text(favoriteMessage);
      }, callback);
    } else {
      if (!container.data('use-active-attr')) {
        container.addClass(activeHeartClass);
      }
      submitHeart('brand', bcode, 'add', undefined, undefined, undefined, function () {
        $favoriteNotify.text(favoritedMessageNotif);
        container.find(messageContainer).text(unfavoriteMessage);
      }, callback);
    }
  }
}
function clearOldFavItems() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'GET',
    url: '/r/ajaxHeartProduct.jsp?action_T=clearolditems',
    success: function success(data) {
      location.reload();
    }
  });
}
function heartProduct(elem, pcode, size, view) {
  var bn = elem;
  var brand = false;
  var plpHeartClass = "plp_main_img_heart";
  var plpHeartActiveClass = "active";
  if (mensHeart) {
    plpHeartClass = "plp_main_img_heartm";
  }
  if (typeof arguments[2] !== "undefined" && arguments[2] === "brand") {
    brand = true;
  }
  if (typeof elem.id === "undefined" || elem.id !== "heart_active_" + pcode && __WEBPACK_IMPORTED_MODULE_0_jquery___default()('div.active', elem).length == 0) {
    if (brand) submitHeart("brand", pcode, "add");else submitHeart("product", pcode, "add");
    for (var j = 0; j < bn.childNodes.length; j++) {
      var bn2 = bn.childNodes[j];
      switch (bn2.nodeType) {
        case 3:
          //text Node
          break;
        case 1:
          //Element node (anchor, div)
          if (bn2.nodeName.toLowerCase() === "div" || bn2.className.toLowerCase() === plpHeartClass) {
            bn2.className += " " + plpHeartActiveClass;
          }
          break;
        default:
        //break;
      }
    }
    elem.id = "heart_active_" + pcode;
    if (typeof arguments[3] === "undefined") {
      if (document.getElementById("plp_quickview_wrap_" + pcode) != null) {
        var pd = document.getElementById("plp_quickview_wrap_" + pcode);
        heartingUnhearting(pd, pcode, "add", plpHeartActiveClass);
      }
    } else {
      if (arguments[3] === "qv") {
        if (document.getElementById("plp_prod_wrap_" + pcode) != null) {
          var _pd = document.getElementById("plp_prod_wrap_" + pcode);
          heartingUnhearting(_pd, pcode, "add", plpHeartActiveClass);
        }
      }
    }
  } else {
    if (brand) {
      submitHeart("brand", pcode, "remove");
    } else {
      if (typeof arguments[2] !== "undefined" && arguments[2] !== "") {
        submitHeart("product", pcode, "remove", size);
      } else {
        submitHeart("product", pcode, "remove");
      }
    }
    for (var _j = 0; _j < bn.childNodes.length; _j++) {
      var _bn = bn.childNodes[_j];
      switch (_bn.nodeType) {
        case 3:
          //text Node
          break;
        case 1:
          //Element node (anchor, div)
          if (_bn.nodeName.toLowerCase() === "div" || _bn.className.toLowerCase() === plpHeartClass) {
            if (_bn.className.toLowerCase().indexOf(plpHeartActiveClass) !== -1) _bn.className = plpHeartClass;
          }
          break;
        default:
        //break;
      }
    }
    elem.id = "";
    if (typeof arguments[3] === "undefined") {
      if (document.getElementById("plp_quickview_wrap_" + pcode) != null) {
        var _pd2 = document.getElementById("plp_quickview_wrap_" + pcode);
        heartingUnhearting(_pd2, pcode, "remove", plpHeartClass);
      }
    } else {
      if (arguments[3] === "qv") {
        if (document.getElementById("plp_prod_wrap_" + pcode) != null) {
          var _pd3 = document.getElementById("plp_prod_wrap_" + pcode);
          heartingUnhearting(_pd3, pcode, "remove", plpHeartClass);
        }
      }
    }
  }
}
function submitHeart(paramtype, paramvalue) {
  if (typeof paramtype === "undefined" || typeof paramvalue === "undefined" || typeof arguments[2] === "undefined") {
    return;
  }
  var psize = "";
  // optional argument
  if (typeof arguments[3] !== "undefined") {
    psize = arguments[3];
  }
  var sectionUrl = "";
  if (typeof arguments[4] !== "undefined") {
    sectionUrl = arguments[4];
  }
  var callback = null;
  if (typeof arguments[6] !== 'undefined') {
    callback = arguments[6];
  }
  var onSuccess = arguments[7];
  var dataToSend = "";
  var department = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#header-jsp').data('department');
  if (paramtype === "product") {
    dataToSend += "&pcode=" + encodeURIComponent(paramvalue);
  } else if (paramtype === "brand") {
    dataToSend += "&bcode=" + encodeURIComponent(paramvalue);
  }
  dataToSend += "&action_T=" + encodeURIComponent(arguments[2]);
  if (mensHeart) {
    dataToSend += "&mensBrand=" + encodeURIComponent("true");
  } else {
    dataToSend += "&mensBrand=" + encodeURIComponent("false");
  }
  if (psize !== "") {
    dataToSend += "&psize=" + encodeURIComponent(psize);
  }
  if (sectionUrl !== "") {
    dataToSend += "&sectionURL=" + encodeURIComponent(sectionUrl);
  }
  if (department) {
    dataToSend += "&d=" + encodeURIComponent(department);
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    url: '/r/ajaxHeartProduct.jsp',
    data: dataToSend,
    success: function success(response) {
      if (paramtype === "product") {
        if (response.success) {
          updateHeartCount(response.count);
        }
        if (response.action === 'add') {
          if (typeof insertCordialUpdateHeartItem === 'function') {
            insertCordialUpdateHeartItem('add', paramvalue);
          }
          if (typeof iPinYouHeartItem === 'function') {
            iPinYouHeartItem(paramvalue);
          }
          if (typeof insertRTBHouseHeartItem === 'function') {
            insertRTBHouseHeartItem(paramvalue);
          }
        } else if (response.action === 'remove') {
          if (typeof insertCordialUpdateHeartItem === 'function') {
            insertCordialUpdateHeartItem('remove', paramvalue);
          }
        }
        if (typeof taboolaWishListAction === 'function') {
          taboolaWishListAction(response.action, paramvalue);
        }
        if (typeof cfyWishListAction === 'function') {
          cfyWishListAction(response.action, response.code, response.price);
        }
        if (typeof brazeAddToFavorites === 'function' && response.success === true) {
          brazeAddToFavorites(response.action, response.code, response.name, response.size, response.imageUrl, response.productUrl, response.price, response.currency, response.department, response.color, response.brandName, response.category, response.cat1);
        }
      } else if (paramtype === "brand") {
        if (typeof brazeBrandFavorites === 'function') {
          brazeBrandFavorites(response.action, response.brandName, response.brandId);
        }
      }
      if (typeof callback === 'function') {
        callback();
      }
      if (response.success) {
        if (typeof onSuccess === 'function') {
          onSuccess();
        }
      }
    }
  });
}
function reloadHearts() {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    type: 'POST',
    url: '/r/ajax/ReloadHeartItems.jsp',
    dataType: 'json',
    success: function success(response) {
      for (var i = 0; i < response.length; i++) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".plp_prod_a_" + response[i]).attr("id", "heart_active_" + response[i]);
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#plp_prod_wrap_" + response[i] + " .plp_main_img_heart").attr("class", "plp_main_img_heart active");
      }
    }
  });
}

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */
/***/ (function(module, exports) {

var engagementTrackingAction = 'product rec engagement';
$(document).ready(function () {
  $(window).on('carouselChange', function (e) {
    handleCarouselEngagement(e);
  });
  $(window).on('beforeunload', function () {
    endEngagement();
  });
  $(document).on('click', 'li.slick-slide', function () {
    var activeCarousel = $(this).closest("div.carousel");
    if (activeCarousel.hasClass("eng-tracking-on")) {
      activeCarousel.removeClass("eng-tracking-on");
      var data = {
        leftclick: activeCarousel.data("eng-left-click"),
        rightclick: activeCarousel.data("eng-right-click"),
        slideclick: $(this).data('slick-index') + 1
      };
      logEngagementWithDetails(window.location.href, activeCarousel.data("type"), engagementTrackingAction, JSON.stringify(data));
      activeCarousel.unbind('mouseleave');
    } else {
      if ($('div.eng-tracking-on').length) {
        // slide clicked of the carousal which was not currently being tracked, so end tracking of the tracked carousal first.
        endEngagement();
      }
      var type = $($(this).closest('div[data-type]')).attr('data-type');
      var _data = {
        leftclick: 0,
        rightclick: 0,
        slideclick: $(this).data('slick-index') + 1
      };
      logEngagementWithDetails(window.location.href, type, engagementTrackingAction, JSON.stringify(_data));
    }
    clearTimeout(window.carouselEngagementTracker);
    window.carouselEngagementTracker = null;
  });
});
function endEngagement() {
  clearTimeout(window.carouselEngagementTracker);
  var activeCarousel = $('div.eng-tracking-on');
  if (typeof activeCarousel !== "undefined" && activeCarousel.length) {
    activeCarousel.removeClass('eng-tracking-on');
    var data = {
      leftclick: activeCarousel.data('eng-left-click'),
      rightclick: activeCarousel.data('eng-right-click')
    };
    activeCarousel.unbind('mouseleave');
    if (typeof activeCarousel.data("pageUrl") !== "undefined" && activeCarousel.data("pageUrl") !== "" && typeof activeCarousel.data("type") !== "undefined" && activeCarousel.data("type") !== "") {
      logEngagementWithDetails(activeCarousel.data("pageUrl"), activeCarousel.data("type"), engagementTrackingAction, JSON.stringify(data));
    }
  }
}
function handleCarouselEngagement(e) {
  var startEngagement = function startEngagement() {
    var activeCarousel = $(e.originalEvent.tracking.element).closest("div.carousel");
    activeCarousel.addClass("eng-tracking-on");
    activeCarousel.data("pageUrl", e.originalEvent.tracking.pageUrl);
    activeCarousel.data("type", e.originalEvent.tracking.type);
    activeCarousel.data("eng-left-click", 0);
    activeCarousel.data("eng-right-click", 1);
    activeCarousel.data("currentSlide", e.originalEvent.tracking.currentSlide);
    activeCarousel.mouseleave(function () {
      clearTimeout(window.carouselEngagementTracker);
      window.carouselEngagementTracker = null;
      window.carouselEngagementTracker = setTimeout(function () {
        endEngagement();
      }, 3000);
    });
  };
  var resetEngagement = function resetEngagement() {
    endEngagement();
    startEngagement();
  };
  var continueEngagement = function continueEngagement() {
    var activeCarousel = $('div.eng-tracking-on');
    clearTimeout(window.carouselEngagementTracker);
    window.carouselEngagementTracker = null;
    if (activeCarousel.data("currentSlide") < e.originalEvent.tracking.currentSlide) {
      activeCarousel.data('eng-right-click', activeCarousel.data('eng-right-click') + 1);
    } else {
      activeCarousel.data('eng-left-click', activeCarousel.data('eng-left-click') + 1);
    }
    activeCarousel.data("currentSlide", e.originalEvent.tracking.currentSlide);
  };
  if ($('div.eng-tracking-on').length) {
    var activeCarousel = $(e.originalEvent.tracking.element).closest('div.carousel');
    if (activeCarousel.hasClass('eng-tracking-on')) {
      continueEngagement();
    } else {
      resetEngagement();
    }
  } else {
    startEngagement();
  }
}

/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_lib__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_base__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_elements__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_modules__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_scss__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__main_scss__);





$(document).ready(function () {
  $('.js-carousel--rtl').slickSlider({
    slidesToShow: 5,
    slidesToScroll: 5,
    rtl: true
  });
});

/***/ }),
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SUPPORTS_TOUCH_CLASS */
/* unused harmony export NO_SUPPORT_TOUCH_CLASS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var SUPPORTS_TOUCH_CLASS = 'touch touchevents';
var NO_SUPPORT_TOUCH_CLASS = 'no-touch no-touchevents';
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$win = options.win,
    win = _options$win === void 0 ? window : _options$win,
    _options$doc = options.doc,
    doc = _options$doc === void 0 ? document : _options$doc;
  var $html = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(doc.documentElement);
  var supportsTouch = 'ontouchstart' in win || win.DocumentTouch && doc instanceof DocumentTouch;
  if (supportsTouch) {
    return $html.addClass(SUPPORTS_TOUCH_CLASS);
  }
  return $html.addClass(NO_SUPPORT_TOUCH_CLASS);
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styleguide_styleguide__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__feature_detects__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globals__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__footer__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__heart__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_product_rec_tracking__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_modules_product_rec_tracking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_modules_product_rec_tracking__);








/***/ }),
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateClsCookieObject; });
var cookies = {
  getItem: function getItem(name) {
    if (!name) {
      return null;
    }
    var returnVal = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(name).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    return returnVal;
  },
  setItem: function setItem(name, value, end, path, domain, secure) {
    if (!name || /^(?:expires|max\-age|path|domain|secure)$/i.test(name)) {
      return false;
    }
    var expires = '';
    if (end) {
      switch (end.constructor) {
        case Number:
          expires = end === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + end;
          break;
        case String:
          expires = "; expires=" + end;
          break;
        case Date:
          expires = "; expires=" + end.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + (domain ? "; domain=" + domain : "") + (path ? "; path=" + path : "") + (secure ? "; secure" : "");
    return true;
  },
  removeItem: function removeItem(sKey, sPath, sDomain) {
    if (!cookies.hasItem(sKey)) {
      return false;
    }
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function hasItem(key) {
    if (!key) {
      return false;
    }
    return new RegExp("(?:^|;\\s*)" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
  },
  keys: function keys() {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
    }
    return aKeys;
  }
};
var setCookie = function setCookie(name, value, expirationInDays) {
  expirationInDays = expirationInDays * 86400;
  cookies.setItem(name, value, expirationInDays, "/");
};
var getCookie = function getCookie(name) {
  return cookies.getItem(name);
};
var removeCookie = cookies.removeItem;
var updateClsCookieObject = function updateClsCookieObject(key, prop) {
  try {
    var banner = JSON.parse(getCookie('cls') || "{}");
    banner[key] = prop;
    setCookie('cls', JSON.stringify(banner), 2);
  } catch (error) {
    console.log(error);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (cookies);

/***/ }),
/* 256 */
/***/ (function(module, exports) {

$(function () {
  $('.js-tabs-ab').tabs({
    tabActive: 'discover__link--active action-button--active'
  });
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__load_image__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__set_css_props__ = __webpack_require__(259);



__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').attr('ontouchstart', '');
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__set_css_props__["a" /* setCSSPropScrollbarWidth */])();
});
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('load', function () {
  //$('img').loadImage();
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULT_OPTIONS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Loads image by replacing the src with data attr
 * @module load-image
 */



var PLUGIN_NAME = 'loadImage';
var DEFAULT_OPTIONS = {
  attr: 'data-src'
};

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, loadImage);

/**
 * Initial function to load image
 * @param {HTMLElement} image - Image to update
 */
function loadImage(image) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _Object$assign = Object.assign({}, DEFAULT_OPTIONS, options),
    attr = _Object$assign.attr;
  var src = image.getAttribute(attr);
  if (src) image.setAttribute('src', src);
  return image;
}
;

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setCSSPropScrollbarWidth;
/**
* Sets CSS custom properties
* @module set-css-props
*/

/**
 * Sets CSS custom property `--scrollbarWidth` value if a scrollbar is visible
 * 
 */
function setCSSPropScrollbarWidth() {
  if (window.innerWidth !== document.body.clientWidth) {
    var scrollbarWidth = window.innerWidth - document.body.clientWidth;
    document.documentElement.style.setProperty("--scrollbarWidth", "".concat(scrollbarWidth, "px"));
  }
}

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toggle_favorite__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fields_validator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fields_invalidate__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fields_error_summary__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fields_form_field__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fields_validate_field__ = __webpack_require__(275);







__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  //$('.js-favorite-button').toggleFavorite();

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.querySelectorAll('[data-validate]')).validator().errorSummary();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.body).formField();
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CHARACTER_COUNTER_OPTIONS */
/* unused harmony export BLOCK */
/* unused harmony export COUNT_ELEMENT */
/* unused harmony export COUNT_BLOCK_ELEMENT */
/* unused harmony export COUNT_BLOCK_ERROR */
/* unused harmony export COUNT_BLOCK_ELEMENT_ERROR */
/* unused harmony export WRAPPER_SELECTOR */
/* unused harmony export COUNT_SELECTOR */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_random__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_stache__ = __webpack_require__(40);
/**
 * Responsible for displaying available characters in a textarea and limiting
 * the amount that can be submitted.
 * @module elements/fields/characterCounter
 */




/**
 * Defines the default options for the a character counter
 * @type {Object}
 */
var CHARACTER_COUNTER_OPTIONS = {
  fieldSelector: 'textarea',
  insertPosition: 'afterbegin',
  a11yCounterTemplate: '{{remaining}} {{remaining|pluralize:"character,characters"}} remaining'
};

/**
 * Defines the block name for the element injected into the DOM.
 * @type {string}
 */
var BLOCK = 'character-counter';

/**
 * Defines the count element injected into the DOM.
 * @type {string}
 */
var COUNT_ELEMENT = 'count';

/**
 * Defines the name of the block and count element.
 * @type {string}
 */
var COUNT_BLOCK_ELEMENT = "".concat(BLOCK, "__").concat(COUNT_ELEMENT);

/**
 * Defines an error block.
 * @type {string}
 */
var COUNT_BLOCK_ERROR = "".concat(BLOCK, "--invalid");

/**
 * Defines an error block element combo.
 * @type {string}
 */
var COUNT_BLOCK_ELEMENT_ERROR = "".concat(COUNT_BLOCK_ELEMENT, "--invalid");

/**
 * Defines the block selector
 * @type {string}
 */
var WRAPPER_SELECTOR = ".".concat(BLOCK);

/**
 * Defines the count block element selector
 * @type {string}
 */
var COUNT_SELECTOR = ".".concat(COUNT_BLOCK_ELEMENT);

/**
 * Updates an element with the text count in the textarea.
 * @param {HTMLElement} countEl - Element being updated
 * @returns {Function} When the event is fired off
 */
var makeUpdateCount = function makeUpdateCount(countEl, a11yCountEl, getA11yCounter) {
  return function (e) {
    var length = e.target.value.length;
    // eslint-disable-next-line no-param-reassign
    countEl.innerText = length;
    // eslint-disable-next-line no-param-reassign
    a11yCountEl.innerText = getA11yCounter(length);
  };
};

/**
 * Responsible for making a set of elements valid.
 * @param {HTMLElement} wrapper - Container of character count
 * @param {HTMLElement} count - Element containing the count
 * @returns {Function} When the event is fired off
 */
var makeValid = function makeValid(wrapper, count) {
  return function () {
    wrapper.classList.remove(COUNT_BLOCK_ERROR);
    count.classList.remove(COUNT_BLOCK_ELEMENT_ERROR);
  };
};

/**
 * Responsible for making a set of elements invalid.
 * @param {HTMLElement} wrapper - Container of character count
 * @param {HTMLElement} count - Element containing the count
 */
var makeInvalid = function makeInvalid(wrapper, count) {
  return function () {
    wrapper.classList.add(COUNT_BLOCK_ERROR);
    count.classList.add(COUNT_BLOCK_ELEMENT_ERROR);
  };
};

/**
 * Creates the character counter markup used to keep track of character
 * counting.
 * @private
 * @param  {string} count - The amount of characters in the field
 * @param  {string} maxLength - The maximum length for the field
 * @param  {string} [className=''] - Additional className
 * @return {string} Fully formed HTML
 */
var createCharacterCounterComponent = function createCharacterCounterComponent(_ref) {
  var count = _ref.count,
    maxLength = _ref.maxLength,
    id = _ref.id,
    a11yText = _ref.a11yText,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return "\n  <span class=\"".concat(BLOCK, " ").concat(className, "\">\n    <span id=\"").concat(id, "\" aria-live=\"polite\" class=\"u-screen-reader\">").concat(a11yText, "</span>\n    <span class=\"").concat(COUNT_BLOCK_ELEMENT, "\">").concat(count, "</span>\n    / ").concat(maxLength, "\n  </span>\n");
};

/**
 * Responsible for setup and eventually rendering a11y counter text.
 * @param {string} template - Template string
 * @param {number} length - The max characters allowed in the textarea
 * @return {Function} When called renders template
 */
var makeGetA11yCounter = function makeGetA11yCounter(template, length) {
  return function (count) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_stache__["a" /* default */])(template, {
      remaining: length - count
    });
  };
};

/**
 * Responsible for either getting a field id if one does not already exist.
 * @param {HTMLElement} field - The field in question
 * @returns {string} A field id
 */
var resolveFieldId = function resolveFieldId(field) {
  var ariaAttr = 'aria-describedby';
  var describedBy = field.getAttribute(ariaAttr);
  if (describedBy) {
    return describedBy;
  }
  var id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_random__["a" /* default */])({
    prefix: 'character-counter'
  });
  field.setAttribute(ariaAttr, id);
  return id;
};

/**
 * Responsible for providing feedback to the user with the amount of characters
 * entered alongside the amount allowed. This is achieved by the following:
 *
 * - Read in the maxlength attribute (if not provided, throws an error since
 *   without it we don't know what to do)
 * - create some HTML that illustrates how many characters are in a given area,
 *   along with the maximum amount of characters
 *
 * From the DOM side, this can take in optional parameters in the form of
 * data attributes:
 *
 * - data-character-counter-add-class-name: allows for a custom class name to
 *   be added to the feedback mechanism created within.
 * - data-character-insert-position: the insert position based the element
 *   passed in using the position values found on insertAdjacentHTML. If this
 *   doesn't exist, it'll use the one provided on wiring, and then fallback to
 *   afterbegin.
 *
 * This happens when the field (an input or textarea) first loads as well as
 * when the user starts entering in characters. Here's an example of markup
 * using all options:
 *
 * @example
 * <div class="things"
 *      data-character-counter-add-class-name="yo-dawg"
 *      data-character-counter-insert-position="beforebegin">
 *   <textarea maxlength="100"></textarea>
 * </div>
 *
 * which will yield:
 *
 * @example
 * <div class="things"
 *      data-character-counter-add-class-name="yo-dawg"
 *      data-character-counter-insert-position="beforebegin">
 *   <span class="character-counter yo-dawg">
 *     <span class="character-counter__count">0</span> / 200
 *   </span>
 *   <textarea maxlength="100"></textarea>
 * </div>
 *
 * @param {HTMLElement} el - Contains the form field
 * @param {Object} options - Configurable options
 */
function characterCounter(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_0__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref2.deregister;
  // The jQuery lookup is for PhantomJS because it's lame and doesn't know how
  // to read from el.dataset because it sucks at life. There, I said it.
  var _Object$assign = Object.assign({}, CHARACTER_COUNTER_OPTIONS, options, el.dataset),
    fieldSelector = _Object$assign.fieldSelector,
    insertPosition = _Object$assign.insertPosition,
    _Object$assign$charac = _Object$assign.characterCounterAddClassName,
    className = _Object$assign$charac === void 0 ? '' : _Object$assign$charac,
    dataAttrInsertPosition = _Object$assign.characterCounterInsertPosition,
    a11yCounterTemplate = _Object$assign.a11yCounterTemplate;
  var field = el.querySelector(fieldSelector);
  var maxLength = field.maxLength;
  var getA11yCounter = makeGetA11yCounter(a11yCounterTemplate, +maxLength);
  if (maxLength < 0) {
    throw new Error("Character counter requires a max length on ".concat(fieldSelector));
  }
  var fieldId = resolveFieldId(field);
  el.insertAdjacentHTML(dataAttrInsertPosition || insertPosition, createCharacterCounterComponent({
    className: className,
    count: field.value.length,
    maxLength: maxLength,
    a11yText: getA11yCounter(field.value.length),
    id: fieldId
  }));
  var wrapperEl = el.querySelector(WRAPPER_SELECTOR);
  var countEl = el.querySelector(COUNT_SELECTOR);
  var a11yCountEl = el.querySelector("#".concat(fieldId));
  var listeners = [{
    evt: 'input',
    handler: makeUpdateCount(countEl, a11yCountEl, getA11yCounter)
  }, {
    evt: 'focus',
    handler: makeValid(wrapperEl, countEl)
  }, {
    evt: 'invalid',
    handler: makeInvalid(wrapperEl, countEl)
  }];
  listeners.forEach(function (_ref3) {
    var evt = _ref3.evt,
      handler = _ref3.handler;
    field.addEventListener(evt, handler);
  });
  return {
    refreshCounter: function refreshCounter() {
      var event = new Event("input");
      field.dispatchEvent(event);
    },
    removeListeners: function removeListeners() {
      deregister();
      listeners.forEach(function (_ref4) {
        var evt = _ref4.evt,
          handler = _ref4.handler;
        field.removeEventListener(evt, handler);
      });
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_register_jquery_plugin__["a" /* default */])('characterCounter', characterCounter);

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_TEMPLATES */
/* unused harmony export EVENTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_stache__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Generically handles various error states around a field
 * @module elements/fields/entry-error
 */






/**
 * Templates used as an absolute fallback
 * @typedef {Object} EntryErrorDefaultTemplates
 * @property {string} requiredTemplate - Template for required error message
 * @property {string} invalidTemplate - Template for invalid error message
 */
var DEFAULT_TEMPLATES = {
  requiredTemplate: 'valid entry required',
  invalidTemplate: 'enter a valid entry'
};
/**
 * Configurable options entry error
 * @typedef {Object} EntryErrorOptions
 * @property {string} label - Label or name of the field
 * @property {string} requiredAttr - Attribute used for indicating field
 * is required
 * @property {string} entryErrorRequiredMessage - Overrides the default
 * required error message
 * @property {string} entryErrorInvalidMessage - Overrides the default
 * required invalid message
 * @property {string} requiredTemplate - Template used for the required error
 * message
 * @property {string} invalidTemplate - Template used for the invalid error
 * message
 * @property {string} selectRequiredTemplate - Template used for the required
 * error message for a select element
 */
/**
 * @type EntryErrorOptions
 */
var DEFAULT_ERROR_LABEL_OPTIONS = {
  label: null,
  requiredAttr: 'data-validate-not-empty',
  entryErrorRequiredMessage: '',
  entryErrorInvalidMessage: '',
  requiredTemplate: '{{label}} entry required',
  invalidTemplate: 'enter a valid {{label}}',
  selectRequiredTemplate: '{{label}} selection required'
};
var EVENT_NS = '.entry-label';
var ELEMENT_ERROR_TEMPLATES = {
  select: 'selectRequiredTemplate'
};
/**
 * Responsible for taking event names and appending a namespace
 * @param {Object} events - Key/value mapping of events
 * @returns {Object} Applicable events containing a namespace
 */
var appendNamespaceToEvents = function appendNamespaceToEvents(events) {
  return Object.keys(events).reduce(function (acc, name) {
    return Object.assign({}, acc, _defineProperty({}, name, events[name] + EVENT_NS));
  }, {});
};
var EVENTS = {
  INVALID: 'invalid',
  BLUR: 'blur',
  CHANGE: 'change',
  INPUT: 'input'
};
var _appendNamespaceToEve = appendNamespaceToEvents(EVENTS),
  INVALID = _appendNamespaceToEve.INVALID,
  BLUR = _appendNamespaceToEve.BLUR,
  CHANGE = _appendNamespaceToEve.CHANGE,
  INPUT = _appendNamespaceToEve.INPUT;

/**
 * Performs any sort of clean up
 * @param {jQuery} $el - Form field
 * @param {Function} deregister - Internally removes the plugin from the
 * registery
 */
var destroy = function destroy($el, deregister) {
  return function () {
    $el.off(EVENT_NS);
    deregister();
  };
};

/**
 * Responsible for resetting an error on a field
 * @param {HTMLElement} el - Form field
 */
var resetField = function resetField(el) {
  el.setCustomValidity('');
  el.setAttribute('aria-invalid', false);
};

/**
 * Responsible for resetting an error on a field based on an event
 * @param {jQuery.Event} e - A dom event
 */
var resetFieldFromEvent = function resetFieldFromEvent(e) {
  resetField(e.target);
};

/**
 * Responsible creating the ability to set an error message
 * @param {jQuery} $el - Form field
 * @param {string} requiredMessage - Error message when a field is required
 * @param {string} invalidMessage - Error message when a field is invalid
 * @returns {Function} Called on to set a possible error message
 */
var makeSetMessage = function makeSetMessage($el, requiredMessage, invalidMessage) {
  return function () {
    var el = $el[0];
    if (!$el.val()) {
      $el.attr('aria-invalid', true);
      el.setCustomValidity(requiredMessage);
      return;
    }
    if ($el.data('entryErrorDisableInvalid')) {
      $el.attr('aria-invalid', false);
      return;
    }
    if ($el.is(':invalid')) {
      $el.attr('aria-invalid', true);
      el.setCustomValidity(invalidMessage);
      return;
    }
    resetField(el);
  };
};

/**
 * Responsible for applying an error if applicable
 * @param {jQuery} $el - Form field
 * @param {Function} setMessage - If applicable sets an error message
 */
var makeApplyError = function makeApplyError($el, setMessage) {
  return function () {
    var el = $el[0];
    var _get = __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(el, 'form.dataset'),
      validateOnlyOnSubmit = _get.validateOnlyOnSubmit;
    if (validateOnlyOnSubmit) {
      return;
    }
    setMessage();
    el.checkValidity();
  };
};
/**
 * Responsible obtaining an error message
 * @param {string} custom - A custom error message
 * @param {string} template - Template used for the error message
 * @param {Object} data - Data used for the error message template
 */
var getMessage = function getMessage(custom, template, data) {
  return custom || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_stache__["a" /* default */])(template, data);
};
/**
 * Determines which template or message should be used from most specific to
 * most general based on a number of configured values.
 * @param {string|undefined} label - Name associated to field
 * @param {string|undefined} errorMessage - Message passed in on a field level
 * @param {string} errorType - Type of error
 * @returns {string} Template or message
 */
var getTemplate = function getTemplate(label, errorMessage, errorType) {
  var template = DEFAULT_ERROR_LABEL_OPTIONS[errorType];
  var defaultMessage = DEFAULT_TEMPLATES[errorType];
  // This means the error message was provided on a field level, so that wins
  // over any other option.
  if (errorMessage) {
    return errorMessage;
  }
  // By default, a label is required since the default template is dependent
  // on the dynamic value of the label. There is a chance that the template
  // could still be undefined since the template can be undefined. In those
  // cases, just use the default template. This should at least indicate
  // something is broken without seeing template variables.
  if (label) {
    return template;
  }
  // If no label is provided, we cannot use the template, so fallback to the
  // default message as the lowest common denominator.
  return defaultMessage;
};
/**
 * Responsible for determining whether an element level required template is
 * needed. This comes as a request where based on an element, a different
 * required message can be used, which adds more complexity but does meet the
 * request.
 * @param {string} nodeName - Element name
 * @param {string} defaultRequiredTemplate - Default template when a field level
 * template cannot be found.
 * @param {EntryErrorOptions} options - Configurable options
 * @returns {string} Template to use when a field specific template is needed
 */
var getElementLevelTemplate = function getElementLevelTemplate(nodeName, defaultRequiredTemplate, options) {
  var elementLevelTemplate = ELEMENT_ERROR_TEMPLATES[nodeName];
  if (elementLevelTemplate) {
    return options[elementLevelTemplate] || defaultRequiredTemplate;
  }
  return defaultRequiredTemplate;
};
/**
 * Responsible for handling errors in a standardized way. In particular, it'll
 * create consistent error handling based on the type of errors.
 * @param {HTMLElement} el - Element with error in question
 * @param {EntryErrorOptions} options - Configurable options
 * @param {Object} actions - Actions to be called on
 * @return {Object} Methods attached to an entry error
 */
function entryError(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = Object.assign({}, DEFAULT_ERROR_LABEL_OPTIONS, options, el.dataset);
  var label = opts.label,
    requiredAttr = opts.requiredAttr,
    requiredTemplateOption = opts.requiredTemplate,
    invalidTemplateOption = opts.invalidTemplate,
    customRequiredMessage = opts.entryErrorRequiredMessage,
    customInvalidMessage = opts.entryErrorInvalidMessage;
  var nodeName = $el.prop('nodeName').toLowerCase();
  var requiredFieldTemplate = getElementLevelTemplate(nodeName, requiredTemplateOption, opts);
  var requiredTemplate = getTemplate(label, requiredFieldTemplate, 'requiredTemplate');
  var invalidTemplate = getTemplate(label, invalidTemplateOption, 'invalidTemplate');
  var requiredMessage = getMessage(customRequiredMessage, requiredTemplate, {
    label: label
  });
  var invalidMessage = getMessage(customInvalidMessage, invalidTemplate, {
    label: label
  });
  var setMessage = makeSetMessage($el, requiredMessage, invalidMessage);
  var applyError = makeApplyError($el, setMessage);
  $el.attr(requiredAttr, true).attr('aria-required', true).on(BLUR, applyError).on(INVALID, setMessage).on(INPUT, resetFieldFromEvent);
  if (nodeName === 'select') {
    $el.on(CHANGE, applyError);
  }
  return {
    destroy: destroy($el, deregister)
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__["a" /* default */])('entryError', entryError);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLASS_NAMES */
/* unused harmony export EVENTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__ = __webpack_require__(1);
/* unused harmony reexport VALIDATOR_EVENTS */
/**
 * Renders an error summary of all form errors in a centralized location.
 * @module elements/fields/error-summary
 */






var VALIDATOR_SUCCESS = __WEBPACK_IMPORTED_MODULE_3__validator__["a" /* EVENTS */].VALIDATOR_SUCCESS,
  VALIDATOR_ERROR = __WEBPACK_IMPORTED_MODULE_3__validator__["a" /* EVENTS */].VALIDATOR_ERROR,
  VALIDATOR_POST_ERROR = __WEBPACK_IMPORTED_MODULE_3__validator__["a" /* EVENTS */].VALIDATOR_POST_ERROR;

var ERROR_SUMMARY_OPTIONS = {
  errorSummaryTitle: '',
  // TODO: See if there is a preferred value here for something more generic
  fieldGroupSelectors: ['.field-group'],
  messageDataAttrs: ['floatingErrorMessage', 'errorMessage'],
  errorPrefix: 'Error:',
  formFieldSelectors: 'input,textarea,select',
  errorContainerClassName: 'error-summary-container',
  createErrorId: function createErrorId(id) {
    return "".concat(Math.random().toString(36).slice(2), "-").concat(id);
  },
  scrollToFn: function scrollToFn() {
    return window.scrollTo(0, 0);
  }
};
var CLASS_NAMES = {
  TITLE: 'error-summary__title',
  SUMMARY_LINK: 'error-summary__link'
};
var EVENTS = {
  CLEAR: 'error-summary:clear'
};
var CLEAR = EVENTS.CLEAR;
var EVENT_NS = '.error-summary';

/**
 * Responsible for creating an error summary template/HTML.
 * @param {Object} data - Data used for creating the template
 * @returns {string} Represents rendered HTML
 */
var errorSummaryTemplate = function errorSummaryTemplate(_ref) {
  var errorPrefix = _ref.errorPrefix,
    title = _ref.title,
    invalidFields = _ref.invalidFields;
  return "\n  <div class=\"error-summary\">\n    <div class=\"error-summary__content\">\n      <h3 class=\"".concat(CLASS_NAMES.TITLE, "\" tabIndex=\"-1\">").concat(title, "</h3>\n      <ul class=\"error-summary__list\">\n        ").concat(invalidFields.map(function (_ref2) {
    var errorMessage = _ref2.errorMessage,
      label = _ref2.label,
      errorItemId = _ref2.errorItemId;
    return "\n          <li class=\"error-summary__item\">\n            <span class=\"u-screen-reader\">".concat(errorPrefix, " </span>\n            <span class=\"icon icon--xs icon--exclamation-point\">\n              <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\">\n                <path d=\"M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 15.2A7.17 7.17 0 0 1 .8 8 7.17 7.17 0 0 1 8 .8 7.17 7.17 0 0 1 15.2 8 7.17 7.17 0 0 1 8 15.2zm0-5.6c.4 0 .6-.3.6-.7l.3-4.3c0-.4-.4-.7-.8-.7s-1 .2-1 .7l.3 4.3c0 .4.2.7.6.7z\"/><circle cx=\"8\" cy=\"11.3\" r=\".9\"/>\n              </svg>\n            </span>\n            <a href=\"#").concat(errorItemId, "\" class=\"").concat(CLASS_NAMES.SUMMARY_LINK, "\">\n              ").concat(label ? "".concat(label, ": ") : '').concat(errorMessage, "\n            </a>\n          </li>\n        ");
  }).join(''), "\n      </ul>\n    </div>\n  </div>\n");
};

/**
 * Responsible for adding an error container to the DOM.
 * @param {jQuery} $el - The container element
 * @param {string} className - Name of class for the prepended element
 * @returns {jQuery} The error container element
 */
var createErrorContainer = function createErrorContainer($el, className) {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("<div class=\"".concat(className, "\"/>")).prependTo($el);
};

/**
 * Responsible for clearing out the error container.
 * @param {jQuery} $errorContainer - Element containing the error summary
 * @returns {Function} Clears out the error container when called on
 */
var removeErrorSummary = function removeErrorSummary($errorContainer) {
  return function () {
    $errorContainer.empty();
  };
};

/**
 * Responsible for rendering the error summary and all the details around the
 * errors.
 * @param {string} title - Title for the error summary
 * @param {jQuery} $errorContainer - Contains the error summary
 * @param {Map} fieldErrorMap - Map of field errors
 * @param {Function} scrollToFn - Handles where to scroll to when the error
 * summary has been shown
 * @return {Function} Called on by an event
 */
var makeShowErrorSummary = function makeShowErrorSummary(errorPrefix, title, $errorContainer, fieldErrorMap, scrollToFn) {
  return function (evt) {
    removeErrorSummary($errorContainer)();
    var invalidElements = evt.originalEvent.detail.invalidElements;
    var invalidFields = invalidElements.reduce(function (acc, invalidElement) {
      var fieldError = fieldErrorMap.get(invalidElement);
      var errorMessage = invalidElement.validationMessage;
      var label = invalidElement.dataset.label;
      if (fieldError) {
        return acc.concat(Object.assign({}, fieldError, {
          errorMessage: errorMessage,
          label: label
        }));
      }
      return acc;
    }, []);
    var markup = errorSummaryTemplate({
      errorPrefix: errorPrefix,
      title: title,
      invalidFields: invalidFields
    });
    $errorContainer.html(markup).find(".".concat(CLASS_NAMES.TITLE)).focus();
    scrollToFn();
  };
};

/**
 * Responsible for scrolling to a field in the DOM.
 * @param {Map} fieldErrorMap - Map of field errors
 */
var scrollToField = function scrollToField(fieldErrorMap) {
  return function (evt) {
    evt.preventDefault();
    var targetErrorSummaryId = evt.currentTarget.getAttribute('href').substr(1);
    var fieldErrorValues = Array.from(fieldErrorMap.values());
    var _find = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(fieldErrorValues, function (_ref3) {
        var errorItemId = _ref3.errorItemId;
        return errorItemId === targetErrorSummaryId;
      }),
      $formField = _find.$formField,
      $fieldContainer = _find.$fieldContainer;
    $formField.focus();
    // This is using the defaults but more information on this can be found here:
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView#Parameters
    $fieldContainer[0].scrollIntoView({
      block: 'center'
    });
  };
};

/**
 * Responsible for cleaning up or tearing down error summary.
 * @param {jQuery} $el = The container element
 * @param {jQuery} $errorContainer - An error container
 * @param {Function} deregister - Unregisters the plugin
 */
var _destroy = function destroy($el, $errorContainer, deregister) {
  $el.off(EVENT_NS);
  $errorContainer.remove();
  deregister();
};

/**
 * Responsible for formatting data attributes into a proper jQuery selector.
 * @param {Array} dataAttrs - List of possible data attributes
 * @returns {string} Data attributes in the form of selectors
 */
var createDataSelectors = function createDataSelectors(dataAttrs) {
  return dataAttrs.map(function (attr) {
    return "[data-".concat(__WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase___default()(attr), "]");
  }).join(',');
};

/**
 * Responsible for creating a consolidated place for a form error item,
 * containing all the necessary information needed for a form error item.
 * @param {string} formSelectors - Represents form field selectors
 * @param {Function} createErrorId - Creates a unique ID
 * @returns {Function} Called on to create a field error item
 */
var createFieldErrorItem = function createFieldErrorItem(formSelectors, createErrorId) {
  return function (map, fieldContainer, id) {
    var formField = fieldContainer;
    var $fieldContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(fieldContainer);
    var $innerFormField = $fieldContainer.find(formSelectors);
    if ($innerFormField.length) {
      formField = $innerFormField[0];
    }
    var $formField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(formField);
    var errorItemId = createErrorId(id);
    var info = {
      errorItemId: errorItemId,
      $fieldContainer: $fieldContainer,
      $formField: $formField
    };

    // This exists so that a container with a form field supercedes a form field
    // that is the same as the container. This would occur when both the
    // container and field are seen as separate elements. Since the container
    // with the form field is the desired result, make sure that wins over when
    // a form field is the same as the container.
    if (map.has(formField) && formField === $fieldContainer[0]) {
      return map;
    }
    return map.set(formField, info);
  };
};

/**
 * Responsible for creating a map of elements which can be used for looking up
 * errors when a form has submitted.
 * @param {jQuery} $el - Container element
 * @param {Array} fieldGroupSelectors - Potential field selectors
 * @param {Array} dataAttrs - Data attributes used for error messages
 * @param {string} formSelectors - Possible form elements that can be queried
 * @param {Function} createErrorId - Creates a unique for each field
 * @returns {Map} Contains all possible fields which may have any sort of error
 * messaging
 */
var createFieldErrorMap = function createFieldErrorMap($el, fieldGroupSelectors, dataAttrs, formSelectors, createErrorId) {
  var fieldSelectors = fieldGroupSelectors.concat(formSelectors, createDataSelectors(dataAttrs)).join(',');
  return $el.find(fieldSelectors).toArray().reduce(createFieldErrorItem(formSelectors, createErrorId), new Map());
};

/**
 * Responsible for displaying an error summary that contains error information
 * upon submitting the form.
 * @param {HTMLElement} el - Element containing form field elements
 * @param {Object} options - Configurable options
 * @param {Object} actions - Actions to be called on
 * @return {Object} Methods attached to an error summary
 */
function errorSummary(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref4.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $errorContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()();
  var _Object$assign = Object.assign({}, ERROR_SUMMARY_OPTIONS, options, $el.data()),
    formSelectors = _Object$assign.formFieldSelectors,
    dataAttrs = _Object$assign.messageDataAttrs,
    errorContainerClassName = _Object$assign.errorContainerClassName,
    createErrorId = _Object$assign.createErrorId,
    errorPrefix = _Object$assign.errorPrefix,
    fieldGroupSelectors = _Object$assign.fieldGroupSelectors,
    scrollToFn = _Object$assign.scrollToFn;
  var title = el.dataset.errorSummaryTitle;
  if (title) {
    $el.data('validateDisableErrorScroll', true);
    var fieldErrorMap = createFieldErrorMap($el, fieldGroupSelectors, dataAttrs, formSelectors, createErrorId);
    $errorContainer = createErrorContainer($el, errorContainerClassName);
    $errorContainer.on('click', ".".concat(CLASS_NAMES.SUMMARY_LINK), scrollToField(fieldErrorMap));
    var showErrorSummary = makeShowErrorSummary(errorPrefix, title, $errorContainer, fieldErrorMap, scrollToFn);
    $el.on(CLEAR + EVENT_NS, removeErrorSummary($errorContainer)).on(VALIDATOR_ERROR + EVENT_NS, showErrorSummary).on(VALIDATOR_POST_ERROR + EVENT_NS, showErrorSummary).on(VALIDATOR_SUCCESS + EVENT_NS, removeErrorSummary($errorContainer));
  }
  return {
    destroy: function destroy() {
      return _destroy($el, $errorContainer, deregister);
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["a" /* default */])('errorSummary', errorSummary);

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for creating a container around a field of elements with the
 * intention of applying a single error message.
 * @module elements/fields/field-container
 */


var FIELD_CONTAINER_DEFAULTS = {
  errorMessage: '',
  blockName: 'fixed-label',
  labelElement: 'label',
  errorElement: 'error',
  labelErrorModifier: 'invalid'
};
var NS = 'field-container';

/**
 * Responsible for creating an error element.
 * @param {string} className - Class name of the container
 * @param {Object} data - Any data for the element
 */
var createErrorElement = function createErrorElement(className, _ref) {
  var message = _ref.message;
  return "<p class=\"".concat(className, "\">").concat(message, "</p>");
};

/**
 * Responsible managing an error around a container of elements.
 * @param {HTMLElement} el - Acts as the container
 * @param {Object} options - Configurable options
 */
function fieldContainer(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref2.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _Object$assign = Object.assign({}, FIELD_CONTAINER_DEFAULTS, options, $el.data()),
    errorMessage = _Object$assign.errorMessage,
    blockName = _Object$assign.blockName,
    labelElement = _Object$assign.labelElement,
    errorElement = _Object$assign.errorElement,
    labelErrorModifier = _Object$assign.labelErrorModifier;
  var errorClassName = "".concat(blockName, "__").concat(errorElement);
  var errorSelector = ".".concat(errorClassName);
  var label = "".concat(blockName, "__").concat(labelElement);
  var labelError = "".concat(blockName, "__").concat(labelElement, "--").concat(labelErrorModifier);
  $el
  // Since we are providing our own way of handling the error message, just in
  // case a floating error message is applied, do not use it in favor of our
  // custom way of handling an error
  .attr('data-disable-floating-error', true).on("mirror-field:error.".concat(NS), function (e) {
    var validationMessage = e.originalEvent.detail.validationMessage;
    $el.find(".".concat(label)).addClass(labelError);
    var $error = $el.find(errorSelector);
    var message = errorMessage || validationMessage;
    if ($error.length) {
      $error.text(message);
    } else {
      $el.append(createErrorElement(errorClassName, {
        message: message
      }));
    }
  }).on("mirror-field:reset.".concat(NS), function () {
    $el.find(".".concat(label)).removeClass(labelError);
    $el.find(errorSelector).remove();
  });
  return {
    removeListeners: function removeListeners() {
      deregister();
      $el.off(".".concat(NS));
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('fieldLabelContainer', fieldContainer);

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CLEAR_ICON_ATTR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_field_behaviors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state_modifiers__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__iconify_behaviors__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__floating_error__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toggle_password__ = __webpack_require__(273);
/**
 * Responsible for combining all fixed label related behaviors and exposing it
 * as a jQuery plugin.
 * @module elements/fields/fixedLabelPlugin
 */






var CLEAR_ICON_ATTR = 'data-iconify-clear';
var BLOCK = 'fixed-label';
var getTogglePass = function getTogglePass(name) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(window, ['rcProps', 'togglePassword', name]);
};
var BUILTIN_BEHAVIORS = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__state_modifiers__["a" /* default */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__iconify_behaviors__["a" /* default */])({
  containerClassName: "".concat(BLOCK, "__iconify")
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__floating_error__["a" /* default */])({
  floatingErrorContainerClassName: "".concat(BLOCK, "--floating-error"),
  floatingErrorClassName: "".concat(BLOCK, "__error")
}), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__toggle_password__["a" /* default */])({
  actionClassName: "".concat(BLOCK, "__toggle-password"),
  fieldAttrs: {
    'data-iconify-disable-clear': true
  },
  showText: getTogglePass('showText'),
  hideText: getTogglePass('hideText'),
  a11yShowText: getTogglePass('a11yShowText'),
  a11yHideText: getTogglePass('a11yHideText')
})];
/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__form_field_behaviors__["a" /* createJQueryPlugin */])('fixedLabel', BLOCK, BUILTIN_BEHAVIORS, function (el, options) {
  if (!el.dataset.iconifyDisableClear) {
    el.setAttribute(CLEAR_ICON_ATTR, 'Clear');
  }
  return Object.assign({}, options);
}));

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__state_modifiers__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__iconify_behaviors__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__iconify_details__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__floating_error__ = __webpack_require__(110);
/**
 * Responsible for combining all floating label related callers and exposing it
 * as a jQuery plugin.
 * @module elements/fields/floatingLabelPlugin
 */






/**
 * Defines any built in callers for a floating label.
 * @type {Array}
 */
var BUILTIN_BEHAVIORS = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__state_modifiers__["a" /* default */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__iconify_behaviors__["a" /* default */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__iconify_details__["a" /* default */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__floating_error__["a" /* default */])()];
/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__form_field_behaviors__["a" /* createJQueryPlugin */])('floatingLabel', 'floating-label', BUILTIN_BEHAVIORS));

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ERROR_SECTION_CLASS_NAME */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for scrolling to a specific position when a form error submission
 * has occurred on a form validator.
 * @module elements/fields/formErrorScroller
 */


var ERROR_SECTION_CLASS_NAME = 'validator-error-section';

/**
 * Determines the scroll position based on the passed in configuration.
 * @private
 * @param {number} scrollPosition - Where in the page to scroll to.
 * @param {string} scrollSelector - A selector within the wrapper.
 * @returns {number|undefined} Where to scroll to when an error occurs.
 */
var resolveFormScrollPosition = function resolveFormScrollPosition(scrollPosition, scrollSelector) {
  var $scroll = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(scrollSelector);
  if ($scroll.length) {
    return $scroll.scrollTop();
  }
  return scrollPosition;
};

/**
 * Determines the insertion position of where the error message should be
 * located within the wrapper.
 * @private
 * @param {jQuery} $wrapper - The wrapper containing the form fields
 * @param {string} insertErrorBefore - The selector used for inserting before an
 * element
 * @param {string} insertErrorAfter - The selector used for inserting after an
 * element
 * @returns {Object} The position and jQuery object where to insert the error
 */
var resolveFormErrorInsertPosition = function resolveFormErrorInsertPosition($wrapper, insertErrorBefore, insertErrorAfter) {
  var errorInsertPositions = [{
    position: 'before',
    selector: insertErrorBefore
  }, {
    position: 'after',
    selector: insertErrorAfter
  }];
  var _errorInsertPositions = errorInsertPositions.map(function (_ref) {
      var position = _ref.position,
        selector = _ref.selector;
      return {
        position: position,
        $el: $wrapper.find(selector)
      };
    }).filter(function (_ref2) {
      var $el = _ref2.$el;
      return $el.length;
    }),
    _errorInsertPositions2 = _slicedToArray(_errorInsertPositions, 1),
    _errorInsertPositions3 = _errorInsertPositions2[0],
    obj = _errorInsertPositions3 === void 0 ? {} : _errorInsertPositions3;
  return obj;
};

/**
 * Renders an error section.
 * @private
 * @param {string} errorMessage - The error message
 * @returns {string} Rendered error section.
 */
var renderErrorSection = function renderErrorSection(_ref3) {
  var errorMessage = _ref3.errorMessage;
  return "\n  <div class=\"form-section ".concat(ERROR_SECTION_CLASS_NAME, "\">\n    <p class=\"form-section__error embedded-error\">").concat(errorMessage, "</p>\n  </div>\n");
};

/**
 * Handles scrolling to a specific position based on what has been provided
 * by the caller. This happens on a form level and provides the flexibility of
 * where the error should be rendered, where the page should scroll to, and the
 * message to use. If any one of these properties is missing, it will not be
 * used. Here are the available options:
 *
 * - data-validate-error-message: the error message
 * - data-validate-scroll-to-position: y-axis to scroll to
 * - data-validate-scroll-to-selector: the top part of the selector to scroll to
 * - data-validate-insert-error-before: a selector within the form where the
 *   error should be injected to before
 * - data-validate-insert-error-after: a selector within the form where the
 *   error should be injected to after
 *
 * scroll-to-position supersedes scroll-to-selector and insert-error-before will
 * supersede insert-error-after.
 *
 * Here's some example markup used for configuration purposes:
 *
 * @example
 * <form
 *   data-validate-error-message="some message"
 *   data-validate-scroll-to-position="0"
 *   data-validate-error-before=".title">
 *   <h1 class="title">I am a title</h1>
 *   <input type="text" name="name">
 *   <input type="submit" value="Submit">
 * </form>
 * @param {jQuery} $wrapper - The wrapper containing the elements
 * @param {Function} scrollTrigger - Function used for scrolling to x/y
 * coordinates.
 * @param {Object} options - Configurable options
 * @returns {boolean} Whether a scroll error has been captured.
 */
var formErrorScroller = function formErrorScroller($wrapper, scrollTrigger) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _Object$assign = Object.assign({}, options, $wrapper.data()),
    errorMessage = _Object$assign.validateErrorMessage,
    scrollPosition = _Object$assign.validateScrollToPosition,
    scrollSelector = _Object$assign.validateScrollToSelector,
    insertErrorBefore = _Object$assign.validateInsertErrorBefore,
    insertErrorAfter = _Object$assign.validateInsertErrorAfter;
  // Nuke any existing sections to remove duplicate error messages.
  $wrapper.find(".".concat(ERROR_SECTION_CLASS_NAME)).remove();
  var position = resolveFormScrollPosition(scrollPosition, scrollSelector);
  var _resolveFormErrorInse = resolveFormErrorInsertPosition($wrapper, insertErrorBefore, insertErrorAfter),
    insertPosition = _resolveFormErrorInse.position,
    $error = _resolveFormErrorInse.$el;

  // If at least one criteria is not met, don't render the message since all
  // are required for this purpose, but no crazy failures occur if this isn't
  // call on, i.e. it's an enhancement, not core functionality.
  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isUndefined___default()(position) && $error && errorMessage) {
    // Since this is within our control, dynamically call on jQuery method for
    // insertion.
    $error[insertPosition](renderErrorSection({
      errorMessage: errorMessage
    }));
    scrollTrigger(0, position);
    return true;
  }
  return false;
};
/* harmony default export */ __webpack_exports__["a"] = (formErrorScroller);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__field_container__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__character_counter__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__floating_label_plugin__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fixed_label_plugin__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__entry_error__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__radio_group_validator__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mirror_field__ = __webpack_require__(271);











// Does the initial setup so that the mirrorField jQuery plugin is available
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__mirror_field__["a" /* default */])();
var makeGetContainer = function makeGetContainer($container) {
  return function ($els) {
    if ($container && $container.length) {
      return $container.find($els);
    }
    return $els;
  };
};
function formField(el) {
  var _options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $entryErrors = $el.find('[data-entry-error]:visible').entryError({
    requiredTemplate: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.entryError.requiredTemplate', ''),
    invalidTemplate: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.entryError.invalidTemplate', '')
  });
  var $floatingLabels = $el.find('.floating-label:visible').floatingLabel();
  var $fixedLabels = $el.find('.fixed-label:visible').fixedLabel();
  var $fieldLabelContainers = $el.find(document.getElementsByClassName('fixed-label--container')).fieldLabelContainer();
  var $characterCounters = $el.find(document.getElementsByClassName('character-counter-field')).characterCounter();
  var $characterCountersInput = $el.find(document.getElementsByClassName('character-counter-input')).characterCounter({
    fieldSelector: 'input'
  });
  var $mirrorFields = $el.find(document.querySelectorAll('[data-mirror-field-name]')).mirrorField();
  var $validateRadioGroups = $el.find(document.getElementsByClassName('validate-radio-group')).radioGroupValidator({
    errorClassName: 'form-section__error',
    errorTemplate: __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(window, 'rcProps.validateRadioGroup.errorTemplate')
  });
  return {
    teardown: function teardown() {
      var teardownOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var $container = teardownOptions.$container;
      // If a container has been provided, this means that the intention is
      // to keep around some of the instances. Therefore, if we intended to
      // teardown all instances but it had previously been torn down, then
      // an error would be thrown accidentally when it wasn't the intention.
      if (!$container) {
        deregister();
      }
      var getContainer = makeGetContainer($el.find($container));
      getContainer($floatingLabels).floatingLabel('removeListeners');
      getContainer($fixedLabels).fixedLabel('removeListeners');
      getContainer($entryErrors).entryError('destroy');
      getContainer($fieldLabelContainers).fieldLabelContainer('removeListeners');
      getContainer($characterCounters).characterCounter('removeListeners');
      getContainer($characterCountersInput).characterCounter('removeListeners');
      getContainer($mirrorFields).mirrorField('destroy');
      getContainer($validateRadioGroups).radioGroupValidator('removeListeners');
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])('formField', formField);

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export iconList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_modal__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iconify_setup__ = __webpack_require__(112);
/* unused harmony reexport VISIBLE_CLASS_NAME */
/**
 * Responsible for using the details behavior within a floating label.
 * @module elements/fields/iconifyDetails
 */




/**
 * Contains the list of icons associated with a more details iconify floating
 * label.
 * @type {Object}
 */
var iconList = [{
  name: 'details',
  iconId: 'details'
}];

/**
 * Defines configurable options
 * @type {Object}
 */
var DEFAULT_MORE_DETAILS = {
  modal: __WEBPACK_IMPORTED_MODULE_0__modules_modal__["a" /* default */]
};

/**
 * Responsible for showing a more details icons within a floating element. Once
 * the icon has been interacted with, it will show a modal. This is different
 * than an iconify-behaviors as this work doesn't need to hook into the
 * floating label events cycle, but rather utilizes the same setup, therefore
 * allowing us to reuse things such as setting up icons and the applicable
 * elements used in a floating label.
 *
 * To configure this work, make sure the following data attributes have been
 * provided:
 *
 * - data-iconify-more-details: contains the title for the icon used for i18n
 *   and accessibility
 * - data-open: an ID to a modal
 *
 * Since this work will leverage the modal, any modal related data attributes
 * can be applied here. Here's an example in HTML to wire this dude up:
 *
 * @example
 * <div
 *     class="floating-label"
 *     data-iconify-more-details="More Details"
 *     data-open="modal-example">
 *   <label for="the-dude" class="floating-label__label">The Dude</label>
 *   <input id="the-dude" class="floating-label__input">
 * </div>
 *
 * <div id="modal-example" class="modal u-center" data-type="default-modal">
 *   <p>modal content goes here</p>
 * </div>
 *
 * @param {Object} options - Configurable options
 * @returns {Function} Initialization of iconify more details
 */
var iconifyMoreDetails = function iconifyMoreDetails() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    var opts = Object.assign({}, DEFAULT_MORE_DETAILS, options);
    var modalFunc = opts.modal;
    for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
      nodes[_key] = arguments[_key];
    }
    var _setup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["c" /* default */])(iconList, nodes, opts),
      container = _setup.container,
      iconNodes = _setup.iconNodes;
    if (!iconNodes) {
      return;
    }
    var detailsIcon = iconNodes.details;
    detailsIcon.classList.add(__WEBPACK_IMPORTED_MODULE_1__iconify_setup__["b" /* VISIBLE_CLASS_NAME */]);
    detailsIcon.addEventListener('click', function () {
      modalFunc(container, {
        triggerOpen: true
      });
    });
  };
};
/* harmony default export */ __webpack_exports__["a"] = (iconifyMoreDetails);

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for applying an error to a form field.
 * @module elements/fields/validator
 */


var DEFAULT_INVALIDATE_OPTIONS = {
  formFieldSelectors: 'input,textarea,select',
  message: 'Received an error'
};

/**
 * Responsible for setting an element as being invalid.
 * @example
 * $('.some-selector').invalidate({
 *   message: 'oh noes??!?! what happened??!?!?1?!',
 * });
 *
 * @param {HTMLElement} el - An element, presumably a form element
 * @param {Object} options - Configurable options
 */
function invalidate(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _Object$assign = Object.assign({}, DEFAULT_INVALIDATE_OPTIONS, options),
    formFieldSelectors = _Object$assign.formFieldSelectors,
    message = _Object$assign.message;
  if ($el.is(formFieldSelectors)) {
    el.setCustomValidity(message);
    el.checkValidity();
    return;
  }
  var $formField = $el.find(formFieldSelectors);
  if ($formField.length) {
    var formField = $formField[0];
    // Grab the first one in the case where there could be more than one, i.e.
    // checkboxes or radios.
    // TODO: See if this needs to be more comprehensive
    formField.setCustomValidity(message);
    formField.checkValidity();
  }
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('invalidate', invalidate, {
  cache: false
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EVENT_NAMESPACE */
/* unused harmony export EVENTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Responsible for creating a group out of a set of fields and when one of those
 * fields is invalid, all are marked as invalid.
 * @module elements/fields/mirror-field
 */

// UNCOMMENT THIS CODE IF BLUR SHOULD BE SUPPORTED
// import find from 'lodash/find';

var EVENT_NAMESPACE = 'mirror-field';
var EVENTS = {
  VALID: 'valid',
  INVALID: 'invalid',
  FOCUS: 'focus',
  ERROR: 'mirror-field:error',
  RESET: 'mirror-field:reset'
  // UNCOMMENT THIS CODE IF BLUR SHOULD BE SUPPORTED
  // BLUR: 'blur',
  // CHANGE: 'change',
};
var FORM_FIELDS = 'input,textarea,select';

/**
 * Creates an event name with a namespace.
 * @param {string} name - Name of the event
 * @returns {string} Event with namespace
 */
var createEventName = function createEventName(name) {
  return "".concat(EVENTS[name.toUpperCase()], ".").concat(EVENT_NAMESPACE);
};

/**
 * Responsible for finding fields based on a group name.
 * @param {Object} fieldMappings - All available field mappings keyed by group
 * name
 * @param {jQuery} $el - Used for looking up the group
 * @returns {Array} All elements within a group
 */
var getFieldList = function getFieldList(fieldMappings, $el) {
  var name = $el.data('mirrorFieldName');
  var fieldList = fieldMappings[name];
  if (fieldList) {
    return fieldList;
  }
  return [];
};

/**
 * Responsible for appending a field to a group.
 * @param {Object} fieldMappings - All available field mappings keyed by group
 * name
 * @param {jQuery} $el - Element being added to group
 * @returns {Object} - Updated field mappings
 */
var updateFieldMappings = function updateFieldMappings(fieldMappings, $el) {
  var name = $el.data('mirrorFieldName');
  var fieldList = getFieldList(fieldMappings, $el);
  var updatedFieldList = fieldList.length ? [].concat(_toConsumableArray(fieldList), [$el]) : [$el];
  return Object.assign({}, fieldMappings, _defineProperty({}, name, updatedFieldList));
};

/**
 * Responsible for receiving a field that is an error and then making all
 * fields associated with the error element invalid.
 * @param {Object} fieldMappings - All available field mappings keyed by group
 * name
 * @param {jQuery} $el - Field applied with error
 */
var _applyError = function applyError(fieldMappings, $el) {
  var fieldList = getFieldList(fieldMappings, $el);
  var updatedFieldList = fieldList.filter(function ($field) {
    return !$field.is($el);
  });
  var validationMessage = $el.prop('validationMessage');
  updatedFieldList.forEach(function ($field) {
    var field = $field[0];
    if ($field.is(FORM_FIELDS)) {
      var eventName = createEventName(EVENTS.INVALID);
      // Remove event so that it doesn't recursively call itself until the
      // call stack goes KABOOM
      $field.off(eventName);
      field.setCustomValidity(validationMessage);
      field.checkValidity();
      // Now that the element has been invalidated, rebind the event for the
      // next invalid event listener.
      $field.on(eventName, function () {
        return _applyError(fieldMappings, $field);
      });
    }
    var errorEvt = new CustomEvent(EVENTS.ERROR, {
      detail: {
        $field: $field,
        validationMessage: validationMessage,
        $source: $el
      }
    });
    field.dispatchEvent(errorEvt);
  });
};

/**
 * Responsible for resetting an error on a subset of mirror fields.
 * @param {Object} fieldMappings - All available field mappings keyed by group
 * name
 * @param {jQuery} $el - Field getting error reset
 */
var resetError = function resetError(fieldMappings, $el) {
  var fieldList = getFieldList(fieldMappings, $el);
  fieldList.forEach(function ($field) {
    var field = $field[0];
    if ($field.is(FORM_FIELDS)) {
      field.setCustomValidity('');
      field.checkValidity();
      // Only make this available to fields since it plays off of the invalid
      // event which exists in the browser. Technically the invalid event can
      // be fired off on a non-form element, but according to the spec, it's
      // supposed to fire off on a submittable element.
      // https://developer.mozilla.org/en-US/docs/Web/Events/invalid
      var validEvt = new CustomEvent(EVENTS.VALID);
      field.dispatchEvent(validEvt);
    }
    var resetEvt = new CustomEvent(EVENTS.RESET, {
      detail: {
        $field: $field,
        $source: $el
      }
    });
    field.dispatchEvent(resetEvt);
  });
};

// UNCOMMENT THIS CODE IF BLUR SHOULD BE SUPPORTED
// const checkForError = (fieldMappings, $el) => {
//   const $activeElement = $(document.activeElement);
//   const fieldList = getFieldList(fieldMappings, $el);
//   const activeElementInList = find(fieldList, $field => $field.is($activeElement));
//   const el = $el[0];

//   if (activeElementInList && $el.is(FORM_FIELDS) && !el.validity.valid) {
//     return;
//   }

//   fieldList.forEach(($field) => {
//     $field.trigger('validator:validate');
//   });

//   const $error = find(fieldList, ($field) => {
//     if (!$field.is(FORM_FIELDS)) {
//       return false;
//     }

//     const field = $field[0];
//     field.checkValidity();
//     const validity = $field.prop('validity');
//     return !validity.valid;
//   });

//   if ($error) {
//     fieldList.forEach(($field) => {
//       if ($field.is(FORM_FIELDS)) {
//         const field = $field[0];
//         field.setCustomValidity($error.prop('validationMessage'));
//         field.checkValidity();
//       }
//     });
//   } else {
//     fieldList.forEach(($field) => {
//       if ($field.is(FORM_FIELDS)) {
//         const field = $field[0];
//         field.setCustomValidity('');
//         field.checkValidity();

//         const validEvt = new CustomEvent('valid');
//         field.dispatchEvent(validEvt);
//       }
//     });
//   }
// };

/**
 * Responsible for setting up mirror field groupings through exposing the
 * ability to register via a function or a jQuery plugin.
 * @return {Object} Available methods for interacting with mirror fields
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var fieldMappings = {};
  var register = function register(el) {
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    var nextFieldMappings = updateFieldMappings(fieldMappings, $el);
    fieldMappings = nextFieldMappings;
    $el.on(createEventName('invalid'), function (_ref) {
      var target = _ref.target;
      return _applyError(fieldMappings, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target));
    }).on(createEventName('focus'), function (_ref2) {
      var target = _ref2.target;
      return resetError(fieldMappings, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target));
    });

    // UNCOMMENT THIS CODE IF BLUR SHOULD BE SUPPORTED
    // $el.on(createEventName('blur'), ({ target }) => checkForError(fieldMappings, $(target)))

    // UNCOMMENT THIS CODE IF BLUR SHOULD BE SUPPORTED
    // if ($el.prop('tagName').toLowerCase() === 'select') {
    //   $el.on(createEventName('change'), ({ target }) => checkForError(fieldMappings, $(target)));
    // }

    return {
      destroy: function destroy() {
        return $el.off(".".concat(EVENT_NAMESPACE));
      }
    };
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('mirrorField', register);
  return {
    register: register
  };
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EMBEDDED_ERROR_CLASS_NAME */
/* unused harmony export DEFAULT_ERROR_MESSAGE */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_property__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniq__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validator__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_stache__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_random__ = __webpack_require__(63);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for applying validation upon a radio group so that it can hook
 * into Constraint Validation API.
 * @module radioGroupValidator
 */








var INPUT_GROUP_OPTIONS = {
  errorClassName: '',
  inputSelector: 'input',
  errorPosition: 'afterbegin',
  labelSelector: '.push-button',
  labelErrorClassName: 'push-button-error',
  errorTemplate: '',
  errorIdentifiedBy: '',
  errorPrefix: 'Error:'
};
var createInputGroupOptions = function createInputGroupOptions() {
  return _objectSpread(_objectSpread({}, INPUT_GROUP_OPTIONS), {}, {
    errorIdentifiedBy: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib_random__["a" /* default */])({
      prefix: 'radio-group-validator-error'
    })
  });
};

/**
 * CSS class name used for embedding an error.
 * @type {string}
 */
var EMBEDDED_ERROR_CLASS_NAME = 'embedded-error';

/**
 * Default error message when one hasn't been provided.
 * @type {string}
 */
var DEFAULT_ERROR_MESSAGE = 'Please select an option';

/**
 * Responsible for taking any registered event listeners and releasing them
 * from memory.
 * @private
 * @param {HTMLInputElement} input - A radio input
 * @param {Array<Object>} listeners - event listeners to be removed
 */
var removeInputListeners = function removeInputListeners(input, listeners) {
  listeners.forEach(function (_ref) {
    var evt = _ref.evt,
      handler = _ref.handler;
    input.removeEventListener(evt, handler);
  });
};

/**
 * Responsible for removing the error message.
 * @private
 * @param {HTMLElement} wrap - Container element
 */
var removeError = function removeError(wrap) {
  var potentialErrors = [function () {
    return wrap.querySelector(".".concat(EMBEDDED_ERROR_CLASS_NAME));
  }, function () {
    var el = wrap.previousSibling;
    return el && el.classList.contains(EMBEDDED_ERROR_CLASS_NAME) && el;
  }, function () {
    var el = wrap.nextSibling;
    return el && el.classList.contains(EMBEDDED_ERROR_CLASS_NAME) && el;
  }];
  var errorElFn = potentialErrors.find(function (fn) {
    return fn();
  });
  if (errorElFn) {
    var errorEl = errorElFn();
    errorEl.parentNode.removeChild(errorEl);
    return;
  }
  throw new Error('No error element found in radio group validator');
};

/**
 * Responsible for building the element for the error.
 * @private
 * @param {string} errorClassName - CSS class name for the error
 * @param {string} errorMessage - The error message
 */
var renderError = function renderError(_ref2) {
  var errorClassName = _ref2.errorClassName,
    errorMessage = _ref2.errorMessage,
    errorPrefix = _ref2.errorPrefix,
    id = _ref2.id;
  var errorElement = "<p ".concat(id ? "id=\"".concat(id, "\"") : '', " class=\"").concat(errorClassName, " ").concat(EMBEDDED_ERROR_CLASS_NAME, "\"><span class=\"u-screen-reader\">").concat(errorPrefix, " </span>").concat(errorMessage, "</p>");
  return errorElement;
};

/**
 * Responsible for figuring out where the error message should be rendered in
 * the DOM.
 * @private
 * @param {Object} dataset - dataset of an HTML
 * @returns {Object} The position and selector used for inserting the error
 */
var determineInsertSelector = function determineInsertSelector(dataset) {
  var insertBeforeSelector = dataset.radioGroupInsertErrorBefore,
    insertAfterSelector = dataset.radioGroupInsertErrorAfter;
  var selectors = [{
    position: 'beforebegin',
    insertSelector: insertBeforeSelector
  }, {
    position: 'afterend',
    insertSelector: insertAfterSelector
  }];
  return __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(selectors, function (_ref3) {
    var position = _ref3.position,
      insertSelector = _ref3.insertSelector;
    if (insertSelector) {
      return {
        position: position,
        insertSelector: insertSelector
      };
    }
    return false;
  }) || {};
};

/**
 * Responsible for retrieving an error message based on a number of rules from
 * most specific to least specific, in particular:
 *
 * - error message on the element
 * - template on an element
 * - template based on passed in options
 * - default error message as a catch all
 *
 * @param {string} errorMessage - Element error message
 * @param {string} template - Stache template for the error message
 * @param {Object} data - Data to be fed into stache template
 * @returns {string} An error message
 */
var getErrorMessage = function getErrorMessage(errorMessage, template, data) {
  if (errorMessage) {
    return errorMessage;
  }
  if (template) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_stache__["a" /* default */])(template, data);
  }
  return DEFAULT_ERROR_MESSAGE;
};

/**
 * Finds the first input that contains a data-label.
 * @param {Array} inputs - List of input elements in the form of an array
 * @returns {string} First found label attribute
 */
var findLabelFromInputs = function findLabelFromInputs(inputs) {
  var getLabel = __WEBPACK_IMPORTED_MODULE_2_lodash_property___default()('dataset.label');
  var input = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(inputs, getLabel);
  if (input) {
    return getLabel(input);
  }
  return '';
};

/**
 * Responsible for appending a new value to aria-labelledby that will be used
 * to communicate an error.
 * @param {HTMLElement} container - Element containing the radio group validator
 * @param {string} errorIdentifiedBy - Value used for aria-labelledby
 */
var applyLabelledByError = function applyLabelledByError(container, errorIdentifiedBy) {
  var existingLabelledBy = (container.getAttribute('aria-labelledby') || '').split(/(\s+)/).filter(function (val) {
    return val.trim().length;
  });
  var updatedLabelledBy = __WEBPACK_IMPORTED_MODULE_3_lodash_uniq___default()([].concat(_toConsumableArray(existingLabelledBy), [errorIdentifiedBy])).join(' ').trim();
  container.setAttribute('aria-labelledby', updatedLabelledBy);
};

/**
 * Responsible for marking a set of inputs as being aria valid or invalid.
 * @param {HTMLInputElement[]} inputs - Elements made valid or invalid
 * @param {boolean} val - Determines whether the elements should be invalid
 */
var applyAriaInvalid = function applyAriaInvalid(inputs, val) {
  inputs.forEach(function (input) {
    input.setAttribute('aria-invalid', val);
  });
};

/**
 * Responsible for seeing if any radio inputs are invalid and if so, to allow
 * for error messaging to be displayed. Once a change event has occurred, the
 * error goes away and will allow for any additional validation to be picked up
 * and allow the cycle to repeat itself.
 *
 * The error message and where it's located is configurable based on data
 * attributes on the element passed in. By default, if no position has been
 * provided, it'll write the error message as the first child of the wrap.
 * Here are the supported position values:
 *
 * - data-radio-group-insert-error-before
 * - data-radio-group-insert-error-after
 *
 * Where the value is a selector within the element passed in. Here's an
 * example:
 *
 * @example
 * <div data-radio-group-error-message="Yeah,well, that's just, like, your opinion, man"
 *      data-radio-group-insert-error-before=".title">
 *   <h2 class="title">I am a title or something</h2>
 *   <input type="radio" name="characters" value="dude" required>
 *   <input type="radio" name="characters" value="walter" required>
 *   <input type="radio" name="characters" value="donny" required>
 *   <button type="submit">Submit</button>
 * </div>
 *
 * @see INPUT_GROUP_OPTIONS
 * @param {HTMLElement} wrap - Element containing the inputs
 * @param {Object} options - Configurable options
 */
function radioGroupValidator(wrap) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["b" /* noopActions */],
    deregister = _ref4.deregister;
  var dataset = wrap.dataset;
  var _Object$assign = Object.assign({}, createInputGroupOptions(), options, dataset),
    inputSelector = _Object$assign.inputSelector,
    errorClassName = _Object$assign.errorClassName,
    errorPosition = _Object$assign.errorPosition,
    labelSelector = _Object$assign.labelSelector,
    labelErrorClassName = _Object$assign.labelErrorClassName,
    radioGroupErrorMessage = _Object$assign.radioGroupErrorMessage,
    errorTemplate = _Object$assign.errorTemplate,
    errorIdentifiedBy = _Object$assign.errorIdentifiedBy,
    errorPrefix = _Object$assign.errorPrefix;
  var _determineInsertSelec = determineInsertSelector(dataset),
    _determineInsertSelec2 = _determineInsertSelec.position,
    position = _determineInsertSelec2 === void 0 ? errorPosition : _determineInsertSelec2,
    insertSelector = _determineInsertSelec.insertSelector;
  var insertionEl = insertSelector ? wrap.querySelector(insertSelector) : wrap;
  var INVALID_SCROLL_POSITION = __WEBPACK_IMPORTED_MODULE_5__validator__["a" /* EVENTS */].INVALID_SCROLL_POSITION;
  var errorShown = false;
  var listeners = [];
  var inputs = Array.from(wrap.querySelectorAll(inputSelector));
  var $labels = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find(labelSelector);
  var label = findLabelFromInputs(inputs);
  var errorMessage = getErrorMessage(radioGroupErrorMessage, errorTemplate, {
    label: label
  });
  applyLabelledByError(wrap, errorIdentifiedBy);
  inputs.forEach(function (input) {
    var invalidHandler;
    var changeHandler;
    var positionHandler;
    input.addEventListener('invalid', invalidHandler = function invalidHandler() {
      if (!errorShown) {
        errorShown = true;
        insertionEl.insertAdjacentHTML(position, renderError({
          errorClassName: errorClassName,
          errorMessage: errorMessage,
          errorPrefix: errorPrefix,
          id: errorIdentifiedBy
        }));
        $labels.addClass(labelErrorClassName);
        inputs[0].setCustomValidity(errorMessage);
        applyAriaInvalid(inputs, true);
      }
    });
    input.addEventListener(INVALID_SCROLL_POSITION, positionHandler = function positionHandler(_ref5) {
      var setElement = _ref5.detail.setElement;
      setElement(wrap);
    });
    input.addEventListener('change', changeHandler = function changeHandler() {
      if (errorShown) {
        errorShown = false;
        removeError(wrap);
        removeInputListeners(input, listeners);
        $labels.removeClass(labelErrorClassName);
        inputs[0].setCustomValidity('');
        applyAriaInvalid(inputs, false);
      }
    });
    listeners = [].concat(_toConsumableArray(listeners), [{
      evt: 'invalid',
      handler: invalidHandler
    }, {
      evt: 'change',
      handler: changeHandler
    }, {
      evt: INVALID_SCROLL_POSITION,
      handler: positionHandler
    }]);
  });
  return {
    removeListeners: function removeListeners() {
      deregister();
      inputs.forEach(function (input) {
        listeners.forEach(function (_ref6) {
          var evt = _ref6.evt,
            handler = _ref6.handler;
          input.removeEventListener(evt, handler);
        });
      });
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["a" /* default */])('radioGroupValidator', radioGroupValidator);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NS */
/* unused harmony export TOGGLE_PASSWORD_CLASSNAME */
/* unused harmony export TOGGLE_PASSWORD_SELECTOR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_noop__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_noop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_noop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assignWith__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_assignWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_assignWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_stache__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__form_field_behaviors__ = __webpack_require__(16);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for toggling a field between being a password and plain text.
 * @module elements/fields/toggle-password
 */






var NS = 'toggle-password';
var TOGGLE_PASSWORD_CLASSNAME = 'toggle-password';
var TOGGLE_PASSWORD_SELECTOR = ".".concat(TOGGLE_PASSWORD_CLASSNAME);
var CONTAINER = __WEBPACK_IMPORTED_MODULE_5__form_field_behaviors__["b" /* TYPES */].CONTAINER,
  FIELD = __WEBPACK_IMPORTED_MODULE_5__form_field_behaviors__["b" /* TYPES */].FIELD;
var TOGGLE_PASSWORD_DEFAULTS = {
  fieldAttrs: {},
  showText: 'show',
  hideText: 'hide',
  a11yShowText: 'show {{label}} field entry',
  a11yHideText: 'hide {{label}} field entry',
  actionClassName: 'toggle-password'
};

/**
 * Default customizer used to determine which value to use for options.
 * @param {*} objValue - Value from target
 * @param {*} srcValue - Value from source
 * @returns {*} Value for key
 */
var defaultCustomizer = function defaultCustomizer(objValue, srcValue) {
  if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(srcValue)) {
    return srcValue;
  }
  return objValue;
};

/**
 * Responsible for rendering and appending the show/hide toggling action.
 * @param {jQuery} $container - Where the toggler will be appended to
 * @param {jQuery} $formField - Form field element
 * @param {string} actionClassName - Class name applied to the toggler
 * @returns {jQuery} The toggler element
 */
var appendToggler = function appendToggler($container, $formField, actionClassName) {
  var formFieldId = $formField.attr('id');
  // start with hide so it forces it to show initially
  $container.append("\n    <a\n      data-toggle-password-state=\"hide\"\n      class=\"".concat(actionClassName, " ").concat(TOGGLE_PASSWORD_CLASSNAME, "\"\n      href=\"#").concat(!__WEBPACK_IMPORTED_MODULE_3_lodash_isNil___default()(formFieldId) ? formFieldId : '', "\">\n    </a>\n  "));
  return $container.find(TOGGLE_PASSWORD_SELECTOR);
};

/**
 * Responsible for updating the toggler based on the state of the toggler.
 * @param {Object} states - Map of the various toggling states
 * @param {jQuery} $formField - Form field element
 * @param {jQuery} $togglePassword - Toggle element
 * @param {Object} options - Configurable options
 */
var updateToggler = function updateToggler(states, $formField, $togglePassword) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$templateData = options.templateData,
    templateData = _options$templateData === void 0 ? {} : _options$templateData;
  var currentState = $togglePassword.data('togglePasswordState');
  var nextStateObj = states[currentState];
  if (!nextStateObj) {
    throw new Error("No toggle password state found for ".concat(currentState));
  }
  var nextState = nextStateObj.state,
    nextText = nextStateObj.text,
    nextA11yText = nextStateObj.a11yText,
    nextType = nextStateObj.type;
  $togglePassword.data('togglePasswordState', nextState).attr('aria-label', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_stache__["a" /* default */])(nextA11yText, templateData)).text(nextText);
  $formField.attr('type', nextType);
};

/**
 * Responsible for setting/wiring up toggle password functionality within a
 * form field behavior. In particular it'll allow for a show/hide toggling of a
 * password field with support around i18n and a11y.
 * @param {Object} [options={}] - Configurable options
 * @return {Function} Passed back the element belonging to the form field
 * behaviors
 */
var togglePassword = function togglePassword() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function () {
    for (var _len = arguments.length, nodes = new Array(_len), _key = 0; _key < _len; _key++) {
      nodes[_key] = arguments[_key];
    }
    var _nodes$filter = nodes.filter(function (_ref) {
        var type = _ref.type;
        return type === CONTAINER;
      }),
      _nodes$filter2 = _slicedToArray(_nodes$filter, 1),
      container = _nodes$filter2[0].node;
    var _nodes$filter3 = nodes.filter(function (_ref2) {
        var type = _ref2.type;
        return type === FIELD;
      }),
      _nodes$filter4 = _slicedToArray(_nodes$filter3, 1),
      formField = _nodes$filter4[0].node;
    var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
    var $formField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(formField);
    var label = $formField.data('label') || '';
    var _assignWith = __WEBPACK_IMPORTED_MODULE_2_lodash_assignWith___default()({}, TOGGLE_PASSWORD_DEFAULTS, options, $container.data(), defaultCustomizer),
      fieldAttrs = _assignWith.fieldAttrs,
      showText = _assignWith.showText,
      hideText = _assignWith.hideText,
      a11yShowText = _assignWith.a11yShowText,
      a11yHideText = _assignWith.a11yHideText,
      actionClassName = _assignWith.actionClassName;
    $container.attr(fieldAttrs);
    if (!$container.data('togglePassword') === true) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_noop___default.a;
    }
    if (formField.type !== 'password') {
      throw new Error('togglePassword requires a field to be password input');
    }
    var states = {
      show: {
        state: 'hide',
        text: hideText,
        a11yText: a11yHideText,
        type: 'text'
      },
      hide: {
        state: 'show',
        text: showText,
        a11yText: a11yShowText,
        type: 'password'
      }
    };
    var $togglePassword = appendToggler($container, $formField, actionClassName);
    updateToggler(states, $formField, $togglePassword, {
      templateData: {
        label: label
      }
    });
    $togglePassword.on("click.".concat(NS), function (e) {
      e.preventDefault();
      updateToggler(states, $formField, $togglePassword, {
        templateData: {
          label: label
        }
      });
    });
    return __WEBPACK_IMPORTED_MODULE_1_lodash_noop___default.a;
  };
};
/* harmony default export */ __webpack_exports__["a"] = (togglePassword);

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator_lib_isEmail__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_validator_lib_isEmail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_validator_lib_isEmail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_validator_lib_isFQDN__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_validator_lib_isFQDN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_validator_lib_isFQDN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for validating an email field with specific messaging based on
 * what is specifically incorrect with the field.
 * @module elements/fields/validate-email
 */





var NS = 'validate-email';
var invalidMessaging = {
  i18nKey: 'isInvalid',
  message: 'Email is invalid'
};
var validationPriorities = [
// When the preceived username is a domain, i.e. an @ symbol is forgotten
{
  condition: function condition(username) {
    return __WEBPACK_IMPORTED_MODULE_2_validator_lib_isFQDN___default()(username);
  },
  i18nKey: 'requiresDomain',
  message: 'Email address needs an @'
},
// When no domain has been provided or a user has only entered a username
Object.assign({}, invalidMessaging, {
  condition: function condition(username, domain) {
    return !domain;
  }
}),
// When no TLD has been provided, i.e. foo@foo
{
  condition: function condition(username, domain) {
    var _domain$split = domain.split('.'),
      _domain$split2 = _slicedToArray(_domain$split, 2),
      tld = _domain$split2[1];
    return !__WEBPACK_IMPORTED_MODULE_2_validator_lib_isFQDN___default()(domain) && !tld;
  },
  i18nKey: 'requiresTLD',
  message: 'Email address needs a top level domain'
},
// Catch all for all usecases that do not meet the above criteria
Object.assign({}, invalidMessaging, {
  condition: function condition(username, domain, email) {
    return !__WEBPACK_IMPORTED_MODULE_1_validator_lib_isEmail___default()(email);
  }
})];

/**
 * Responsible for making the source element either valid or invalid.
 * @param {jQuery} $el - Element with reference to target
 * @param {string} message - The error message
 */
var verifyError = function verifyError($el) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var source = $el[0];
  source.setCustomValidity(message);
  source.checkValidity();
  if (!message) {
    var evt = new CustomEvent('valid');
    source.dispatchEvent(evt);
  }
};

/**
 * Responsible for running through messages with the intention of returning
 * which type of validation has been found.
 * @param {jQuery} $el - Elements checked to be a valid email
 * @param {Object} options - Configurable options
 * @returns {string} Value used for setting custom validity
 */
var validateEmail = function validateEmail($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var email = $el.val();
  // Make sure we have a value just in case the field is not required. That
  // can be handled by another validator.
  if (!email) {
    return '';
  }
  var _Object$assign = Object.assign({}, {
      global: window
    }, options),
    global = _Object$assign.global;
  var _email$split = email.split('@'),
    _email$split2 = _slicedToArray(_email$split, 2),
    username = _email$split2[0],
    _email$split2$ = _email$split2[1],
    domain = _email$split2$ === void 0 ? '' : _email$split2$;
  var validation = __WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(validationPriorities, function (_ref) {
    var condition = _ref.condition;
    return condition(username, domain, email);
  });
  if (validation) {
    var i18nKey = validation.i18nKey,
      message = validation.message;
    return __WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(global, ['rcProps', 'emailValidation', i18nKey], message);
  }
  return '';
};

/**
 * Responsible for applying email validation with specific error messages
 * based on a succession of validations.
 * @param {HTMLElement} el - Element receiving email validation
 * @param {Object} options - Configurable options
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  $el.on("blur.".concat(NS), function () {
    var message = validateEmail($el, options);
    verifyError($el, message);
  });
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for validating a field so that it simulates a user interacting
 * with a field.
 * @module elements/fields/validate-field
 */



var VALIDATE_FIELDS_DEFAULTS = {
  val: null,
  retainFocus: true
};
function validateField(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _Object$assign = Object.assign({}, VALIDATE_FIELDS_DEFAULTS, options),
    val = _Object$assign.val,
    retainFocus = _Object$assign.retainFocus;
  var prevActiveElement = document.activeElement;
  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isNil___default()(val)) {
    $el.val(val);
  }
  $el.trigger('focus').trigger('blur');
  if (retainFocus) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(prevActiveElement).trigger('focus');
  }
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])('validate', validateField, {
  cache: false
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeValidateMissing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validator_constants__ = __webpack_require__(62);
/* unused harmony reexport DEFAULT_MESSAGE */







/**
 * Ensures that an element is not missing a value. This is different from a
 * required attribute as the validation occurs on submit by the validator
 * verses natively in the browser.
 *
 * @param {string} dataAttr - The data attribute receiving the missing
 * validation
 * @returns {Function} Runs through the validation
 */
var makeValidateMissing = function makeValidateMissing() {
  var dataAttr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'validateMissing';
  return function ($el) {
    var errorMessage = $el.data('errorMessage');
    var message = $el.data(dataAttr);
    var hasValue = !!$el.val();
    var type = $el.prop('type');
    if (type === 'radio') {
      var nameProp = $el.prop('name');
      var $inputs = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document.getElementsByName(nameProp));
      var validElements = $inputs.filter(function (_, input) {
        return __WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(input, 'validity.valid');
      });
      if (validElements.length !== $inputs.length) {
        return '';
      }
      var $checked = $inputs.filter(':checked');
      if ($checked.length) {
        return '';
      }
      hasValue = false;
      var validateSelector = "[data-".concat(__WEBPACK_IMPORTED_MODULE_2_lodash_kebabCase___default()(dataAttr), "]");
      var $customErrorMessages = $inputs.filter(validateSelector);
      if ($customErrorMessages.length) {
        message = $customErrorMessages.eq(0).data(dataAttr);
      }
      var $defaultErrorMessage = $inputs.filter('[data-error-message]');
      if ($defaultErrorMessage.length) {
        errorMessage = $defaultErrorMessage.eq(0).data('errorMessage');
      }
    }
    if (type === 'checkbox' && !$el.is(':checked')) {
      hasValue = false;
    }
    if (!hasValue) {
      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(message)) {
        return message;
      }
      return errorMessage || __WEBPACK_IMPORTED_MODULE_4__validator_constants__["a" /* DEFAULT_MESSAGE */];
    }
    return '';
  };
};

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateSameAs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validator_constants__ = __webpack_require__(62);
/* unused harmony reexport DEFAULT_MESSAGE */
/**
 * Responsible making sure a source element value matches to a target element
 * value.
 * @module elements/fields/validate-same-as
 */



var NS = 'validate-same-as';

/**
 * Responsible for making the source element either valid or invalid.
 * @param {jQuery} $source - Element with reference to target
 * @param {string} message - The error message
 */
var verifyError = function verifyError($source) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var source = $source[0];
  source.setCustomValidity(message);
  source.checkValidity();
  if (!message) {
    var evt = new CustomEvent('valid');
    source.dispatchEvent(evt);
  }
};

/**
 * Responsible for validating the source and target element values and determine
 * if an error has been found.
 * @param {jQuery} $source - Element with reference to target
 * @param {jQuery} $target - Target element
 * @returns {string} The error message
 */
var validateMatching = function validateMatching($source, $target) {
  var sourceValue = $source.val();
  var targetValue = $target.val();
  if (sourceValue !== targetValue) {
    return $source.data('errorMessage') || __WEBPACK_IMPORTED_MODULE_1__validator_constants__["a" /* DEFAULT_MESSAGE */];
  }
  return '';
};

/**
 * Responsible for matching the source value with the target value and makes
 * target element either valid or invalid.
 * @param {jQuery} $source - Element with reference to target
 * @param {jQuery} $target - Target element
 */
var matchesTarget = function matchesTarget($source, $target) {
  var message = validateMatching($source, $target);
  verifyError($source, message);
};

/**
 * Responsible for finding the target element.
 * @param {jQuery} $source - Element with reference to target
 * @returns {jQuery} The target element
 */
var getTarget = function getTarget($source) {
  var selector = $source.data('validateSameAs');
  var $form = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($source.prop('form'));
  var $target = $form.find(selector);
  if (!$target.length) {
    throw new Error("No matching selector ".concat(selector, " found for same as"));
  }
  return $target;
};

/**
 * Used for hooking into a validator data attribute.
 * @param {jQuery} $source - Element with reference to target
 * @returns {string} Error message if an error is found
 */
var validateSameAs = function validateSameAs($source) {
  var $target = getTarget($source);
  $target.on("blur.".concat(NS), function () {
    return matchesTarget($source, $target);
  });
  return validateMatching($source, $target);
};

/**
 * Responsible for finding a target element and ensuring that both fields have
 * the same values.
 * @param {HTMLElement} source - Element with reference to target
 * @returns {Object} Additional methods attached validate same as
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (source) {
  var $source = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(source);
  var $target = getTarget($source);
  validateSameAs($source);
  $source.on("blur.".concat(NS), function () {
    var message = validateMatching($source, $target);
    verifyError($source, message);
  });
  return {
    teardown: function teardown() {
      $source.off(".".concat(NS));
      $target.off(".".concat(NS));
    }
  };
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export ACTIVE_CLASS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Toggles the 'active' class modifier on favorite buttons when clicking
 * @module toggleFavorite
 */



var PLUGIN_NAME = 'toggleFavorite';
var ACTIVE_CLASS = 'favorite-button--active';

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleFavorite);

/**
 * Sets up click event toggle for favorite heart button.
 * @param {HTMLElement} el - Elements matching the selector (likely .favorite-button)
 */
function toggleFavorite() {
  var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  $el.on('click', function () {
    return toggleActive($el);
  });
}
;

// Toggle the active class
var toggleActive = function toggleActive($el) {
  $el.toggleClass(ACTIVE_CLASS);
};

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_easing__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_easing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_easing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_debounce__);



window.jQuery = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window.debounce = __WEBPACK_IMPORTED_MODULE_2_lodash_debounce___default.a;
__WEBPACK_IMPORTED_MODULE_0_jquery___default()('document').ready(function () {});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Toggle classes
 * @module abControls
 */




// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'abControls';

/**
 * Applies any sort of event handlers for the abControls.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var activeClass = 'ab-controls--active';
  $el.find('.js-ab-controls-btn').on('click', function () {
    if ($el.hasClass(activeClass)) {
      $el.removeClass(activeClass);
    } else {
      $el.addClass(activeClass);
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('mouseup.dropdown', function (e) {
    if (!$el.is(e.target) && $el.has(e.target).length === 0) {
      $el.removeClass(activeClass);
    }
  });
  $el.find('.js-ab-controls-close').on('click', function (e) {
    e.preventDefault();
    $el.removeClass('ab-controls--show');
    localStorage.setItem('abControls', 'false');
  });
  $el.find('.ab-controls-clickable').on('click', function (e) {
    var element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.target);
    var request = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: "/dbadmin/spring-controller/abtest/toggleABTestGroup",
      type: "POST",
      data: element.data('value')
    });
    request.done(function (msg) {
      window.location.reload(true);
    });
    request.fail(function (jqXHR, textStatus) {});
  });
};
/**
 * Initializes abControls.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function abControls(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: "/dbadmin/spring-controller/abtest/abtest-widget",
    type: "GET",
    data: {
      abtestids: $el.data('ids'),
      device: 'desktop'
    },
    success: function success(data) {
      $el.append(data);
      setEventListeners($el);
      if (localStorage.getItem('abControls') === 'false') {
        $el.removeClass('ab-controls--show');
      } else if (localStorage.getItem('abControls') === 'true' || localStorage.getItem('abControls') === null) {
        $el.addClass('ab-controls--show');
        localStorage.setItem('abControls', 'true');
      }
    }
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, abControls);

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__custom_video_player__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/**
 * Inline Video Module (formerly Floating Video)
 * @module floatingVideo
 */






// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'floatingVideo';
var DEFAULTS = {
  videoMuted: true,
  // Renders the mute/volume button (flag is inverted). Defaulted here so the
  // gallery gets it regardless of which init path runs — one caller invokes
  // .floatingVideo() with no options. [UX-20630]
  hideMute: true,
  $originalTrigger: null
};
var buildVideo = function buildVideo(videoUrl, videoPosterUrl, aspectRatio) {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("\n  <video class=\"u-full-width\" ".concat(aspectRatio ? "style=\"aspect-ratio:".concat(aspectRatio, ";\"") : '', " poster=\"").concat(videoPosterUrl, "\" playsinline=\"playsinline\" loop muted>\n    <source src=\"").concat(videoUrl, "\" type=\"video/mp4\">\n  </video>\n"));
};

/**
 * Replaces the trigger's thumbnail with an inline video and wires it up to
 * the custom video player. The video adopts the placeholder image's aspect
 * ratio so its height matches surrounding gallery image slides.
 * @param  {jQuery} $el - trigger element
 * @param  {Object} options - Any options provided upon initialization
 */
var renderInlineVideo = function renderInlineVideo($el, options) {
  var videoUrl = $el.data('videoUrl');
  var videoPosterUrl = $el.data('videoPosterUrl');
  var $thumbnail = $el.find('figure');
  var $img = $thumbnail.find('img');
  var aspectRatio;
  if ($img.length) {
    var w = $img.attr('width');
    var h = $img.attr('height');
    if (w && h) aspectRatio = "".concat(w, "/").concat(h);
  }
  var $video = buildVideo(videoUrl, videoPosterUrl, aspectRatio);
  if ($thumbnail.length) {
    $thumbnail.replaceWith($video);
  } else {
    $el.prepend($video);
  }
  $video.customVideoPlayer(options);
};

/**
 * Initializes floatingVideo
 * @param {HTMLElement} el - trigger element with data-video-url and data-video-poster-url
 * @param {Object} options - Options used for wiring up the video
 * @see DEFAULTS
 */
function floatingVideo(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  opts.$originalTrigger = $el;
  renderInlineVideo($el, opts);
  return {};
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, floatingVideo);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);

var SELECTORS = {
  FOLLOWED: {
    CONTAINER: '.cards--shops'
  },
  RECOMMENDED: {
    CONTAINER: '.recommended-shops'
  },
  HOT_LIST: {
    CONTAINER: '.hotlist-shops'
  }
};
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  // Execute only if at least one of the container elements exists
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.FOLLOWED.CONTAINER).length || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.RECOMMENDED.CONTAINER).length || __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.HOT_LIST.CONTAINER).length) {
    SELECTORS.RECOMMENDED.HEART_ICON = "".concat(SELECTORS.RECOMMENDED.CONTAINER, "__favorite");
    SELECTORS.RECOMMENDED.ACTIVE_CLASS = 'recommended-shops__favorite--active';
    SELECTORS.RECOMMENDED.CAROUSEL_CONTAINER = '.js-carousel-shops';
    SELECTORS.RECOMMENDED.SLICK_CONTAINER = '.slick-slider';
    SELECTORS.RECOMMENDED.SLICK_SLIDE = '.slick-slide';
    SELECTORS.FOLLOWED.CARD_CONTAINER = '.card--shops';
    SELECTORS.FOLLOWED.HEART_ICON = "".concat(SELECTORS.FOLLOWED.CARD_CONTAINER, "__header-icon");
    SELECTORS.HOT_LIST.HEART_ICON = "".concat(SELECTORS.HOT_LIST.CONTAINER, "__favorite");
    addFollowButtonListener();
    addUnfollowButtonListener();
    addHotlistHeartButtonListener();
  }
  function addFollowButtonListener() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.RECOMMENDED.CAROUSEL_CONTAINER).on('click', SELECTORS.RECOMMENDED.HEART_ICON, handleFollowButtonClick);
  }
  function addUnfollowButtonListener() {
    var $unfollowButtons = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.FOLLOWED.HEART_ICON);
    $unfollowButtons.each(function () {
      var $unfollowButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      $unfollowButton.on('click', handleUnfollowButtonClick);
    });
  }
  function handleFollowButtonClick() {
    var $followButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if (!$followButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
      $followButton.toggleClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS);
      $followButton.prop('disabled', true);
      var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        cplId: $followButton.data('cpl-id'),
        shopId: $followButton.data('shop-id'),
        brand: $followButton.data('brand'),
        isMens: $followButton.data('is-mens'),
        operation: window.rcProps.myShops.myShopAddOperation
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        url: window.rcProps.myShops.updateMyShopPath,
        type: 'post',
        data: data,
        success: function success(response) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
            open: "my-shop-add-confirm-modal",
            type: 'notification',
            triggerOpen: true,
            returnFocus: '',
            closeButton: false
          });
          var i = $followButton.closest(SELECTORS.RECOMMENDED.SLICK_SLIDE).data('slick-index');
          $followButton.closest(SELECTORS.RECOMMENDED.SLICK_CONTAINER).delay(800).slick('slickRemove', i).slick('refresh');
          location.reload();
        }
      });
    }
  }
  function handleUnfollowButtonClick() {
    var $unfollowButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    $unfollowButton.closest('li').delay(800).remove();
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      cplId: $unfollowButton.data('cpl-id'),
      shopId: $unfollowButton.data('shop-id'),
      brand: $unfollowButton.data('brand'),
      isMens: $unfollowButton.data('is-mens'),
      operation: window.rcProps.myShops.myShopRemoveOperation
    });
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: window.rcProps.myShops.updateMyShopPath,
      type: 'post',
      data: data,
      success: function success(response) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          open: "my-shop-remove-confirm-modal",
          type: 'notification',
          triggerOpen: true,
          returnFocus: '',
          closeButton: false
        });
        var totalShops = parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shops-size').text()) - 1;
        if (totalShops >= 0) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#shops-size').text(totalShops);
        }
        var url = new URL(window.location.href);
        var shopsOnPage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.FOLLOWED.CARD_CONTAINER).length;
        if (shopsOnPage < 1) {
          __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pagination__wrap').hide();
          var pageNo = url.searchParams.get('pageNum');
          if (pageNo) {
            pageNo = parseInt(pageNo) - 1;
            if (pageNo <= 1) {
              url.searchParams["delete"]('pageNum');
            } else {
              url.searchParams.set('pageNum', pageNo);
            }
          }
        }
        window.location.href = url.href;
      }
    });
  }
  function addHotlistHeartButtonListener() {
    var $heartButtons = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(SELECTORS.HOT_LIST.HEART_ICON);
    $heartButtons.each(function addUnfollow() {
      var $heartButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      $heartButton.on('click', handleHeartButtonClick);
    });
  }
  function handleHeartButtonClick() {
    var $heartButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if (!$heartButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
      addHearted($heartButton);
    } else {
      removeHearted($heartButton);
    }
  }
  function addHearted($followButton) {
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      cplId: $followButton.data('cpl-id'),
      shopId: $followButton.data('shop-id'),
      brand: $followButton.data('brand'),
      isMens: $followButton.data('is-mens'),
      operation: window.rcProps.myShops.myShopAddOperation
    });
    if ($followButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
      return;
    }
    $followButton.toggleClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: window.rcProps.myShops.updateMyShopPath,
      type: 'post',
      data: data,
      success: function success() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          open: "my-shop-add-confirm-modal",
          type: 'notification',
          triggerOpen: true,
          closeButton: false
        });
      }
    });
  }
  function removeHearted($unfollowButton) {
    var data = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
      cplId: $unfollowButton.data('cpl-id'),
      shopId: $unfollowButton.data('shop-id'),
      brand: $unfollowButton.data('brand'),
      isMens: $unfollowButton.data('is-mens'),
      operation: window.rcProps.myShops.myShopRemoveOperation
    });
    if (!$unfollowButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
      return;
    }
    $unfollowButton.toggleClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
      url: window.rcProps.myShops.updateMyShopPath,
      type: 'post',
      data: data,
      success: function success() {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
          open: "my-shop-remove-confirm-modal",
          type: 'notification',
          triggerOpen: true,
          closeButton: false
        });
      }
    });
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_EVENT */
/* unused harmony export AUTO_VALUE */
/* unused harmony export BLOCK_VALUE */
/* unused harmony export CHECKED_ATTR */
/* unused harmony export FORCE_OPEN_CLASS */
/* unused harmony export UNIFORM_SPEED_ATTR */
/* unused harmony export UNIFORM_SPEED_PX_PER_MS */
/* unused harmony export UNIFORM_SPEED_MIN */
/* unused harmony export UNIFORM_SPEED_MAX_DISTANCE */
/* unused harmony export UNIFORM_SPEED_DATA_KEY */
/* unused harmony export UNIFORM_SPEED_TALL_CLASS */
/* unused harmony export UNIFORM_SPEED_ROW_CLASS */
/* unused harmony export UNIFORM_SPEED_ROW_HEIGHT_PROP */
/* unused harmony export DEFAULTS */
/* unused harmony export cappedDistance */
/* unused harmony export computeSpeedFromHeight */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Responsible for creating an accordion based on elements existing in the DOM
 * @module modules/accordion
 */



var PLUGIN_NAME = 'accordion';
var CLICK_EVENT = 'click';
var AUTO_VALUE = 'auto';
var BLOCK_VALUE = 'block';
var CHECKED_ATTR = 'checked';
var FORCE_OPEN_CLASS = '.accordion__item--force-open';

// uniformSpeed: scale duration AND distance to content height so every section opens
// at the same perceived speed. Sections taller than UNIFORM_SPEED_MAX_DISTANCE (e.g.
// the ~15k px designer list) animate only up to the cap, then reveal the rest
// instantly below the fold — so they don't race.
// Hyphenated because it's interpolated into an attribute selector: a camelCased value
// would build [data-uniformSpeed], which does not match data-uniform-speed.
var UNIFORM_SPEED_ATTR = 'uniform-speed'; // data-uniform-speed opts one in
var UNIFORM_SPEED_PX_PER_MS = 1.3; // shared unfurl rate (pixels per millisecond)
var UNIFORM_SPEED_MIN = 200; // ms floor so tiny sections aren't jarringly instant
var UNIFORM_SPEED_MAX_DISTANCE = 900; // px cap on animated distance (~1 viewport)
var UNIFORM_SPEED_DATA_KEY = 'uniformSpeedDuration'; // per-item cached duration
// Set at init on items whose content exceeds the cap, so the stylesheet can skip
// layout and paint for their off-screen rows. @see measureForUniformSpeed
var UNIFORM_SPEED_TALL_CLASS = 'js-accordion-tall';
var UNIFORM_SPEED_ROW_CLASS = 'js-accordion-row'; // marks one repeated row
// Measured row height, published for the stylesheet's contain-intrinsic-size. Set on
// the item and inherited by its rows, so it's one write rather than one per row.
var UNIFORM_SPEED_ROW_HEIGHT_PROP = '--accordion-row-height';
var DEFAULTS = {
  accItem: '.accordion__item',
  accContent: '.accordion__content',
  accActive: 'accordion__item--active',
  accRadio: 'js-accordion-radio',
  accLabel: '.accordion__label',
  accSpeed: 500,
  accToggle: false,
  accDataToggleAttr: 'toggle',
  accQueryOpen: false,
  accDataQueryAttr: 'queryString',
  accScrollToView: false,
  // Default to true for backward compatibility
  accDataScrollAttr: 'scroll-to-view',
  // Data attribute name
  uniformSpeed: false,
  onComplete: function onComplete() {}
};

/**
 * Merges together all the options and the various conditions in which they
 * can be set.
 * @private
 * @param  {jQuery} $el - The container element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Object} Immutable version of the options
 */
var mergeOptions = function mergeOptions($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, DEFAULTS, options);
  var _opts = opts,
    accDataToggleAttr = _opts.accDataToggleAttr,
    accDataQueryAttr = _opts.accDataQueryAttr;
  if ($el.data(accDataToggleAttr) === true) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
      accToggle: true
    });
  }
  if ($el.data(accDataQueryAttr) === true) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
      accQueryOpen: true
    });
  }

  // Check for the scroll-to-view data attribute
  if ($el.data(opts.accDataScrollAttr) !== undefined) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
      accScrollToView: $el.data(opts.accDataScrollAttr)
    });
  }
  if ($el.data('acc-speed') !== undefined) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
      accSpeed: $el.data('acc-speed')
    });
  }
  if ($el.is("[data-".concat(UNIFORM_SPEED_ATTR, "]"))) {
    opts = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, opts, {
      uniformSpeed: true
    });
  }
  return opts;
};

/**
 * Caps how far a section animates so tall ones (e.g. the ~15k px designer list)
 * animate to the cap and reveal the rest on completion, instead of racing.
 * @param {number} height - Full content height in pixels
 * @return {number} Distance to animate, in pixels
 */
var cappedDistance = function cappedDistance(height) {
  return Math.min(height, UNIFORM_SPEED_MAX_DISTANCE);
};

/**
 * Converts a content height into a duration so every section opens at the same
 * perceived speed: distance capped first (see cappedDistance), then floored.
 * @param {number} height - Full content height in pixels
 * @return {number} Duration in ms
 */
var computeSpeedFromHeight = function computeSpeedFromHeight(height) {
  return Math.max(UNIFORM_SPEED_MIN, Math.round(cappedDistance(height) / UNIFORM_SPEED_PX_PER_MS));
};

/**
 * Resolves an item's animation duration: the cached per-item uniformSpeed value if
 * set, else the configured speed (an explicit accSpeed of 0 always wins, for the
 * query-string "open instantly" path).
 * @private
 * @param {jQuery} $item - The accordion item being animated
 * @param {Object} options
 * @param {number} options.accSpeed - Configured/overridden speed
 * @return {number} Duration in ms
 */
var resolveSpeed = function resolveSpeed($item, _ref) {
  var accSpeed = _ref.accSpeed;
  if (accSpeed === 0) {
    return 0;
  }
  var cached = $item.data(UNIFORM_SPEED_DATA_KEY);
  return cached === undefined ? accSpeed : cached;
};

/**
 * Caps very tall content to UNIFORM_SPEED_MAX_DISTANCE before collapsing so it closes
 * at the shared rate; the trimmed part is below the cap, so it isn't seen.
 * @private
 * @param {jQuery} $content - The content element(s) about to collapse
 */
var capCloseHeight = function capCloseHeight($content) {
  $content.get().forEach(function (el) {
    var $c = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    if ($c.outerHeight(true) > UNIFORM_SPEED_MAX_DISTANCE) {
      $c.css({
        height: UNIFORM_SPEED_MAX_DISTANCE
      });
    }
  });
};

/**
 * Handles any sort of defaults when the accordion is called upon.
 * @private
 * @param  {jQuery} $el - The container element
 * @param  {Object} options - Any options provided upon initialization
 * @param  {string} options.accActive - Selector representing the active
 * className
 * @param  {string} options.accContent - Selector representing the content for
 * the tab
 */
var applyDefaultsToActive = function applyDefaultsToActive($el, _ref2) {
  var accActive = _ref2.accActive,
    accContent = _ref2.accContent,
    accLabel = _ref2.accLabel;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(accActive), $el).find(accContent).css({
    display: BLOCK_VALUE,
    height: AUTO_VALUE
  }).find(accLabel).attr('aria-expanded', 'true');
};

/**
 * Handles any sort of defaults when the accordion is using radio buttons.
 * @private
 * @param  {jQuery} $el - The container element
 * @param  {Object} options - Any options provided upon initialization
 * @param  {string} options.accActive - Selector representing the active
 * className
 * @param  {string} options.accContent - Selector representing the content for
 * the tab
 * @param  {string} options.accItem - Selector representing the tab
 * @param  {string} options.accRadio - Selector representing a radio button
 */
var applyDefaultsToRadio = function applyDefaultsToRadio($el, _ref3) {
  var accActive = _ref3.accActive,
    accContent = _ref3.accContent,
    accItem = _ref3.accItem,
    accRadio = _ref3.accRadio;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(accRadio, ":").concat(CHECKED_ATTR), $el).parents(accItem).addClass(accActive).find(accContent).css({
    height: AUTO_VALUE
  });
};

/**
 * Closes the currently active tab.
 * @private
 * @param  {jQuery} $el - The container element
 * @param  {Object} opts - Any options provided upon initialization
 * @param  {string} opts.accLabel - Selector representing the label className
 * @param  {string} opts.accActive - Selector representing the active
 * className
 * @param  {string} opts.accContent - Selector representing the content for
 * the tab
 * @param  {string} opts.accItem - Selector representing the tab
 * @param  {boolean} opts.uniformSpeed - When true, caps very tall content before
 * collapsing so it closes at the shared rate (see capCloseHeight)
 * @see resolveSpeed for how the animation duration is determined
 */
var closeActiveTab = function closeActiveTab($el, opts) {
  var accLabel = opts.accLabel,
    accActive = opts.accActive,
    accContent = opts.accContent,
    accItem = opts.accItem;
  var $active = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(accActive), $el);
  var $content = $active.find(accContent);
  if (opts.uniformSpeed) {
    capCloseHeight($content);
  }
  $content.stop().animate({
    height: 0
  }, resolveSpeed($active, opts), function callback() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeAttr('style');
  });
  $el.find(accLabel).attr('aria-expanded', false);
  $el.find(accItem).removeClass(accActive);
};

/**
 * Opens a tab and provides any DOM manipulation and styles used to show a tab.
 * @private
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {jQuery} $parent - The parent of the interacted label
 * @param  {Object} opts - Any options provided upon initialization
 * @param  {string} opts.accLabel - Selector representing the label className
 * @param  {string} opts.accActive - Selector representing the active
 * className
 * @param  {string} opts.accContent - Selector representing the content for
 * the tab
 * @param  {string} opts.accRadio - Selector representing a radio button
 * @param  {boolean} opts.uniformSpeed - When true, animates at most
 * UNIFORM_SPEED_MAX_DISTANCE px, then reveals the remainder on completion (see
 * cappedDistance)
 * @param  {Function} opts.onComplete - Called when the animation has completed
 * @see resolveSpeed for how the animation duration is determined
 */
var openTab = function openTab($el, $parent, opts) {
  var accLabel = opts.accLabel,
    accActive = opts.accActive,
    accContent = opts.accContent,
    accRadio = opts.accRadio,
    onComplete = opts.onComplete;
  var content = $parent.find(accContent);
  content.css({
    height: AUTO_VALUE,
    display: BLOCK_VALUE
  });
  var contentHeight = content.outerHeight(true);
  // For very tall uniformSpeed sections, only animate up to the cap; the completion
  // callback below sets height:auto, revealing the remainder instantly.
  var target = opts.uniformSpeed ? cappedDistance(contentHeight) : contentHeight;
  content.css({
    height: 0
  }).stop().animate({
    height: target
  }, resolveSpeed($parent, opts), function () {
    content.css({
      height: AUTO_VALUE
    });
    // Only scroll if data-scroll-to-view="true" is explicitly added to the element
    // First check if the parent accordion element has it
    var elScrollOption = $el.data('scroll-to-view');
    // Then check if this specific accordion item has it
    var parentScrollOption = $parent.data('scroll-to-view');

    // Only scroll if explicitly set to true (not just present)
    var shouldScroll = elScrollOption === true || parentScrollOption === true;
    if (shouldScroll) {
      var headerOffset = $parent.offset().top;
      var fixedHeaderHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-header').outerHeight() || 0;
      var customOffset = parseInt($parent.data('scroll-offset') || $el.data('scroll-offset') || 0, 10);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').animate({
        scrollTop: headerOffset - fixedHeaderHeight - 30 - customOffset
      }, 300);
    }
    onComplete();
  });
  $parent.find(accLabel).attr('aria-expanded', true);
  $parent.addClass(accActive).children(accRadio).prop(CHECKED_ATTR, true);
};

/**
 * Closes an existing tab that has directly been interacted with.
 * @private
 * @param  {jQuery} $parent - The parent containing the entire tab.
 * @param  {Object} opts - Any options provided upon initialization
 * @param  {string} opts.accLabel - Selector representing the label className
 * @param  {string} opts.accActive - Selector representing the active
 * className
 * @param  {string} opts.accContent - Selector representing the content for
 * the tab
 * @param  {boolean} opts.uniformSpeed - When true, caps very tall content before
 * collapsing so it closes at the shared rate (see capCloseHeight)
 * @see resolveSpeed for how the animation duration is determined
 */
var closeExistingActiveTab = function closeExistingActiveTab($parent, opts) {
  var accLabel = opts.accLabel,
    accActive = opts.accActive,
    accContent = opts.accContent;
  var $content = $parent.find(accContent);
  if (opts.uniformSpeed) {
    capCloseHeight($content);
  }
  $content.stop().animate({
    height: 0
  }, resolveSpeed($parent, opts), function callback() {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeAttr('style');
    $parent.removeClass(accActive);
  });
  $parent.find(accLabel).attr('aria-expanded', false);
};

/**
 * At init, caches each item's height-proportional duration (read back on
 * open/close via resolveSpeed). Briefly forces each collapsed section visible to
 * measure it, then restores it synchronously so nothing flashes.
 *
 * Reuses that same measurement to flag sections taller than the animated distance
 * with UNIFORM_SPEED_TALL_CLASS, so the stylesheet only skips layout/paint for rows
 * in sections that actually have off-screen rows to skip. Also publishes a measured
 * row height for those sections, so the stylesheet's cold-start size estimate for
 * not-yet-rendered rows matches the real rows instead of a hardcoded guess.
 * @private
 * @param {jQuery} $el - The container element
 * @param {Object} options
 * @param {string} options.accItem - Selector for an accordion item
 * @param {string} options.accContent - Selector for an item's content
 */
var measureForUniformSpeed = function measureForUniformSpeed($el, _ref4) {
  var accItem = _ref4.accItem,
    accContent = _ref4.accContent;
  $el.find(accItem).get().forEach(function (item) {
    var $item = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(item);
    var content = $item.find(accContent).first();
    if (!content.length) {
      return;
    }

    // Preserve any inline styles, force the content measurable, then restore.
    var inline = {
      display: content[0].style.display,
      height: content[0].style.height
    };
    content.css({
      display: BLOCK_VALUE,
      height: AUTO_VALUE
    });
    var contentHeight = content.outerHeight(true);
    var isTall = contentHeight > UNIFORM_SPEED_MAX_DISTANCE;
    // Measure a real row while the content is still laid out. Only tall sections get
    // containment, so only they need the height. undefined when there are no rows.
    var rowHeight = isTall ? content.find(".".concat(UNIFORM_SPEED_ROW_CLASS)).first().outerHeight(true) : 0;
    content.css(inline);
    $item.data(UNIFORM_SPEED_DATA_KEY, computeSpeedFromHeight(contentHeight));
    // Both of these go on the item rather than the content: closing an item calls
    // removeAttr('style') on its content, which would wipe the custom property.
    // The item is still an ancestor of the rows, so it inherits down all the same.
    if (rowHeight) {
      $item.css(UNIFORM_SPEED_ROW_HEIGHT_PROP, "".concat(Math.round(rowHeight), "px"));
    }
    // Flagged after measuring, so the heights above come from a true full layout
    // rather than the intrinsic-size estimate containment would report.
    $item.toggleClass(UNIFORM_SPEED_TALL_CLASS, isTall);
  });
};

/**
 * Handles the click event when a label has been iteracted with.
 * @private
 * @param {jQuery.Event} evt - A jQuery event
 * @param {HTMLElement} currentTarget - The current target interacted with
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {Object} opts - Options passed along from initialization
 */
var itemClickHandler = function itemClickHandler(_ref5, $el, opts) {
  var currentTarget = _ref5.currentTarget;
  var accActive = opts.accActive,
    accItem = opts.accItem,
    accToggle = opts.accToggle;
  var $parent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(currentTarget).closest(accItem);
  if (!$parent.hasClass(accActive)) {
    if (!accToggle) {
      closeActiveTab($el, opts);
    }
    openTab($el, $parent, opts);
  } else {
    closeExistingActiveTab($parent, opts);
  }
};

/**
 * Add aria-labelledby to modal content for accessible
 * audible title that corresponds with modal's heading
 * @param  {jQuery} $el
 */

var addAccContentAria = function addAccContentAria($el) {
  var $accLabel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.find('.accordion__label'));
  if ($accLabel.length && !$accLabel.attr('id')) {
    var accContentTargetId = "accordion__content-".concat(Math.ceil(Math.random() * 10000000000));
    $accLabel.attr('id', accContentTargetId).attr('tabindex', '0');
  }
};

/**
 * Utility function to pull query parameter form URL
 * @private
 * @param {String} name - String to look for in URL
 */
var getParameterByName = function getParameterByName(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

/**
 * Applies any sort of event handlers for the accordion.
 * @private
 * @param {jQuery} $el - Containing the elements for the accordion
 * @param {Object} options - Options used for wiring up the accordion
 * @see DEFAULTS
 */
var applyEventHandlers = function applyEventHandlers($el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var accLabel = opts.accLabel,
    accItem = opts.accItem,
    accQueryOpen = opts.accQueryOpen,
    accRadio = opts.accRadio;
  // check if accordion has data attr set to true
  if (accQueryOpen) {
    // check for query string in URL
    var accordionOpen = getParameterByName('accordionOpen');
    if (accordionOpen) {
      // set parent for openTab
      var $parent = $el.find('#' + accordionOpen).closest(accItem);

      //  Set animation speed to 0 so default active tab closes as quick as possible.
      closeActiveTab($el, _objectSpread(_objectSpread({}, opts), {}, {
        accSpeed: 0
      }));
      openTab($el, $parent, _objectSpread(_objectSpread({}, opts), {}, {
        accSpeed: 0
      }));
    }
  }
  $el.on(CLICK_EVENT, "".concat(opts.accItem, ":not(").concat(FORCE_OPEN_CLASS, ") ").concat(opts.accLabel), function (evt) {
    return itemClickHandler(evt, $el, opts);
  });
  // Radio Accordion
  $el.find(".".concat(accRadio)).on(CLICK_EVENT, function (evt) {
    itemClickHandler(evt, $el, opts);
  });
};

/**
 * Initializes an accordion based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * accordion
 * @param {Object} options - Options used for wiring up the accordion
 * @see DEFAULTS
 */
function accordion(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = mergeOptions($el, options);
  if (opts.uniformSpeed) {
    measureForUniformSpeed($el, opts);
  }
  addAccContentAria($el);
  applyDefaultsToActive($el, opts);
  applyDefaultsToRadio($el, opts);
  applyEventHandlers($el, opts);
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, accordion);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Countdown days, hours, minutes and seconds
 * @module addToCalendar
 */





// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'addToCalendar';
var DEFAULTS = {
  icsServices: ['iCal', 'Outlook']
};
var formatTime = function formatTime(date) {
  var newDate = new Date(date);
  return newDate.toISOString().replace(/-|:|\.\d+/g, '');
};
var calculateEndTime = function calculateEndTime(startTime, endTime, opts) {
  var duration = opts.duration;
  var MS_IN_MINUTES = 60 * 1000;
  return endTime ? formatTime(endTime) : formatTime(new Date(startTime.getTime() + duration * MS_IN_MINUTES));
};
var googleGenerator = function googleGenerator(startTime, endTime, opts) {
  var title = opts.title,
    description = opts.description,
    address = opts.address;
  var formatedStartTime = formatTime(startTime);
  var calEndTime = calculateEndTime(startTime, endTime, opts);
  var href = encodeURI("https://www.google.com/calendar/render?action=TEMPLATE&text=".concat(title || '', "&dates=").concat(formatedStartTime || '', "/").concat(calEndTime || '', "&details=").concat(description || '', "&location=").concat(address || '', "&sprop=&sprop=name:"));
  return "<a class=\"action-button action-button--md action-button--full\" target=\"_blank\" href=\"".concat(href, "\">Google Calendar</a>");
};
var yahooGenerator = function yahooGenerator(startTime, endTime, opts) {
  var title = opts.title,
    description = opts.description,
    address = opts.address,
    duration = opts.duration;
  var formatedStartTime = formatTime(opts.start);
  var MS_IN_MINUTES = 60 * 1000;
  var eventDuration = endTime ? (endTime.getTime() - startTime.getTime()) / MS_IN_MINUTES : duration;

  // Yahoo dates are crazy, we need to convert the duration from minutes to hh:mm
  var hourDuration = eventDuration < 600 ? "0".concat(Math.floor(eventDuration / 60)) : "".concat(Math.floor(eventDuration / 60));
  var minuteDuration = eventDuration % 60 < 10 ? "0".concat(eventDuration % 60) : "".concat(eventDuration % 60);
  var formatedEventDuration = "".concat(hourDuration).concat(minuteDuration);
  var href = encodeURI("http://calendar.yahoo.com/?v=60&view=d&type=20&title=".concat(title || '', "&st=").concat(formatedStartTime, "&dur=").concat(formatedEventDuration || '', "&desc=").concat(description || '', "&in_loc=").concat(address || ''));
  return "<a class=\"action-button action-button--md action-button--full\" target=\"_blank\" href=\"".concat(href, "\">Yahoo! Calendar</a>");
};
var icsGenerator = function icsGenerator(startTime, endTime, opts) {
  var icsServices = opts.icsServices,
    url = opts.url,
    title = opts.title,
    description = opts.description,
    address = opts.address;
  var formatedStartTime = formatTime(startTime);
  var calcEndTime = calculateEndTime(startTime, endTime, opts);
  var icsButtons = icsServices.map(function (calendarName) {
    /* eslint-disable prefer-template */
    var href = encodeURI('data:text/calendar;charset=utf8,' + ['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', 'URL:' + url, 'DTSTART:' + (formatedStartTime || ''), 'DTEND:' + (calcEndTime || ''), 'SUMMARY:' + (title || ''), 'DESCRIPTION:' + (description || ''), 'LOCATION:' + (address || ''), 'END:VEVENT', 'END:VCALENDAR'].join('\n'));
    return "<a class=\"action-button action-button--md action-button--full\" target=\"_blank\"\n    href=\"".concat(href, "\">").concat(calendarName, " Calendar</a>");
  });
  return icsButtons;
};
var generateMarkup = function generateMarkup($el, startTime, endTime, opts) {
  var googleBtn = googleGenerator(startTime, endTime, opts);
  var yahooBtn = yahooGenerator(startTime, endTime, opts);
  var otherServicesBtn = icsGenerator(startTime, endTime, opts);
  $el.append(googleBtn, yahooBtn, otherServicesBtn);
};

/**
 * Initializes addToCalendar
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function addToCalendar(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var start = opts.start,
    end = opts.end;
  var startTime = new Date(start);
  var endTime = new Date(end);
  generateMarkup($el, startTime, endTime, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, addToCalendar);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export RESIZE_EVENT */
/* unused harmony export SLICK_TRACK */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slick_carousel__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__slick_carousel__);
/**
 * Responsive Layout Switcher
 * 
 * Toggles between a grid layout and carousel/slider layout based on screen width.
 * Uses a carousel for tablet devices and grid for desktop.
 *
 * @module breakpointLayoutSwitch
 */






// Constants for plugin configuration
var PLUGIN_NAME = 'breakpointLayoutSwitch';
var RESIZE_EVENT = 'resize';
var SLICK_TRACK = '.js-carousel__track';
var DEFAULTS = {
  switchBreakpoint: 900,
  // Width in pixels where the layout will switch
  slidesToShow: 10,
  // Number of slides visible at once in carousel mode
  slidesToScroll: 10,
  // Number of slides to scroll at once
  infinite: false,
  // Whether the carousel loops infinitely
  dotsClass: "carousel__dots",
  appendDots: ".js-carousel-dots"
};

/**
 * Initializes the Slick carousel for smaller screens
 * 
 * @param {jQuery} $el - The container element
 * @param {jQuery} $slickTrack - The element to be transformed into a carousel
 * @param {Object} opts - Configuration options
 */
var setUpSlick = function setUpSlick($el, $slickTrack, opts) {
  // Remove grid classes if they exist
  // $slickTrack.removeClass('g n-block-grid--5');

  // Extract options
  var slidesToShow = opts.slidesToShow,
    slidesToScroll = opts.slidesToScroll,
    infinite = opts.infinite,
    dotsClass = opts.dotsClass,
    appendDots = opts.appendDots;

  // Get navigation arrows
  var getPrev = $el.find(".js-carousel__prev");
  var getNext = $el.find('.js-carousel__next');

  // Initialize Slick carousel with options
  $slickTrack.slick({
    dots: true,
    customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
    dotsClass: dotsClass,
    appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(appendDots),
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    infinite: infinite,
    nextArrow: getNext,
    prevArrow: getPrev
  });
};

/**
 * Restores the grid layout for larger screens
 * 
 * @param {jQuery} $el - The container element
 * @param {jQuery} $slickTrack - The element to be transformed back to grid
 * @param {Object} opts - Configuration options
 */
var setUpGrid = function setUpGrid($el, $slickTrack, opts) {
  // Destroy Slick instance
  $slickTrack.slick('unslick');

  // Clean up DOM structure created by Slick
  var gridItems = $slickTrack.find('.js-layout-switch-item');
  gridItems.unwrap().unwrap();
  gridItems.attr('style', '');

  // Add grid classes
  // $slickTrack.addClass('g n-block-grid--5');
};

/**
 * Core function that decides which layout to use based on window width
 * 
 * @param {jQuery} $el - The container element
 * @param {jQuery} $window - jQuery window object
 * @param {Object} opts - Configuration options
 */
var breakpointLayoutSwitchFunc = function breakpointLayoutSwitchFunc($el, $window, opts) {
  var $slickTrack = $el.find(SLICK_TRACK);
  var switchBreakpoint = opts.switchBreakpoint;

  // Check if Slick is already initialized
  var slickIsInitialized = $slickTrack.hasClass('slick-initialized');

  // Check if window width is below the breakpoint
  var windowMatchesMediaQuery = window.matchMedia("(max-width: ".concat(switchBreakpoint - 1, "px)")).matches;

  // Switch to Slick if below breakpoint and not initialized
  if (windowMatchesMediaQuery && !slickIsInitialized) {
    setUpSlick($el, $slickTrack, opts);
  }
  // Switch to Grid if above breakpoint and Slick is initialized
  else if (!windowMatchesMediaQuery && slickIsInitialized) {
    setUpGrid($el, $slickTrack, opts);
  }
};

/**
 * Sets up window resize event listener
 * 
 * @param {jQuery} $el - The container element
 * @param {jQuery} $window - jQuery window object
 * @param {Object} opts - Configuration options
 */
var applyEventHandlers = function applyEventHandlers($el, $window) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  $window.on(RESIZE_EVENT, function () {
    breakpointLayoutSwitchFunc($el, $window, opts);
  });
};

/**
 * Main initialization function for the breakpointLayoutSwitch plugin
 * 
 * @param {HTMLElement} el - The container element
 * @param {Object} options - Custom configuration options
 * @returns {void}
 */
function breakpointLayoutSwitch(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  // Merge default options with custom options
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);

  // Initialize layout based on current window size
  breakpointLayoutSwitchFunc($el, $window, opts);

  // Set up resize listener to switch layouts when window size changes
  applyEventHandlers($el, $window, opts);
}

// Register as a jQuery plugin
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, breakpointLayoutSwitch);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export regExList */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Responsible for using the creditcard behavior within a floating label.
 * @module elements/fields/iconifyCreditCard
 */



var PLUGIN_NAME = 'ccMask';

var DEFAULTS = {};

/**
 * Contains the list of regex associated with creditcards
 * @type {Array}
 */
var regExList = [{
  name: 'visa',
  regex: '^4'
}, {
  name: 'amex',
  regex: '^(34|37)'
}, {
  name: 'master',
  regex: '^5[1-5]'
}, {
  name: 'jcb',
  regex: '^(352[89]|35[3-8][0-9])'
}, {
  name: 'discover',
  regex: '^(6011|65|64[4-9]|622(1(2[6-9]|[3-9])|[2-8]{2}|9([01]|2[0-5])))'
}];

/**
 * Shows the active credit card icon
 * @param {HTMLFormElement} formField - The form element in the floating label
 * @param {HTMLElement} container - The icon container
 * @param {Object} iconNodes - icons keyed by icon name with icon HTML element
 */
var getCardIcon = function getCardIcon($el, defaultCCTemplate, amexCCTemplate, initRegExpList, maskOptions) {
  var ccNumber = $el.val();
  var _initRegExpList$filte = initRegExpList.filter(function (_ref) {
      var regex = _ref.regex;
      return regex.test(ccNumber);
    }),
    _initRegExpList$filte2 = _slicedToArray(_initRegExpList$filte, 1),
    _initRegExpList$filte3 = _initRegExpList$filte2[0],
    _initRegExpList$filte4 = _initRegExpList$filte3 === void 0 ? {
      name: 'generic'
    } : _initRegExpList$filte3,
    activeCard = _initRegExpList$filte4.name;
  // const $activeCard = $(iconNodes[activeCard]);
  $el.mask(activeCard === 'amex' ? amexCCTemplate : defaultCCTemplate, maskOptions);
  // showCard($activeCard, container);
};
/**
 * Initialize credit cards' regex
 * @private
 * @returns {Array} - returns initialized regex array
 */
var initRegex = function initRegex() {
  return regExList.map(function (_ref2) {
    var name = _ref2.name,
      regex = _ref2.regex;
    return {
      name: name,
      regex: new RegExp(regex)
    };
  });
};
/**
 * Set Data Attributes for each credit card icons
 * @private
 * @param {HTMLFormElement} formField - The form element in the floating label
 * @param {HTMLElement} container - The icon container
 * @param {Object} iconNodes - icons keyed by icon name with icon HTML element
 */
var applyMask = function applyMask($el) {
  var defaultCCTemplate = '0000 0000 0000 0000';
  var amexCCTemplate = '0000 000000 00000';
  var initRegExpList = initRegex();
  var maskOptions = {
    onKeyPress: function onKeyPress() {
      getCardIcon($el, defaultCCTemplate, amexCCTemplate, initRegExpList, maskOptions);
    },
    'translation': {
      0: {
        pattern: /[0-9*]/
      }
    }
  };
  getCardIcon($el, defaultCCTemplate, amexCCTemplate, initRegExpList, maskOptions);
  $el.mask(defaultCCTemplate, maskOptions);
};

/**
 * Initializes an ccMask based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * ccMask
 * @param {Object} options - Options used for wiring up the ccMask
 * @see DEFAULTS
 */
function ccMask(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  applyMask($el);
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, ccMask);

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_EVENT */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
* Creates a counter
* @module copyToClipboard
*/



var PLUGIN_NAME = 'copyToClipboard';
var CLICK_EVENT = 'click';
var DEFAULTS = {
  container: '.js-copy-clipboard-wrapper',
  textToCopy: '.js-copy-clipboard-text',
  notify: 'false',
  activeClass: ''
};
var copyToClipboardFunc = function copyToClipboardFunc($el, opts) {
  var container = opts.container;
  var textContainer = opts.textToCopy;
  var textToCopy = $el.closest(container).find(textContainer).get(0);
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    var el = textToCopy.get(0);
    var editable = el.contentEditable;
    var readOnly = el.readOnly;
    el.contentEditable = true;
    el.readOnly = true;
    var range = document.createRange();
    range.selectNodeContents(el);
    var sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
    el.setSelectionRange(0, 999999);
    el.contentEditable = editable;
    el.readOnly = readOnly;
  } else {
    textToCopy.select();
  }
  document.execCommand('copy');
  textToCopy.blur();
};
var copyToClipboardNotification = function copyToClipboardNotification($el, opts) {
  var activeClass = opts.activeClass;
  if (opts.notify === true) {
    $el.addClass(activeClass);
    var removeActive = function removeActive() {
      $el.removeClass(activeClass);
    };
    setTimeout(removeActive, 3000);
  }
};
/**
* Applies any sort of event handlers for the count incrementation.
* @param {jQuery} $el - Containing the elements for the Counter
* @param {Object} options - Options used for wiring up the Counter
* @see DEFAULTS
*/
var applyEventHandlers = function applyEventHandlers($el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.on(CLICK_EVENT, function () {
    copyToClipboardFunc($el, opts);
    copyToClipboardNotification($el, opts);
  });
};
/**
* Initializes blank based on provided parameters.
* @param {HTMLElement} el - An element containing the elements for the
* Counter
* @param {Object} options - Options used for wiring up the Count
* @see DEFAULTS
*/
function copyToClipboard(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  applyEventHandlers($el, opts);
}
// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, copyToClipboard);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_HANDLER */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * counter on click
 * @module counter
 */



var PLUGIN_NAME = 'counters';
var CLICK_HANDLER = 'click';

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */

var $counter = 1;
var counterAddHandler = function counterAddHandler($el) {
  var $countAddTarget = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-counter-add');
  var $counterAdd = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.data('counter-add'));
  var $counterAriaLabel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#quantity-update');
  if (parseInt($counterAdd.text(), 5) <= 5) {
    $counter += 1;
    $counterAdd.text(function () {
      return $counter;
    });
    $counterAriaLabel.text("Quantity ".concat($counter));
    if (parseInt($counterAdd.text(), 10) === 5) {
      $counterAdd.text(function () {
        return $counter;
      });
      $countAddTarget.attr('disabled', true);
    }
  } else {
    $counterAdd.text(function () {
      return $counter;
    });
    $countAddTarget.attr('disabled', false);
  }
};
var counterSubHandler = function counterSubHandler($el) {
  var $countSubTarget = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-counter-sub');
  var $counterSub = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.data('counter-sub'));
  var $counterAriaLabel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#quantity-update');
  if (parseInt($counterSub.text(), 10) > 1) {
    $counter -= 1;
    $counterSub.text(function () {
      return $counter;
    });
    $counterAriaLabel.text("Quantity ".concat($counter));
    $el.removeAttr('disabled');
  }
  if (parseInt($counterSub.text(), 10) < 2) {
    $counterSub.text(function () {
      return $counter;
    });
    $countSubTarget.attr('disabled', true);
  } else {
    $counterSub.text(function () {
      return $counter;
    });
    $countSubTarget.attr('disabled', false);
  }
};
var setEventListeners = function setEventListeners($el, options) {
  $el.on(CLICK_HANDLER, function () {
    counterAddHandler($el, options);
    counterSubHandler($el, options);
  });
};

/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function counter(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  setEventListeners($el, options);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, counter);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Toggle classes
 * @module drawer
 */






// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'drawer';
var DEFAULTS = {
  drawerClass: '',
  drawerTarget: '',
  returnFocus: '',
  trapFocusFunc: __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].trapFocus.bind(__WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */]),
  releaseFocusFunc: __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].releaseFocus.bind(__WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */])
};

/**
 * Callback after css animation
 * @param {jQuery} $el - css animated element
 */
var afterAnimation = function afterAnimation($el, cb) {
  var animationDone = false;
  $el.on('transitionend', function (e) {
    if (e.propertyName === 'transform' && !animationDone) {
      animationDone = true;
      cb();
    }
  });
  setTimeout(function () {
    if (!animationDone) {
      animationDone = true;
      cb();
    }
  }, 350);
};
/**
 * Applies any sort of event handlers for the drawer.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.on('click', function (evt) {
    evt.preventDefault();
    var $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.attr('href'));
    // If a data-swap-target attribute was used instead of href
    if (options.drawerTarget !== '') {
      $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.drawerTarget);
    }
    $changingElClass.toggleClass(options.drawerClass);

    // Shift and trap focus to modal after animation
    afterAnimation($changingElClass, function () {
      options.trapFocusFunc($changingElClass);
      if ($changingElClass.find('.drawer__hed').length) {
        $changingElClass.find('.drawer__hed').children('.drawer__link').focus();
      }
      if (!options.returnFocus) {
        drawerLastFocus($el);
      }
      if (options.returnFocus) {
        options.releaseFocusFunc($el, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).data('lastFocus'));
      }
    });
  });
};
/**
 * Save last focus element that opened drawer
 * @param  {jQuery} $el - last focusable element
 */
var drawerLastFocus = function drawerLastFocus($el) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).data('lastFocus', $el);
};
/**
 * Initializes drawer.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function drawer(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, drawer);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles setting container to even width to prevent font pixelation in chrome/safari
 * @module dropdown enter
 */




// Expose the function as a jQuery plugin for ease of uses
var PLUGIN_NAME = 'dropdownEnter';
var DEFAULTS = {};
function dropdownOnEnter(evt) {
  var $dropdownLink = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);

  // Check if width has been previously set
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("setWidth") === true) {
    return;
  }
  var $dropdownMenus = $dropdownLink.find(".dropdown__menu");

  // Set a width for each dropdown menu in dropdown link
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.each($dropdownMenus, function (index, value) {
    var $dropdownMenu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var width = $dropdownMenu.width();
    if (width % 2 === 1) {
      width += 1;
      $dropdownMenu.width(width);
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data("setWidth", true);
  });
}
function setEventListeners($el, opts) {
  $el.on("mouseenter", dropdownOnEnter);
}

/**
 * Initializes dropdownEnter.
 * @param {HTMLElement} el - button /element that opens dropdown menu
 * @param {Object} options - Options used for wiring up the dropdownEnter
 * @see DEFAULTS
 */
function dropdownEnter(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, dropdownEnter);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DD_CLASS */
/* unused harmony export DD_MENU_CLASS */
/* unused harmony export DD_TRIGGER_CLASS */
/* unused harmony export DD_OPEN_STATE */
/* unused harmony export DD_DISABLED_STATE */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_merge_options__ = __webpack_require__(2);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Dropdown
 * Handles dropdown functions
 * Improved UX
 * Improved accessibility
 * @module dropdown
 */





var PLUGIN_NAME = 'dropdown';
var DD_CLASS = '.js-dropdown';
var DD_MENU_CLASS = '.js-dropdown__menu';
var DD_TRIGGER_CLASS = '.js-dropdown__trigger';
var DD_OPEN_STATE = 'dd-is-open';
var DD_DISABLED_STATE = 'is-disabled';
var DEFAULTS = {
  animationSpeed: 0,
  wait: 100,
  returnFocus: null,
  offsetContent: false,
  // Grace period before a dropdown closes after the pointer leaves it.
  // Overridable per instance, including via a `data-close-delay` attribute.
  closeDelay: 150
};

var makeConditionalDebounce = function makeConditionalDebounce(fn, wait, shouldSkip) {
  var debounced = __WEBPACK_IMPORTED_MODULE_4_lodash_debounce___default()(fn, wait);
  var wrapper = function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (shouldSkip()) {
      debounced.cancel();
      return fn.apply(this, args);
    }
    return debounced.apply(this, args);
  };
  wrapper.cancel = debounced.cancel.bind(debounced);
  wrapper.flush = (debounced.flush || function () {}).bind(debounced);
  return wrapper;
};

/**
 * Set Open State
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 */
var setOpenState = function setOpenState($el, $ddTrigger, $ddMenu) {
  $el.addClass(DD_OPEN_STATE);
  $ddTrigger.addClass(DD_OPEN_STATE);
  $ddMenu.addClass(DD_OPEN_STATE);
  $el.trigger('dropdown.open');
};
/**
 * Remove Open State
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 */
var removeOpenState = function removeOpenState($el, $ddTrigger, $ddMenu) {
  $el.removeClass(DD_OPEN_STATE);
  $ddTrigger.removeClass(DD_OPEN_STATE);
  $ddMenu.removeClass(DD_OPEN_STATE);
};
/**
 * Set Aria Expanded
 * @param  {jQuery} $el - dropdown trigger element
 * @param  {boolean} $ddMenu - dropdown content element
 */
var ariaExpanded = function ariaExpanded($el, bool) {
  $el.attr('aria-expanded', bool);
};
/**
 * Release Trap Focus
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $returnFocus - returnFocus
 */
var releaseTrapFocus = function releaseTrapFocus($el, $returnFocus) {
  if ($el.hasClass('trapped')) {
    $el.removeClass('trapped');
    if ($returnFocus) {
      __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].releaseFocus($el, $returnFocus);
    } else {
      __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].releaseFocus($el);
    }
  }
};
/**
 * Close Dropdown
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var closeDropdown = function closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts) {
  /* This setTimeout is use for IE 11 focus issue. This is allows focus flow
   * to happen naturally. It seems like without the setTimeout the focus order
   * gets thrown off.
   */
  setTimeout(function () {
    // Cancel the trailing debounced invocation.
    openDebounce.cancel();
    removeOpenState($el, $ddTrigger, $ddMenu);
    $ddMenu.stop().animate({
      opacity: 0
    }, opts.animationSpeed / 2, function () {
      ariaExpanded($ddTrigger, false);
      $ddMenu.css('display', 'none');
    });
  }, 1);
};
/**
 * Focus on dropdown trigger
 * @param  {jQuery} $el - dropdown wrap
 */
var focusOnTrigger = function focusOnTrigger($el) {
  $el.find(DD_TRIGGER_CLASS).first().focus();
};
/**
 * Top Level Menu Items Handler
 * @param  {event} evt - key event
 * @param  {boolean} isTrigger - if element is a trigger
 * @param  {jQuery} $targetMenu - targeted dropdown
 * @param  {jQuery} $siblingsMenu - Siblings Menu
 * @param  {string} direction - prev or next
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var topLevelMenuItemHandler = function topLevelMenuItemHandler(evt, $targetMenu, $siblingsMenu, direction, $el, $ddTrigger, $ddMenu, openDebounce, opts) {
  var $newTargetMenu = $targetMenu;
  if (!$targetMenu.length) {
    if (direction == 'next') {
      $newTargetMenu = $siblingsMenu.first();
    } else {
      $newTargetMenu = $siblingsMenu.last();
    }
  }
  closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
  focusOnTrigger($newTargetMenu);
};
/**
 * Arrow Handler
 * @param  {event} evt - key event
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {jQuery} $focusable - dropdown focusable elements
 * @param  {jQuery} $firstFocusable - first focusable element
 * @param  {string} direction - prev or next
 */
var arrowHandler = function arrowHandler(evt, $el, $ddTrigger, $ddMenu, openDebounce, opts, $focusable, $firstFocusable, direction) {
  if (isNav) {
    evt.preventDefault();
    evt.stopPropagation();
  }
  var $siblingsMenu = $el.siblings(DD_CLASS);
  var isNav = $siblingsMenu.length > 1;
  var $currentEl = $el.find(':focus');
  var isTrigger = $currentEl.hasClass(DD_TRIGGER_CLASS.replace('.', ''));
  var isArrowRight = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'ARROWRIGHT';
  var isArrowDown = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'ARROWDOWN';
  var isArrowLeft = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'ARROWLEFT';
  var focusList = _toConsumableArray($focusable);
  var currentIndex = focusList.indexOf($currentEl[0]);
  var targetIndex = direction == "next" ? currentIndex + 1 : currentIndex - 1;
  var $targetFocusableEl = focusList[targetIndex];
  var $targetMenu = direction == "next" ? $el.next(DD_CLASS) : $el.prev(DD_CLASS);
  var isTargetMenu = $targetMenu.length;
  var noTargetMenuAndItem = !$targetMenu.length && !$targetFocusableEl;
  if (isNav) {
    if (isTrigger) {
      if (isArrowRight || isArrowLeft) {
        topLevelMenuItemHandler(evt, $targetMenu, $siblingsMenu, direction, $el, $ddTrigger, $ddMenu, openDebounce, opts);
      }
    }
    if ($targetFocusableEl) {
      if (!isTrigger || isArrowDown) {
        $targetFocusableEl.focus();
      }
    }
    if (!isTrigger && !$targetFocusableEl) {
      closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
      if (isTargetMenu) {
        focusOnTrigger($targetMenu);
      }
      if (noTargetMenuAndItem) {
        focusOnTrigger($siblingsMenu.first());
      }
    }
  }
};
/**
 * Keydown Handler
 * @param  {event} evt - key event
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var keydownHandler = function keydownHandler(evt, $el, $ddTrigger, $ddMenu, openDebounce, opts) {
  var $focusable = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].findFocusable($el);
  var $firstFocusable = $focusable.eq(0);
  var $lastFocusable = $focusable.eq(-1);
  var isTab = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'TAB';
  var isShiftTab = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'SHIFT_TAB';
  var isEnter = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'ENTER';
  var isSpace = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'SPACE';
  var isClick = evt.type === "click";
  var isEscape = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].keys.ESCAPE;
  var isNextArrows = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'ARROWRIGHT' || __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'ARROWDOWN';
  var isPrevArrows = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'ARROWLEFT' || __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'ARROWUP';
  var isFirstItem = evt.target === $firstFocusable[0];
  var isLastItem = evt.target === $lastFocusable[0];
  var $returnFocus = $el.data('returnFocus');

  // prevent default for enter and space when trigger element is focused
  if ((isEnter || isSpace) && evt.target === $ddTrigger[0]) {
    evt.preventDefault();
  }
  if (isEscape) {
    evt.stopPropagation();
    // Close current dropdown
    closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
    if ($el.hasClass('trapped')) {
      releaseTrapFocus($el, $returnFocus);
    } else {
      focusOnTrigger($el);
    }
    // Close new dropdown because of new focus
    closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
  }
  if ((isEnter || isClick || isSpace) && evt.target === $ddTrigger[0]) {
    if ($el.hasClass('dropdown') && !$el.hasClass('dd-is-open')) {
      openDebounceHandler($el, $ddTrigger, $ddMenu, opts);
    } else if ($el.hasClass('dropdown') && $el.hasClass('dd-is-open')) {
      closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
    }
    //use case for when enter key is used for popover
    if ($el.hasClass('popover') && !$el.hasClass('dd-is-open')) {
      openDebounceHandler($el, $ddTrigger, $ddMenu, opts);
    } else if ($el.hasClass('popover') && $el.hasClass('dd-is-open')) {
      closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
    }
  }
  if (!$el.hasClass('trapped')) {
    if (isLastItem && isTab || isFirstItem && isShiftTab) {
      closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
    }
  }
  if (isNextArrows) {
    arrowHandler(evt, $el, $ddTrigger, $ddMenu, openDebounce, opts, $focusable, $firstFocusable, 'next');
  }
  if (isPrevArrows) {
    arrowHandler(evt, $el, $ddTrigger, $ddMenu, openDebounce, opts, $focusable, $firstFocusable, 'prev');
  }
};
/**
 * Open Dropdown
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var openDropdown = function openDropdown($el, $ddTrigger, $ddMenu, opts) {
  if ($ddMenu.hasClass(DD_OPEN_STATE)) {
    return;
  }
  lazyLoadContent($el);
  setOpenState($el, $ddTrigger, $ddMenu);
  $ddMenu.css({
    display: 'block',
    opacity: 1
  });
  ariaExpanded($ddTrigger, true);
};

/**
 * Lazy Load Content within Dropdown
 * @param  {jQuery} $el - dropdown wrap
 */
var lazyLoadContent = function lazyLoadContent($el) {
  if ($el.data('lazy-load')) {
    var $lazyImages = $el.find('img[data-lazy]');
    $lazyImages.each(function lazyImages() {
      var $lazyImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      var imageSource = $lazyImage.attr('src');
      var dataSource = $lazyImage.data('lazy');
      var srcset = $lazyImage.data('srcset');
      if (imageSource !== dataSource) {
        $lazyImage.attr('src', dataSource);
      }
      if (srcset) {
        $lazyImage.attr('srcset', srcset);
      }
    });
  }
};
/**
 * Open Dropdown Handler
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var openDebounceHandler = function openDebounceHandler($el, $ddTrigger, $ddMenu, opts) {
  if (!$el.hasClass(DD_DISABLED_STATE)) {
    openDropdown($el, $ddTrigger, $ddMenu, opts);
  }
};
/**
 * Set Aria Controls
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 */
var setAriaControls = function setAriaControls($ddTrigger, $ddMenu) {
  if ($ddMenu.length) {
    var ddMenuID = $ddMenu.attr('id');
    if (_typeof(ddMenuID) !== ( true ? "undefined" : _typeof(undefined)) && ddMenuID !== false) {
      $ddTrigger.attr('aria-controls', ddMenuID);
    } else {
      var randomNum = Math.ceil(Math.random() * 10000000000);
      var newMenuID = "dd-menu-".concat(randomNum);
      $ddTrigger.attr('aria-controls', newMenuID);
      $ddMenu.attr('id', newMenuID);
    }
  }
};
/**
 * Set Aria
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 */
var setA11y = function setA11y($el, $ddTrigger, $ddMenu) {
  // If dropdown is an anchor add role="button" attribute
  if ($ddTrigger.closest('a').length) {
    $ddTrigger.attr('role', 'button');
  }
  ariaExpanded($ddTrigger, false);
  setAriaControls($ddTrigger, $ddMenu);
};
/**
 * Set Aria
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 */
var offsetContent = function offsetContent($el, $ddMenu) {
  var menuWidth = $ddMenu.outerWidth();
  var btnOffset = $el.offset().left;
  var windowWidth = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).width();
  if (menuWidth + btnOffset > windowWidth) {
    $ddMenu.css({
      right: 0,
      left: 'auto'
    });
  } else if (menuWidth > btnOffset) {
    $ddMenu.css({
      left: 0,
      right: 'auto'
    });
  }
};
/**
 * Prevent Hash
 * @param  {event} interaction event
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 */
var preventHash = function preventHash(evt, $ddTrigger) {
  if (__WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'ENTER' || evt.type == 'click') {
    if ($ddTrigger.attr('href') == "#") {
      evt.preventDefault();
    }
  }
};
/**
 * Set Event Listeners
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var closeDropdownOutside = function closeDropdownOutside($el, $ddTrigger, $ddMenu, openDebounce, opts, evt) {
  if (!$el.is(evt.target) && $el.has(evt.target).length === 0) {
    releaseTrapFocus($el);
    closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
  }
};
/**
 * Set Close Timeout
 * Some users accidentally leaves dropdown when entering the dropdown content.
 * This set timeout allows buffer time for user to reenter the dropdown
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setCloseTimeout = function setCloseTimeout($el, $ddTrigger, $ddMenu, openDebounce, opts) {
  openDebounce.cancel();
  $el.data('close-timeout', setTimeout(function () {
    closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
  }, opts.closeDelay));
};
/**
 * Clear set timeout for closing the dropdown
 * @param  {jQuery} $el - dropdown wrap
 */
var clearCloseTimeout = function clearCloseTimeout($el) {
  clearTimeout($el.data('close-timeout'));
};
/**
 * Set Event Listeners
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {lodash} openDebounce - debounce for opening dropdown
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, $ddTrigger, $ddMenu, openDebounce, opts) {
  $el.on('mousemove.dropdown', openDebounce).on('mouseleave.dropdown', function () {
    return setCloseTimeout($el, $ddTrigger, $ddMenu, openDebounce, opts);
  }).on('mouseenter.dropdown', function () {
    return clearCloseTimeout($el);
  }).on('keydown.dropdown', function (evt) {
    keydownHandler(evt, $el, $ddTrigger, $ddMenu, openDebounce, opts);
  }).on('click.dropdown', '.js-dropdown-close', function (evt) {
    closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
    focusOnTrigger($el);
    closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
  });
  $ddTrigger.on('click.dropdown', function (evt) {
    var isVoiceOverClick = evt.offsetX === 0 && evt.offsetY === 0 && evt.detail === 1;
    var isAnchor = evt.target.tagName === 'A';
    if (isAnchor) {
      // VoiceOver "click" on anchor, so prevent navigation to another page but handle dropdown
      if (isVoiceOverClick) {
        evt.preventDefault();
      }
      preventHash(evt, $ddTrigger);
    }
    keydownHandler(evt, $el, $ddTrigger, $ddMenu, openDebounce, opts);
  }).on('keydown.dropdown', function (evt) {
    return preventHash(evt, $ddTrigger);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('mouseup.dropdown', function (evt) {
    closeDropdownOutside($el, $ddTrigger, $ddMenu, openDebounce, opts, evt);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('touchstart.dropdown', function (evt) {
    closeDropdownOutside($el, $ddTrigger, $ddMenu, openDebounce, opts, evt);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('resize', __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function () {
    offsetContent($el, $ddMenu);
  }, 300));
};
/**
 * Open and Trap another dropdown
 * @param  {jQuery} $el - dropdown wrap
 * @param  {jQuery} $ddTrigger - dropdown trigger element
 * @param  {jQuery} $ddMenu - dropdown content element
 * @param  {jQuery} $returnFocus - return focus
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var _openAndTrap = function openAndTrap($el, $ddTrigger, $ddMenu, $returnFocus, opts) {
  openDebounceHandler($el, $ddTrigger, $ddMenu, opts);
  __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].trapFocus($ddMenu);
  $el.addClass('trapped').data('returnFocus', $returnFocus);
  var headingFocus = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($ddMenu.find('h2:visible').first());
  if (headingFocus) {
    headingFocus.focus();
  } else {
    $ddTrigger.focus();
  }
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - dropdown wrap
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function dropdown(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $ddMenu = $el.find(DD_MENU_CLASS).first();
  var $ddTrigger = $el.find(DD_TRIGGER_CLASS);
  var openDebounce = makeConditionalDebounce(function () {
    return openDebounceHandler($el, $ddTrigger, $ddMenu, opts);
  }, opts.wait,
  // condition: skip debounce if ANY dropdown is open
  function () {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-dropdown.dd-is-open').length > 0;
  });
  setA11y($el, $ddTrigger, $ddMenu);
  if (opts.offsetContent) {
    offsetContent($el, $ddMenu);
  }
  setEventListeners($el, $ddTrigger, $ddMenu, openDebounce, opts);
  return {
    open: function open() {
      return openDebounceHandler($el, $ddTrigger, $ddMenu, opts);
    },
    openAndTrap: function openAndTrap($returnFocus) {
      return _openAndTrap($el, $ddTrigger, $ddMenu, $returnFocus, opts);
    },
    close: function close() {
      return closeDropdown($el, $ddTrigger, $ddMenu, openDebounce, opts);
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, dropdown);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_mask_plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options_js__ = __webpack_require__(2);
/**
 * Handles all focus to anchor
 * @module enabledButton to
 */






// Expose the function as a jQuery plugin for ease of uses
var PLUGIN_NAME = 'enabledButton';
var DEFAULTS = {
  ebRequiredInputs: '',
  ebAtLeastOne: false
};

/**
 * Check if any inputs has a value
 * @param  {jQuery} $el - the disabled button
 * @param  {Array} inputArrays - array of inputs
 */
var atLeastOne = function atLeastOne($el, inputArrays) {
  var hasValue = false;
  inputArrays.forEach(function (el) {
    if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).val() && !hasValue) {
      hasValue = true;
    }
  });
  if (hasValue) {
    $el.prop('disabled', false);
  } else {
    $el.prop('disabled', true);
  }
};
/**
 * Check if any inputs has a value
 * @param  {jQuery} $el - the disabled button
 * @param  {regex} pattern - regex pattern
 * * @param  {val} string - input value
 */
var validatePattern = function validatePattern($el, pattern, val) {
  var re = new RegExp(pattern);
  if (re.test(val)) {
    $el.prop('disabled', false);
  } else {
    $el.prop('disabled', true);
  }
};

/**
 * Add Event Listeners to inputs
 * can be set.
 * @param  {jQuery} $el - button /element that opens modal
 * @param  {Object} opts - Any options provided upon initialization
 */
var addEventListerners = function addEventListerners($el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ebRequiredInputs = opts.ebRequiredInputs,
    ebAtLeastOne = opts.ebAtLeastOne;
  var inputArrays = ebRequiredInputs.split(',');
  inputArrays.forEach(function (el) {
    var $input = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
    var pattern = $input.attr('pattern');
    $input.on('keyup', function () {
      if (ebAtLeastOne) {
        atLeastOne($el, inputArrays);
      } else if (pattern) {
        validatePattern($el, pattern, $input.val());
      }
    });
  });
};

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @see DEFAULTS
 */
function enabledButton(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options_js__["a" /* default */])(DEFAULTS, options, $el);
  addEventListerners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, enabledButton);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles all radios and checkboxes to be togglable with enter key
 * @module enterable
 */





// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'enterable';
var DEFAULTS = {};

/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.on('keydown.enterable', function (evt) {
    if (__WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].keys.ENTER) {
      $el.trigger('click');
    }
  });
};
/**
 * Initializes enterable.
 * @param {HTMLElement} el - button /element that opens enterable
 * @param {Object} options - Options used for wiring up the enterable
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function enterable(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 ? arguments[2] : undefined,
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, enterable);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_throttle__);


// Pins the "filtered by" bar to the top of the viewport on PLPs that render the
// multi-select left nav, and lets the filter row be dragged horizontally.
$(document).ready(function () {
  var $targetElement = $('.js-filters-by-sticky');
  var hasClass = false; // Track if class is already added/removed

  if ($targetElement.length === 0) return;

  // Get the initial position of the target element from the top of the document
  var elementOffsetTop = $targetElement.offset().top;

  // Create a throttled scroll handler using Lodash
  // The function will execute at most once every 100ms
  var handleScroll = __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default()(function () {
    var scrollY = window.scrollY;

    // Add fixed class when the top of the element reaches the top of the viewport
    if (scrollY >= elementOffsetTop && !hasClass) {
      $targetElement.addClass('fixed');
      hasClass = true;
    } else if (scrollY < elementOffsetTop && hasClass) {
      $targetElement.removeClass('fixed');
      hasClass = false;
    }
  }, 100);

  // Attach the throttled handler to scroll event
  $(window).on('scroll', handleScroll);

  // Initial check on page load
  if (window.scrollY >= elementOffsetTop) {
    $targetElement.addClass('fixed');
    hasClass = true;
  }

  // Add mouse drag scrolling functionality to the horizontal scroll container
  $('.js-filters-by-sticky').on('filtersReady', function () {
    var $container = $(this).find('.horizontal-scroll');
    var mouseIsDown = false;
    var startMouseX;
    var currentMouseX;
    var startScrollLeft;
    var dragThreshold = 2; // pixels to consider it a drag vs click

    $container.css('cursor', 'grab');
    $container.on('mousedown', function (e) {
      mouseIsDown = true;
      $container.css('cursor', 'grabbing');
      startMouseX = e.pageX;
      currentMouseX = startMouseX;
      startScrollLeft = $container.scrollLeft();
      e.preventDefault();
    });

    // Use document-level mouseup/mousemove so fast drags that leave the
    // container boundary don't leave mouseIsDown stuck as true
    $(document).on('mouseup.horizontalDrag', function () {
      if (!mouseIsDown) return;
      mouseIsDown = false;
      $container.css('cursor', 'grab');

      // Consider it a drag if the container scrolled OR the mouse moved —
      // the latter covers the case where the container is at the scroll boundary
      var scrollDelta = Math.abs($container.scrollLeft() - startScrollLeft);
      var mouseDelta = Math.abs(currentMouseX - startMouseX);
      if (scrollDelta > dragThreshold || mouseDelta > dragThreshold) {
        // Use capture phase so this fires before the button's click handler,
        // preventing the filter from being removed after a drag
        $container[0].addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
        }, {
          capture: true,
          once: true
        });
      }
    });
    $(document).on('mousemove.horizontalDrag', function (e) {
      if (!mouseIsDown) return;
      e.preventDefault();
      currentMouseX = e.pageX;
      var walk = (currentMouseX - startMouseX) * 2;
      $container.scrollLeft(startScrollLeft - walk);
    });
  });
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);




/**
 * Calculates the scroll y position of the threshold element.
 * @param {jQuery} $window - Window in the environment
 * @param {jQuery} $document - Document in the environment
 * @param {jQuery} $threshold - Threshold element
 * @returns {number} Scroll y position of the threshold element
 */
var getScrollYPosition = function getScrollYPosition($window, $document, $threshold) {
  var docHeight = $document.height();
  var windowHeight = $window.height();
  var exceedingHeight = $threshold.outerHeight(true);
  return docHeight - exceedingHeight - windowHeight;
};

/**
 * Adds click handler to close NTF
 * @returns {void}
 */
var toast = function toast() {
  var toast = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fixed-toast');
  var close = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.fixed-toast--close');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(close).on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(toast).hide();
  });
};

/**
 * Applies class to element whenever it hits a threshold.
 * @param {HTMLElement} - Element receiving class when threshold is hit
 * @param {Object} [options={}]
 * @param {Object} [options.window=window] - Window in the environment
 * @param {HTMLElement} [options.document=document] - Document in the environment
 * @param {string} [options.blockName='fixed-corner'] - Block name in BEM
 * scheme for instance
 * @param {string} [options.offModifier='off'] - Modifier when threshold is hit
 * @param {string} [options.controlModifier='center'] - Modifier denoting no
 * functionality should be applied
 * @param {string} [options.thresholdSelector='.site-footer'] - Selector used to
 * denote when the class should be applied
 * @param {number} [options.wait=100] - Time which throttle should be applied to
 * scroll/resize event
 */
function fixedCorner(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _Object$assign = Object.assign({}, options, $el.data()),
    _Object$assign$window = _Object$assign.window,
    win = _Object$assign$window === void 0 ? window : _Object$assign$window,
    _Object$assign$docume = _Object$assign.document,
    doc = _Object$assign$docume === void 0 ? document : _Object$assign$docume,
    _Object$assign$blockN = _Object$assign.blockName,
    blockName = _Object$assign$blockN === void 0 ? 'fixed-corner' : _Object$assign$blockN,
    _Object$assign$offMod = _Object$assign.offModifier,
    offModifier = _Object$assign$offMod === void 0 ? 'off' : _Object$assign$offMod,
    _Object$assign$contro = _Object$assign.controlModifier,
    controlModifier = _Object$assign$contro === void 0 ? 'center' : _Object$assign$contro,
    _Object$assign$thresh = _Object$assign.thresholdSelector,
    thresholdSelector = _Object$assign$thresh === void 0 ? '.site-footer' : _Object$assign$thresh,
    _Object$assign$wait = _Object$assign.wait,
    wait = _Object$assign$wait === void 0 ? 100 : _Object$assign$wait;
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(win);
  var $document = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(doc);
  var offClassName = "".concat(blockName, "--").concat(offModifier);
  var controlClassName = "".concat(blockName, "--").concat(controlModifier);
  var $threshold = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(thresholdSelector);
  $window.on('scroll resize', __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function () {
    var thresholdScrollYPosition = getScrollYPosition($window, $document, $threshold);
    if ($el.hasClass(controlClassName)) {
      return;
    }
    var scrollYPosition = $window.scrollTop();
    if (scrollYPosition >= thresholdScrollYPosition) {
      return $el.addClass(offClassName);
    }
    return $el.removeClass(offClassName);
  }, wait));
}
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  toast();
});
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])('fixedCorner', fixedCorner);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_breaky__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_breaky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_breaky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_throttle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_throttle__);
/**
 * Fixed Header is problematic for accessibility.
 * Unfixed header if...
 * user tabs
 * font size is zoomed
 * window is zoomed
 * @module header
 */





var PLUGIN_NAME = 'fixedHeader';
var DEFAULTS = {
  fixedClass: 'is-fixed',
  pageContent: '.page',
  tablet: false,
  ab1017: false
};



/**
 * Scroll Site's Fixed Header
 * @param  {jQuery} $el - header element
 */

var fixHeaderScroll = function fixHeaderScroll($el) {
  if ($el.hasClass('is-fixed-scroll')) {
    var lastScrollTop = 0;
    var headerPosition = 0;
    var $headerHeight = $el.outerHeight(true);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scroll(function (event) {
      if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#tr-mybag').hasClass('dd-is-open')) {
        var st = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).scrollTop();
        var top = st * -1;
        var scrollDiff = $headerHeight;
        var diffPosition = top - lastScrollTop;
        headerPosition = headerPosition + diffPosition;
        // detect scrolling direction
        if (headerPosition < -scrollDiff && diffPosition < 0) {
          // scrolling down
          headerPosition = -scrollDiff;
        } else if (headerPosition > 0) {
          // scrolling up
          headerPosition = 0;
        }
        // Conditional below is to fix a bug on Safari
        if (top > 0) {
          headerPosition = 0;
        }
        lastScrollTop = top;
        return $el.css({
          'transform': 'translate3d(0px, ' + headerPosition + 'px, 0px)'
        });
      }
    });
  }
};
var checkOverride = function checkOverride($el, opts) {
  var fixedClass = opts.fixedClass;
  if ($el.hasClass('override-header')) {
    $el.removeClass(opts.fixedClass);
    fixedClass = 'is-fixed-scroll';
  }
  return fixedClass;
};
/**
 * Add margin at the top of the page content when header is fixed
 * to account for the height of the fixed header and any banners
 * @param  {jQuery} $el - header element
 */
var addPageContentMargin = function addPageContentMargin($el, opts) {
  var ab1017 = opts.ab1017;
  var topHalfHeader = ab1017 ? 0 : 33;
  var topMargin = $el.outerHeight(true) + topHalfHeader;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.pageContent).css("margin-top", topMargin);
};
/**
 * Remove margin at the top of the page content when header is unfixed
 * @param  {jQuery} $el - header element
 */
var removePageContentMargin = function removePageContentMargin($el, opts) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.pageContent).css("margin-top", 0);
};
/**
 * Fix Site's Header
 * @param  {jQuery} $el - header element
 */
var fixHeader = function fixHeader($el, opts) {
  var ab1017 = opts.ab1017;
  var fixedClass = checkOverride($el, opts);
  $el.addClass(fixedClass);
  if (!opts.tablet) {
    if (!ab1017) {
      $el.addClass('u-margin-b--xl');
    }
    // $el.addClass('u-padding-t--lg');
  }
  $el.trigger("fixedHeader.fixed");
  if (__WEBPACK_IMPORTED_MODULE_1_breaky___default.a.value != "tablet") {
    addPageContentMargin($el, opts);
  } else {
    $el.removeClass('u-margin-tb--xl');
  }
};

/**
 * Unfix Site's Header
 * @param  {jQuery} $el - header element
 */
var unFixHeader = function unFixHeader($el, opts) {
  var fixedClass = checkOverride($el, opts);
  $el.removeClass(fixedClass);
  $el.removeClass('u-margin-b--xl');
  $el.removeClass('u-padding-t--lg');
  if (__WEBPACK_IMPORTED_MODULE_1_breaky___default.a.value === 'tablet') {
    $el.addClass('u-margin-tb--xl');
  }
  $el.trigger("fixedHeader.static");
  removePageContentMargin($el, opts);
};
/**
 * Get original font size of body
 * @param  {jQuery} $body - body element
 */
var getFontSize = function getFontSize($body) {
  var currentStyle = $body.attr('style');
  $body.removeAttr('style');
  var fontSize = Number($body.css('font-size').replace('px', ''));
  $body.attr('style', currentStyle);
  return fontSize;
};
/**

 * Check if font is zoomed
 * @param  {jQuery} $el - header element
 * @param  {jQuery} $window - window element
 * @param  {jQuery} $body - header element
 */
var fontZoomCheck = function fontZoomCheck($el, $window, $body, opts) {
  var fixedClass = checkOverride($el, opts);
  if ($el.hasClass(fixedClass)) {
    var actualFontSize = Number($window[0].getComputedStyle(document.body).getPropertyValue('font-size').replace('px', ''));
    // 110% of base font size
    var threshold = 1.1;
    var baseFontSize = getFontSize($body);
    ;
    if (actualFontSize > baseFontSize * threshold) {
      unFixHeader($el, opts);
    }
  }
};
/**
 * Fixed Header Toggle Base on Scroll
 * @param  {jQuery} $el - header element
 * @param  {jQuery} $html - html element
 * @param  {jQuery} $window - window element
 * @param  {pixelValue} bannerOffset - value of header offset
 */
var fixedHeaderToggle = function fixedHeaderToggle($el, $html, $window, bannerOffset, opts) {
  var fixedClass = checkOverride($el, opts);
  var ab1017 = opts.ab1017;
  var noFocus = $html.hasClass('no-focus');
  var isFixed = $el.hasClass(fixedClass);
  var topHalfHeader = 33;
  var windowScrollTop = $window.scrollTop();
  var headerOffset = ab1017 ? bannerOffset.header : bannerOffset.header + topHalfHeader;
  if (windowScrollTop > headerOffset && !isFixed && noFocus) {
    fixHeader($el, opts);
    fixHeaderScroll($el, opts);
  } else if (windowScrollTop < headerOffset && isFixed) {
    unFixHeader($el, opts);
  }
  if (ab1017) {
    var throttleBuffer = 150;
    var throttleOffset = headerOffset + throttleBuffer;
    var isThrottled = $el.data('scrollThrottled');
    var rebind = $el.data('rebindScroll');
    if (rebind) {
      if (windowScrollTop > throttleOffset && !isThrottled) {
        rebind(true);
        $el.data('scrollThrottled', true);
      } else if (windowScrollTop <= throttleOffset && isThrottled) {
        rebind(false);
        $el.data('scrollThrottled', false);
      }
    }
  }
};

/**
 * Resize Logo Based on Scroll Position ab1017
 * @param  {jQuery}     $el          - header element
 * @param  {pixelValue} bannerOffset - value of header offset
 */
var resizeLogo = function resizeLogo($el, bannerOffset) {
  var $icon = $el.find('.branding__logo');
  var headerOffset = bannerOffset.header;
  var iconFullWidth = 217;
  var iconMinWidth = 186;
  var iconWidthDiff = iconFullWidth - iconMinWidth;
  if (scrollY > headerOffset) {
    $icon.css('width', iconMinWidth + 'px');
    return;
  }
  $icon.css('width', iconFullWidth - scrollY / headerOffset * iconWidthDiff + 'px');
};

/**
 * Scroll Handler
 * @param  {jQuery} $el - header element
 * @param  {jQuery} $html - html element
 * @param  {jQuery} $window - window element
 * @param  {jQuery} $body - header element
 * @param  {pixelValue} bannerOffset - value of header offset
 */
var positionHandler = function positionHandler($el, $html, $window, $body, bannerOffset, opts) {
  /* Only fix the header if the window has enough scroll to get past the header */
  var minimumScrollHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).height() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).height() - __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).scrollTop();
  var headerHeight = $el.height();
  if (minimumScrollHeight > headerHeight) {
    fixedHeaderToggle($el, $html, $window, bannerOffset, opts);
    fontZoomCheck($el, $window, $body, opts);
  }
};
/**
 * Tab Event
 * @param  {jQuery} $el - header element
 * @param  {event} evt - key event
 */
var tabEventHandler = function tabEventHandler($el, evt, opts) {
  if (__WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'TAB' || __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */].parseKey(evt) === 'SHIFT_TAB') {
    unFixHeader($el, opts);
  }
};
/**
 * Set Event Listeners
 * @param  {jQuery} $el - header element
 * @param  {jQuery} $html - html element
 * @param  {jQuery} $window - window element
 * @param  {jQuery} $body - window element
 * @param  {pixelValue} bannerOffset - value of header offset
 */
var setEventListeners = function setEventListeners($el, $html, $window, $body, bannerOffset, opts) {
  $html.on('mousedown.fixedHeader', function () {
    return fixedHeaderToggle($el, $html, $window, bannerOffset, opts);
  });
  $html.on('keyup.fixedHeader', function (evt) {
    return tabEventHandler($el, evt, opts);
  });
  if (opts.ab1017) {
    var scrollHandler = function scrollHandler() {
      return positionHandler($el, $html, $window, $body, bannerOffset, opts);
    };
    var throttledScrollHandlerFixed = __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default()(scrollHandler, 100);
    var throttledScrollHandler = __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default()(scrollHandler, 10);
    $window.on('scroll.fixedHeader', scrollHandler);
    $el.data('rebindScroll', function (fixed) {
      $window.off('scroll.fixedHeader');
      $window.on('scroll.fixedHeader', fixed ? throttledScrollHandlerFixed : throttledScrollHandler);
    });
    var ticking = false;
    $window.on('scroll.resizeLogo', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          resizeLogo($el, bannerOffset);
          ticking = false;
        });
        ticking = true;
      }
    });
  } else {
    $window.on('scroll.fixedHeader', __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default()(function (evt) {
      return positionHandler($el, $html, $window, $body, bannerOffset, opts);
    }, 100));
  }
};
/**
 * Get if there's a global banner and return offset value
 * @param  {jQuery} $el - header element
 * @return {pixelValue} Immutable version of the options
 */
var getHeaderOffset = function getHeaderOffset($el) {
  return $el.offset().top === 0 ? 1 : $el.offset().top;
};

/**
 * @param  {jQuery} $el - header element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var appendFixScroll = function appendFixScroll($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
};

/**
 * Initializes Header.
 * @param {HTMLElement} el - header element
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function fixedHeader(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $html = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html');
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
  var $body = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body');
  var bannerOffset = {
    header: getHeaderOffset($el)
  };

  // cookie banner disclaimer
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cookiesBar").on('closeCookieBanner', function (evt) {
    bannerOffset.header = getHeaderOffset($el);
  });
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, $html, $window, $body, bannerOffset, opts);
  positionHandler($el, $html, $window, $body, bannerOffset, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, fixedHeader);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles all focus to anchor
 * @module maskDate to
 */





// Expose the function as a jQuery plugin for ease of uses
var PLUGIN_NAME = 'fixedSidebar';
var DEFAULTS = {};
var applyEventListners = function applyEventListners(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $header = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-header');
  var $footer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-site-footer');
  var sidebarWidth = $el.outerWidth();
  var sidebarPagePos = $el.offset().top;
  var sibebarPosCaptured = false;
  var offsetTop = 10;
  var offsetBottom = 20;
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
  var sidebarFixed = false;
  $window.on('scroll.fixedSidebar resize.fixedSidebar', __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(function () {
    var footerTop = $footer.offset().top;
    var viewportTop = $window.scrollTop();
    var viewportBottom = viewportTop + $window.height();
    var headerHeight = $header.height();
    var headerIsFixed = $header.hasClass('is-fixed');
    if (headerIsFixed && !sibebarPosCaptured) {
      sidebarPagePos = $el.offset().top - offsetTop;
      sibebarPosCaptured = true;
    }
    /*
       Calculate header height to get header bottom position.
      Statement is true when scroll bar top position meets the bottom header.
      Then side bar will be fixed.
      */
    if (viewportTop + headerHeight >= sidebarPagePos && !sidebarFixed) {
      sidebarFixed = true;
      $el.addClass('fixed-sidebar').css({
        top: "".concat(headerHeight + offsetTop, "px"),
        width: sidebarWidth,
        height: "calc(100vh - ".concat(headerHeight, "px)")
      });
    }
    if (sidebarFixed) {
      /*
        When the viewport scroll position meets the scroll position of the scroll bar and height
      */
      if (viewportTop + headerHeight <= sidebarPagePos) {
        $el.removeClass('fixed-sidebar').css({
          top: '',
          width: '',
          height: ''
        });
        sidebarFixed = false;
      }
      /*
        When footer is visible inside the viewport
      */
      if (viewportBottom >= footerTop) {
        var footerVisibleHeight = viewportBottom - footerTop;
        $el.css({
          height: "calc(100vh - ".concat(headerHeight + footerVisibleHeight + offsetBottom, "px)")
        });
      }
    }
  }, 10));
  $el.on('mouseenter', function () {
    $el.focus();
  });
};
var wrapSidebar = function wrapSidebar($el) {
  $el.wrapInner('<div class="fixed-sidebar__wrap"></div>');
};

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function fixedSidebar(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 ? arguments[2] : undefined,
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  applyEventListners(el);
  wrapSidebar($el);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, fixedSidebar);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles all focus to anchor
 * @module focus to
 */




// Expose the function as a jQuery plugin for ease of uses
var PLUGIN_NAME = 'focusTo';
var DEFAULTS = {
  updateURL: false,
  scrollStickyNavAB789: !__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-sticky-nav').hasClass('js-sticky-target')
};

/**
 * Prevents focus scroll
 * @param {HTMLElement} $target - element sending focus to
 */
var focusWithoutScroll = function focusWithoutScroll($target) {
  var x = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).scrollLeft();
  var y = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).scrollTop();
  $target.focus();
  window.scrollTo(x, y);
};

/**
 * Scrolls to element
 * @param {HTMLElement} $target - element sending focus to
 * @param {number} scrollPosOffset - offset number
 */
var scrollToElement = function scrollToElement($target, opts, scrollPosOffset) {
  var focusActive = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').hasClass('focus-active');
  var stickyNavHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-sticky-target').outerHeight() || 0;
  var targetTop = $target.offset().top;
  var scrollTarget = targetTop - stickyNavHeight;
  if (focusActive) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').stop().animate({
      'scrollTop': $target.offset().top - 10
    }, 400);
  } else {
    if (DEFAULTS.scrollStickyNavAB789) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').stop().animate({
        scrollTop: scrollTarget - 110
      }, 400);
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').stop().animate({
        'scrollTop': $target.offset().top - scrollPosOffset
      }, 400);
    }
  }
};

/**
 * Initiates Focus / Scroll
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {object} evt - event object
 */
function focusStart(el, evt) {
  evt.preventDefault(evt);
  var headerHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-header').height() || 0;
  var headerIsFixed = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-header').hasClass('is-fixed');
  var hash = el.hash;
  var $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(hash);
  var scrollPosOffset = 0;
  if (headerIsFixed) {
    scrollPosOffset = 0;
  } else {
    scrollPosOffset = headerHeight;
  }
  window.history.pushState("", "", hash);
  focusWithoutScroll($target);
  scrollToElement($target, scrollPosOffset);
}
/**
 * Handles Event Listeners.
 * @param  {jQuery} $el - button /element selector
 * @param {HTMLElement} el - button /element that opens focusTo
 */
function setEventListeners($el, el) {
  $el.on('click', function (evt) {
    focusStart(el, evt);
  });
}

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function focusTo(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 ? arguments[2] : undefined,
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, focusTo);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/**
 * Dynamically applies span classes to size option items
 * so their content does not overflow and width aligns to
 * a grid layout
 * @module gridSpanSizer
 */



var containerSelector = '.ab839__size-options';
var itemSelector = '.size-options__item';
var maxSpan = 6;
var itemTooltipToggleDisplay = 'size-options__tooltip--toggle';
var spanClassPrefix = 'size-options__item--span';
var debounceDelay = 150;

/**
 * Check if element content is overflowing
 * @private
 * @param {HTMLElement} el - The element to check
 * @returns {boolean} True if overflowing
 */
var isOverflowing = function isOverflowing(el) {
  return el.scrollWidth > el.clientWidth;
};

/**
 * Apply span sizing logic to all items
 * @private
 * @param {jQuery} $container - The container element
 */
var applySpanLogic = function applySpanLogic($container) {
  var items = $container.find(itemSelector);
  items.each(function () {
    var $item = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    $item.addClass(itemTooltipToggleDisplay);

    // Remove previous span classes
    var classList = Array.prototype.slice.call(this.classList);
    classList.forEach(function (cls) {
      if (cls.indexOf(spanClassPrefix) === 0) {
        $item.removeClass(cls);
      }
    });
    var span = 1;

    // Try span1 → maxSpan
    while (span <= maxSpan) {
      var cls = spanClassPrefix + span;
      $item.addClass(cls);
      if (!isOverflowing(this)) {
        // This span works
        break;
      }
      $item.removeClass(cls);
      span++;
    }
    $item.removeClass(itemTooltipToggleDisplay);
  });
};

/**
 * Set up resize event listener
 * @private
 * @param {jQuery} $container - The container element
 */
var setEventListeners = function setEventListeners($container) {
  var handleResizeStart = function handleResizeStart() {
    $container.find(itemSelector).addClass(itemTooltipToggleDisplay);
  };
  var handleResize = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
    applySpanLogic($container);
  }, debounceDelay);
  window.addEventListener('resize', function () {
    handleResizeStart(); // Run immediately
    handleResize(); // Run debounced
  });
};

/**
 * Initializes the grid span sizer plugin
 * @param {HTMLElement} el - Container element
 * @see DEFAULTS
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.gridSpanSizer = function () {
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(containerSelector);
  if ($container.length === 0) {
    return;
  }

  // Run on page load
  applySpanLogic($container);

  // Set up resize listener
  setEventListeners($container);
};

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export INIT_HANDLER */
/* unused harmony export BP_HANDLER */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Slick Slider with breakpoints init
 * @module gwp‰esponsiveSlider
 */




var PLUGIN_NAME = 'gwpResponsiveSlider';
var INIT_HANDLER = 'init';
var BP_HANDLER = 'breakpoint';
var DEFAULTS = {};

/**
 * handle break points based num of slides
 */
var gwpBreakpoints = function gwpBreakpoints(breakpoint, totalSlides, slidesToShow, $slides, el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  if (breakpoint === 1027) {
    if (totalSlides > slidesToShow) {
      $el.removeClass('gwp-confirm__grid--unslick');
      $slides.removeClass('gwp-confirm__grid-item--slide');
      $slides.addClass('gwp-confirm__grid-item--slide-init');
    } else {
      $el.addClass('gwp-confirm__grid--unslick');
      $slides.addClass('gwp-confirm__grid-item--slide');
      $slides.removeClass('gwp-confirm__grid-item--slide-init');
    }
  } else {
    if (totalSlides > slidesToShow) {
      $el.removeClass('gwp-confirm__grid--unslick');
      $slides.addClass('gwp-confirm__grid-item--slide-init');
      $slides.removeClass('gwp-confirm__grid-item--slide');
    } else {
      $el.addClass('gwp-confirm__grid--unslick');
      $slides.addClass('gwp-confirm__grid-item--slide');
      $slides.removeClass('gwp-confirm__grid-item--slide-init');
    }
  }
};
var setEventListeners = function setEventListeners(initTrack) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(initTrack).on(INIT_HANDLER, function (evt, slick) {
    var breakpoint = slick.activeBreakpoint;
    var totalSlides = slick.$slides.length;
    var slidesToShow = slick.options.slidesToShow;
    var $slides = slick.$slideTrack.find('.gwp-confirm__grid-item');
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(initTrack);
    gwpBreakpoints(breakpoint, totalSlides, slidesToShow, $slides, el);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(initTrack).on(BP_HANDLER, function (evt, slick, breakpoint) {
    var totalSlides = slick.$slides.length;
    var slidesToShow = slick.options.slidesToShow;
    var $slides = slick.$slideTrack.find('.gwp-confirm__grid-item');
    var el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(initTrack);
    gwpBreakpoints(breakpoint, totalSlides, slidesToShow, $slides, el);
  });
};

/**
 * Initializes Breakpoint logic.
 * @param {HTMLElement} $initTrack - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function gwpResponsiveSlider(el, options) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  setEventListeners($el);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, gwpResponsiveSlider);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


// https://stackoverflow.com/questions/7838680/detecting-that-the-browser-has-no-mouse-and-is-touch-only
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  var $body = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('body');
  var $html = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html');
  var detectEvents = function detectEvents(e) {
    if (e.type === 'mousemove') {
      $html.addClass('has-mousemove');
    } else if (e.type === 'touchstart') {
      $html.addClass('has-touchstart');
    }
    $body.off('.detectEventType');
  };
  // attach both events to body
  $body.on('mousemove.detectEventType touchstart.detectEventType', detectEvents);
});

/***/ }),
/* 302 */
/***/ (function(module, exports) {

$(document).ready(function () {
  $('.js-form-search').on('submit', function (e) {
    var searchInput = $('.js-site-search__textbox', $(this));
    var screenWidth = $(window).width();
    if (!searchInput.is(':visible')) {
      e.preventDefault();
      var width;
      if (screenWidth > 920) {
        width = 456;
      } else if (screenWidth > 870) {
        width = 396;
      } else if (screenWidth > 820) {
        width = 440;
      } else {
        width = 360;
      }
      if ($('.ab553').length) {
        var $container = $('.ab553');
        $container.addClass('is-open--tablet');
      }
      searchInput.addClass('header__input-search__active').animate({
        width: width
      }, 600, function () {
        $('.site-search__typeahead').css({
          "float": 'left'
        });
        if (screenWidth <= 820) {
          searchInput.css('padding-top', '5px');
        }
        // UX-21255: the visual search coachmark (abtests/ab553.js) listens for this and
        // calls preventDefault() when it is about to appear, so the field is not
        // auto-focused until the coachmark has been dismissed.
        var openEvent = $.Event('visualSearch:tabletOpen');
        $('.ab553').trigger(openEvent);
        if (!openEvent.isDefaultPrevented()) {
          searchInput.focus();
        }
      });
    } else if (searchInput.is(':visible') && searchInput.val() === '' && screenWidth < 1001) {
      // if input field is visible and empty close input field when clicking search icon
      e.preventDefault();
      closeSearchInput(searchInput);
    }
  });
  function closeSearchInput(searchInputActive) {
    if ($('.ab553').length) {
      var $container = $('.ab553');
      $container.removeClass('is-open--tablet');
      $container.trigger('visualSearch:tabletClose'); // UX-21255: dismiss the coachmark with the field
    }
    searchInputActive.animate({
      width: 0
    }, 600, function () {
      searchInputActive.removeClass('header__input-search__active');
      $('.site-search__typeahead').css({
        "float": ''
      });
    });
  }
  $(document).on('click', function (e) {
    var searchInputActive = $('.header__input-search__active');
    if (searchInputActive && !$(e.target).is('.header__input-search__active, .site-search__typeahead')) {
      closeSearchInput(searchInputActive);
    }
  });
  $(document).on('keyup', function (e) {
    if (e.key == "Enter" && $('.header__input-search__active').length) {
      if ($('.ab553').length && !$(e.target).hasClass('js-visual-search-button')) {
        $('.header__input-search__active').focus();
      }
    }
    if (e.key == "Escape" && ($('.header__input-search__active').is(":focus") || $('.header__icon-search').is(":focus")) && $('.header__input-search__active').length) {
      closeSearchInput($('.header__input-search__active'));
      $('.header__icon-search').focus();
    }
  });
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
var _this = this;
/**
 * Handles image upload and preview functionality
 * @module imageUploader
 */




var PLUGIN_NAME = 'imageUploader';
var DEFAULTS = {
  uploadButton: '.js-trigger-upload-btn',
  fileInput: '#js-image-upload-target',
  previewImage: '.js-preview-img',
  removeButton: '.js-remove-img',
  imagePlaceholder: '.js-image-upload-ph',
  dropzone: '.js-dropzone'
};

/**
 * Handles the image preview functionality.
 * @param  {Object} opts - The options provided by the user or defaults.
 */

var previewImage = function previewImage(file, opts) {
  var $previewImg = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.previewImage);
  var $removeImgBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.removeButton);
  var $imgPlaceholder = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.imagePlaceholder);
  if (file) {
    window.uploadedImage = file;
    window.updatedImage = true;
    var reader = new FileReader();
    reader.onload = function (e) {
      $previewImg.attr('src', e.target.result);
      $previewImg.show();
      $removeImgBtn.removeClass('u-hide');
      $imgPlaceholder.hide();
    };
    reader.readAsDataURL(file);
  }
};
var handleImageUpload = function handleImageUpload(opts) {
  var $fileInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.fileInput);
  $fileInput.on('change', function (event) {
    var file = event.target.files[0];
    previewImage(file, opts);
  });
};
var handleDragAndDrop = function handleDragAndDrop(opts) {
  var $dropzone = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.dropzone);
  $dropzone.on('dragover', function (e) {
    e.preventDefault();
    $dropzone.addClass('drag-over');
  });
  $dropzone.on('dragleave', function () {
    $dropzone.removeClass('drag-over');
  });
  $dropzone.on('drop', function (e) {
    e.preventDefault();
    $dropzone.removeClass('drag-over');
    var file = e.originalEvent.dataTransfer.files[0]; // Get the dropped file
    previewImage(file, opts); // Preview the dropped image

    // Optional: set the file in the input field if you want to keep it in sync
    var $fileInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.fileInput);
    $fileInput.prop('files', e.originalEvent.dataTransfer.files);
  });
};

/**
 * Handles image removal functionality.
 * @param  {Object} opts - The options provided by the user or defaults.
 */
var handleImageRemove = function handleImageRemove(opts) {
  var $fileInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.fileInput);
  var $previewImg = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.previewImage);
  var $removeImgBtn = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.removeButton);
  var $imgPlaceholder = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.imagePlaceholder);
  $removeImgBtn.on('click', function () {
    $fileInput.val('');
    $previewImg.attr('src', '#').hide();
    $imgPlaceholder.show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(_this).hide();
    window.uploadedImage = null;
    window.updatedImage = true;
  });
};

/**
 * Initializes the image uploader plugin.
 * @param {HTMLElement} el - The form element or container triggering the upload
 * @param {Object} options - Options for configuring the image uploader
 * @see DEFAULTS
 */
function imageUploader(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $uploadButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.uploadButton);
  var $fileInput = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.fileInput);

  // When the "Upload Image" button is clicked, trigger the file input
  $uploadButton.on('click', function (e) {
    e.preventDefault();
    $fileInput.trigger('click');
  });

  // Set up the handlers for image upload and remove
  handleImageUpload(opts);
  handleDragAndDrop(opts);
  handleImageRemove(opts);
}

// Register the plugin with jQuery
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, imageUploader);

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Toggle classes
 * @module impressionsControls
 */




// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'impressionsControls';

/**
 * Applies any sort of event handlers for the impressionsControls.
 * @param  {jQuery} $el - link
 */
var setEventListeners = function setEventListeners($el) {
  var activeClass = 'ab-controls--active';
  $el.find('.js-impressions-controls-btn').on('click', function () {
    if ($el.hasClass(activeClass)) {
      $el.removeClass(activeClass);
    } else {
      $el.addClass(activeClass);
    }
  });
  $el.find('.js-impressions-controls-close').on('click', function (e) {
    e.preventDefault();
    $el.removeClass('ab-controls--show');
    localStorage.setItem('impressionsControls', 'false');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).on('mouseup.dropdown', function (e) {
    if (!$el.is(e.target) && $el.has(e.target).length === 0) {
      $el.removeClass(activeClass);
    }
  });
};

/**
 * Impressions polling
 * @param  {jQuery} $el - link
 */
var _doPoll = function doPoll($el) {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.get('/dbadmin/spring-controller/impressions/impressions-data', function (data) {
    $el.find('.impressions-widget-data').html(data);
    setEventListeners($el);
    setTimeout(function () {
      _doPoll($el);
    }, 3000);
  });
};

/**
 * Initializes impressionsControls.
 * @param {HTMLElement} el - link
 */
function impressionsControls(el) {
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: "/dbadmin/spring-controller/impressions/impressions-widget",
    type: "GET",
    data: {
      device: 'desktop'
    },
    success: function success(data) {
      $el.append(data);
      _doPoll($el);
      if (localStorage.getItem('impressionsControls') === 'false') {
        $el.removeClass('ab-controls--show');
      } else if (localStorage.getItem('impressionsControls') === 'true' || localStorage.getItem('impressionsControls') === null) {
        $el.addClass('ab-controls--show');
        localStorage.setItem('impressionsControls', 'true');
      }
    }
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, impressionsControls);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_EVENT */
/* unused harmony export CHANGE_EVENT */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Creates a counter
 * @module incrementCount
 */




var PLUGIN_NAME = 'incrementCount';
var CLICK_EVENT = 'click';
var CHANGE_EVENT = 'change';
var DEFAULTS = {
  count: 0
};

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, incrementCount);

/**
 * Initializes blank based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * Counter
 * @param {Object} options - Options used for wiring up the Count
 * @see DEFAULTS
 */
function incrementCount(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  applyEventHandlers($el, opts);
}
;

/**
 * Applies any sort of event handlers for the count incrementation.
 * @param {jQuery} $el - Containing the elements for the Counter
 * @param {Object} options - Options used for wiring up the Counter
 * @see DEFAULTS
 */
var applyEventHandlers = function applyEventHandlers($el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.find('.js-plus').on(CLICK_EVENT, function (evt) {
    plus(evt, $el, opts);
  });
  $el.find('.js-minus').on(CLICK_EVENT, function (evt) {
    minus(evt, $el, opts);
  });
  $el.find('.js-checkin').on(CHANGE_EVENT, function (evt) {
    checkin(evt, $el, opts);
  });
};
var plus = function plus(evt, $el, opts) {
  evt.preventDefault();
  var $elCount = $el.find('.js-count');
  var $elCheckin = $el.find('.js-checkin');
  if ($elCheckin.is(':checked')) {
    return;
  }
  opts.count++;
  $elCount.val(opts.count);
};
var minus = function minus(evt, $el, opts) {
  evt.preventDefault();
  var $elCount = $el.find('.js-count');
  var $elCheckin = $el.find('.js-checkin');
  if ($elCheckin.is(':checked')) {
    return;
  }
  if (opts.count > 0) {
    opts.count--;
    $elCount.val(opts.count);
  }
};
var checkin = function checkin(evt, $el, opts) {
  var $elCount = $el.find('.js-count');
  var $elTotal = $el.find('.js-total');
  var $elCheckin = $el.find('.js-checkin');
  if ($elCheckin.is(':checked')) {
    var $elSum = parseInt($elCount.val(), 10) + parseInt(1, 10);
    $elTotal.val($elSum);
  } else {
    $elTotal.val(0);
  }
};

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles all jump container
 * @module jump container
 */




// Expose the function as a jQuery plugin for ease of uses
var PLUGIN_NAME = 'jumpContainer';
var DEFAULTS = {
  updateURL: false,
  navItems: '.js-jump-container-nav a',
  content: '.js-jump-container-content'
};
function jump($parent, $el, opts, e, el) {
  e.preventDefault();
  var hash = el.hash,
    $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(hash);
  var topPos = $target[0].offsetTop;
  $parent.find(opts.content).scrollTop(topPos - 10);
  $target.focus();
}
function setEventListeners($parent, opts) {
  $parent.find(opts.navItems).on('click', function (e) {
    jump($parent, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), opts, e, this);
  });
}

/**
 * Initializes jumpContainer.
 * @param {HTMLElement} el - button /element that opens jumpContainer
 * @param {Object} options - Options used for wiring up the jumpContainer
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function jumpContainer(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 ? arguments[2] : undefined,
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, jumpContainer);

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_lazy__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery_lazy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery_lazy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_lazy_plugins_jquery_lazy_ajax__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery_lazy_plugins_jquery_lazy_ajax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery_lazy_plugins_jquery_lazy_ajax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omit__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__ = __webpack_require__(1);





function lazyAjax(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _afterLoad = options.afterLoad,
    _onError = options.onError;
  var opts = __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default()(options, ['afterLoad', 'onError']);
  var combinedOptions = Object.assign({
    onError: function onError($el) {
      if (_onError) {
        options.onError($el);
      }
      $el.trigger('lazy-ajax:error', [$el]);
    },
    afterLoad: function afterLoad($el) {
      if (_afterLoad) {
        options.afterLoad($el);
      }
      $el.trigger('lazy-ajax:after-load', [$el]);
    },
    ajaxCreateData: function ajaxCreateData($el) {
      var json = $el.data('lazy-json');
      if (!json) {
        return null;
      }
      return json;
    }
  }, opts);
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).Lazy(combinedOptions);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_register_jquery_plugin__["a" /* default */])('lazyAjax', lazyAjax);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery_mask_plugin__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery_mask_plugin__);
/**
 * Handles all focus to anchor
 * @module maskDate to
 */






// Expose the function as a jQuery plugin for ease of uses
var PLUGIN_NAME = 'maskDate';
var DEFAULTS = {
  updateURL: false
};
function setFormating($el, opts) {
  if ($el.length) {
    $el.mask('00/00/0000');
  }
}

/**
 * Initializes focusTo.
 * @param {HTMLElement} el - button /element that opens focusTo
 * @param {Object} options - Options used for wiring up the focusTo
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
function maskDate(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 ? arguments[2] : undefined,
    deregister = _ref.deregister;
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options_js__["a" /* default */])(DEFAULTS, options, $el);
  setFormating($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, maskDate);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_breaky__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_breaky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_breaky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery_doubletaptogo__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery_doubletaptogo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery_doubletaptogo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery_mask_plugin__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery_mask_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery_mask_plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__slick_carousel__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__grid_span_sizer__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__enabled_button__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__accordion__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__countdown__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enterable__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__fixed_header__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dropdown__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__progress_ring__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__dropdown_enter__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__track_video__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__sticky_video__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__slick_slider__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__increment_count__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__focus_to__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__close_banner__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__toggle_text__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__toggle_elements__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__toggle_display__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__jump_container__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__toggle_row__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__mask_date__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__toggle_change__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__toggle_reveal__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__switch_class__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__drawer__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__sticky_scroll__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__rating_scale_rating_scale__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__copy_clipboard__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__tooltip__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__recs_pop_out__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__has_mouse_event__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__fixed_corner__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__scroll_to_top__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__trim_total__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__tabs__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__product_swatches__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__sticky_nav__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__fixed_sidebar__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__cc_mask__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__ab_controls__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__impressions_controls__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__lazy_ajax__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__progressiveButton__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__add_to_calendar__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__counter__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__no_focus__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__header__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__gwp_responsive_slider__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__product_filter_active_button__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__filters_sticky__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__slides__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__abtest_follow_shops__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__image_upload__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__shop_the_look__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__abtest_custom_video_player__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__abtest_floating_video__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__breakpoint_layout_switch__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__responsive_placeholder__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_lodash_throttle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__abtests_ab795__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__abtests_ab795___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__abtests_ab795__);




































































// import '../abtests/ab553';

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_53__no_focus__["a" /* default */])();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-enabled-button').enabledButton();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-beauty-add-on').recsPopOut();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-custom-video-player').customVideoPlayer();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-beauty-add-on-full').slickSlider({
    slidesToScroll: 6,
    slidesToShow: 6,
    lazyLoad: 'ondemand',
    responsive: [{
      breakpoint: 899,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }, {
      breakpoint: 1027,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-buy-again-add-on').slickSlider({
    responsive: [{
      breakpoint: 899,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 1027,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel--ambassador').slickSlider({
    slidesToShow: 7,
    slidesToScroll: 7,
    customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
    dots: true,
    appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".image-carousel__dots-container--centered"),
    responsive: [{
      breakpoint: 1025,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel--ambassador-users').slickSlider({
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: true,
    customPaging: function customPaging(slick, i) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */])(slick, i, true);
    },
    // Set true to show numbers
    appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".image-carousel__indicators"),
    responsive: [{
      breakpoint: 1256,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }, {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-sidebar').fixedSidebar();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-sticky-nav').stickyNav();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-switch-class').switchClass();

  // drawer animation of dynamic content in buy now modal on PDP
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-counter').counters();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-drawer').drawer();
  // $('.js-lazy-ajax').lazyAjax(); - not in use - see demo for usecases - /r/r_src/main/styleguide/site/lazy-ajax-demo.html
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-text').toggleText();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-elements').toggleElements();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-row').toggleRow();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-focus-to').focusTo();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-jump-container').jumpContainer();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-tooltip').tooltip();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-progress-ring').progressRing();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-track-video').trackVideo();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-order-hist-total').trimTotal();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-cc').ccMask();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-copy-clipboard').copyToClipboard();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-change').toggleChange();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-toggle-display").toggleDisplay();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-progressive-button').progressiveButton();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-add-to-calendar').addToCalendar();
  // $('.js-single-cc').singleCC();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-upload-form').imageUploader();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-live').slickSlider({
    responsive: [{
      breakpoint: 769,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel--loyalty').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [{
      breakpoint: 821,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel__mix-match').slickSlider({
    infinite: true,
    nextArrow: ".carousel__nav-next",
    prevArrow: ".carousel__nav-prev",
    dots: true,
    accessiblePaging: true,
    dotsClass: "image-carousel__dots",
    appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".image-carousel__dots-container"),
    slidesToShow: 1,
    slidesToScroll: 1
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-ctl-more').slickSlider();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-oh-recs').slickSlider({
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [{
      breakpoint: 1025,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel').slickSlider({
    responsive: [{
      breakpoint: 899,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }]
  });

  // Mock Content Start - UX-18974
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-search').slickSlider({
    slidesToShow: 7,
    slidesToScroll: 7,
    dots: true,
    responsive: [{
      breakpoint: 899,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }]
  });
  // Mock Content End - UX-18974
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-pw').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }, {
      breakpoint: 822,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel--top-designers').slickSlider({
    slidesToShow: 6,
    slidesToScroll: 4,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-shops').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4,
    lazyLoad: 'progressive',
    responsive: [{
      breakpoint: 822,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel--full').slickSlider({
    dots: true,
    customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
    dotsClass: "image-carousel__dots",
    appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".image-carousel__dots-container")
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel--centered').slickSlider({
    dots: true,
    customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
    dotsClass: "image-carousel__dots",
    appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".image-carousel__dots-container--centered")
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel--centered--ab').slickSlider({
    dots: true,
    customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
    dotsClass: "image-carousel__dots",
    appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".image-carousel__dots-container--centered"),
    slidesToShow: 8,
    slidesToScroll: 8,
    responsive: [{
      breakpoint: 1027,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-hot-list-bs').breakpointLayoutSwitch({
    dots: true,
    customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
    slidesToShow: 3.2,
    slidesToScroll: 3
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-foundation-flats').each(function () {
    var $foundationFlats = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var $foundationFlatsDots = $foundationFlats.find(".carousel__dots-container");
    $foundationFlats.slickSlider({
      dots: true,
      customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
      slidesToShow: 4,
      slidesToScroll: 4,
      dotsClass: "carousel__dots",
      appendDots: $foundationFlatsDots,
      responsive: [{
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }]
    });
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel--gwp .js-carousel__track').gwpResponsiveSlider();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel--gwp').slickSlider({
    responsive: [{
      breakpoint: 1027,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    }]
  });
  //Acts as a thumbnail navigation for PDP main image carousel.
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-primary-nav > .pdp__pager-thumb').on('click mouseover', function (e) {
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slides-slick').slick('slickGoTo', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).index(), true);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-plp-bottom-carousel').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4,
    accessibility: true,
    nextArrow: ".js-carousel__next",
    prevArrow: ".js-carousel__prev"
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-similar-carousel').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-beauty-feature').slickSlider({
    slidesToShow: 1,
    slidesToScroll: 1,
    customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
    dots: true,
    dotsClass: "image-carousel__dots",
    appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".image-carousel__dots-container")
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.order-tracking-ctl .js-carousel-ctl').slickSlider({
    //  order-tracking/returns page UX-11481 Mocks
    slidesToScroll: 5,
    dots: true,
    dotsClass: "ctl-carousel__dots",
    appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".ctl-carousel__dots-container")
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-si').each(function () {
    //order-tracking/returns page UX-11481 Mocks
    var $carouselSI = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    $carouselSI.slickSlider({
      slidesToShow: 5,
      slidesToScroll: 5
    });
  });

  // UX-17870
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-order-tabs').tabs({
    tab: '.tab__link',
    tabContent: '.tab__content',
    tabContentActive: 'tab__content--active',
    tabActive: 'tab__link--active'
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-beauty').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-stylewith').slickSlider({
    slidesToShow: 3,
    slidesToScroll: 3,
    speed: 200
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-beauty-edit').slickSlider({
    infinite: true,
    slidesToShow: 1,
    dots: true,
    dotsClass: "slick-dots"
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-bridesmaid-style').slickSlider({
    slidesToShow: 2,
    slidesToScroll: 2,
    showStatus: true,
    responsive: [{
      breakpoint: 1025,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-single-product').slickSlider({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true,
    nextArrow: ".js-carousel__nav-next-single",
    prevArrow: ".js-carousel__nav-prev-single"
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-qv-ctl').slickSlider({
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: ".js-carousel__nav-next-qv-ctl",
    prevArrow: ".js-carousel__nav-prev-qv-ctl"
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-gc-carousel').slickSlider({
    slidesToShow: 5,
    // centerMode must have slidesToShow set to an odd number
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    accessibility: false,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3 // centerMode must have slidesToShow set to an odd number
      }
    }]
  });

  // Global Banner slider
  // const bannerSlideshow = $('.js-slideshow');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-slideshow').each(function () {
    var $bannerSlideshow = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var language = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').attr('lang');
    var rtlBool = language === "ar";
    if ($bannerSlideshow.children('.banner--slider-list__item').length > 1) {
      $bannerSlideshow.slick({
        autoplay: true,
        autoplaySpeed: 6000,
        prevArrow: $bannerSlideshow.siblings('.banner__slick-prev'),
        nextArrow: $bannerSlideshow.siblings('.banner__slick-next'),
        rtl: rtlBool
      });
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner__slick-next, .banner__slick-prev').on('click', function () {
        $bannerSlideshow.slick('slickPause');
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner__slick-next, .banner__slick-prev').hide();
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.banner--slider-list').show();
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-ctl-stylitics').slickSlider({
    slidesToShow: 2,
    slidesToScroll: 2,
    infinite: false
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-ctl-stylitics--extended').slickSlider({
    infinite: false,
    dotsClass: "image-carousel__dots",
    dots: true,
    customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
    appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".image-carousel__dots-stylitics")
  });
  function carouselLwlImages($carouselName) {
    var countImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($carouselName + ' .slick-list').find(".slick-active").length;
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()($carouselName + ' .slide-image-count').each(function () {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).append(countImage);
    });
  }
  window.slickSliderATBCTL = function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-ctl-atb').slickSlider({
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: false
    });
  };
  window.slickSliderLooksWeLoveBig = function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel__lwl').each(function () {
      var $carousel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      $carousel.slickSlider({
        dots: true,
        customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
        lazyLoad: 'progressive',
        dotsClass: "image-carousel__dots",
        appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".image-carousel__dots-container-lwl"),
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4 // this number ties with custom-pages.js to get total of dots
      });
      $carousel.on('breakpoint', function () {
        carouselLwlImages();
      });
      $carousel.keydown(function (e) {
        // Move the focus to the current slide if user is using the
        // left and right arrow keys
        if (e.keyCode == 37 || e.keyCode == 39) {
          e.preventDefault();
          // Set focus after slick has moved position
          $carousel.on('setPosition', function () {
            $carousel.find('.slick-current a').focus();
            $carousel.off('setPosition');
          });
        }
      });
    });
  };
  window.slickSliderLooksWeLoveBig();
  window.slickSliderLooksWeLoveSmall = function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lwl-carousel').slickSlider({
      dots: true,
      customPaging: __WEBPACK_IMPORTED_MODULE_3__slick_custom_paging__["a" /* default */],
      lazyLoad: 'progressive',
      dotsClass: "image-carousel__dots",
      appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".image-carousel__dots-container"),
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 3 // this number ties with custom-pages.js to get total of dots
    });
  };
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-shop-trends').slickSlider({
    lazyLoad: 'ondemand',
    slidesToShow: 5,
    slidesToScroll: 1
  });
  window.slickSliderLooksWeLoveSmall();
  carouselLwlImages('.js-carousel__lwl');
  carouselLwlImages('.js-lwl-carousel');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-fit-videos').slickSlider({
    slidesToShow: 6,
    slidesToScroll: 6,
    infinite: true,
    centerPadding: '0px',
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToScroll: 4,
        slidesToShow: 4
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel-cpl-list').slickSlider({
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToScroll: 4,
        slidesToShow: 4
      }
    }]
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-rating-scale').ratingScale({
    titleSelector: '.form-section__title'
  });

  // input masking
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-tel-us').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-tel-us').mask('+1(000) 000-0000');
  }
  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-mx').length) {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-mx').mask('+52#000000000');
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-mask-date').maskDate();
  window.Keyboard = __WEBPACK_IMPORTED_MODULE_2__keyboard__["a" /* default */];
  window.throttle = __WEBPACK_IMPORTED_MODULE_66_lodash_throttle___default.a;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-header').fixedHeader();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scroll(function () {
    var fixedHeaderHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-header.is-fixed').height();
    var scroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop();
    if (scroll > 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-hotlist-ads").addClass("is-fixed");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-hotlist-ads").css('margin-top', fixedHeaderHeight);
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-hotlist-ads").removeClass("is-fixed");
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-hotlist-ads").css('margin-top', 0);
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-dropdown').dropdown();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-sign-out').on('click', function (e) {
    e.preventDefault();
    signOut();
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-modal').modal();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal.a11y();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-enterable').enterable();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-sticky-video__container').stickyVideo();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-guest-row').incrementCount();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-reveal').toggleReveal();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-toggle-reveal--ipad').toggleReveal();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".js-accordion").accordion();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-countdown').countdown();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-sticky-scroll]').stickyScroll();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".dropdown.dropdown--center").dropdownEnter();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".fixed-corner").fixedCorner();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.back-to-top').scrollToTop();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-tabs').tabs();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-faqs-tabs').tabs({
    tabActive: 'action-button--active',
    tabToggleOff: true
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.product-swatches--collapse').productSwatches();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-double-tap-main .js-dropdown').doubleTapToGo();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-ab-controls').abControls(); // Ab Testing Controls for previewing on testing servers
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-impressions-controls').impressionsControls();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-voyages-package').each(function () {
    var $voyagesSelf = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var $voyagersSlideshow = $voyagesSelf.find('.js-voyagers-slideshow');
    var $voyagersPrev = $voyagesSelf.find('.js-voyages-slideshow-prev');
    var $voyagersNext = $voyagesSelf.find('.js-voyages-slideshow-next');
    $voyagersSlideshow.slick({
      lazyLoad: 'ondemand',
      prevArrow: $voyagersPrev,
      nextArrow: $voyagersNext,
      dots: true
    });
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-product-filter-active-button').productFilterActiveButton({
    mountEl: '#filters-container',
    layoutType: 'inline'
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-lazy-image').lazy({
    bind: 'event',
    effect: 'fadeIn',
    effectTime: 200,
    threshold: 500,
    throttle: 0
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-stl-modal').shopTheLook();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-floating-video-button').floatingVideo({
    hideMute: true
  });

  //MOCK TEST JS FOR FAVORTING DESIGNERS UX-18624
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-favorite-designer').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('favorite-button--heart-active');
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-placeholder-switch-text').responsivePlaceholder();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-carousel--banner').slickSlider({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    infinite: true
  });
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(3);


/*

Creates no focus on click events, but focuses when tabs

*/

var $html = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html');
var focusClass = 'no-focus';
var focusActiveClass = 'focus-active';
/**
 * Tab Event
 * @param  {jQuery} $html - html element
 * @param  {event} evt - key event
 */
var tabEventHandler = function tabEventHandler($html, evt) {
  if (__WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === 'TAB' || __WEBPACK_IMPORTED_MODULE_1__keyboard__["a" /* default */].parseKey(evt) === 'SHIFT_TAB') {
    $html.removeClass(focusClass);
    $html.addClass(focusActiveClass);
  }
};
var clickEventHandler = function clickEventHandler($html) {
  $html.addClass(focusClass);
  $html.removeClass(focusActiveClass);
};
var noFocus = function noFocus() {
  $html.addClass(focusClass);
  $html.on('mousedown.noFocus', function (evt) {
    return clickEventHandler($html, evt);
  });
  $html.on('keyup.noFocus', function (evt) {
    return tabEventHandler($html, evt);
  });
};
/* harmony default export */ __webpack_exports__["a"] = (noFocus);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_props__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__product_filter_count__ = __webpack_require__(118);
/**
 * Sidebar product filter search
 * @module productFilterActiveSearch
 */






var PLUGIN_NAME = 'productFilterActiveButton';
var DEFAULTS = {
  clearAllText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.filter.clearAllText', 'Clear All'),
  filteredByText: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_props__["a" /* get */])('rcProps.filter.filteredByText', 'Filtered By'),
  mountEl: null,
  layoutType: 'default'
};
var isSmartFiltersPage = function isSmartFiltersPage() {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#smart-filters').length > 0;
};
var createCloseIcon = function createCloseIcon() {
  var iconClasses = isSmartFiltersPage() ? 'u-margin-l--xs' : 'icon--xs u-margin-l--sm';
  return "<span class=\"icon icon--x ".concat(iconClasses, "\">\n            <svg viewBox=\"0 0 16 16\" aria-hidden=\"true\" focusable=\"false\"\n                role=\"presentation\">\n                <path\n                    d=\"M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28\n                        4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8\n                        9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z\">\n                </path>\n            </svg>\n        </span>");
};
var createFilterButton = function createFilterButton(text, isSmartFilter, layoutType) {
  if (isSmartFiltersPage()) {
    return isSmartFilter ? "<li class=\"horizontal-scroll__item horizontal-scroll__item--basis-none\">\n            <div class=\"pill-button pill-button--white-blk-stroke\">\n                <span class=\"icon icon--smart-filters icon icon--xs u-padding-l--none\">\n                    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\">\n                        <path d=\"M6.55625 14.3982C5.9875 10.2414 5.76 10.0051 1.6125 9.445C1.2625 9.40124 1 9.1037 1 \n                                8.7449C1 8.39485 1.2625 8.0973 1.6125 8.05354C5.76875 7.48471 5.99625 7.25718 6.565 \n                                3.10031C6.6175 2.71525 6.97625 2.45272 7.3525 2.50522C7.65875 2.54898 7.90375 2.79402 \n                                7.9475 3.10031C8.5075 7.25718 8.74375 7.48471 12.8913 8.05354C13.2413 8.0973 13.5037 \n                                8.39485 13.5037 8.7449C13.5037 9.09495 13.2413 9.39249 12.8913 9.445C8.735 10.0051 \n                                8.5075 10.2414 7.9475 14.3982C7.895 14.7833 7.53625 15.0458 7.16 14.9933C6.85375 \n                                14.9496 6.60875 14.7045 6.565 14.3982H6.55625ZM12.1475 5.89197C11.9113 4.18547 11.8238 \n                                4.08921 10.1175 3.85292C9.9775 3.83542 9.86375 3.7129 9.86375 3.57288C9.86375 3.42411 \n                                9.96875 3.30159 10.1175 3.28409C11.8238 3.05655 11.92 2.96029 12.1475 1.25379C12.165 \n                                1.10502 12.2875 1 12.4275 1C12.5675 1 12.69 1.10502 12.7163 1.24504C12.9438 2.95154 \n                                13.04 3.0478 14.7463 3.27534C14.895 3.29284 15 3.41536 15 3.56413C15 3.7129 14.895 \n                                3.82667 14.7463 3.84417C13.04 4.0717 12.9438 4.16797 12.7163 5.88322C12.69 6.02324 \n                                12.5763 6.12826 12.4275 6.13701C12.2788 6.13701 12.165 6.03199 12.1388 5.88322L12.1475 \n                                5.89197Z\" fill=\"#6E6E6E\">\n                                \n                        </path>\n                    </svg>\n                </span>\n                <span class=\"u-margin-l--md\">".concat(text, "</span>\n                ").concat(createCloseIcon(), "\n            </div>\n        </li>") : "<li class=\"horizontal-scroll__item horizontal-scroll__item--basis-none\">\n            <div class=\"pill-button pill-button--light-grey\">\n                <span>".concat(text, "</span>\n                ").concat(createCloseIcon(), "\n            </div>\n        </li>");
  } else {
    var cssClasses = layoutType === 'inline' ? 'horizontal-scroll__item horizontal-scroll__item--basis-none' : 'u-inline-block u-padding-t--md u-padding-r--md';
    return "<li class=\"".concat(cssClasses, "\">\n                <button class=\"pill-button pill-button--light-grey\">\n                    ").concat(text, "\n                    ").concat(createCloseIcon(), "\n                </button>\n            </li>");
  }
};
var containerButtonsDefaultLayout = function containerButtonsDefaultLayout(clearAllText, filteredByText) {
  return "<div class=\"u-padding-b--lg u-margin-b--xxl u-border-b u-border--xs u-border--color-lighter\">\n    <div class=\"u-flex u-flex--space-between\"><h2 class=\"h3-secondary u-capitalize u-margin-tb--none\">".concat(filteredByText, ":</h2> <button class=\"link u-lowercase js-search-multi-filter-clear-all\">").concat(clearAllText, "</button></div>\n    <ul class=\"u-margin-l--none u-padding-t--xl\"></ul>\n  </div> ");
};
var containerButtonsPageLayout = function containerButtonsPageLayout(clearAllText, filteredByText) {
  return "<div class=\"u-padding-b--lg\">\n    <div class=\"u-flex u-flex--space-between\"><h2 class=\"u-text--lg u-weight--normal u-capitalize u-margin-t--md u-margin-b--none\">".concat(filteredByText, ":</h2></div>\n    <ul class=\"u-margin-l--none u-padding-b--md\"><li class=\"u-inline-block u-padding-t--md u-padding-r--md\"><button class=\"pill-button pill-button--black js-search-multi-filter-clear-all\">").concat(clearAllText, "</button></li></ul>");
};
var containerButtonsInlineLayout = function containerButtonsInlineLayout(clearAllText, filteredByText) {
  return "<div class=\"u-padding-b--lg u-flex\">\n    <div style=\"white-space: nowrap;\"><h2 class=\"u-text--md u-weight--normal u-capitalize u-margin-t--md u-margin-b--none\">".concat(filteredByText, ":</h2></div>\n    <div class=\"horizontal-scroll\" style=\"width: initial;\">\n      <ul class=\"horizontal-scroll__item-wrap horizontal-scroll__item-wrap--first-no-padding u-margin-b--none\"></ul>\n    </div>\n    <button class=\"pill-button pill-button--black js-search-multi-filter-clear-all\" style=\"white-space: nowrap; margin-left: 8px\">").concat(clearAllText, "</button>\n  </div>");
};
var createContainerButtons = function createContainerButtons(clearAllText, filteredByText, layoutType) {
  if (isSmartFiltersPage()) {
    return "<div class=\"u-flex u-flex--v-ctr u-padding-tb--lg\">\n                 <div class=\"filters__container--sub u-flex u-flex--v-ctr\">\n                    <span class=\"u-font-primary u-text-transform-none u-text--lg u-white-space--nowrap\">\n                        ".concat(filteredByText, "\n                    </span>\n                    <div class=\"horizontal-scroll u-margin-l--lg u-flex u-flex--wrap u-margin-t--xs u-margin-b--none u-padding-b--none\" style=\"gap: 8px;\">\n                        <ul class=\"horizontal-scroll__item-wrap u-margin-b--none\"></ul>\n                    </div>\n                    <button class=\"pill-button pill-button--black u-white-space--nowrap u-margin-l--lg js-clear-filters-button\">").concat(clearAllText, "</button>\n                 </div>\n            </div>");
  } else {
    switch (layoutType) {
      case 'page':
        return containerButtonsPageLayout(clearAllText, filteredByText);
      case 'inline':
        return containerButtonsInlineLayout(clearAllText, filteredByText);
      default:
        return containerButtonsDefaultLayout(clearAllText, filteredByText);
    }
  }
};
var addButtonsContainer = function addButtonsContainer($filtersContainer, $checkboxes, _ref) {
  var clearAllText = _ref.clearAllText,
    filteredByText = _ref.filteredByText,
    layoutType = _ref.layoutType;
  var $buttonContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(createContainerButtons(clearAllText, filteredByText, layoutType));
  var $clearAllButton = $buttonContainer.find('button');
  $filtersContainer.prepend($buttonContainer);
  $clearAllButton.on('click', function () {
    $checkboxes.each(function (index, checkbox) {
      if (checkbox.checked) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox).prop('checked', false);
      }
    });
    if (!isSmartFiltersPage()) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(":button.pill-button", $buttonContainer).remove();
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()("span[id$='-filter-count']", $filtersContainer).empty();
    checkButtonListVisibility($buttonContainer, $checkboxes);
  });
  return {
    $buttonListContainer: $filtersContainer,
    $buttonList: $buttonContainer.find('ul')
  };
};
var addButtonToList = function addButtonToList($checkbox, $buttonList, layoutType) {
  var checkboxText = $checkbox.next().text().split('(')[0];
  var isSmartFilter = $checkbox.hasClass('js-smart-filter');
  var $filterButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(createFilterButton(checkboxText, isSmartFilter, layoutType));
  if (layoutType === 'page') {
    // insert new button before the "clear all" button
    $buttonList.find('.js-search-multi-filter-clear-all').before($filterButton);
  } else {
    // insert new button at the end of button list
    $buttonList.append($filterButton);
  }
  $filterButton.on('click', function () {
    var val = $checkbox.val();
    if (val && !isSmartFilter) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[value=\"".concat(val, "\"]:not(.js-smart-filter)")).prop('checked', false);
    } else {
      $checkbox.prop('checked', false);
    }
    $checkbox.trigger('change');
    if (isSmartFilter) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#submit-smart-filters').trigger('click');
    }
  });
  return $filterButton;
};
var countChecked = function countChecked($checkboxes) {
  return $checkboxes.filter(':checked').length;
};
var checkButtonListVisibility = function checkButtonListVisibility($buttonListContainer, $checkboxes) {
  var $stickyElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-left-nav-sticky-element');
  var useDisplayStyle = isSmartFiltersPage();
  if (countChecked($checkboxes)) {
    $stickyElement.addClass('sidebar-sticky--filters');
    if (useDisplayStyle) {
      $buttonListContainer.show();
    } else {
      $buttonListContainer.removeClass('u-hide');
    }
    return;
  }
  $stickyElement.removeClass('sidebar-sticky--filters');
  if (useDisplayStyle) {
    $buttonListContainer.hide();
  } else {
    $buttonListContainer.addClass('u-hide');
  }
};
var initActiveButtons = function initActiveButtons($buttonListContainer, $buttonList, $checkboxes, _ref2) {
  var layoutType = _ref2.layoutType;
  var filterButtonMap = {};
  $checkboxes.each(function (index, checkbox) {
    var $checkbox = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox);
    if (checkbox.checked) {
      if ($checkbox.hasClass('js-smart-filter')) {
        filterButtonMap[checkbox.id] = addButtonToList($checkbox, $buttonList, layoutType);
      } else {
        var inputValue = $checkbox.val();
        if (inputValue) {
          filterButtonMap[inputValue] = filterButtonMap[inputValue] || addButtonToList($checkbox, $buttonList, layoutType);
        } else {
          filterButtonMap[checkbox.id] = addButtonToList($checkbox, $buttonList, layoutType);
        }
      }
    }
    if (!$checkbox.hasClass('js-smart-filter')) {
      $checkbox.on('change', function () {
        var inputValue = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();
        if (checkbox.checked) {
          if (inputValue) {
            filterButtonMap[inputValue] = filterButtonMap[inputValue] || addButtonToList($checkbox, $buttonList, layoutType);
          } else {
            filterButtonMap[checkbox.id] = addButtonToList($checkbox, $buttonList, layoutType);
          }
        } else {
          if (inputValue) {
            filterButtonMap[inputValue].remove();
            delete filterButtonMap[inputValue];
          } else {
            filterButtonMap[checkbox.id].remove();
            delete filterButtonMap[checkbox.id];
          }
        }
        checkButtonListVisibility($buttonListContainer, $checkboxes);
      });
    }
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#submit-smart-filters').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter').each(function (index, checkbox) {
      var $checkbox = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(checkbox);
      var $filterButton = filterButtonMap[checkbox.id];
      if (checkbox.checked) {
        if (!$filterButton) {
          filterButtonMap[checkbox.id] = addButtonToList($checkbox, $buttonList, layoutType);
        }
      } else if ($filterButton) {
        delete filterButtonMap[checkbox.id];
        $filterButton.remove();
      }
    });
    checkButtonListVisibility($buttonListContainer, $checkboxes);
  });
  $buttonListContainer.find('.js-clear-filters-button').on('click', function () {
    Object.values(filterButtonMap).forEach(function ($filterButton) {
      if ($filterButton) {
        $filterButton.remove();
      }
    });
    filterButtonMap = {};
    var url = new URL(window.location.href);
    window.history.pushState({}, "", removeSearchParams(url));
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#submit-smart-filters').data('ignoreHistory', true).trigger('click');
    checkButtonListVisibility($buttonListContainer, $checkboxes);
  });
};

/**
 * Initializes productFilterActiveButton.
 * @param {HTMLElement} container - filter container
 * @param {Object} options - Options used for wiring up the plugin
 * @see DEFAULTS
 */
function productFilterActiveButton(container) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(container);
  var $countInitEls = $container.find('[data-filter-count]');
  var smartFilters = isSmartFiltersPage();
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_styleguide_lib_merge_options__["a" /* default */])(DEFAULTS, options, $container);
  // mount by default will be the container but can be overriden by the
  // mountEl property.
  opts.mountEl = options.mountEl ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.mountEl) : $container;
  opts.layoutType = smartFilters ? 'default' : options.layoutType;
  var $checkboxes = smartFilters ? __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-smart-filter').add($container.find('input[type="checkbox"]')) : $container.find('input[type="checkbox"]');
  var _addButtonsContainer = addButtonsContainer(opts.mountEl, $checkboxes, opts),
    $buttonListContainer = _addButtonsContainer.$buttonListContainer,
    $buttonList = _addButtonsContainer.$buttonList;
  initActiveButtons($buttonListContainer, $buttonList, $checkboxes, opts);
  checkButtonListVisibility($buttonListContainer, $checkboxes);
  $countInitEls.productFilterCount();
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productFilterActiveButton);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/**
 * Product Swatches
 * @module productSwatches
 */





var PLUGIN_NAME = 'productSwatches';
var DEFAULTS = {
  productSwatch: '.product-swatches__swatch',
  viewMoreBtnBlock: '.js-toggle-block',
  viewMoreBtn: '.js-toggle-row',
  visibleRows: 2,
  radioSelector: '.product-swatches__radio'
};

/**
 * Checks if the top of the last swatch is >= the height of the swatch
 * multiplied by the # of expected rows
 * @param  {jQuery} $el - product swatches element
 * @param  {jQuery} $lastSwatch - last swatch nested in the product swatches element
 * @return {Boolean}
 */
var lastSwatchIsHidden = function lastSwatchIsHidden($el, $lastSwatch, opts) {
  if ($lastSwatch.position().top >= $lastSwatch.outerHeight(true) * opts.visibleRows) {
    return true;
  }
  return false;
};

/**
 * Toggle View More button
 * @param  {jQuery} $el - product swatches element
 * @param  {jQuery} $lastSwatch - last swatch nested in the product swatches element
 */
var toggleViewMore = function toggleViewMore($el, $lastSwatch, opts) {
  var viewMoreBtn = opts.viewMoreBtn,
    viewMoreBtnBlock = opts.viewMoreBtnBlock;
  if (lastSwatchIsHidden($el, $lastSwatch, opts)) {
    $el.next(viewMoreBtnBlock).find(viewMoreBtn).removeClass('u-hide');
  } else {
    $el.next(viewMoreBtnBlock).find(viewMoreBtn).addClass('u-hide');
  }
};
/**
 * Initialize keyboard navigation for radio buttons
 * @param  {jQuery} $el - product swatches element
 * @param  {Object} opts - options
 */
var initKeyboardNavigation = function initKeyboardNavigation($el, opts) {
  var $swatches = $el.find(opts.radioSelector);

  // Set initial tabindex
  $swatches.each(function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('tabindex', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prop('checked') ? '0' : '-1');
  });

  // Arrow key navigation - attach directly to each radio button
  $swatches.on('keydown', function (e) {
    var $allSwatches = $el.find(opts.radioSelector); // Re-query to ensure we have all
    var currentIndex = $allSwatches.index(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
    var newIndex = currentIndex;
    var count = $allSwatches.length;
    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        e.preventDefault();
        newIndex = (currentIndex + 1) % count;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        e.preventDefault();
        newIndex = (currentIndex - 1 + count) % count;
        break;
      default:
        return;
    }
    $allSwatches.attr('tabindex', '-1');
    $allSwatches.eq(newIndex).attr('tabindex', '0').prop('checked', true).focus().trigger('change');
  });

  // Handle clicks to update tabindex
  $swatches.on('change', function () {
    var $allSwatches = $el.find(opts.radioSelector);
    $allSwatches.attr('tabindex', '-1');
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('tabindex', '0');
  });
};

/**
 * Set Event Listener
 * @param  {jQuery} $el - header element
 * @param  {jQuery} $window - window element
 */
var setEventListener = function setEventListener($el, $window, opts) {
  var $lastSwatch = $el.find(opts.productSwatch).last();
  $window.on('resize.productSwatch', __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
    toggleViewMore($el, $lastSwatch, opts);
  }, 100)).trigger('resize.productSwatch');
};

/**
 * Initializes product swatches
 * @param {HTMLElement} el - product swatches element
 * @see DEFAULTS
 */
function productSwatches(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  initKeyboardNavigation($el, opts);
  setEventListener($el, $window, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, productSwatches);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options_js__ = __webpack_require__(2);
/**
 * Progress Ring module
 * @module progressRing
 */





// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'progressRing';
var DEFAULTS = {
  filled: 0,
  filledRing: '.progress-ring__circle--fill',
  pending: 0,
  pendingRing: '.progress-ring__circle--pending',
  progressRings: '.progress-ring__circle',
  progressRingSVG: 'progress-ring__diagram',
  strokeWidth: 17,
  width: 144
};

/**
 * Calculates the radius of the circle. The radius needs to take into account
 * the added width from the stroke
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @return {Number} The radius of the progress ring
 */
var calculateRadius = function calculateRadius(options) {
  return options.width / 2 - options.strokeWidth / 2;
};

/**
 * Calculates the circumference of the progress ring. This number allows
 * us to calculate the value for the percentage of the progress ring
 * that should be filled
 * @param  {Number} radius - The radius of the progress ring
 * @return {Number} The circumference of the progress ring
 */
var calculateCircumference = function calculateCircumference(radius) {
  return radius * 2 * Math.PI;
};

/**
 * Calculates and adds the stroke-dashoffset attribute to the pending progress ring
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Number} circumference - The circumference of the progress ring
 */
var setPendingRing = function setPendingRing($el, options, circumference) {
  options.filled = options.filled < 0 ? 0 : options.filled;
  var amountFilled = circumference * (1 - (parseFloat(options.pending) + parseFloat(options.filled)));
  var parent = $el.find(options.pendingRing);
  parent.attr("stroke-dashoffset", amountFilled);
  parent.children().attr('from', circumference);
  parent.children().attr('to', amountFilled);
};

/**
 * Calculates and adds the stroke-dashoffset attribute to the filled progress ring
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Number} circumference - The circumference of the progress ring
 */
var setFilledRing = function setFilledRing($el, options, circumference) {
  options.filled = options.filled < 0 ? 0 : options.filled;
  var amountFilled = circumference * (1 - options.filled);
  var parent = $el.find(options.filledRing);
  parent.attr("stroke-dashoffset", amountFilled);
  parent.children().attr('from', circumference);
  parent.children().attr('to', amountFilled);
};

/**
 * Sets the viewBox property on the <svg> tag dynamically based on the width option
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setSVGViewBox = function setSVGViewBox($el, options) {
  // jQuery attr() does not work with the viewBox attribute so must convert from
  // jQuery to JavaScript to use the setAttribute() method
  var el = $el.get(0);
  var progressRingSVG = el.getElementsByClassName(options.progressRingSVG)[0];
  progressRingSVG.setAttribute("viewBox", "0 0 ".concat(options.width, " ").concat(options.width));
};

/**
 * Sets the calculated attributes to each of the <circle> elements in the
 * progress ring module
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setProgressRingAttributes = function setProgressRingAttributes($el, options) {
  var radius = calculateRadius(options);
  var circumference = calculateCircumference(radius);
  $el.find(options.progressRings).each(function (index, progressRing) {
    progressRing.setAttribute("cx", options.width / 2);
    progressRing.setAttribute("cy", options.width / 2);
    progressRing.setAttribute("r", radius - 1);
    progressRing.setAttribute("stroke-dasharray", circumference);
    progressRing.setAttribute("stroke-width", options.strokeWidth);
  });
  setPendingRing($el, options, circumference);
  setFilledRing($el, options, circumference);
  setSVGViewBox($el, options);
};

/**
 * Updates the values of the progress ring and rerenders it.
 * Meant to be used if the progress ring needs to be updated after the page
 * has already been rendered.
 * @param  {jQuery} $el - progress ring element
 * @param  {Number} filled - % of the progress ring that should be filled
 * @param  {Number} pending - % of the progress ring that is pending
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var _rerender = function rerender($el, filled, pending, options) {
  var updatedOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options_js__["a" /* default */])(DEFAULTS, {
    filled: filled,
    pending: pending
  }, $el);
  setProgressRingAttributes($el, updatedOptions);
};

/**
 * Initializes progressRing
 * @param {HTMLElement} el - progress ring element
 * @param {Object} options - Options used for wiring up the progressRing
 * @see DEFAULTS
 */
function progressRing(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options_js__["a" /* default */])(DEFAULTS, options, $el);
  setProgressRingAttributes($el, opts);
  return {
    rerender: function rerender(filled, pending) {
      return _rerender($el, filled, pending, opts);
    }
  };
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, progressRing);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_HANDLER */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options_js__ = __webpack_require__(2);
/**
 * Progressive Button on click
 * @module progressiveButton
 */




var PLUGIN_NAME = 'progressiveButton';
var CLICK_HANDLER = 'click';
var DEFAULTS = {
  time: 2000
};

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */

var progressiveFlow = function progressiveFlow($el, options) {
  // Get button-specific data attributes
  var onLoadSelector = $el.data('on-load-state');
  var finalBtnSelector = $el.data('final-state');
  var textSubmit = $el.data('text-on-submit');

  // Find closest parent container to scope the selectors
  var $elParent = $el.closest('.js-progressive-button__container');
  var $container = $elParent.length ? $elParent : $el.parent();

  // Find elements within the same container instead of global document
  var $onLoad = $container.find(onLoadSelector);
  var $finalBtn = $container.find(finalBtnSelector);
  setTimeout(function () {
    $el.attr('disabled', true);
  });

  // if there's another button to show,
  // hide the original button
  if (finalBtnSelector) {
    $el.hide();
  }
  $onLoad.removeClass('u-hide');
  if (textSubmit) {
    if ($el.is('input')) {
      $el.val(textSubmit);
    } else {
      $el.text(textSubmit);
    }
  }
  if (finalBtnSelector) {
    setTimeout(function () {
      $onLoad.hide();
      $finalBtn.removeClass('u-hide');
    }, options.time);
  }
};
var _reset = function reset($el) {
  // Get button-specific data attributes directly from the element
  var onLoadSelector = $el.data('on-load-state');
  var finalBtnSelector = $el.data('final-state');
  var dataText = $el.data('text');
  setTimeout(function () {
    $el.removeAttr('disabled');
  });
  if (dataText) {
    if ($el.is('input')) {
      $el.val(dataText);
    } else {
      $el.text(dataText);
    }
  }
  if (finalBtnSelector) {
    $el.show();
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(onLoadSelector).removeClass('u-inline-block');
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(onLoadSelector).addClass('u-hide');
};
var setEventListeners = function setEventListeners($el, options) {
  $el.on(CLICK_HANDLER, function (e) {
    e.stopPropagation();
    progressiveFlow($el, options);
  });
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the button
 * @see DEFAULTS
 */
function progressiveButton(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options_js__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
  return {
    reset: function reset() {
      return _reset($el);
    },
    // Mock Content Start - AB Test 400
    run: function run() {
      return progressiveFlow($el, opts);
    }
    // Mock Content End - AB Test 400
  };
}
;
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, progressiveButton);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RATING_SCALE_OPTIONS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for the interacting with the rating scale which allows a user to
 * select a rating for a given product
 * @module modules/rating-scale/ratingScale
 */




/**
 * Defines the defaults around the rating scale.
 * @type {Object}
 */
var RATING_SCALE_OPTIONS = {
  titleSelector: 'h2',
  block: 'rating-scale-field',
  inputElement: 'input',
  labelElement: 'label',
  filledModifier: 'filled'
};

/**
 * Will apply class names to the block, input, and label based on the
 * operation, i.e. add/remove.
 * @private
 * @param {HTMLElement} el - Contains the star ratings
 * @param {String} op - The operation applied to the class name
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var updateField = function updateField(el, op, block, inputElement, labelElement, filledModifier) {
  el.classList[op]("".concat(block, "--").concat(filledModifier));
  var inputBlockElement = "".concat(block, "__").concat(inputElement);
  el.querySelector(".".concat(inputBlockElement)).classList[op]("".concat(inputBlockElement, "--").concat(filledModifier));
  var labelBlockElement = "".concat(block, "__").concat(labelElement);
  el.querySelector(".".concat(labelBlockElement)).classList[op]("".concat(labelBlockElement, "--").concat(filledModifier));
};

/**
 * Removes filled CSS class names.
 * @private
 * @param {HTMLElement} el - Contains the star ratings
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var removeFilledClassNames = function removeFilledClassNames(el, block, inputElement, labelElement, filledModifier) {
  return updateField(el, 'remove', block, inputElement, labelElement, filledModifier);
};

/**
 * Adds filled CSS class names.
 * @private
 * @param {HTMLElement} el - Contains the star ratings
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var addFilledClassNames = function addFilledClassNames(el, block, inputElement, labelElement, filledModifier) {
  return updateField(el, 'add', block, inputElement, labelElement, filledModifier);
};

/**
 * Will apply the filled modifier to any elements considered to be filled.
 * @private
 * @param {HTMLElement} wrap - Contains the star ratings
 * @param {HTMLElement} target - The block interacted with
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var applyFilledState = function applyFilledState(wrap, target, block, inputElement, labelElement, filledModifier) {
  var sections = Array.from(wrap.querySelectorAll(".".concat(block)));
  var selectedIndex = __WEBPACK_IMPORTED_MODULE_1_lodash_findIndex___default()(sections, function (blockEl) {
    return blockEl === target;
  });
  sections.some(function (field, index) {
    if (index > selectedIndex) {
      return true;
    }
    addFilledClassNames(field, block, inputElement, labelElement, filledModifier);
    return false;
  });
};

/**
 * Updates the title based on the element interacted with.
 * @private
 * @param {Event} e - Event object
 * @param {HTMLElement} titleEl - The title element
 */
var updateTitle = function updateTitle(e, titleEl, $el) {
  /* eslint-disable no-param-reassign */
  var ratingText = e.currentTarget.dataset.ratingText;
  if (ratingText) {
    titleEl.textContent = ratingText;
  } else {
    var selectedElement = $el[0];
    var selectedText = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(selectedElement).data('rating-text');
    titleEl.textContent = selectedText;
  }
  /* eslint-enable no-param-reassign */
};

/**
 * Removes all filled modifiers.
 * @private
 * @param {HTMLElement} el - Contains the star ratings
 * @param {String} block - Block name containing the rating
 * @param {String} inputElement - Input element name with the rating value
 * @param {String} labelElement - Label element name with the rating content
 * @param {String} filledModifier - The filled modifier name
 */
var resetFilled = function resetFilled(el, block, inputElement, labelElement, filledModifier) {
  Array.from(el.querySelectorAll(".".concat(block))).forEach(function (field) {
    removeFilledClassNames(field, block, inputElement, labelElement, filledModifier);
  });
};

/**
 * Responsible for the basic interactivity around the fit rating scale. It
 * expects a set of radio inputs that represents the rating from the form. It
 * assumes the following DOM structure with defaults provided:
 *
 * @example
 * <fieldset>
 *   <legend>Some Title</legend>
 *   <div class="rating-scale-field" data-rating-text="So Lame">
 *     <input type="radio" name="rating-scale" value="1" id="1-star"
 *     class="rating-scale-field__input">
 *     <label for="1-star" class="rating-scale-field__label icon">1 Star</label>
 *   </div>
 *   <div class="rating-scale-field" data-rating-text="Sorta Stoked">
 *     <input type="radio" name="rating-scale" value="2" id="2-star"
 *     class="rating-scale-field__input">
 *     <label for="2-star" class="rating-scale-field__label icon">2 Star</label>
 *   </div>
 *   <div class="rating-scale-field" data-rating-text="Totally Stoked">
 *     <input type="radio" name="rating-scale" value="3" id="3-star"
 *     class="rating-scale-field__input">
 *     <label for="3-star" class="rating-scale-field__label icon">3 Star</label>
 *   </div>
 *   <div class="rating-scale-field" data-rating-text="Mind Blown">
 *     <input type="radio" name="rating-scale" value="4" id="4-star"
 *     class="rating-scale-field__input">
 *     <label for="4-star" class="rating-scale-field__label icon">4 Star</label>
 *   </div>
 * </fieldset>
 *
 * Whenever a star rating has been interacted with, it'll do the following:
 *
 * - Apply filled class names to all .rating-scale-field that appear before the
 *   selected choice
 * - Will update the title of the section based on the data-rating-text
 *   attribute
 * - Will naturally select the input as the value
 *
 * @see RATING_SCALE_OPTIONS
 * @param {HTMLElement} wrap - Contains the star ratings
 * @param {Object} options - Configurable options
 */
function ratingScale(wrap) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // console.log(options)
  var _Object$assign = Object.assign({}, RATING_SCALE_OPTIONS, __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).data(), options),
    block = _Object$assign.block,
    inputElement = _Object$assign.inputElement,
    labelElement = _Object$assign.labelElement,
    filledModifier = _Object$assign.filledModifier,
    titleSelector = _Object$assign.titleSelector,
    rateText = _Object$assign.rateText;
  var titleEl = wrap.querySelector(titleSelector);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).on('click mouseenter', ".".concat(block), function (e) {
    var input = e.currentTarget.querySelector(".".concat(block, "__").concat(inputElement));
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find('.js-review-error__rating').hide();
    if (input !== e.target && e.type === "click") {
      return;
    }
    resetFilled(wrap, block, inputElement, labelElement, filledModifier);
    updateTitle(e, titleEl);
    applyFilledState(wrap, e.currentTarget, block, inputElement, labelElement, filledModifier);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).on('mouseleave', function (e) {
    var inputName = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget).find("".concat(inputElement)).attr('name');
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()("[name=".concat(inputName, "]:checked")).parent(".".concat(block));
    resetFilled(wrap, block, inputElement, labelElement, filledModifier);
    if ($el.length === 0) {
      titleEl.textContent = rateText;
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(wrap).find('.js-review-error__rating').show();
    } else {
      updateTitle(e, titleEl, $el);
      applyFilledState(wrap, $el[0], block, inputElement, labelElement, filledModifier);
    }
  });
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])('ratingScale', ratingScale);

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_breaky__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_breaky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_breaky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slick_carousel__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slick_slider__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slick_custom_paging__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_throttle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_throttle__);








// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'recsPopOut';
var DEFAULTS = {
  railTopMargin: 36,
  rail: '.product-recs--pop-out',
  pageContent: '.container--sb',
  backToTop: '.fixed-corner',
  header: '.site-header',
  headerBanner: '.global-banner',
  bannerSlider: '.banner--slider',
  footer: '.site-footer'
};

/**
 * Determines Top Margin of Rail
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var updateTopMarginRail = function updateTopMarginRail(_ref) {
  var header = _ref.header,
    railTopMargin = _ref.railTopMargin,
    rail = _ref.rail;
  var $rail = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(rail);
  var isRailActive = $rail.hasClass('active');
  var $recsContainer = $rail.closest('.js-recs-wrapper');
  var recentlyViwedIsLong = $recsContainer.find('.js-carousel--centered--ab').length;
  var marginTop = 0;
  if (isRailActive) {
    if (recentlyViwedIsLong) {
      var headerHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(header).outerHeight();
      var bannersHeight = isHeaderFixed() ? 0 : __WEBPACK_IMPORTED_MODULE_0_jquery___default()('header').position().top;
      marginTop = headerHeight + railTopMargin + bannersHeight;
    } else {
      marginTop = 24;
    }
  }
  $rail.css({
    marginTop: marginTop
  });
};

/**
 * Get 'fixed' state of header element
 */
var isHeaderFixed = function isHeaderFixed() {
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-header').hasClass('is-fixed');
};
/**
 * Updates Top Margin Based on Header
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var updateRailTopPos = function updateRailTopPos(opts) {
  var header = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-header');
  header.on('fixedHeader.fixed fixedHeader.static', function () {
    updateTopMarginRail(opts);
  });
};
/**
 * Hides back to top
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var hideBackToTop = function hideBackToTop(opts) {
  var $backToTopContiner = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.backToTop);
  $backToTopContiner.hide();
};
/**
 * shows back to top
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var showBacktoTop = function showBacktoTop(opts) {
  var $backToTopContiner = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.backToTop);
  $backToTopContiner.show();
};

/**
 * shows back to top
 * @param  {Object} [options={}] - Any options provided upon initialization
 * @param  {Object} {} - empty object
 */
var staticRail = function staticRail(opts, railHedHeight) {
  var footer = opts.footer;
  var $pagepageContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.pageContent);
  var relativeClass = 'u-relative';
  var railAbsolute = 'product-recs--pop-out--absolute';
  var railAbsoluteReducedLeft = 'product-recs--pop-out--absolute-left';
  var $rail = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.rail);
  // Added this for when rail is within a gc
  var $hasRailParent = $rail.closest('.js-recs-popout-container--center').length;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('scroll.railRecs resize.railRecs', __WEBPACK_IMPORTED_MODULE_7_lodash_throttle___default()(function () {
    var footerTopPosition = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(footer).position().top;
    var windowHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).height();
    var scrollPosition = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop();
    var footerVisibleHeight = scrollPosition + windowHeight - footerTopPosition;
    var marginSpacing = opts.railTopMargin;
    if (footerVisibleHeight < 0) {
      // footer is not visible
      // rail is fixed
      railHedHeight.railHeight = $rail.height();
      $rail.removeClass(railAbsolute);
      $rail.css({
        'max-height': '100%'
      });
      $pagepageContent.removeClass(relativeClass);
      // footer is visible and has parent 'js-recs-popout-container--center', rail is fixed
      if ($hasRailParent && footerVisibleHeight < 0) {
        railHedHeight.railHeight = $rail.height();
        $rail.removeClass(railAbsoluteReducedLeft);
        $rail.css({
          'max-height': '100%'
        });
        $pagepageContent.removeClass(relativeClass);
      }
    } else {
      // footer is visible
      if (windowHeight < footerTopPosition + marginSpacing && footerTopPosition > -marginSpacing) {
        // footer is below the fold when window scroll top is 0
        $rail.css({
          'max-height': '100%'
        });
        $rail.addClass(railAbsolute);
        $pagepageContent.addClass(relativeClass);
        // footer is visible and has parent 'js-recs-popout-container--center' and reduce left property to be closer to content
        if ($hasRailParent && windowHeight < footerTopPosition + marginSpacing && footerTopPosition > -marginSpacing) {
          $rail.css({
            'max-height': railHedHeight.railHeight
          });
          $rail.addClass(railAbsoluteReducedLeft);
          $rail.removeClass(railAbsolute);
          $pagepageContent.addClass(relativeClass);
        }
      } else {
        // footer is above the fold when window scroll top is 0
        $rail.css({
          'max-height': "calc(100% - ".concat(marginSpacing, "px - ").concat(marginSpacing, "px)")
        });
        $rail.addClass(railAbsolute);
        $pagepageContent.addClass(relativeClass);
        if ($hasRailParent) {
          $rail.css({
            'max-height': "calc(100% - ".concat(marginSpacing, "px - ").concat(marginSpacing, "px)")
          });
          $rail.removeClass(railAbsolute);
          $rail.addClass(railAbsoluteReducedLeft);
          $pagepageContent.addClass(relativeClass);
        }
      }
    }
  }, 70)).resize();
};
/**
 * Page content height to determine if the rail is absolute or fixed
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setRailType = function setRailType(opts) {
  // saving height to an obj. as user scrolls
  var railHedHeight = {};
  staticRail(opts, railHedHeight);
};

/**
 * Destroys slick slider and show recs on the right of page
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var runAbove = function runAbove($recs, $rail, opts) {
  var slickSliderExist = $recs.data('slickSlider');
  $rail.addClass('active');
  $recs.find('.js-carousel__track').removeClass('product-recs--slick-flex');
  if (slickSliderExist) {
    $recs.slickSlider('destroy');
  }
  hideBackToTop(opts);
  updateTopMarginRail(opts);
  setRailType(opts);
};

/**
 * Show recs in page as a carousel
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var runBelow = function runBelow($recs, $rail, opts) {
  var $hasRailParent = $rail.closest('.js-recs-popout-container--center').length;
  $rail.removeClass('active');
  showBacktoTop(opts);
  updateTopMarginRail(opts);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('.railRecs');
  if ($hasRailParent) {
    $recs.slickSlider({
      slidesToShow: 6,
      slidesToScroll: 6,
      lazyLoad: 'ondemand',
      responsive: [{
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      }, {
        breakpoint: 899,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }]
    });
    $recs.find('.js-carousel__track').addClass('product-recs--slick-flex');
  } else if ($rail.hasClass('js-popout-recs-b')) {
    $recs.slickSlider({
      customPaging: __WEBPACK_IMPORTED_MODULE_4__slick_custom_paging__["a" /* default */],
      dots: true,
      dotsClass: "image-carousel__dots",
      appendDots: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".image-carousel__dots-container"),
      slidesToShow: 5,
      slidesToScroll: 5,
      lazyLoad: 'ondemand'
    });
    $recs.find('.js-carousel__track').addClass('product-recs--slick-flex');
  } else {
    $recs.slickSlider({
      responsive: [{
        breakpoint: 899,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }]
    });
  }
};

/**
 * Toggles between slick and rail depending browser width
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var toggleRail = function toggleRail(breakpoint, $recs, $rail, opts) {
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
  var initialWidth = $window.width();
  var isCarousel = initialWidth < breakpoint ? true : false;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('resize', function () {
    if ($window.width() >= breakpoint && isCarousel === false) {
      isCarousel = true;
      runAbove($recs, $rail, opts);
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scroll();
    } else if ($window.width() <= breakpoint && isCarousel === true) {
      isCarousel = false;
      runBelow($recs, $rail, opts);
    }
  }).resize();
};

/**
 * Set listeners depending on window width
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var trackWindowSize = function trackWindowSize($recs, opts) {
  var $rail = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(opts.rail);
  if ($rail.hasClass('js-popout-recs-b')) {
    toggleRail(1026, $recs, $rail, opts);
  } else {
    toggleRail(1960, $recs, $rail, opts);
  }
  updateRailTopPos(opts);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('load', function () {
    updateTopMarginRail(opts);
    setRailType(opts);
  });
};
function recsPopOut(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $recs = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib_merge_options__["a" /* default */])(DEFAULTS, options, $recs);
  trackWindowSize($recs, opts);

  // update when cookie banner is closed
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#cookiesBar").on('closeCookieBanner', function (evt) {
    updateTopMarginRail(opts);
    setRailType(opts);
  });
}

// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, recsPopOut);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_debounce__);
/**
 * Responsive text field placeholder textbased on viewport width
 * Text field attr placeholder text will toggle based on viewport width
 * @module responsivePlaceholder
 */






// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'responsivePlaceholder';
var DEFAULTS = {
  placeholderTablet: null,
  placeholderBreakpoint: '1000',
  debounceDelay: 250 // Add debounce to resize event
};

/**
 * Initializes responsivePlaceholder
 * @param {HTMLElement} el - input element
 * @param {Object} options - Options used for customizing the responsive placeholder
 * @see DEFAULTS
 * @returns {Object|boolean} - Returns plugin instance or false if initialization fails
 */
function responsivePlaceholder(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var placeholderTablet = opts.placeholderTablet,
    placeholderBreakpoint = opts.placeholderBreakpoint,
    debounceDelay = opts.debounceDelay;

  // Store the original desktop placeholder from the element
  opts.placeholderDesktop = $el.attr('placeholder');

  // Return false if tablet placeholder is not provided
  if (placeholderTablet === null) return false;

  // Update placeholder based on current screen width
  function updatePlaceholder() {
    var windowWidth = window.innerWidth;
    var newPlaceholder = windowWidth <= placeholderBreakpoint ? placeholderTablet : opts.placeholderDesktop;

    // Only update if placeholder has changed
    if ($el.attr('placeholder') !== newPlaceholder) {
      $el.attr('placeholder', newPlaceholder);
    }
  }

  // Create debounced update function
  var debouncedUpdatePlaceholder = __WEBPACK_IMPORTED_MODULE_3_lodash_debounce___default()(updatePlaceholder, debounceDelay);

  // Initialize
  updatePlaceholder();

  // Set up event listener
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on("resize.".concat(PLUGIN_NAME), debouncedUpdatePlaceholder);

  // Build the public API
  var api = {
    // Update placeholders immediately
    update: updatePlaceholder,
    // Destroy the plugin instance and clean up
    destroy: function destroy() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off("resize.".concat(PLUGIN_NAME));
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el).attr('placeholder', opts.placeholderDesktop);
      return null;
    }
  };

  // Store the API on the element's data attribute
  $el.data(PLUGIN_NAME, api);
  return api;
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, responsivePlaceholder);

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_includes__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__ = __webpack_require__(1);





/**
 * Triggers the scroll event to move to the top of the page.
 * @param {jQuery} $body - Body element
 * @param {jQuery} $screen - The main viewport of the site
 */
var anchorPage = function anchorPage($body, $screen) {
  var focusActive = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').hasClass('focus-active');
  $screen.animate({
    scrollTop: 0
  }, 'slow', function () {
    if (focusActive) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#main-content')[0].focus({
        preventScroll: true
      });
    } else {
      $body.attr('tabIndex', -1)[0].focus({
        preventScroll: true
      });
    }
  });
};

/**
 * Simple helper used to set and resolve the visibility state and convert to a
 * promise for ease of interacting with.
 * @param {jQuery} $el - Target element
 * @param {string} visibilityState - The state in which the element should be
 * visible, translates to the method on the jQuery object
 * @param {Object} data - Data used to resolve the promise
 * @returns {jQuery.Deferred} When the visibility action has completed
 */
var resolveVisibilityState = function resolveVisibilityState($el, visibilityState) {
  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(['fadeIn', 'fadeOut'], visibilityState)) {
    return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Deferred().reject(new Error("Invalid visibility state of ".concat(visibilityState)));
  }
  var $deferred = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.Deferred();
  $el[visibilityState](function () {
    $deferred.resolve();
  });
  return $deferred.promise();
};

/**
 * Handles the visibility of the target element, i.e. when it is hidden or
 * visible.
 * @param {jQuery} - Target element
 * @param {jQuery} - window object
 * @param {number} - scrollThreshold - The position in which the target element
 * should be visible
 * @param {boolean} - Whether the target element initiated the scrolling and if
 * it's currently scrolling
 * @returns {jQuery.Deferred} When the visibility state has completed.
 */
var handleVisibility = function handleVisibility($el, $window, scrollThreshold, isScrolling) {
  if (isScrolling) {
    return resolveVisibilityState($el, 'fadeOut');
  }
  var scrollPos = $window.scrollTop();
  if (scrollPos > scrollThreshold) {
    return resolveVisibilityState($el, 'fadeIn');
  }
  return resolveVisibilityState($el, 'fadeOut');
};

/**
 * Scrolls the page to the top while providing additional visibility behavior
 * to the target element.
 * @param {HTMLElement} el - Element used for targeting the browser to scroll to top
 * @param {Object} [options={}]
 * @param {HTMLElement|string} [options.window=window] = The window element/selector
 * @param {string} [options.screen='HTMLAllCollection,body'] = The visible screen
 * @param {number} [options.wait=100] = The time to wait upon throttling the
 * scroll event
 * @param {number} [options.scrollThreshold=250] - The position in which the
 * target element should be visible
 */
var scrollToTop = function scrollToTop(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _Object$assign = Object.assign({}, options, $el.data()),
    _Object$assign$window = _Object$assign.window,
    win = _Object$assign$window === void 0 ? window : _Object$assign$window,
    _Object$assign$screen = _Object$assign.screen,
    screenSelector = _Object$assign$screen === void 0 ? 'html,body' : _Object$assign$screen,
    _Object$assign$conten = _Object$assign.content,
    content = _Object$assign$conten === void 0 ? 'body' : _Object$assign$conten,
    _Object$assign$wait = _Object$assign.wait,
    wait = _Object$assign$wait === void 0 ? 100 : _Object$assign$wait,
    _Object$assign$scroll = _Object$assign.scrollThreshold,
    scrollThreshold = _Object$assign$scroll === void 0 ? 250 : _Object$assign$scroll;
  var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(win);
  var $screen = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(screenSelector);
  var $body = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(content);
  var isScrolling = false;
  if ($el.length) {
    $el.on('click', function (evt) {
      anchorPage($body, $screen, evt);
      var focusActive = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').hasClass('focus-active');
      if (focusActive) {
        isScrolling = false;
      } else {
        isScrolling = true;
      }
    });
    $window.on('scroll', __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(function () {
      handleVisibility($el, $window, scrollThreshold, isScrolling).then(function () {
        if (isScrolling && $window.scrollTop() === 0) {
          isScrolling = false;
        }
      });
    }, wait));
  }
  ;
};
/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_register_jquery_plugin__["a" /* default */])('scrollToTop', scrollToTop));

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);



// modules class target = '.js-stl-modal' so as to not conflict with .js-shop-the-look for PDP stylitics

var PLUGIN_NAME = 'shopTheLook';
function shopTheLook(el) {
  applyEventHandlers(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(el));
}
/**
 * Applies any sort of event handlers for the Shop The Look
 * @param {jQuery} $el - Containing the elements to attach event listeners to
 * @see DEFAULTS
 */
var applyEventHandlers = function applyEventHandlers($el) {
  $el.on('click', function (e) {
    var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    e.preventDefault();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.modal({
      url: window.rcProps.shopTheLookModalHref,
      data: __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.param({
        qvGroupName: $this.data('qvGroupName'),
        title: $this.data('title'),
        navSrc: $this.data('navSrc')
      }),
      triggerOpen: true,
      type: 'large',
      fullHeight: true,
      onComplete: function onComplete(_ref) {
        var content = _ref.content;
        var productBlocks = content.find('.shop-the-look__recs-block');
        var $slick = content.find('.js-shop-the-look-carousel');
        content.css({
          'overflow': 'hidden'
        });
        var index = 0;
        if ($this.data('activeId')) {
          index = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-qv-item', content).toArray().map(function (qvItem) {
            return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(qvItem).data('qvId');
          }).indexOf($this.data('activeId')) || 0;
        }
        productBlocks.eq(index).fadeIn(100);
        $slick.slickSlider({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          initialSlide: index,
          dots: true,
          dotsClass: "slick-dots",
          appendDots: content.find(".shop-the-look__styles-dots"),
          rtl: __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html').attr('dir') === 'rtl',
          prevArrow: '.js-stl-carousel__prev',
          nextArrow: '.js-stl-carousel__next'
        });
        $slick.on('beforeChange', function (event, slick, oldSlideIndex, slideIndex) {
          productBlocks.eq(oldSlideIndex).fadeOut(100, function () {
            productBlocks.eq(slideIndex).fadeIn(100);
          });
        });
      }
    });
  });
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, shopTheLook);

/***/ }),
/* 320 */,
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_array_includes_js__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_array_includes_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es_array_includes_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__ = __webpack_require__(1);

/**
 * Fixed Nav.
 * 
 * @module header
 */






var PLUGIN_NAME = 'stickyNav';
var DEFAULTS = {
  stickyElement: '',
  fixedHeader: '.js-fixed-header',
  navLinks: '.js-sticky-nav-link',
  sections: '.js-sticky-nav-section'
};

/**
 * Unfix Site's Header
 * @param  {jQuery} $el - header element
 */
var unStickyNav = function unStickyNav($el) {
  $el.css({
    position: 'static'
  });
};

/**
 * Make Navigation Sticky
 * @param {jQuery} $el - header element
 * @param {jQuery} $html - html element
 */
var setStickyPosition = function setStickyPosition($el, $html) {
  $el.css({
    position: 'sticky'
  });
};

/**
 * Update Active Navigation Link
 * @param {jQuery} $el - header element
 * @param {jQuery} $window - window element
 * @param {Object} opts - options object
 */
var updateActiveNav = function updateActiveNav($el, $window, opts) {
  var fixedHeader = opts.fixedHeader,
    navLinks = opts.navLinks,
    sections = opts.sections;
  var fixedHeaderHeight = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(fixedHeader).outerHeight() || 0;
  var stickyNavHeight = $el.outerHeight();
  var windowScrollTop = $window.scrollTop();
  var sectionsArray = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(sections).toArray();
  sectionsArray.forEach(function (section) {
    var sectionTop = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(section).offset().top - fixedHeaderHeight - stickyNavHeight - 50;
    var sectionBottom = sectionTop + __WEBPACK_IMPORTED_MODULE_1_jquery___default()(section).outerHeight();
    if (windowScrollTop >= sectionTop && windowScrollTop < sectionBottom) {
      var sectionId = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(section).attr('id');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(navLinks).removeClass('active');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()("a[href=\"#".concat(sectionId, "\"]")).addClass('active');
    }
  });
};

/**
 * Handle Tab Scrolling
 * @param {Event} evt - event object
 * @param {jQuery} $el - header element
 * @param {Object} opts - options object
 */
var handleSectionScroll = function handleSectionScroll(evt, $el, opts) {
  evt.preventDefault();
  var fixedHeader = opts.fixedHeader;
  var $sectionClicked = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(evt.currentTarget.hash);
  var fixedHeaderHeight = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(fixedHeader).outerHeight() || 0;
  var stickyNavHeight = $el.outerHeight();
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html, body').animate({
    scrollTop: $sectionClicked.offset().top - (fixedHeaderHeight + stickyNavHeight)
  }, 500);
};

/**
 * Update Scroll Position
 * @param {jQuery} $el - header element
 * @param {jQuery} $window - window element
 * @param {Object} opts - options object
 */
var scrollPositionHandler = function scrollPositionHandler($el, $window, opts) {
  updateActiveNav($el, $window, opts);
};

/**
 * Set Navigation Offset
 * @param {jQuery} $el - header element
 * @param {Object} opts - options object
 */
var setNavOffsetValue = function setNavOffsetValue($el, opts) {
  var fixedHeader = opts.fixedHeader;
  var fixedHeaderHeight = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(fixedHeader).outerHeight() || 0;
  $el.css({
    top: "".concat(fixedHeaderHeight, "px")
  });
};

/**
 * Handle Tab Key Events
 * @param {jQuery} $el - header element
 * @param {Event} evt - key event
 */
var tabEventHandler = function tabEventHandler($el, evt) {
  if (['TAB', 'SHIFT_TAB'].includes(__WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */].parseKey(evt))) {
    unStickyNav($el);
  }
};

/**
 * Set Event Listeners
 * @param {jQuery} $el - header element
 * @param {jQuery} $html - html element
 * @param {jQuery} $window - window element
 * @param {jQuery} $body - body element
 * @param {Object} opts - options object
 */
var setEventListeners = function setEventListeners($el, $html, $window, opts) {
  var navLinks = opts.navLinks;
  $html.on('mousedown.stickyNav', function () {
    return setStickyPosition($el, $html);
  });
  $html.on('keyup.stickyNav', function (evt) {
    return tabEventHandler($el, evt);
  });
  $window.on('scroll.stickyNav', __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default()(function () {
    return scrollPositionHandler($el, $window, opts);
  }, 100));
  __WEBPACK_IMPORTED_MODULE_1_jquery___default()(navLinks).on('click', function (evt) {
    return handleSectionScroll(evt, $el, opts);
  });
};

/**
 * Initialize Fixed Navigation
 * @param {HTMLElement} el - header element
 * @param {Object} options - options object
 */
function stickyNav(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $html = __WEBPACK_IMPORTED_MODULE_1_jquery___default()('html');
  var $window = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(window);
  var $el = DEFAULTS.stickyElement ? __WEBPACK_IMPORTED_MODULE_1_jquery___default()(DEFAULTS.stickyElement) : __WEBPACK_IMPORTED_MODULE_1_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setNavOffsetValue($el, opts);
  setEventListeners($el, $html, $window, opts);
}

// Register jQuery plugin
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, stickyNav);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export SCROLL_EVENT */
/* unused harmony export RESIZE_EVENT */
/* unused harmony export WINDOW */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles scrolling effect
 * @module stickyScroll
 */




var PLUGIN_NAME = 'stickyScroll';
var SCROLL_EVENT = 'scroll';
var RESIZE_EVENT = 'resize';
var WINDOW = window;
var DEFAULTS = {
  marginTop: 0
};
var getMaxHeight = function getMaxHeight() {};

/**
 * Handle Scroll Event
 * @param  {jQuery} $el - scroll Element
 */
var scrollEventHandler = function scrollEventHandler(el, container, opts) {
  var marginTop = opts.marginTop;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(WINDOW).on("".concat(SCROLL_EVENT, " ").concat(RESIZE_EVENT), function () {
    var windowHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).height();
    var scroll = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop();
    var headerHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.site-header__content').outerHeight();
    var containerBoundaries = container.offset();
    var containerHeight = container.outerHeight();
    var containerTopPosition = containerBoundaries.top;

    // get navMaxHeight
    var navFooterOffset = scroll + windowHeight - containerTopPosition - containerHeight;
    var navFooterOffsetValue = navFooterOffset < 0 ? 0 : navFooterOffset;
    var navMaxHeight = windowHeight - headerHeight - navFooterOffsetValue;
    el.css({
      maxHeight: navMaxHeight
    });
    if (scroll + headerHeight + marginTop > containerBoundaries.top) {
      el.addClass("sticky-scroll--is-fixed").css({
        top: headerHeight + marginTop
      });
    } else {
      // Scrollling above
      el.removeClass("sticky-scroll--is-fixed");
    }
  });
};

/**
 * Set Event setEventListeners
 * @param  {jQuery} $el - dropdown wrap
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var applyEventHandlers = function applyEventHandlers(el, container) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  scrollEventHandler(el, container, opts);
};

// const getBoundaries = (el) => { el.offset() }

/**
 * Initializes Fixed Scroll.
 * @param {HTMLElement} el - scroll Element
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function stickyScroll(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var container = $el.parent('[data-sticky-scroll-container]');
  applyEventHandlers($el, container, opts);
}
// Expose the function as a jQuery plugin for ease of use
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, stickyScroll);

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export CONTAINER_CLASS_NAME */
/* unused harmony export WRAP_CLASS_NAME */
/* unused harmony export FIXED_WRAP_CLASS_NAME */
/* unused harmony export STOPPED_WRAP_CLASS_NAME */
/* unused harmony export IFRAME_CLASS_NAME */
/* unused harmony export VIMEO_API_URL */
/* unused harmony export YOUTUBE_API_URL */
/* unused harmony export FIXED_VIDEO_WIDTH */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Sticky Video
 * @module stickyVideo
 */




var PLUGIN_NAME = 'stickyVideo';
/**
 * Defines default configuration for stick video.
 * @type {Object}
 */
var DEFAULTS = {};
/**
 * CSS className used for the container.
 * @type {string}
 */
var CONTAINER_CLASS_NAME = 'sticky-video';
/**
 * CSS className used for the video wrap.
 * @type {string}
 */
var WRAP_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__wrap");
/**
 * CSS className used for fixed video wrap.
 * @type {string}
 */
var FIXED_WRAP_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__wrap--fixed"); /**
                                                                                     * CSS className used for stopped video wrap.
                                                                                     * @type {string}
                                                                                     */
var STOPPED_WRAP_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__wrap--stopped");
/**
 * CSS className used for the video iframe.
 * @type {string}
 */
var IFRAME_CLASS_NAME = "".concat(CONTAINER_CLASS_NAME, "__iframe");
/**
 * Vimeo API
 * @type {string}
 */
var VIMEO_API_URL = 'https://player.vimeo.com/api/player.js';
/**
 * YouTube API
 * @type {string}
 */
var YOUTUBE_API_URL = 'https://www.youtube.com/iframe_api';
/**
 * Video Width when fixed
 * @type {string}
 */
var FIXED_VIDEO_WIDTH = 300;
/**
 * Add selected class to selected thumbnail
 * @param {jQuery} $thumbnail - jQuery object for thumbnail
 */
var nowPlayingMessage = function nowPlayingMessage($thumbnail) {
  var selectedClass = 'beautyshop__thumbnail-selected';
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(selectedClass)).removeClass(selectedClass);
  $thumbnail.addClass(selectedClass);
};
/**
 * Reset video position
 * @private
 * @param  {jQuery} wrap - sticky wrap element
 * @param  {number} video width
 */
var unfixedVideo = function unfixedVideo(wrap, videoWidth) {
  wrap.removeClass(FIXED_WRAP_CLASS_NAME).css({
    position: "absolute",
    width: videoWidth,
    top: 0,
    left: 0,
    opacity: 0
  }).stop().animate({
    opacity: 1
  }, 600, function () {
    wrap.removeAttr("style");
  });
};
/**
 * Fixed video at the bottom
 * @private
 * @param  {jQuery} wrap - sticky wrap element
 */
var fixedVideoBottom = function fixedVideoBottom(wrap) {
  wrap.addClass("".concat(FIXED_WRAP_CLASS_NAME, " stick")).css({
    position: "fixed",
    height: 'initial',
    top: 'initial',
    bottom: 200,
    zIndex: 8,
    opacity: 0,
    left: 20,
    width: FIXED_VIDEO_WIDTH
  }).stop().animate({
    opacity: 1
  }, 700);
};
/**
 * Fixed video at the bottom
 * @private
 * @param  {jQuery} wrap - sticky wrap element
 * @param  {number} videoHeight - height of video
 * @param  {number} navBottomPosition - navigation bottom position
 */
var fixedVideoTop = function fixedVideoTop(wrap, videoHeight, navBottomPosition) {
  wrap.addClass("".concat(FIXED_WRAP_CLASS_NAME, " stick")).css({
    position: "fixed",
    height: videoHeight,
    top: navBottomPosition + 115,
    zIndex: 8,
    opacity: 0,
    left: 20,
    width: FIXED_VIDEO_WIDTH
  }).stop().animate({
    opacity: 1
  }, 700);
};
/**
 * Handle video stickiness
 * @param  {object} stickyOpts - object of sticky elements
 * @see DEFAULTS
 */
var stickyVideoFunctionality = function stickyVideoFunctionality(_ref) {
  var videoContainer = _ref.videoContainer,
    wrap = _ref.wrap,
    iframe = _ref.iframe,
    player = _ref.player;
  var $nav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".site-header .nav__wrapper");
  var videoHeight = videoContainer.outerHeight(true);
  var videoWidth = videoContainer.width();
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('scroll.stickyVideo').on('scroll.stickyVideo', function () {
    var scrollPos = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).scrollTop();
    var navOffset = $nav.offset();
    var videoOffSet = videoContainer.offset();
    var videoTopPosition = videoOffSet.top - scrollPos;
    var videoBottomPosition = videoOffSet.top - scrollPos - __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).height();
    var isHeaderFixed = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-fixed-header-wrap').hasClass('is-fixed');
    var videoDownLimit = videoHeight * .85;
    var videoUpLimit = -1 * (videoHeight - videoDownLimit);
    var navBottomPosition = isHeaderFixed ? navOffset.top - scrollPos + $nav.height() : 0;
    var isVideoAboveView = isHeaderFixed ? navBottomPosition >= videoTopPosition + videoDownLimit : -1 * videoTopPosition >= videoDownLimit;
    var isVideoBelowView = videoBottomPosition >= videoUpLimit;
    var isFixed = wrap.hasClass(FIXED_WRAP_CLASS_NAME);
    var isStopped = wrap.hasClass(STOPPED_WRAP_CLASS_NAME);
    if (!isStopped && !isFixed) {
      if (isVideoAboveView) {
        fixedVideoTop(wrap, videoHeight, navBottomPosition);
      }
      if (isVideoBelowView) {
        fixedVideoBottom(wrap);
      }
    }
    if (isFixed && !isVideoAboveView && !isVideoBelowView) {
      unfixedVideo(wrap, videoWidth);
      if (isStopped) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).off('scroll.stickyVideo');
      }
    }
  });
};
/**
 * Player on play handler
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 */
var onPlay = function onPlay(stickyOpts) {
  var wrap = stickyOpts.wrap;
  wrap.removeClass(STOPPED_WRAP_CLASS_NAME);
  stickyVideoFunctionality(stickyOpts);
};
/**
 * Player on stop handler
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 */
var onStop = function onStop(_ref2) {
  var wrap = _ref2.wrap;
  wrap.addClass(STOPPED_WRAP_CLASS_NAME);
};
/**
 * Apply Event Handler to load video
 * @param  {object} stickyOpts - object of sticky elements
 * @see DEFAULTS
 */
var applyEventHandlers = function applyEventHandlers(stickyOpts) {
  var container = stickyOpts.container;
  var $loadVideoTrigger = container.find('.js-load-video');
  $loadVideoTrigger.on('click', function (evt) {
    loadNewVideo(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), stickyOpts);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-video').focus();
  });
};
/**
 * Set up Vimeo player event
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 */
var setVimeoEvents = function setVimeoEvents(stickyOpts) {
  var player = stickyOpts.player;
  applyEventHandlers(stickyOpts);
  player.on('play', function () {
    onPlay(stickyOpts);
  });
  player.on('pause', function () {
    onStop(stickyOpts);
  });
};
/**
 * Clean title for GA tracking
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 * @return {string} unique id for youtube initialization
 */
var createUniqueID = function createUniqueID(_ref3) {
  var iframe = _ref3.iframe;
  var ytid = "yt-".concat(Math.ceil(Math.random() * 10000000000));
  iframe.attr('id', ytid);
  return ytid;
};
/**
 * Check Vimeo auto play
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 * @param  {event} youtube play event
 */
var checkVimeoAutoplay = function checkVimeoAutoplay(_ref4) {
  var iframe = _ref4.iframe,
    player = _ref4.player;
  var autoplay = iframe.data('autoplay');
  if (autoplay) {
    player.ready().then(function () {
      player.play();
    });
  }
};
/**
 * Check YouTube auto play
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 * @param  {event} youtube play event
 */
var checkYouTubeAutoPlay = function checkYouTubeAutoPlay(_ref5) {
  var iframe = _ref5.iframe;
  return function (event) {
    var autoplay = iframe.data('autoplay');
    if (autoplay) {
      event.target.playVideo();
    }
  };
};
/**
 * Set up YouTube player event
 * @private
 * @param  {event} youtube play event
 */
var setYouTubeEvents = function setYouTubeEvents(stickyOpts) {
  return function (event) {
    switch (event.data) {
      case 1:
        onPlay(stickyOpts);
        break;
      case 2:
        onStop(stickyOpts);
        break;
      default:
    }
  };
};
/**
 * Init YouTube Player
 * @private
 * @param  {jQuery} $el - iframe of video to track
 * @param  {object} stickyOpts - object of sticky elements
 */
var initYouTubeVideo = function initYouTubeVideo(stickyOpts) {
  var ytid = createUniqueID(stickyOpts);
  var setYTEvents = setYouTubeEvents(stickyOpts);
  applyEventHandlers(stickyOpts);
  var ytCheckAutoPlay = checkYouTubeAutoPlay(stickyOpts);
  return new YT.Player(ytid, {
    events: {
      onReady: ytCheckAutoPlay,
      onStateChange: setYTEvents
    }
  });
};
/**
 * Setup players for respective video sources
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 */
var setupPlayer = function setupPlayer(stickyOpts) {
  var iframe = stickyOpts.iframe;
  if (playerType(iframe, 'vimeo')) {
    var vimeoPlayer = new Vimeo.Player(iframe);
    var opts = Object.assign({}, stickyOpts, {
      player: vimeoPlayer
    });
    setVimeoEvents(opts);
    checkVimeoAutoplay(opts);
  } else if (playerType(iframe, 'youtube')) {
    if (window.youtubeLoaded) {
      var ytPlayer = initYouTubeVideo(stickyOpts);
      var _opts = Object.assign({}, stickyOpts, {
        player: ytPlayer
      });
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('youtubeLoaded', function () {
      var ytPlayer = initYouTubeVideo(stickyOpts);
      var opts = Object.assign({}, stickyOpts, {
        player: ytPlayer
      });
    });
  }
};
/**
 * Attach a new a video base on selection
 * @param  {jQuery} $trigger - the element that triggers this function
 * @param  {object} stickyOpts - object of sticky elements
 * @see DEFAULTS
 */
var loadNewVideo = function loadNewVideo($trigger, stickyOpts) {
  var container = stickyOpts.container,
    iframe = stickyOpts.iframe;
  var videoUrl = $trigger.data('video-url');
  var videoTitle = $trigger.children('.js-video-title').text();
  var $stickyIframeWrap = container.find('.sticky-video__iframe-wrap');
  var newVideoIFrame = "\n    <iframe id=\"js-video\" class=\"".concat(IFRAME_CLASS_NAME, "\"\n    src=\"").concat(videoUrl, "?autoplay=1\"\n    width=\"100%\"\n    height=\"100%\"\n    title=\"").concat(videoTitle, "\"\n    data-autoplay=\"true\"\n    frameborder=\"0\"\n    webkitallowfullscreen\n    mozallowfullscreen\n    allowfullscreen>\n    </iframe>\n  ");
  $stickyIframeWrap.html(newVideoIFrame);
  var opts = Object.assign({}, stickyOpts, {
    iframe: __WEBPACK_IMPORTED_MODULE_0_jquery___default()("#js-video")
  });
  nowPlayingMessage($trigger);
  setupPlayer(opts);
};
/**
 * Setup players for respective video sources
 * @param  {jQuery} $el - iframe of video to track
 * @param  {string} string of video type to test source against
 */
var playerType = function playerType($el, type) {
  var src = $el.attr('src').toLowerCase();
  if (src.indexOf(type) !== -1) {
    return true;
  }
  return false;
};
/**
 * Load correct api base on url
 * @private
 * @param  {object} stickyOpts - object of sticky elements
 */
var loadAPI = function loadAPI(stickyOpts) {
  var apiURL;
  var apiURL2;
  var iframe = stickyOpts.iframe;
  if (playerType(iframe, 'vimeo')) {
    apiURL = VIMEO_API_URL;
    apiURL2 = YOUTUBE_API_URL;
  } else if (playerType(iframe, 'youtube')) {
    apiURL = YOUTUBE_API_URL;
    apiURL2 = VIMEO_API_URL;
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: apiURL,
    cache: true,
    dataType: 'script'
  }).done(function () {
    setupPlayer(stickyOpts);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: apiURL2,
    cache: true,
    dataType: 'script'
  });
};

/**
 * Initializes an toggleContent based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the
 * toggleContent
 * @param {Object} options - Options used for wiring up the toggleContent
 * @see DEFAULTS
 */
function stickyVideo(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var $stickyContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(CONTAINER_CLASS_NAME));
  var $stickWrap = $stickyContainer.find(".".concat(WRAP_CLASS_NAME));
  var $stickIFrame = $stickyContainer.find(".".concat(IFRAME_CLASS_NAME));
  var stickyOpts = {
    container: $el,
    videoContainer: $stickyContainer,
    wrap: $stickWrap,
    iframe: $stickIFrame
  };
  loadAPI(stickyOpts);
}
;
/**
 * Add event for YouTube API ready method
 */
window.onYouTubeIframeAPIReady = function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).trigger('youtubeLoaded');
  window.youtubeLoaded = true;
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, stickyVideo);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Toggle classes
 * @module switchClass
 */




// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'switchClass';
var DEFAULTS = {
  switchClass: '',
  switchTarget: ''
};

/**
 * Applies any sort of event handlers for the switchClass.
 * @param  {jQuery} $el - link
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $el.on('click', function (evt) {
    evt.preventDefault();
    var $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($el.attr('href'));
    // If a data-switch-target attribute was used instead of href
    if (options.switchTarget !== '') {
      $changingElClass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.switchTarget);
    }
    $changingElClass.toggleClass(options.switchClass);
  });
};
/**
 * Initializes switchClass.
 * @param {HTMLElement} el - link
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function switchClass(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, switchClass);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Responsible for showing/hiding content based on a tab structure
 * @module modules/tabs
 */


var JS_TABS_DEFAULT_OPTIONS = {
  tab: '.tabs__link',
  tabContent: '.tabs__content',
  tabContentActive: 'tabs__content--active',
  tabActive: 'tabs__link--active',
  tabToggleOff: false,
  tabUrl: ''
};
var makeToggleTab = function makeToggleTab($tab, initialActiveClass, activeClass, tabToggleOff) {
  return function ($target) {
    var isTabActive = $target.hasClass(activeClass);
    $tab.removeClass(activeClass).attr('tabindex', '-1') // Make inactive tabs not focusable
    .find('.u-screen-reader').remove();
    if (isTabActive && tabToggleOff) {
      $target.removeClass(activeClass).attr('tabindex', '-1').find('.u-screen-reader').remove();
    } else {
      $target.addClass(activeClass).attr('tabindex', '0') // Make active tab focusable
      .append('<span class="u-screen-reader" aria-live="assertive"> has been selected</span>');
    }
    if (initialActiveClass) {
      $tab.removeClass(initialActiveClass);
      $tab.attr('aria-selected', false);
      $target.addClass(initialActiveClass);
      $target.attr('aria-selected', true);
    }
  };
};
var showImages = function showImages(target) {
  // lazy load hidden tab images on click
  // * consider only loading images in view and then using scroll to load the rest
  var $lazyImages = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target).find('img[data-src]').not('.loaded');
  if ($lazyImages.length) {
    $lazyImages.lazy({
      bind: "event",
      effect: 'fadeIn'
    }).addClass('loaded');
  }
};
var makeToggleContent = function makeToggleContent($content, tabContentActive, tabToggleOff) {
  return function ($target) {
    var $contentSelector = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($target.data('tab-content'));
    var isTabContentActive = $contentSelector.hasClass(tabContentActive);
    $content.removeClass(tabContentActive);
    if (isTabContentActive && tabToggleOff) {
      $contentSelector.removeClass(tabContentActive);
    } else {
      $contentSelector.addClass(tabContentActive).parent().children().not($contentSelector).removeClass(tabContentActive);
    }
    showImages($contentSelector);
  };
};
var resizeSlick = function resizeSlick($target, slickTarget) {
  var contentSelector = $target.data('tab-content');
  var $slickCarousel = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(contentSelector).find(slickTarget);
  $slickCarousel.slick('setPosition');
};
var tabs = function tabs(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var _Object$assign = Object.assign({}, JS_TABS_DEFAULT_OPTIONS, $el.data(), options),
    tab = _Object$assign.tab,
    tabContent = _Object$assign.tabContent,
    tabActive = _Object$assign.tabActive,
    tabContentActive = _Object$assign.tabContentActive,
    tabToggleOff = _Object$assign.tabToggleOff,
    tabUrl = _Object$assign.tabUrl;
  var $tab = $el.find(tab);
  var $content = $el.find(tabContent);
  var $tabContentActive = $el.find('.' + tabContentActive);
  var activeTabClass = $el.data('active-tab') ? $el.data('active-tab').replace('.', '') : false;
  var toggleTab = makeToggleTab($tab, activeTabClass, tabActive, tabToggleOff);
  var toggleContent = makeToggleContent($content, tabContentActive, tabToggleOff);
  showImages($tabContentActive);

  // Initialize tabindex for all tabs
  $tab.each(function () {
    var $currentTab = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if ($currentTab.hasClass(tabActive)) {
      $currentTab.attr('tabindex', '0');
    } else {
      $currentTab.attr('tabindex', '-1');
    }
  });
  var activateTab = function activateTab($target) {
    var slickTarget = $target.data('tab-slick-initializer');
    var tabUrl = $target.data('tab-url');
    toggleTab($target);
    toggleContent($target);
    if (tabUrl && !$target.hasClass('loaded')) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
        url: tabUrl,
        success: function success(response) {
          var contentSelector = $target.data('tab-content');
          var $tabContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(contentSelector);
          $tabContent.html(response);
          showImages($tabContent[0]);
          $target.addClass('loaded');
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.error("".concat(textStatus, " ").concat(errorThrown));
        }
      });
    }
    if (slickTarget) {
      resizeSlick($target, slickTarget);
    }
    $target.trigger('tab:activated');
  };
  $tab.on('click', function (e) {
    e.preventDefault();
    var $target = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget);
    activateTab($target);
  });

  // Add keyboard navigation
  $tab.on('keydown', function (e) {
    var $currentTab = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget);
    var currentIndex = $tab.index($currentTab);
    var $targetTab;
    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        // Move to previous tab (wrap to last if at first)
        $targetTab = currentIndex > 0 ? $tab.eq(currentIndex - 1) : $tab.eq($tab.length - 1);
        activateTab($targetTab);
        $targetTab.focus();
        break;
      case 'ArrowRight':
        e.preventDefault();
        // Move to next tab (wrap to first if at last)
        $targetTab = currentIndex < $tab.length - 1 ? $tab.eq(currentIndex + 1) : $tab.eq(0);
        activateTab($targetTab);
        $targetTab.focus();
        break;
      case 'Home':
        e.preventDefault();
        // Move to first tab
        $targetTab = $tab.eq(0);
        activateTab($targetTab);
        $targetTab.focus();
        break;
      case 'End':
        e.preventDefault();
        // Move to last tab
        $targetTab = $tab.eq($tab.length - 1);
        activateTab($targetTab);
        $targetTab.focus();
        break;
    }
  });
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])('tabs', tabs);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles radios and checkboxes change event to toggle a class to a given element
 * @module toggleChange
 */




var PLUGIN_NAME = 'toggleChange';
var DEFAULTS = {
  ctToggleClass: '',
  ctSelector: '',
  ctInverse: false,
  ctChildSelector: [],
  ctChildToggleClass: [],
  ctChildInverse: []
};

/**
 * Normalizes an option into an array so callers can safely iterate it.
 * jQuery's .data() only parses a data attribute into an array when it is
 * valid JSON (double quotes); a single-quoted value comes through as a raw
 * string. This accepts a real array, a bracketed string (single or double
 * quotes), or a plain string, and always returns an array.
 * @param  {Array|String} value - option value from data attributes / init
 * @return {Array} normalized array (empty when nothing usable is provided)
 */
var toArray = function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value !== 'string' || value.trim() === '') {
    return [];
  }
  var trimmed = value.trim();
  if (trimmed.charAt(0) === '[' && trimmed.charAt(trimmed.length - 1) === ']') {
    try {
      var parsed = JSON.parse(trimmed.replace(/'/g, '"'));
      return Array.isArray(parsed) ? parsed : [parsed];
    } catch (e) {
      return trimmed.slice(1, -1).split(',').map(function (item) {
        return item.trim().replace(/^['"]+|['"]+$/g, '');
      }).filter(Boolean);
    }
  }
  return [trimmed];
};

/**
 * Return the input type of the element
 * @param  {jQuery} $el - checkbox / radio
 * @return {String} type of either checkbox or radio
 */
var inputType = function inputType($el) {
  return $el.attr('type');
};

/**
 * Return radio group
 * @param  {jQuery} $el - checkbox / radio
 * @return {jQuery} radio group
 */
var radioGroup = function radioGroup($el) {
  var groupName = $el.attr('name');
  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[type=\"radio\"][name=\"".concat(groupName, "\"]"));
};
var toggleClassHandler = function toggleClassHandler($el, action, opts) {
  if (action == "add" && !opts.ctInverse || action == "remove" && opts.ctInverse) {
    $el.addClass(opts.ctToggleClass);
  }
  if (action == "remove" && !opts.ctInverse || action == "add" && opts.ctInverse) {
    $el.removeClass(opts.ctToggleClass);
  }
};
var toggleChildClassHandler = function toggleChildClassHandler($el, action, opts) {
  opts.ctChildSelector.forEach(function (childSelector, index) {
    var childToggleClass = opts.ctChildToggleClass[index];
    $el.find(childSelector).each(function toggleFoundChild() {
      var $child = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      if (action == "add" && !opts.ctChildInverse[index] || action == "remove" && opts.ctChildInverse[index]) {
        $child.addClass(childToggleClass);
      }
      if (action == "remove" && !opts.ctChildInverse[index] || action == "add" && opts.ctChildInverse[index]) {
        $child.removeClass(childToggleClass);
      }
    });
  });
};

/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $selector = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.ctSelector);
  var type = inputType($el);
  if (type === 'radio') {
    var $radioGroup = radioGroup($el);
    var deselectEvent = "deselect-".concat($el.attr('name'));
    $radioGroup.on('click', function customDeselectEvent() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()("input[name=\"".concat(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('name'), "\"]")).not(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this)).trigger(deselectEvent);
    });
    $el.on('change', function () {
      toggleClassHandler($selector, "add", options);
    }).on(deselectEvent, function () {
      toggleClassHandler($selector, "remove", options);
    });
  }
  if (type === 'checkbox') {
    $el.on('change', function (evt) {
      if (evt.currentTarget.checked) {
        toggleClassHandler($selector, "add", options);
        if (options.ctChildSelector.length > 0 && options.ctChildToggleClass.length > 0) {
          toggleChildClassHandler($selector, "add", options);
        }
      }
      if (!evt.currentTarget.checked) {
        toggleClassHandler($selector, "remove", options);
        if (options.ctChildSelector.length > 0 && options.ctChildToggleClass.length > 0) {
          toggleChildClassHandler($selector, "remove", options);
        }
      }
    });
  }
};
/**
 * Set dom state if element is checked
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setChecked = function setChecked($el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $selector = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.ctSelector);
  if ($el[0].checked && !$el[0].disabled && !options.ctInverse) {
    $selector.addClass(options.ctToggleClass);
    if (options.ctChildSelector.length > 0 && options.ctChildToggleClass.length > 0) {
      toggleChildClassHandler($selector, "add", options);
    }
  }
};
/**
 * Initializes toggleChange.
 * @param {HTMLElement} el - button /element that triggers toggleChange
 * @param {Object} options - Options used for wiring up the toggleChange
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */

function toggleChange(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  opts.ctChildSelector = toArray(opts.ctChildSelector);
  opts.ctChildToggleClass = toArray(opts.ctChildToggleClass);
  opts.ctChildInverse = toArray(opts.ctChildInverse);
  setEventListeners($el, opts);
  setChecked($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleChange);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_HANDLER */
/* unused harmony export CHANGE_HANDLER */
/* unused harmony export FOCUS_HANDLER */
/* unused harmony export BLUR_HANDLER */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keyboard__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/**
 * Toggle Display on click
 * @module toggleDisplay
 */





var PLUGIN_NAME = 'toggleDisplay';
var CLICK_HANDLER = 'click';
var CHANGE_HANDLER = 'change';
var FOCUS_HANDLER = 'focus';
var BLUR_HANDLER = 'blur';
var DEFAULTS = {};

/**
 * Handle Toggling Event
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var toggler = function toggler($el, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE) {
  if (ANIMATION_TYPE === 'pop') {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_SHOW).show();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_HIDE).hide();
  } else {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_SHOW).slideDown();
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_HIDE).slideUp();
  }
};
var selfToggler = function selfToggler($el, TOGGLE_THIS, ANIMATION_TYPE) {
  if (ANIMATION_TYPE === 'slide') {
    if ($el.hasClass('is-active')) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_THIS).slideUp();
      $el.removeClass('is-active');
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_THIS).slideDown();
      $el.addClass('is-active');
    }
  } else {
    if ($el.hasClass('is-active')) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_THIS).hide();
      $el.removeClass('is-active');
    } else {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(TOGGLE_THIS).show();
      $el.addClass('is-active');
    }
  }
};
var setEventListeners = function setEventListeners($el, TOGGLE_THIS, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE, options) {
  $el.on(CLICK_HANDLER, function () {
    if (TOGGLE_THIS) {
      selfToggler($el, TOGGLE_THIS, ANIMATION_TYPE, options);
    } else {
      toggler($el, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE, options);
    }
  });
  $el.on(CHANGE_HANDLER, function () {
    var selectedOption = $el.find(':selected');
    var $showElements = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(selectedOption.attr('data-toggle-select-show'));
    var $hideElements = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(selectedOption.attr('data-toggle-select-hide'));
    var $animationType = selectedOption.attr('data-toggle-select-animation');
    if ($showElements && $hideElements) {
      toggler(selectedOption, $showElements, $hideElements, $animationType, options);
    }
  });
  $el.on(FOCUS_HANDLER, function () {
    toggler($el, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE, options);
  });
};

/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function toggleDisplay(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  var TOGGLE_SHOW = $el.data('toggle-select-show');
  var TOGGLE_HIDE = $el.data('toggle-select-hide');
  var TOGGLE_THIS = $el.data('toggle-select-this');
  var ANIMATION_TYPE = $el.data('toggle-select-animation');
  setEventListeners($el, TOGGLE_THIS, TOGGLE_SHOW, TOGGLE_HIDE, ANIMATION_TYPE, options);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleDisplay);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export ACTIVE_CLASS */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Toggle Elements on click
 * @module toggleElements
 */




var PLUGIN_NAME = 'toggleElements';
var ACTIVE_CLASS = 'toggle-text--is-active';
var DEFAULTS = {
  toggleElementDefault: '',
  // Corrected option names
  toggleElementAlt: '',
  // Corrected option names
  toggleTextPoliteness: 'assertive'
};

/**
 * Add aria live attribute to targeted el
 * @param  {jQuery} $el - button /element that toggles text or elements
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, _ref) {
  var toggleElementDefault = _ref.toggleElementDefault,
    toggleElementAlt = _ref.toggleElementAlt;
  var toggleElements = function toggleElements() {
    var isChecked = $el.is(':checked');
    var $defaultElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(toggleElementDefault));
    var $altElement = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(toggleElementAlt));
    if (isChecked) {
      $defaultElement.hide();
      $altElement.show();
    } else {
      $defaultElement.show();
      $altElement.hide();
    }
    $el.toggleClass(ACTIVE_CLASS);
  };
  $el.on('click.triggerElements', toggleElements);
  $el.on('change.triggerElements', toggleElements);
};

/**
 * Initializes the toggleElement or toggleElements.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function toggleElement(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleElement);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/**
 * Handles back to top button
 * @module toggleReveal
 */



var PLUGIN_NAME = 'toggleReveal';
var DEFAULTS = {};
var makeDisableFocus = function makeDisableFocus(toggleContainer, toggleButton) {
  return function () {
    toggleContainer.find('a').not(toggleButton).attr('tabindex', -1);
  };
};
var makeEnableFocus = function makeEnableFocus(toggleContainer, toggleButton) {
  return function () {
    toggleContainer.find('a').not(toggleButton).attr('tabindex', 0).attr('aria-hidden', false).focus({
      preventScroll: true
    });
  };
};
var updateButtonCopy = function updateButtonCopy(toggleButton) {
  var currentText = toggleButton.find('.action-button__copy').text();
  var newToggleText = toggleButton.data('close-copy');
  toggleButton.data('close-copy', currentText).find('.action-button__copy').text(newToggleText);
};
var makeHandleReveal = function makeHandleReveal(toggleButton, toggleContainer, disableFocus, enableFocus) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-similar-items').css({
      'height': 'initial',
      'padding-bottom': 'initial'
    });
    toggleContainer.toggleClass('active');
    var redirectUrl = toggleButton.data('url');
    updateButtonCopy(toggleButton);
    if (toggleContainer.hasClass('active')) {
      // Check if the slidedown button has a specific class and hide it
      if (toggleButton.hasClass('js-slidedown--toggle-display')) {
        toggleButton.hide();
      }
      enableFocus();
      if (redirectUrl) {
        var anchor = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<a>', {
          href: redirectUrl,
          "class": toggleButton.attr('class'),
          html: toggleButton.html()
        });
        toggleButton.replaceWith(anchor);
      }
    } else {
      if (redirectUrl) {
        if (toggleButton.prop("tagName").toLowerCase() === 'button') {
          var btnURL = "window.location = \"".concat(redirectUrl, "\"");
          toggleButton.attr('onClick', btnURL).trigger('click');
        } else {
          // assumes it's an anchor tag
          toggleButton.attr('href', redirectUrl);
          toggleContainer.addClass('active');
        }
      }
      disableFocus();
    }
  };
};
function toggleReveal(el) {
  var toggleButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var toggleContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(toggleButton.data('containerSelector'));
  var disableFocus = makeDisableFocus(toggleContainer, toggleButton);
  var enableFocus = makeEnableFocus(toggleContainer, toggleButton);
  var handleReveal = makeHandleReveal(toggleButton, toggleContainer, disableFocus, enableFocus);
  disableFocus();
  toggleButton.on('click', handleReveal);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleReveal);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export CLICK_HANDLER */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Toggle Row and Text of CTA on click
 * @module toggleRow
 */




var PLUGIN_NAME = 'toggleRow';
var CLICK_HANDLER = 'click';
var DEFAULTS = {};

/**
 * Add aria live attribute to targeted el
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [opts={}] - Any options provided upon initialization
 */

var addClass = function addClass($toggleBlock, className) {
  $toggleBlock.addClass(className);
};
var removeClass = function removeClass($toggleBlock, className) {
  $toggleBlock.removeClass(className);
};
var updateText = function updateText($el, newText) {
  $el.text(newText);
};
var toggleView = function toggleView($el, opts) {
  var container = opts.container,
    toggleBlock = opts.toggleBlock,
    activeClass = opts.activeClass,
    updatedText = opts.updatedText,
    defaultText = opts.defaultText;
  var $toggleBlock = $el.closest(container).find(toggleBlock);
  var hasClass = $toggleBlock.hasClass(activeClass);
  if (hasClass) {
    removeClass($toggleBlock, activeClass);
    updateText($el, defaultText);
  } else {
    addClass($toggleBlock, activeClass);
    updateText($el, updatedText);
  }
};
var setEventListeners = function setEventListeners($el, opts) {
  $el.on(CLICK_HANDLER, function (evt) {
    evt.preventDefault();
    toggleView($el, opts);
  });
};

/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function toggleRowInit(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleRowInit);

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export ACTIVE_CLASS */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Toggle Text on click
 * @module toggleText
 */




var PLUGIN_NAME = 'toggleText';
var ACTIVE_CLASS = 'toggle-text--is-active';
var DEFAULTS = {
  toggleTextTargetClass: '',
  toggleTextDefault: '',
  toggleTextAlt: '',
  toggleTextPoliteness: 'assertive'
};

/**
 * Applies any event handlers to toggle text trigger
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var makeAccessible = function makeAccessible(_ref) {
  var toggleTextTargetClass = _ref.toggleTextTargetClass,
    toggleTextPoliteness = _ref.toggleTextPoliteness;
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(toggleTextTargetClass)).each(function ariaLiveTriggers() {
    var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    if (!$el.data('no-aria-live')) {
      $el.attr('aria-live', toggleTextPoliteness);
    }
  });
};
/**
 * Add aria live attribute to targeted el
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, _ref2) {
  var toggleTextTargetClass = _ref2.toggleTextTargetClass,
    toggleTextDefault = _ref2.toggleTextDefault,
    toggleTextAlt = _ref2.toggleTextAlt;
  $el.on('click.triggerText', function (evt) {
    evt.preventDefault();
    var isActive = $el.hasClass(ACTIVE_CLASS);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(toggleTextTargetClass)).each(function changeText() {
      var $changingEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      if ($changingEl.data('toggle-text-reverse')) {
        $changingEl.text(isActive ? toggleTextAlt : toggleTextDefault);
      } else {
        $changingEl.text(isActive ? toggleTextDefault : toggleTextAlt);
      }
    });
    $el.toggleClass(ACTIVE_CLASS);
  });
  $el.on('change.triggerText', function (evt) {
    var isActive = $el.is(':checked').hasClass(ACTIVE_CLASS);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(".".concat(toggleTextTargetClass)).each(function changeText() {
      var $changingEl = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
      if ($changingEl.data('toggle-text-reverse')) {
        $changingEl.text(isActive ? toggleTextAlt : toggleTextDefault);
      } else {
        $changingEl.text(isActive ? toggleTextDefault : toggleTextAlt);
      }
    });
    $el.toggleClass(ACTIVE_CLASS);
  });
};
var hasHash = function hasHash($el) {
  var href = $el.attr('href');
  if (href) {
    if (href.toLowerCase().indexOf('#') !== -1 && href.length > 1) {
      return href;
    }
  }
  return false;
};
/**
 * Give <a> a unique href value, in order to avoid users hearing
 * "visited" on links they've yet to visit.
 * @param  {jQuery} $el - button /element that toggles text
 */
var makeUniqueHash = function makeUniqueHash($el) {
  if ($el.is('a') && !hasHash($el)) {
    $el.attr('href', "#toggle-text-uid-".concat(Math.ceil(Math.random() * 10000000000)));
  }
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function toggleText(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  makeAccessible(opts);
  makeUniqueHash($el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, toggleText);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Tooltip functunality
 * @module tooltip
 */




var PLUGIN_NAME = 'tooltip';
var DEFAULTS = {
  preventDefault: true,
  removeTooltipOnHover: false
};

/**
 * Sends focus to the content container.
 * @param  {jQuery} $el - button /element that toggles text
 */
var scrollToView = function scrollToView($el) {
  var tooltipContent = '.js-tooltip-content';
  $el.find(tooltipContent).focus();
};
/**
 * Prevents default functunality on click
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
var setEventListeners = function setEventListeners($el, opts) {
  $el.on('click', function (evt) {
    if (opts.preventDefault === true) {
      evt.preventDefault();
    }
    scrollToView($el);
  });
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-tooltip-content').find('a').on('click', function (e) {
    e.stopPropagation();
  });

  // if Tooltip has data attribute data-remove-tooltip-hover
  var dataremoveTooltipOnHover = $el.data('remove-tooltip-on-hover'); // Accesses data-remove-tooltip-hover
  var removeTooltipOnHover = dataremoveTooltipOnHover !== undefined ? dataremoveTooltipOnHover === true || dataremoveTooltipOnHover === "" : opts.removeTooltipOnHover;
  if (removeTooltipOnHover) {
    var tooltipContent = $el.find('.js-tooltip-content');
    // Show child tooltip when hovering over the parent
    $el.on('mouseenter', function () {
      tooltipContent.removeClass('js-remove-hover');
    });
    // Hide tooltip when the mouse leaves the parent area
    $el.on('mouseleave', function () {
      tooltipContent.addClass('js-remove-hover');
    });
    // MUST Hide when hovering OVER the tooltip itself
    tooltipContent.on('mouseenter', function (e) {
      e.stopPropagation(); // Prevents the event from bubbling up to the parent
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('js-remove-hover');
    });
  }
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function tooltip(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, tooltip);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULTS */
/* unused harmony export PLUGIN_NAME */
/* unused harmony export VIMEO_API_URL */
/* unused harmony export YOUTUBE_API_URL */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_merge_options__ = __webpack_require__(2);
/**
 * Handles all Video tracking
 * @module trackVideo
 */




var DEFAULTS = {
  eventCategory: 'Beauty Video'
};

// Expose the function as a jQuery plugin for ease of use
var PLUGIN_NAME = 'trackVideo';
var VIMEO_API_URL = 'https://player.vimeo.com/api/player.js';
var YOUTUBE_API_URL = 'https://www.youtube.com/iframe_api';

/**
 * Setup players for respective video sources
 * @param  {jQuery} $el - iframe of video to track
 * @param  {string} string of video type to test source against
 */
var playerType = function playerType($el, type) {
  var src = $el.attr('src').toLowerCase();
  if (src.indexOf(type) !== -1) {
    return true;
  }
  return false;
};

/**
 * Clean title for GA tracking
 * @param  {string} video title
 * @return {string} clean title with no space or special characters
 */
var cleanTitle = function cleanTitle(title) {
  return title.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-');
};

/**
 * Set up Vimeo player event
 * @param  {object} vimeo player
 */
var setVimeoEvents = function setVimeoEvents(player, opts) {
  var videoTitle;
  player.getVideoTitle().then(function (title) {
    videoTitle = cleanTitle(title);
  });
  player.on('play', function () {});
};
/**
 * Clean title for GA tracking
 * @param  {jQuery} $el - iframe of video to track
 * @return {string} unique id for youtube initialization
 */
var createUniqueID = function createUniqueID($el) {
  var ytid = "yt-".concat(Math.ceil(Math.random() * 10000000000));
  $el.attr('id', ytid);
  return ytid;
};
/**
 * Init YouTube Player
 * @param  {event} youtube player event
 */
var onYouTubePlayerReady = function onYouTubePlayerReady(event) {
  var videoTitle = cleanTitle(event.target.getVideoData().title);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target.a).data('video-title', videoTitle);
};

/**
 * Init YouTube Player
 * @param  {jQuery} $el - iframe of video to track
* @return {object} YT Object
 */
var initYouTubeVideo = function initYouTubeVideo($el, opts) {
  var ytid = createUniqueID($el);
  return new YT.Player(ytid, {
    events: {
      onReady: onYouTubePlayerReady,
      onStateChange: function onStateChange(event) {}
    }
  });
};
/**
 * Setup players for respective video sources
 * @param  {jQuery} $el - iframe of video to track
 */
var setupPlayer = function setupPlayer($el, opts) {
  if (playerType($el, 'vimeo')) {
    var player = new Vimeo.Player($el);
    setVimeoEvents(player, opts);
  } else if (playerType($el, 'youtube')) {
    if (window.youtubeLoaded) {
      initYouTubeVideo($el, opts);
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('youtubeLoaded', function () {
      initYouTubeVideo($el, opts);
    });
  }
};
/**
 * Load correct api base on url
 * @param  {jQuery} $el - iframe of video to track
 */
var loadAPI = function loadAPI($el, opts) {
  var apiURL;
  if (playerType($el, 'vimeo')) {
    apiURL = VIMEO_API_URL;
  } else if (playerType($el, 'youtube')) {
    apiURL = YOUTUBE_API_URL;
  }
  __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
    url: apiURL,
    cache: true,
    dataType: 'script'
  }).done(function () {
    setupPlayer($el, opts);
  });
};
/**
 * Initializes modal.
 * @param {HTMLElement} el - iframe of video to track
 * @see DEFAULTS
 */
function trackVideo(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  loadAPI($el, opts);
}

/**
* Add event for YouTube API ready method
*/
window.onYouTubeIframeAPIReady = function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).trigger('youtubeLoaded');
  window.youtubeLoaded = true;
};
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, trackVideo);

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLUGIN_NAME */
/* unused harmony export DEFAULTS */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_breaky__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_breaky___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_breaky__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge_options__ = __webpack_require__(2);
/**
 * Toggle Text on click
 * @module trimTotal
 */





var PLUGIN_NAME = 'trimTotal';
// export const ACTIVE_CLASS = 'toggle-text--is-active';

var DEFAULTS = {
  total: 0,
  elementToUpdate: 'order-history__img-overlay-text',
  elementContainer: '.order-history__img-container',
  overlayClass: 'order-history__img-overlay',
  totalShown: {
    tablet: 3,
    smallDesktop: 4,
    desktop: 5
  }
};
var addOverlay = function addOverlay($el, elementToUpdate, elementContainer, overlayClass, totalHiddenNumber, childElementToSelect) {
  var layoverMarkup = "<div class=\"".concat(overlayClass, "\">\n                              <p class=\"").concat(elementToUpdate, "\">+").concat(totalHiddenNumber, "</p>\n                          </div>");
  $el.find("".concat(elementContainer, ":nth-child(").concat(childElementToSelect, ")")).append(layoverMarkup);
};
var removeOverlay = function removeOverlay($el, overlayClass) {
  $el.find(".".concat(overlayClass)).remove();
};
var makeUpdateImages = function makeUpdateImages($el, overlayClass, total, elementToUpdate, elementContainer) {
  return function (shown, breakpoint) {
    removeOverlay($el, overlayClass);
    if (total > shown) {
      var elementWithOverlay = 1;
      var totalHiddenNumber = total - shown + elementWithOverlay;
      var childElementToSelect = shown;
      addOverlay($el, elementToUpdate, elementContainer, overlayClass, totalHiddenNumber, childElementToSelect);
    }
  };
};

/**
 * Applies any event handlers to toggle text trigger
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */

var updateTotalNumber = function updateTotalNumber($el, _ref) {
  var total = _ref.total,
    elementToUpdate = _ref.elementToUpdate,
    elementContainer = _ref.elementContainer,
    overlayClass = _ref.overlayClass,
    totalShown = _ref.totalShown;
  var $elementToUpdate = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elementToUpdate);
  var shownAtTablet = totalShown.tablet;
  var shownAtSmallDesktop = totalShown.smallDesktop;
  var shownAtDesktop = totalShown.desktop;
  var childElementToSelect = 0;
  var updateImage = makeUpdateImages($el, overlayClass, total, elementToUpdate, elementContainer);
  __WEBPACK_IMPORTED_MODULE_2_breaky___default.a.at("tablet", function () {
    updateImage(shownAtTablet, 'tablet');
  });
  __WEBPACK_IMPORTED_MODULE_2_breaky___default.a.at("small-desktop", function () {
    updateImage(shownAtSmallDesktop, 'small-desktop');
  });
  __WEBPACK_IMPORTED_MODULE_2_breaky___default.a.above("desktop", function () {
    updateImage(shownAtDesktop, 'desktop');
  });
};

/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
function trimTotal(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var $el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
  var opts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib_merge_options__["a" /* default */])(DEFAULTS, options, $el);
  updateTotalNumber($el, opts);
}
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__lib_register_jquery_plugin__["a" /* default */])(PLUGIN_NAME, trimTotal);

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(11);
var tryToString = __webpack_require__(367);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(139);
var create = __webpack_require__(354);
var defineProperty = __webpack_require__(32).f;

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(13);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(17);
var ownKeys = __webpack_require__(362);
var getOwnPropertyDescriptorModule = __webpack_require__(128);
var definePropertyModule = __webpack_require__(32);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(11);
var definePropertyModule = __webpack_require__(32);
var makeBuiltIn = __webpack_require__(352);
var defineGlobalProperty = __webpack_require__(65);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(8);

var navigator = globalThis.navigator;
var userAgent = navigator && navigator.userAgent;

module.exports = userAgent ? String(userAgent) : '';


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(8);
var userAgent = __webpack_require__(340);

var process = globalThis.process;
var Deno = globalThis.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(8);
var getOwnPropertyDescriptor = __webpack_require__(128).f;
var createNonEnumerableProperty = __webpack_require__(121);
var defineBuiltIn = __webpack_require__(339);
var defineGlobalProperty = __webpack_require__(65);
var copyConstructorProperties = __webpack_require__(338);
var isForced = __webpack_require__(349);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis;
  } else if (STATIC) {
    target = globalThis[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis[TARGET] && globalThis[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(14);
var hasOwn = __webpack_require__(17);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && function something() { /* empty */ }.name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(335);
var isNullOrUndefined = __webpack_require__(126);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(68);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(13);
var fails = __webpack_require__(12);
var classof = __webpack_require__(337);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(13);
var isCallable = __webpack_require__(11);
var store = __webpack_require__(70);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(368);
var globalThis = __webpack_require__(8);
var isObject = __webpack_require__(31);
var createNonEnumerableProperty = __webpack_require__(121);
var hasOwn = __webpack_require__(17);
var shared = __webpack_require__(70);
var sharedKey = __webpack_require__(131);
var hiddenKeys = __webpack_require__(69);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = globalThis.TypeError;
var WeakMap = globalThis.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(12);
var isCallable = __webpack_require__(11);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = false;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__(364);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(13);
var fails = __webpack_require__(12);
var isCallable = __webpack_require__(11);
var hasOwn = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(14);
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__(343).CONFIGURABLE;
var inspectSource = __webpack_require__(347);
var InternalStateModule = __webpack_require__(348);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(41);
var definePropertiesModule = __webpack_require__(355);
var enumBugKeys = __webpack_require__(66);
var hiddenKeys = __webpack_require__(69);
var html = __webpack_require__(345);
var documentCreateElement = __webpack_require__(123);
var sharedKey = __webpack_require__(131);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(14);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(138);
var definePropertyModule = __webpack_require__(32);
var anObject = __webpack_require__(41);
var toIndexedObject = __webpack_require__(42);
var objectKeys = __webpack_require__(359);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(129);
var enumBugKeys = __webpack_require__(66);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(13);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(129);
var enumBugKeys = __webpack_require__(66);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(67);
var isCallable = __webpack_require__(11);
var isObject = __webpack_require__(31);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw new $TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(68);
var uncurryThis = __webpack_require__(13);
var getOwnPropertyNamesModule = __webpack_require__(356);
var getOwnPropertySymbolsModule = __webpack_require__(357);
var anObject = __webpack_require__(41);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(134);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(134);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  var len = toIntegerOrInfinity(argument);
  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__(130);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(67);
var isObject = __webpack_require__(31);
var isSymbol = __webpack_require__(127);
var getMethod = __webpack_require__(344);
var ordinaryToPrimitive = __webpack_require__(361);
var wellKnownSymbol = __webpack_require__(139);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw new $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var globalThis = __webpack_require__(8);
var isCallable = __webpack_require__(11);

var WeakMap = globalThis.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),
/* 369 */,
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// eslint-disable-next-line no-empty-function
module.exports = function () {};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(372)() ? Object.assign : __webpack_require__(373);


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	var assign = Object.assign, obj;
	if (typeof assign !== "function") return false;
	obj = { foo: "raz" };
	assign(obj, { bar: "dwa" }, { trzy: "trzy" });
	return obj.foo + obj.bar + obj.trzy === "razdwatrzy";
};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys  = __webpack_require__(374)
  , value = __webpack_require__(378)
  , max   = Math.max;

module.exports = function (dest, src /*, …srcn*/) {
	var error, i, length = max(arguments.length, 2), assign;
	dest = Object(value(dest));
	assign = function (key) {
		try {
			dest[key] = src[key];
		} catch (e) {
			if (!error) error = e;
		}
	};
	for (i = 1; i < length; ++i) {
		src = arguments[i];
		keys(src).forEach(assign);
	}
	if (error !== undefined) throw error;
	return dest;
};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(375)() ? Object.keys : __webpack_require__(376);


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
		return false;
	}
};


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(71);

var keys = Object.keys;

module.exports = function (object) { return keys(isValue(object) ? Object(object) : object); };


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(71);

var forEach = Array.prototype.forEach, create = Object.create;

var process = function (src, obj) {
	var key;
	for (key in src) obj[key] = src[key];
};

// eslint-disable-next-line no-unused-vars
module.exports = function (opts1 /*, …options*/) {
	var result = create(null);
	forEach.call(arguments, function (options) {
		if (!isValue(options)) return;
		process(Object(options), result);
	});
	return result;
};


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(71);

module.exports = function (value) {
	if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
	return value;
};


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(380)() ? String.prototype.contains : __webpack_require__(381);


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var str = "razdwatrzy";

module.exports = function () {
	if (typeof str.contains !== "function") return false;
	return str.contains("dwa") === true && str.contains("foo") === false;
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var indexOf = String.prototype.indexOf;

module.exports = function (searchString /*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var global     = __webpack_require__(44)
  , validTypes = { object: true, symbol: true };

module.exports = function () {
	var Symbol = global.Symbol;
	var symbol;
	if (typeof Symbol !== "function") return false;
	symbol = Symbol("test symbol");
	try { String(symbol); }
	catch (e) { return false; }

	// Return 'true' also for polyfills
	if (!validTypes[typeof Symbol.iterator]) return false;
	if (!validTypes[typeof Symbol.toPrimitive]) return false;
	if (!validTypes[typeof Symbol.toStringTag]) return false;

	return true;
};


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (value) {
	if (!value) return false;
	if (typeof value === "symbol") return true;
	if (!value.constructor) return false;
	if (value.constructor.name !== "Symbol") return false;
	return value[value.constructor.toStringTag] === "Symbol";
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d = __webpack_require__(43);

var create = Object.create, defineProperty = Object.defineProperty, objPrototype = Object.prototype;

var created = create(null);
module.exports = function (desc) {
	var postfix = 0, name, ie11BugWorkaround;
	while (created[desc + (postfix || "")]) ++postfix;
	desc += postfix || "";
	created[desc] = true;
	name = "@@" + desc;
	defineProperty(
		objPrototype, name,
		d.gs(null, function (value) {
			// For IE11 issue see:
			// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
			//    ie11-broken-getters-on-dom-objects
			// https://github.com/medikoo/es6-symbol/issues/12
			if (ie11BugWorkaround) return;
			ie11BugWorkaround = true;
			defineProperty(this, name, d(value));
			ie11BugWorkaround = false;
		})
	);
	return name;
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d            = __webpack_require__(43)
  , NativeSymbol = __webpack_require__(44).Symbol;

module.exports = function (SymbolPolyfill) {
	return Object.defineProperties(SymbolPolyfill, {
		// To ensure proper interoperability with other native functions (e.g. Array.from)
		// fallback to eventual native implementation of given symbol
		hasInstance: d(
			"", (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill("hasInstance")
		),
		isConcatSpreadable: d(
			"",
			(NativeSymbol && NativeSymbol.isConcatSpreadable) ||
				SymbolPolyfill("isConcatSpreadable")
		),
		iterator: d("", (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill("iterator")),
		match: d("", (NativeSymbol && NativeSymbol.match) || SymbolPolyfill("match")),
		replace: d("", (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill("replace")),
		search: d("", (NativeSymbol && NativeSymbol.search) || SymbolPolyfill("search")),
		species: d("", (NativeSymbol && NativeSymbol.species) || SymbolPolyfill("species")),
		split: d("", (NativeSymbol && NativeSymbol.split) || SymbolPolyfill("split")),
		toPrimitive: d(
			"", (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill("toPrimitive")
		),
		toStringTag: d(
			"", (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill("toStringTag")
		),
		unscopables: d(
			"", (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill("unscopables")
		)
	});
};


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var d              = __webpack_require__(43)
  , validateSymbol = __webpack_require__(141);

var registry = Object.create(null);

module.exports = function (SymbolPolyfill) {
	return Object.defineProperties(SymbolPolyfill, {
		for: d(function (key) {
			if (registry[key]) return registry[key];
			return (registry[key] = SymbolPolyfill(String(key)));
		}),
		keyFor: d(function (symbol) {
			var key;
			validateSymbol(symbol);
			for (key in registry) {
				if (registry[key] === symbol) return key;
			}
			return undefined;
		})
	});
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ES2015 Symbol polyfill for environments that do not (or partially) support it



var d                    = __webpack_require__(43)
  , validateSymbol       = __webpack_require__(141)
  , NativeSymbol         = __webpack_require__(44).Symbol
  , generateName         = __webpack_require__(384)
  , setupStandardSymbols = __webpack_require__(385)
  , setupSymbolRegistry  = __webpack_require__(386);

var create = Object.create
  , defineProperties = Object.defineProperties
  , defineProperty = Object.defineProperty;

var SymbolPolyfill, HiddenSymbol, isNativeSafe;

if (typeof NativeSymbol === "function") {
	try {
		String(NativeSymbol());
		isNativeSafe = true;
	} catch (ignore) {}
} else {
	NativeSymbol = null;
}

// Internal constructor (not one exposed) for creating Symbol instances.
// This one is used to ensure that `someSymbol instanceof Symbol` always return false
HiddenSymbol = function Symbol(description) {
	if (this instanceof HiddenSymbol) throw new TypeError("Symbol is not a constructor");
	return SymbolPolyfill(description);
};

// Exposed `Symbol` constructor
// (returns instances of HiddenSymbol)
module.exports = SymbolPolyfill = function Symbol(description) {
	var symbol;
	if (this instanceof Symbol) throw new TypeError("Symbol is not a constructor");
	if (isNativeSafe) return NativeSymbol(description);
	symbol = create(HiddenSymbol.prototype);
	description = description === undefined ? "" : String(description);
	return defineProperties(symbol, {
		__description__: d("", description),
		__name__: d("", generateName(description))
	});
};

setupStandardSymbols(SymbolPolyfill);
setupSymbolRegistry(SymbolPolyfill);

// Internal tweaks for real symbol producer
defineProperties(HiddenSymbol.prototype, {
	constructor: d(SymbolPolyfill),
	toString: d("", function () { return this.__name__; })
});

// Proper implementation of methods exposed on Symbol.prototype
// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
defineProperties(SymbolPolyfill.prototype, {
	toString: d(function () { return "Symbol (" + validateSymbol(this).__description__ + ")"; }),
	valueOf: d(function () { return validateSymbol(this); })
});
defineProperty(
	SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive,
	d("", function () {
		var symbol = validateSymbol(this);
		if (typeof symbol === "symbol") return symbol;
		return symbol.toString();
	})
);
defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d("c", "Symbol"));

// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
defineProperty(
	HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
	d("c", SymbolPolyfill.prototype[SymbolPolyfill.toStringTag])
);

// Note: It's important to define `toPrimitive` as last one, as some implementations
// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
// And that may invoke error in definition flow:
// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
defineProperty(
	HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
	d("c", SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive])
);


/***/ }),
/* 388 */
/***/ (function(module, exports) {

var naiveFallback = function () {
	if (typeof self === "object" && self) return self;
	if (typeof window === "object" && window) return window;
	throw new Error("Unable to resolve global `this`");
};

module.exports = (function () {
	if (this) return this;

	// Unexpected strict mode (may happen if e.g. bundled into ESM module)

	// Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
	// In all ES5+ engines global object inherits from Object.prototype
	// (if you approached one that doesn't please report)
	try {
		Object.defineProperty(Object.prototype, "__global__", {
			get: function () { return this; },
			configurable: true
		});
	} catch (error) {
		// Unfortunate case of Object.prototype being sealed (via preventExtensions, seal or freeze)
		return naiveFallback();
	}
	try {
		// Safari case (window.__global__ is resolved with global context, but __global__ does not)
		if (!__global__) return naiveFallback();
		return __global__;
	} finally {
		delete Object.prototype.__global__;
	}
})();


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	if (typeof globalThis !== "object") return false;
	if (!globalThis) return false;
	return globalThis.Array === Array;
};


/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 391 */
/***/ (function(module, exports) {

/*
 Original Plugin by Osvaldas Valutis, www.osvaldas.info
 http://osvaldas.info/drop-down-navigation-responsive-and-touch-friendly
 Available for use under the MIT License
 */
/**
 * jquery-doubleTapToGo plugin
 * Copyright 2017 DACHCOM.DIGITAL AG
 * @author Marco Rieser
 * @author Volker Andres
 * @author Stefan Hagspiel
 * @version 3.0.2
 * @see https://github.com/dachcom-digital/jquery-doubletaptogo
 */
!function(t,e,s,i){"use strict";function n(e,s){this.element=e,this.settings=t.extend({},a,s),this._defaults=a,this._name=o,this.init()}var o="doubleTapToGo",a={automatic:!0,selectorClass:"doubletap",selectorChain:"li:has(ul)"};t.extend(n.prototype,{preventClick:!1,currentTap:t(),init:function(){t(this.element).on("touchstart","."+this.settings.selectorClass,this._tap.bind(this)).on("click","."+this.settings.selectorClass,this._click.bind(this)).on("remove",this._destroy.bind(this)),this._addSelectors()},_addSelectors:function(){this.settings.automatic===!0&&t(this.element).find(this.settings.selectorChain).addClass(this.settings.selectorClass)},_click:function(e){this.preventClick?e.preventDefault():this.currentTap=t()},_tap:function(e){var s=t(e.target).closest("li");return s.hasClass(this.settings.selectorClass)?s.get(0)===this.currentTap.get(0)?void(this.preventClick=!1):(this.preventClick=!0,this.currentTap=s,void e.stopPropagation()):void(this.preventClick=!1)},_destroy:function(){t(this.element).off()},reset:function(){this.currentTap=t()}}),t.fn[o]=function(e){var s,a=arguments;return e===i||"object"==typeof e?this.each(function(){t.data(this,o)||t.data(this,o,new n(this,e))}):"string"==typeof e&&"_"!==e[0]&&"init"!==e?(this.each(function(){var i=t.data(this,o),r="destroy"===e?"_destroy":e;i instanceof n&&"function"==typeof i[r]&&(s=i[r].apply(i,Array.prototype.slice.call(a,1))),"destroy"===e&&t.data(this,o,null)}),s!==i?s:this):void 0}}(jQuery,window,document);

/***/ }),
/* 392 */
/***/ (function(module, exports) {

/*!
 * jQuery & Zepto Lazy - AJAX Plugin - v1.4
 * http://jquery.eisbehr.de/lazy/
 *
 * Copyright 2012 - 2018, Daniel 'Eisbehr' Kern
 *
 * Dual licensed under the MIT and GPL-2.0 licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl-2.0.html
 */
;(function($) {
    // load data by ajax request and pass them to elements inner html, like:
    // <div data-loader="ajax" data-src="url.html" data-method="post" data-type="html"></div>
    $.lazy('ajax', function(element, response) {
        ajaxRequest(this, element, response, element.attr('data-method'));
    });

    // load data by ajax get request and pass them to elements inner html, like:
    // <div data-loader="get" data-src="url.html" data-type="html"></div>
    $.lazy('get', function(element, response) {
        ajaxRequest(this, element, response, 'GET');
    });

    // load data by ajax post request and pass them to elements inner html, like:
    // <div data-loader="post" data-src="url.html" data-type="html"></div>
    $.lazy('post', function(element, response) {
        ajaxRequest(this, element, response, 'POST');
    });

    // load data by ajax put request and pass them to elements inner html, like:
    // <div data-loader="put" data-src="url.html" data-type="html"></div>
    $.lazy('put', function(element, response) {
        ajaxRequest(this, element, response, 'PUT');
    });

    /**
     * execute ajax request and handle response
     * @param {object} instance
     * @param {jQuery|object} element
     * @param {function} response
     * @param {string} [method]
     */
    function ajaxRequest(instance, element, response, method) {
        method = method ? method.toUpperCase() : 'GET';

        var data;
        if ((method === 'POST' || method === 'PUT') && instance.config('ajaxCreateData')) {
            data = instance.config('ajaxCreateData').apply(instance, [element]);
        }

        $.ajax({
            url: element.attr('data-src'),
            type: method === 'POST' || method === 'PUT' ? method : 'GET',
            data: data,
            dataType: element.attr('data-type') || 'html',

            /**
             * success callback
             * @access private
             * @param {*} content
             * @return {void}
             */
            success: function(content) {
                // set responded data to element's inner html
                element.html(content);

                // use response function for Zepto
                response(true);

                // remove attributes
                if (instance.config('removeAttribute')) {
                    element.removeAttr('data-src data-method data-type');
                }
            },

            /**
             * error callback
             * @access private
             * @return {void}
             */
            error: function() {
                // pass error state to lazy
                // use response function for Zepto
                response(false);
            }
        });
    }
})(window.jQuery || window.Zepto);

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * jQuery Easing v1.4.1 - http://gsgd.co.uk/sandbox/jquery/easing/
 * Open source under the BSD License.
 * Copyright © 2008 George McGinley Smith
 * All rights reserved.
 * https://raw.github.com/gdsmith/jquery-easing/master/LICENSE
*/

(function (factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function ($) {
			return factory($);
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module === "object" && typeof module.exports === "object") {
		exports = factory(require('jquery'));
	} else {
		factory(jQuery);
	}
})(function($){

// Preserve the original jQuery "swing" easing as "jswing"
$.easing.jswing = $.easing.swing;

var pow = Math.pow,
	sqrt = Math.sqrt,
	sin = Math.sin,
	cos = Math.cos,
	PI = Math.PI,
	c1 = 1.70158,
	c2 = c1 * 1.525,
	c3 = c1 + 1,
	c4 = ( 2 * PI ) / 3,
	c5 = ( 2 * PI ) / 4.5;

// x is the fraction of animation progress, in the range 0..1
function bounceOut(x) {
	var n1 = 7.5625,
		d1 = 2.75;
	if ( x < 1/d1 ) {
		return n1*x*x;
	} else if ( x < 2/d1 ) {
		return n1*(x-=(1.5/d1))*x + 0.75;
	} else if ( x < 2.5/d1 ) {
		return n1*(x-=(2.25/d1))*x + 0.9375;
	} else {
		return n1*(x-=(2.625/d1))*x + 0.984375;
	}
}

$.extend( $.easing,
{
	def: 'easeOutQuad',
	swing: function (x) {
		return $.easing[$.easing.def](x);
	},
	easeInQuad: function (x) {
		return x * x;
	},
	easeOutQuad: function (x) {
		return 1 - ( 1 - x ) * ( 1 - x );
	},
	easeInOutQuad: function (x) {
		return x < 0.5 ?
			2 * x * x :
			1 - pow( -2 * x + 2, 2 ) / 2;
	},
	easeInCubic: function (x) {
		return x * x * x;
	},
	easeOutCubic: function (x) {
		return 1 - pow( 1 - x, 3 );
	},
	easeInOutCubic: function (x) {
		return x < 0.5 ?
			4 * x * x * x :
			1 - pow( -2 * x + 2, 3 ) / 2;
	},
	easeInQuart: function (x) {
		return x * x * x * x;
	},
	easeOutQuart: function (x) {
		return 1 - pow( 1 - x, 4 );
	},
	easeInOutQuart: function (x) {
		return x < 0.5 ?
			8 * x * x * x * x :
			1 - pow( -2 * x + 2, 4 ) / 2;
	},
	easeInQuint: function (x) {
		return x * x * x * x * x;
	},
	easeOutQuint: function (x) {
		return 1 - pow( 1 - x, 5 );
	},
	easeInOutQuint: function (x) {
		return x < 0.5 ?
			16 * x * x * x * x * x :
			1 - pow( -2 * x + 2, 5 ) / 2;
	},
	easeInSine: function (x) {
		return 1 - cos( x * PI/2 );
	},
	easeOutSine: function (x) {
		return sin( x * PI/2 );
	},
	easeInOutSine: function (x) {
		return -( cos( PI * x ) - 1 ) / 2;
	},
	easeInExpo: function (x) {
		return x === 0 ? 0 : pow( 2, 10 * x - 10 );
	},
	easeOutExpo: function (x) {
		return x === 1 ? 1 : 1 - pow( 2, -10 * x );
	},
	easeInOutExpo: function (x) {
		return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
			pow( 2, 20 * x - 10 ) / 2 :
			( 2 - pow( 2, -20 * x + 10 ) ) / 2;
	},
	easeInCirc: function (x) {
		return 1 - sqrt( 1 - pow( x, 2 ) );
	},
	easeOutCirc: function (x) {
		return sqrt( 1 - pow( x - 1, 2 ) );
	},
	easeInOutCirc: function (x) {
		return x < 0.5 ?
			( 1 - sqrt( 1 - pow( 2 * x, 2 ) ) ) / 2 :
			( sqrt( 1 - pow( -2 * x + 2, 2 ) ) + 1 ) / 2;
	},
	easeInElastic: function (x) {
		return x === 0 ? 0 : x === 1 ? 1 :
			-pow( 2, 10 * x - 10 ) * sin( ( x * 10 - 10.75 ) * c4 );
	},
	easeOutElastic: function (x) {
		return x === 0 ? 0 : x === 1 ? 1 :
			pow( 2, -10 * x ) * sin( ( x * 10 - 0.75 ) * c4 ) + 1;
	},
	easeInOutElastic: function (x) {
		return x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ?
			-( pow( 2, 20 * x - 10 ) * sin( ( 20 * x - 11.125 ) * c5 )) / 2 :
			pow( 2, -20 * x + 10 ) * sin( ( 20 * x - 11.125 ) * c5 ) / 2 + 1;
	},
	easeInBack: function (x) {
		return c3 * x * x * x - c1 * x * x;
	},
	easeOutBack: function (x) {
		return 1 + c3 * pow( x - 1, 3 ) + c1 * pow( x - 1, 2 );
	},
	easeInOutBack: function (x) {
		return x < 0.5 ?
			( pow( 2 * x, 2 ) * ( ( c2 + 1 ) * 2 * x - c2 ) ) / 2 :
			( pow( 2 * x - 2, 2 ) *( ( c2 + 1 ) * ( x * 2 - 2 ) + c2 ) + 2 ) / 2;
	},
	easeInBounce: function (x) {
		return 1 - bounceOut( 1 - x );
	},
	easeOutBounce: bounceOut,
	easeInOutBounce: function (x) {
		return x < 0.5 ?
			( 1 - bounceOut( 1 - 2 * x ) ) / 2 :
			( 1 + bounceOut( 2 * x - 1 ) ) / 2;
	}
});

});


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(460),
    hashDelete = __webpack_require__(461),
    hashGet = __webpack_require__(462),
    hashHas = __webpack_require__(463),
    hashSet = __webpack_require__(464);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(18),
    root = __webpack_require__(4);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 399 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 400 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 401 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(24),
    keys = __webpack_require__(20);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(24),
    keysIn = __webpack_require__(100);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(78),
    isFlattenable = __webpack_require__(469);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 406 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(15),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(75),
    equalArrays = __webpack_require__(169),
    equalByTag = __webpack_require__(450),
    equalObjects = __webpack_require__(451),
    getTag = __webpack_require__(52),
    isArray = __webpack_require__(7),
    isBuffer = __webpack_require__(94),
    isTypedArray = __webpack_require__(188);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(52),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(75),
    baseIsEqual = __webpack_require__(156);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 411 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(187),
    isMasked = __webpack_require__(472),
    isObject = __webpack_require__(9),
    toSource = __webpack_require__(185);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(52),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(15),
    isLength = __webpack_require__(95),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(88),
    nativeKeys = __webpack_require__(486);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(9),
    isPrototype = __webpack_require__(88),
    nativeKeysIn = __webpack_require__(487);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(410),
    getMatchData = __webpack_require__(454),
    matchesStrictComparable = __webpack_require__(178);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(156),
    get = __webpack_require__(6),
    hasIn = __webpack_require__(514),
    isKey = __webpack_require__(87),
    isStrictComparable = __webpack_require__(177),
    matchesStrictComparable = __webpack_require__(178),
    toKey = __webpack_require__(33);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(79);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 421 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 422 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(511),
    defineProperty = __webpack_require__(168),
    identity = __webpack_require__(34);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(23),
    arrayMap = __webpack_require__(77),
    isArray = __webpack_require__(7),
    isSymbol = __webpack_require__(57);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(502);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(144),
    arrayIncludes = __webpack_require__(148),
    arrayIncludesWith = __webpack_require__(398),
    cacheHas = __webpack_require__(162),
    createSet = __webpack_require__(446),
    setToArray = __webpack_require__(90);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(49),
    last = __webpack_require__(520),
    parent = __webpack_require__(489),
    toKey = __webpack_require__(33);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);

  // Prevent prototype pollution:
  // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
  // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
  var index = -1,
      length = path.length;

  if (!length) {
    return true;
  }

  while (++index < length) {
    var key = toKey(path[index]);

    // Always block "__proto__" anywhere in the path if it's not expected
    if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) {
      return false;
    }

    // Block constructor/prototype as non-terminal traversal keys to prevent
    // escaping the object graph into built-in constructors and prototypes.
    if ((key === 'constructor' || key === 'prototype') && index < length - 1) {
      return false;
    }
  }

  var obj = parent(object, path);
  return obj == null || delete obj[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(77);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(34);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(160);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(4);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(103)(module)))

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(82);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 433 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(23);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(82);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(24),
    getSymbols = __webpack_require__(86);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(24),
    getSymbolsIn = __webpack_require__(174);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(4);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 439 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(158),
    isIterateeCall = __webpack_require__(176);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(50),
    root = __webpack_require__(4);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(430),
    hasUnicode = __webpack_require__(175),
    stringToArray = __webpack_require__(500),
    toString = __webpack_require__(36);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(76),
    createCtor = __webpack_require__(50),
    createHybrid = __webpack_require__(166),
    createRecurry = __webpack_require__(167),
    getHolder = __webpack_require__(84),
    replaceHolders = __webpack_require__(55),
    root = __webpack_require__(4);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(157),
    isArrayLike = __webpack_require__(35),
    keys = __webpack_require__(20);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(76),
    createCtor = __webpack_require__(50),
    root = __webpack_require__(4);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(143),
    noop = __webpack_require__(101),
    setToArray = __webpack_require__(90);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(159),
    createBind = __webpack_require__(441),
    createCurry = __webpack_require__(443),
    createHybrid = __webpack_require__(166),
    createPartial = __webpack_require__(445),
    getData = __webpack_require__(173),
    mergeData = __webpack_require__(485),
    setData = __webpack_require__(182),
    setWrapToString = __webpack_require__(183),
    toInteger = __webpack_require__(59);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(518);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(421);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(23),
    Uint8Array = __webpack_require__(145),
    eq = __webpack_require__(56),
    equalArrays = __webpack_require__(169),
    mapToArray = __webpack_require__(483),
    setToArray = __webpack_require__(90);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(171);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(513),
    overRest = __webpack_require__(181),
    setToString = __webpack_require__(91);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(490);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(177),
    keys = __webpack_require__(20);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(23);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 456 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 457 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(49),
    isArguments = __webpack_require__(93),
    isArray = __webpack_require__(7),
    isIndex = __webpack_require__(53),
    isLength = __webpack_require__(95),
    toKey = __webpack_require__(33);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 459 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(54);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 461 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(54);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(54);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(54);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 465 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(82),
    cloneDataView = __webpack_require__(432),
    cloneRegExp = __webpack_require__(433),
    cloneSymbol = __webpack_require__(434),
    cloneTypedArray = __webpack_require__(435);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(48),
    getPrototype = __webpack_require__(85),
    isPrototype = __webpack_require__(88);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(23),
    isArguments = __webpack_require__(93),
    isArray = __webpack_require__(7);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 470 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(72),
    getData = __webpack_require__(173),
    getFuncName = __webpack_require__(453),
    lodash = __webpack_require__(532);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(438);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 473 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(47);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(47);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(47);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(47);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(395),
    ListCache = __webpack_require__(46),
    Map = __webpack_require__(73);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(51);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(51);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(51);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(51);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 483 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(521);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(163),
    composeArgsRight = __webpack_require__(164),
    replaceHolders = __webpack_require__(55);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(180);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 487 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 488 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(79),
    baseSlice = __webpack_require__(160);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 490 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(83),
    isIndex = __webpack_require__(53);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 492 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 493 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(46);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 495 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 496 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 497 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(46),
    Map = __webpack_require__(73),
    MapCache = __webpack_require__(74);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 499 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(401),
    hasUnicode = __webpack_require__(175),
    unicodeToArray = __webpack_require__(503);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(484);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 502 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 503 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 504 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(147),
    arrayIncludes = __webpack_require__(148);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(72),
    LodashWrapper = __webpack_require__(142),
    copyArray = __webpack_require__(83);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(24),
    createAssigner = __webpack_require__(440),
    keys = __webpack_require__(20);

/**
 * This method is like `_.assign` except that it accepts `customizer`
 * which is invoked to produce the assigned values. If `customizer` returns
 * `undefined`, assignment is handled by the method instead. The `customizer`
 * is invoked with five arguments: (objValue, srcValue, key, object, source).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} [customizer] The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @see _.assignInWith
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   return _.isUndefined(objValue) ? srcValue : objValue;
 * }
 *
 * var defaults = _.partialRight(_.assignWith, customizer);
 *
 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
  copyObject(source, keys(source), object, customizer);
});

module.exports = assignWith;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var capitalize = __webpack_require__(509),
    createCompounder = __webpack_require__(165);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

module.exports = camelCase;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(36),
    upperFirst = __webpack_require__(529);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(152);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 511 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(449),
    toString = __webpack_require__(36);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(405);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(406),
    hasPath = __webpack_require__(458);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(155),
    isArrayLike = __webpack_require__(35),
    isString = __webpack_require__(97),
    toInteger = __webpack_require__(59),
    values = __webpack_require__(530);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(409),
    baseUnary = __webpack_require__(81),
    nodeUtil = __webpack_require__(89);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(15),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(15),
    getPrototype = __webpack_require__(85),
    isObjectLike = __webpack_require__(10);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(413),
    baseUnary = __webpack_require__(81),
    nodeUtil = __webpack_require__(89);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 520 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(74);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(4);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(77),
    baseClone = __webpack_require__(152),
    baseUnset = __webpack_require__(427),
    castPath = __webpack_require__(49),
    copyObject = __webpack_require__(24),
    customOmitClone = __webpack_require__(448),
    flatRest = __webpack_require__(452),
    getAllKeysIn = __webpack_require__(172);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(158),
    createWrap = __webpack_require__(447),
    getHolder = __webpack_require__(84),
    replaceHolders = __webpack_require__(55);

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

module.exports = partial;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(422),
    isIterateeCall = __webpack_require__(176),
    toFinite = __webpack_require__(190);

/** Built-in method references without a dependency on `root`. */
var freeParseFloat = parseFloat;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min,
    nativeRandom = Math.random;

/**
 * Produces a random number between the inclusive `lower` and `upper` bounds.
 * If only one argument is provided a number between `0` and the given number
 * is returned. If `floating` is `true`, or either `lower` or `upper` are
 * floats, a floating-point number is returned instead of an integer.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * **Note:** If `lower` is greater than `upper`, the values are swapped.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Number
 * @param {number} [lower=0] The lower bound.
 * @param {number} [upper=1] The upper bound.
 * @param {boolean} [floating] Specify returning a floating-point number.
 * @returns {number} Returns the random number.
 * @example
 *
 * _.random(0, 5);
 * // => an integer between 0 and 5
 *
 * // when lower is greater than upper the values are swapped
 * _.random(5, 0);
 * // => an integer between 0 and 5
 *
 * _.random(5);
 * // => also an integer between 0 and 5
 *
 * _.random(-5);
 * // => an integer between -5 and 0
 *
 * _.random(5, true);
 * // => a floating-point number between 0 and 5
 *
 * _.random(1.2, 5.2);
 * // => a floating-point number between 1.2 and 5.2
 */
function random(lower, upper, floating) {
  if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
    upper = floating = undefined;
  }
  if (floating === undefined) {
    if (typeof upper == 'boolean') {
      floating = upper;
      upper = undefined;
    }
    else if (typeof lower == 'boolean') {
      floating = lower;
      lower = undefined;
    }
  }
  if (lower === undefined && upper === undefined) {
    lower = 0;
    upper = 1;
  }
  else {
    lower = toFinite(lower);
    if (upper === undefined) {
      upper = lower;
      lower = 0;
    } else {
      upper = toFinite(upper);
    }
  }
  if (lower > upper) {
    var temp = lower;
    lower = upper;
    upper = temp;
  }
  if (floating || lower % 1 || upper % 1) {
    var rand = nativeRandom();
    return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
  }
  return baseRandom(lower, upper);
}

module.exports = random;


/***/ }),
/* 526 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(161),
    castFunction = __webpack_require__(429),
    toInteger = __webpack_require__(59);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(426);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(442);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(428),
    keys = __webpack_require__(20);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(402),
    hasUnicodeWord = __webpack_require__(459),
    toString = __webpack_require__(36),
    unicodeWords = __webpack_require__(504);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(72),
    LodashWrapper = __webpack_require__(142),
    baseLodash = __webpack_require__(80),
    isArray = __webpack_require__(7),
    isObjectLike = __webpack_require__(10),
    wrapperClone = __webpack_require__(506);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 533 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  * $script.js JS loader & dependency manager
  * https://github.com/ded/script.js
  * (c) Dustin Diaz 2014 | License MIT
  */

(function (name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else this[name] = definition()
})('$script', function () {
  var doc = document
    , head = doc.getElementsByTagName('head')[0]
    , s = 'string'
    , f = false
    , push = 'push'
    , readyState = 'readyState'
    , onreadystatechange = 'onreadystatechange'
    , list = {}
    , ids = {}
    , delay = {}
    , scripts = {}
    , scriptpath
    , urlArgs

  function every(ar, fn) {
    for (var i = 0, j = ar.length; i < j; ++i) if (!fn(ar[i])) return f
    return 1
  }
  function each(ar, fn) {
    every(ar, function (el) {
      fn(el)
      return 1
    })
  }

  function $script(paths, idOrDone, optDone) {
    paths = paths[push] ? paths : [paths]
    var idOrDoneIsDone = idOrDone && idOrDone.call
      , done = idOrDoneIsDone ? idOrDone : optDone
      , id = idOrDoneIsDone ? paths.join('') : idOrDone
      , queue = paths.length
    function loopFn(item) {
      return item.call ? item() : list[item]
    }
    function callback() {
      if (!--queue) {
        list[id] = 1
        done && done()
        for (var dset in delay) {
          every(dset.split('|'), loopFn) && !each(delay[dset], loopFn) && (delay[dset] = [])
        }
      }
    }
    setTimeout(function () {
      each(paths, function loading(path, force) {
        if (path === null) return callback()
        
        if (!force && !/^https?:\/\//.test(path) && scriptpath) {
          path = (path.indexOf('.js') === -1) ? scriptpath + path + '.js' : scriptpath + path;
        }
        
        if (scripts[path]) {
          if (id) ids[id] = 1
          return (scripts[path] == 2) ? callback() : setTimeout(function () { loading(path, true) }, 0)
        }

        scripts[path] = 1
        if (id) ids[id] = 1
        create(path, callback)
      })
    }, 0)
    return $script
  }

  function create(path, fn) {
    var el = doc.createElement('script'), loaded
    el.onload = el.onerror = el[onreadystatechange] = function () {
      if ((el[readyState] && !(/^c|loade/.test(el[readyState]))) || loaded) return;
      el.onload = el[onreadystatechange] = null
      loaded = 1
      scripts[path] = 2
      fn()
    }
    el.async = 1
    el.src = urlArgs ? path + (path.indexOf('?') === -1 ? '?' : '&') + urlArgs : path;
    head.insertBefore(el, head.lastChild)
  }

  $script.get = create

  $script.order = function (scripts, id, done) {
    (function callback(s) {
      s = scripts.shift()
      !scripts.length ? $script(s, id, done) : $script(s, callback)
    }())
  }

  $script.path = function (p) {
    scriptpath = p
  }
  $script.urlArgs = function (str) {
    urlArgs = str;
  }
  $script.ready = function (deps, ready, req) {
    deps = deps[push] ? deps : [deps]
    var missing = [];
    !each(deps, function (dep) {
      list[dep] || missing[push](dep);
    }) && every(deps, function (dep) {return list[dep]}) ?
      ready() : !function (key) {
      delay[key] = delay[key] || []
      delay[key][push](ready)
      req && req(missing)
    }(deps.join('|'))
    return $script
  }

  $script.done = function (idOrDone) {
    $script([null], idOrDone)
  }

  return $script
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60), __webpack_require__(533)))

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(535);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(60)))

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isPrototype = __webpack_require__(540);

module.exports = function (value) {
	if (typeof value !== "function") return false;

	if (!hasOwnProperty.call(value, "length")) return false;

	try {
		if (typeof value.length !== "number") return false;
		if (typeof value.call !== "function") return false;
		if (typeof value.apply !== "function") return false;
	} catch (error) {
		return false;
	}

	return !isPrototype(value);
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(192);

// prettier-ignore
var possibleTypes = { "object": true, "function": true, "undefined": true /* document.all */ };

module.exports = function (value) {
	if (!isValue(value)) return false;
	return hasOwnProperty.call(possibleTypes, typeof value);
};


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(537);

var classRe = /^\s*class[\s{/}]/, functionToString = Function.prototype.toString;

module.exports = function (value) {
	if (!isFunction(value)) return false;
	if (classRe.test(functionToString.call(value))) return false;
	return true;
};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(538);

module.exports = function (value) {
	if (!isObject(value)) return false;
	try {
		if (!value.constructor) return false;
		return value.constructor.prototype === value;
	} catch (error) {
		return false;
	}
};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isByteLength;

var _assertString = __webpack_require__(102);

var _assertString2 = _interopRequireDefault(_assertString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString2.default)(str);
  var min = void 0;
  var max = void 0;
  if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }
  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}
module.exports = exports['default'];

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = __webpack_require__(102);

var _assertString2 = _interopRequireDefault(_assertString);

var _merge = __webpack_require__(194);

var _merge2 = _interopRequireDefault(_merge);

var _isByteLength = __webpack_require__(541);

var _isByteLength2 = _interopRequireDefault(_isByteLength);

var _isFQDN = __webpack_require__(193);

var _isFQDN2 = _interopRequireDefault(_isFQDN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};

/* eslint-disable max-len */
/* eslint-disable no-control-regex */
var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */
/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString2.default)(str);
  options = (0, _merge2.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);
    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');

  var lower_domain = domain.toLowerCase();
  if (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com') {
    user = user.replace(/\./g, '').toLowerCase();
  }

  if (!(0, _isByteLength2.default)(user, { max: 64 }) || !(0, _isByteLength2.default)(domain, { max: 254 })) {
    return false;
  }

  if (!(0, _isFQDN2.default)(domain, { require_tld: options.require_tld })) {
    return false;
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;

  var user_parts = user.split('.');
  for (var i = 0; i < user_parts.length; i++) {
    if (!pattern.test(user_parts[i])) {
      return false;
    }
  }

  return true;
}
module.exports = exports['default'];

/***/ }),
/* 543 */,
/* 544 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// dist/chrome.js